import { jsx as f, jsxs as X, Fragment as Oe } from "react/jsx-runtime";
import * as c from "react";
import R, { createContext as Pt, forwardRef as Xe, useContext as Mt, useState as Je, useEffect as Ee, useLayoutEffect as Oo, useRef as Ne, useCallback as un, isValidElement as rr, PureComponent as Mo, useImperativeHandle as Zy, useMemo as Ht, cloneElement as Do, createElement as xe, Children as nn, Fragment as Cd, useReducer as Qy } from "react";
import { p as Re, M as ne, N as Tn, F as Me, G as ze, r as mt, s as $, O as br, q as me, Q as rs, _ as os, T as as, U as Ie, V as is, W as ss, X as cs, Y as ls, Z as us, $ as ds, H as fs, I as Ed, a0 as Jy, a1 as ew, a2 as or, a3 as An, B as Sd, t as yr, o as wr, a4 as ps, a5 as ms, a6 as Pd, a7 as vs, a8 as hs, a9 as xd, aa as _d, v as tw, w as nw, x as rw, y as ow, A as aw, C as iw, D as sw, E as cw, z as lw, ab as uw } from "./sidebar-59b82a61.js";
import { ac as yH, P as wH, ad as CH, b as EH, a as SH, n as PH, ae as xH, ai as _H, aj as TH, an as NH, al as RH, ak as $H, ag as OH, af as MH, am as DH, ah as AH, S as IH, c as kH, j as LH, h as FH, ao as BH, i as WH, ap as jH, g as HH, aq as UH, l as VH, d as GH, ar as KH, as as YH, f as zH, e as qH, at as XH, au as ZH, av as QH, aw as JH, k as e6, ax as t6, ay as n6, m as r6, az as o6, aA as a6, aC as i6, aD as s6, aB as c6, u as l6 } from "./sidebar-59b82a61.js";
import { s as I, P as Fe, u as Ut, t as Cr, v as Td } from "./resizable-a59df3c1.js";
import { A as d6, c as f6, b as p6, D as m6, w as v6, d as h6, z as g6, g as b6, e as y6, B as w6, G as C6, x as E6, f as S6, y as P6, C as x6, E as _6, F as T6, a as N6, r as R6, q as $6, R as O6, m as M6, o as D6, S as A6, j as I6, H as k6, k as L6, I as F6, L as B6, K as W6, J as j6, h as H6, i as U6, T as V6, p as G6, l as K6, n as Y6 } from "./resizable-a59df3c1.js";
import * as Nd from "react-dom";
import Er, { flushSync as Rd } from "react-dom";
import { ChevronDown as $d, ChevronRight as Sr, MoreHorizontal as Od, ChevronLeft as Md, ArrowLeft as dw, ArrowRight as fw, Check as gs, X as Dd, Search as pw, Circle as bs, Minus as mw } from "lucide-react";
import rn from "clsx";
import "./use-mobile-b816b6c7.js";
import "tailwind-merge";
function Vt(e) {
  const t = e + "CollectionProvider", [n, r] = Re(t), [o, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (y) => {
    const { scope: g, children: m } = y, h = R.useRef(null), b = R.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ f(o, { scope: g, itemMap: b, collectionRef: h, children: m });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = R.forwardRef(
    (y, g) => {
      const { scope: m, children: h } = y, b = a(s, m), w = ne(g, b.collectionRef);
      return /* @__PURE__ */ f(Tn, { ref: w, children: h });
    }
  );
  l.displayName = s;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", p = R.forwardRef(
    (y, g) => {
      const { scope: m, children: h, ...b } = y, w = R.useRef(null), C = ne(g, w), E = a(u, m);
      return R.useEffect(() => (E.itemMap.set(w, { ref: w, ...b }), () => void E.itemMap.delete(w))), /* @__PURE__ */ f(Tn, { [d]: "", ref: C, children: h });
    }
  );
  p.displayName = u;
  function v(y) {
    const g = a(e + "CollectionConsumer", y);
    return R.useCallback(() => {
      const h = g.collectionRef.current;
      if (!h)
        return [];
      const b = Array.from(h.querySelectorAll(`[${d}]`));
      return Array.from(g.itemMap.values()).sort(
        (E, P) => b.indexOf(E.ref.current) - b.indexOf(P.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: i, Slot: l, ItemSlot: p },
    v,
    r
  ];
}
var vw = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], G = vw.reduce((e, t) => {
  const n = c.forwardRef((r, o) => {
    const { asChild: a, ...i } = r, s = a ? Tn : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(s, { ...i, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Ot(e, t) {
  e && Nd.flushSync(() => e.dispatchEvent(t));
}
var ys = "Collapsible", [hw, Ad] = Re(ys), [gw, ws] = hw(ys), Id = c.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: o,
      disabled: a,
      onOpenChange: i,
      ...s
    } = e, [l = !1, u] = Me({
      prop: r,
      defaultProp: o,
      onChange: i
    });
    return /* @__PURE__ */ f(
      gw,
      {
        scope: n,
        disabled: a,
        contentId: ze(),
        open: l,
        onOpenToggle: c.useCallback(() => u((d) => !d), [u]),
        children: /* @__PURE__ */ f(
          G.div,
          {
            "data-state": Es(l),
            "data-disabled": a ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
Id.displayName = ys;
var kd = "CollapsibleTrigger", Ld = c.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, o = ws(kd, n);
    return /* @__PURE__ */ f(
      G.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": Es(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: t,
        onClick: I(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Ld.displayName = kd;
var Cs = "CollapsibleContent", Fd = c.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = ws(Cs, e.__scopeCollapsible);
    return /* @__PURE__ */ f(Fe, { present: n || o.open, children: ({ present: a }) => /* @__PURE__ */ f(bw, { ...r, ref: t, present: a }) });
  }
);
Fd.displayName = Cs;
var bw = c.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...a } = e, i = ws(Cs, n), [s, l] = c.useState(r), u = c.useRef(null), d = ne(t, u), p = c.useRef(0), v = p.current, y = c.useRef(0), g = y.current, m = i.open || s, h = c.useRef(m), b = c.useRef(void 0);
  return c.useEffect(() => {
    const w = requestAnimationFrame(() => h.current = !1);
    return () => cancelAnimationFrame(w);
  }, []), mt(() => {
    const w = u.current;
    if (w) {
      b.current = b.current || {
        transitionDuration: w.style.transitionDuration,
        animationName: w.style.animationName
      }, w.style.transitionDuration = "0s", w.style.animationName = "none";
      const C = w.getBoundingClientRect();
      p.current = C.height, y.current = C.width, h.current || (w.style.transitionDuration = b.current.transitionDuration, w.style.animationName = b.current.animationName), l(r);
    }
  }, [i.open, r]), /* @__PURE__ */ f(
    G.div,
    {
      "data-state": Es(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !m,
      ...a,
      ref: d,
      style: {
        "--radix-collapsible-content-height": v ? `${v}px` : void 0,
        "--radix-collapsible-content-width": g ? `${g}px` : void 0,
        ...e.style
      },
      children: m && o
    }
  );
});
function Es(e) {
  return e ? "open" : "closed";
}
var yw = Id, ww = Ld, Cw = Fd, Dt = "Accordion", Ew = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Ss, Sw, Pw] = Vt(Dt), [Ao, _8] = Re(Dt, [
  Pw,
  Ad
]), Ps = Ad(), Bd = R.forwardRef(
  (e, t) => {
    const { type: n, ...r } = e, o = r, a = r;
    return /* @__PURE__ */ f(Ss.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ f(Nw, { ...a, ref: t }) : /* @__PURE__ */ f(Tw, { ...o, ref: t }) });
  }
);
Bd.displayName = Dt;
var [Wd, xw] = Ao(Dt), [jd, _w] = Ao(
  Dt,
  { collapsible: !1 }
), Tw = R.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: o = () => {
      },
      collapsible: a = !1,
      ...i
    } = e, [s, l] = Me({
      prop: n,
      defaultProp: r,
      onChange: o
    });
    return /* @__PURE__ */ f(
      Wd,
      {
        scope: e.__scopeAccordion,
        value: s ? [s] : [],
        onItemOpen: l,
        onItemClose: R.useCallback(() => a && l(""), [a, l]),
        children: /* @__PURE__ */ f(jd, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ f(Hd, { ...i, ref: t }) })
      }
    );
  }
), Nw = R.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...a
  } = e, [i = [], s] = Me({
    prop: n,
    defaultProp: r,
    onChange: o
  }), l = R.useCallback(
    (d) => s((p = []) => [...p, d]),
    [s]
  ), u = R.useCallback(
    (d) => s((p = []) => p.filter((v) => v !== d)),
    [s]
  );
  return /* @__PURE__ */ f(
    Wd,
    {
      scope: e.__scopeAccordion,
      value: i,
      onItemOpen: l,
      onItemClose: u,
      children: /* @__PURE__ */ f(jd, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ f(Hd, { ...a, ref: t }) })
    }
  );
}), [Rw, Io] = Ao(Dt), Hd = R.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: r, dir: o, orientation: a = "vertical", ...i } = e, s = R.useRef(null), l = ne(s, t), u = Sw(n), p = Ut(o) === "ltr", v = I(e.onKeyDown, (y) => {
      var _;
      if (!Ew.includes(y.key))
        return;
      const g = y.target, m = u().filter((T) => {
        var k;
        return !((k = T.ref.current) != null && k.disabled);
      }), h = m.findIndex((T) => T.ref.current === g), b = m.length;
      if (h === -1)
        return;
      y.preventDefault();
      let w = h;
      const C = 0, E = b - 1, P = () => {
        w = h + 1, w > E && (w = C);
      }, x = () => {
        w = h - 1, w < C && (w = E);
      };
      switch (y.key) {
        case "Home":
          w = C;
          break;
        case "End":
          w = E;
          break;
        case "ArrowRight":
          a === "horizontal" && (p ? P() : x());
          break;
        case "ArrowDown":
          a === "vertical" && P();
          break;
        case "ArrowLeft":
          a === "horizontal" && (p ? x() : P());
          break;
        case "ArrowUp":
          a === "vertical" && x();
          break;
      }
      const S = w % b;
      (_ = m[S].ref.current) == null || _.focus();
    });
    return /* @__PURE__ */ f(
      Rw,
      {
        scope: n,
        disabled: r,
        direction: o,
        orientation: a,
        children: /* @__PURE__ */ f(Ss.Slot, { scope: n, children: /* @__PURE__ */ f(
          G.div,
          {
            ...i,
            "data-orientation": a,
            ref: l,
            onKeyDown: r ? void 0 : v
          }
        ) })
      }
    );
  }
), io = "AccordionItem", [$w, xs] = Ao(io), Ud = R.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: r, ...o } = e, a = Io(io, n), i = xw(io, n), s = Ps(n), l = ze(), u = r && i.value.includes(r) || !1, d = a.disabled || e.disabled;
    return /* @__PURE__ */ f(
      $w,
      {
        scope: n,
        open: u,
        disabled: d,
        triggerId: l,
        children: /* @__PURE__ */ f(
          yw,
          {
            "data-orientation": a.orientation,
            "data-state": qd(u),
            ...s,
            ...o,
            ref: t,
            disabled: d,
            open: u,
            onOpenChange: (p) => {
              p ? i.onItemOpen(r) : i.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
Ud.displayName = io;
var Vd = "AccordionHeader", Gd = R.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Io(Dt, n), a = xs(Vd, n);
    return /* @__PURE__ */ f(
      G.h3,
      {
        "data-orientation": o.orientation,
        "data-state": qd(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
Gd.displayName = Vd;
var Qa = "AccordionTrigger", Kd = R.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Io(Dt, n), a = xs(Qa, n), i = _w(Qa, n), s = Ps(n);
    return /* @__PURE__ */ f(Ss.ItemSlot, { scope: n, children: /* @__PURE__ */ f(
      ww,
      {
        "aria-disabled": a.open && !i.collapsible || void 0,
        "data-orientation": o.orientation,
        id: a.triggerId,
        ...s,
        ...r,
        ref: t
      }
    ) });
  }
);
Kd.displayName = Qa;
var Yd = "AccordionContent", zd = R.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Io(Dt, n), a = xs(Yd, n), i = Ps(n);
    return /* @__PURE__ */ f(
      Cw,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": o.orientation,
        ...i,
        ...r,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
zd.displayName = Yd;
function qd(e) {
  return e ? "open" : "closed";
}
var Ow = Bd, Mw = Ud, Dw = Gd, Xd = Kd, Zd = zd;
const T8 = Ow, Aw = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Mw,
  {
    ref: n,
    className: $("border-b", e),
    ...t
  }
));
Aw.displayName = "AccordionItem";
const Iw = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ f(Dw, { className: "flex", children: /* @__PURE__ */ X(
  Xd,
  {
    ref: r,
    className: $(
      "flex flex-1 items-center justify-between py-4 text-sm font-medium transition-all hover:underline text-left [&[data-state=open]>svg]:rotate-180",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ f($d, { className: "h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200" })
    ]
  }
) }));
Iw.displayName = Xd.displayName;
const kw = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ f(
  Zd,
  {
    ref: r,
    className: "overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
    ...n,
    children: /* @__PURE__ */ f("div", { className: $("pb-4 pt-0", e), children: t })
  }
));
kw.displayName = Zd.displayName;
var Lw = "DismissableLayer", Ja = "dismissableLayer.update", Fw = "dismissableLayer.pointerDownOutside", Bw = "dismissableLayer.focusOutside", rl, Qd = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Jd = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, u = c.useContext(Qd), [d, p] = c.useState(null), v = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, y] = c.useState({}), g = ne(t, (S) => p(S)), m = Array.from(u.layers), [h] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), b = m.indexOf(h), w = d ? m.indexOf(d) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, E = w >= b, P = Hw((S) => {
      const _ = S.target, T = [...u.branches].some((k) => k.contains(_));
      !E || T || (o == null || o(S), i == null || i(S), S.defaultPrevented || s == null || s());
    }, v), x = Uw((S) => {
      const _ = S.target;
      [...u.branches].some((k) => k.contains(_)) || (a == null || a(S), i == null || i(S), S.defaultPrevented || s == null || s());
    }, v);
    return br((S) => {
      w === u.layers.size - 1 && (r == null || r(S), !S.defaultPrevented && s && (S.preventDefault(), s()));
    }, v), c.useEffect(() => {
      if (d)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (rl = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), ol(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (v.body.style.pointerEvents = rl);
        };
    }, [d, v, n, u]), c.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), ol());
    }, [d, u]), c.useEffect(() => {
      const S = () => y({});
      return document.addEventListener(Ja, S), () => document.removeEventListener(Ja, S);
    }, []), /* @__PURE__ */ f(
      G.div,
      {
        ...l,
        ref: g,
        style: {
          pointerEvents: C ? E ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: I(e.onFocusCapture, x.onFocusCapture),
        onBlurCapture: I(e.onBlurCapture, x.onBlurCapture),
        onPointerDownCapture: I(
          e.onPointerDownCapture,
          P.onPointerDownCapture
        )
      }
    );
  }
);
Jd.displayName = Lw;
var Ww = "DismissableLayerBranch", jw = c.forwardRef((e, t) => {
  const n = c.useContext(Qd), r = c.useRef(null), o = ne(t, r);
  return c.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ f(G.div, { ...e, ref: o });
});
jw.displayName = Ww;
function Hw(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = me(e), r = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          ef(
            Fw,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Uw(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = me(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && ef(Bw, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function ol() {
  const e = new CustomEvent(Ja);
  document.dispatchEvent(e);
}
function ef(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Ot(o, a) : o.dispatchEvent(a);
}
var pa = "focusScope.autoFocusOnMount", ma = "focusScope.autoFocusOnUnmount", al = { bubbles: !1, cancelable: !0 }, Vw = "FocusScope", tf = c.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...i
  } = e, [s, l] = c.useState(null), u = me(o), d = me(a), p = c.useRef(null), v = ne(t, (m) => l(m)), y = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (r) {
      let m = function(C) {
        if (y.paused || !s)
          return;
        const E = C.target;
        s.contains(E) ? p.current = E : Ft(p.current, { select: !0 });
      }, h = function(C) {
        if (y.paused || !s)
          return;
        const E = C.relatedTarget;
        E !== null && (s.contains(E) || Ft(p.current, { select: !0 }));
      }, b = function(C) {
        if (document.activeElement === document.body)
          for (const P of C)
            P.removedNodes.length > 0 && Ft(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", h);
      const w = new MutationObserver(b);
      return s && w.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", h), w.disconnect();
      };
    }
  }, [r, s, y.paused]), c.useEffect(() => {
    if (s) {
      sl.add(y);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const b = new CustomEvent(pa, al);
        s.addEventListener(pa, u), s.dispatchEvent(b), b.defaultPrevented || (Gw(Xw(nf(s)), { select: !0 }), document.activeElement === m && Ft(s));
      }
      return () => {
        s.removeEventListener(pa, u), setTimeout(() => {
          const b = new CustomEvent(ma, al);
          s.addEventListener(ma, d), s.dispatchEvent(b), b.defaultPrevented || Ft(m ?? document.body, { select: !0 }), s.removeEventListener(ma, d), sl.remove(y);
        }, 0);
      };
    }
  }, [s, u, d, y]);
  const g = c.useCallback(
    (m) => {
      if (!n && !r || y.paused)
        return;
      const h = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, b = document.activeElement;
      if (h && b) {
        const w = m.currentTarget, [C, E] = Kw(w);
        C && E ? !m.shiftKey && b === E ? (m.preventDefault(), n && Ft(C, { select: !0 })) : m.shiftKey && b === C && (m.preventDefault(), n && Ft(E, { select: !0 })) : b === w && m.preventDefault();
      }
    },
    [n, r, y.paused]
  );
  return /* @__PURE__ */ f(G.div, { tabIndex: -1, ...i, ref: v, onKeyDown: g });
});
tf.displayName = Vw;
function Gw(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Ft(r, { select: t }), document.activeElement !== n)
      return;
}
function Kw(e) {
  const t = nf(e), n = il(t, e), r = il(t.reverse(), e);
  return [n, r];
}
function nf(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function il(e, t) {
  for (const n of e)
    if (!Yw(n, { upTo: t }))
      return n;
}
function Yw(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function zw(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ft(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && zw(e) && t && e.select();
  }
}
var sl = qw();
function qw() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = cl(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = cl(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function cl(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Xw(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Zw = "Portal", rf = c.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [o, a] = c.useState(!1);
  mt(() => a(!0), []);
  const i = n || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? Er.createPortal(/* @__PURE__ */ f(G.div, { ...r, ref: t }), i) : null;
});
rf.displayName = Zw;
var of = rs(), va = function() {
}, ko = c.forwardRef(function(e, t) {
  var n = c.useRef(null), r = c.useState({
    onScrollCapture: va,
    onWheelCapture: va,
    onTouchMoveCapture: va
  }), o = r[0], a = r[1], i = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, d = e.enabled, p = e.shards, v = e.sideCar, y = e.noIsolation, g = e.inert, m = e.allowPinchZoom, h = e.as, b = h === void 0 ? "div" : h, w = e.gapMode, C = os(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = v, P = as([n, t]), x = Ie(Ie({}, C), o);
  return c.createElement(
    c.Fragment,
    null,
    d && c.createElement(E, { sideCar: of, removeScrollBar: u, shards: p, noIsolation: y, inert: g, setCallbacks: a, allowPinchZoom: !!m, lockRef: n, gapMode: w }),
    i ? c.cloneElement(c.Children.only(s), Ie(Ie({}, x), { ref: P })) : c.createElement(b, Ie({}, x, { className: l, ref: P }), s)
  );
});
ko.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ko.classNames = {
  fullWidth: is,
  zeroRight: ss
};
var ei = !1;
if (typeof window < "u")
  try {
    var Lr = Object.defineProperty({}, "passive", {
      get: function() {
        return ei = !0, !0;
      }
    });
    window.addEventListener("test", Lr, Lr), window.removeEventListener("test", Lr, Lr);
  } catch {
    ei = !1;
  }
var gn = ei ? { passive: !1 } : !1, Qw = function(e) {
  return e.tagName === "TEXTAREA";
}, af = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Qw(e) && n[t] === "visible")
  );
}, Jw = function(e) {
  return af(e, "overflowY");
}, e0 = function(e) {
  return af(e, "overflowX");
}, ll = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = sf(e, r);
    if (o) {
      var a = cf(e, r), i = a[1], s = a[2];
      if (i > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, t0 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, n0 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, sf = function(e, t) {
  return e === "v" ? Jw(t) : e0(t);
}, cf = function(e, t) {
  return e === "v" ? t0(t) : n0(t);
}, r0 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, o0 = function(e, t, n, r, o) {
  var a = r0(e, window.getComputedStyle(t).direction), i = a * r, s = n.target, l = t.contains(s), u = !1, d = i > 0, p = 0, v = 0;
  do {
    var y = cf(e, s), g = y[0], m = y[1], h = y[2], b = m - h - a * g;
    (g || b) && sf(e, s) && (p += b, v += g), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (d && (o && Math.abs(p) < 1 || !o && i > p) || !d && (o && Math.abs(v) < 1 || !o && -i > v)) && (u = !0), u;
}, Fr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ul = function(e) {
  return [e.deltaX, e.deltaY];
}, dl = function(e) {
  return e && "current" in e ? e.current : e;
}, a0 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, i0 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, s0 = 0, bn = [];
function c0(e) {
  var t = c.useRef([]), n = c.useRef([0, 0]), r = c.useRef(), o = c.useState(s0++)[0], a = c.useState(cs)[0], i = c.useRef(e);
  c.useEffect(function() {
    i.current = e;
  }, [e]), c.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var m = ls([e.lockRef.current], (e.shards || []).map(dl), !0).filter(Boolean);
      return m.forEach(function(h) {
        return h.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), m.forEach(function(h) {
          return h.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = c.useCallback(function(m, h) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !i.current.allowPinchZoom;
    var b = Fr(m), w = n.current, C = "deltaX" in m ? m.deltaX : w[0] - b[0], E = "deltaY" in m ? m.deltaY : w[1] - b[1], P, x = m.target, S = Math.abs(C) > Math.abs(E) ? "h" : "v";
    if ("touches" in m && S === "h" && x.type === "range")
      return !1;
    var _ = ll(S, x);
    if (!_)
      return !0;
    if (_ ? P = S : (P = S === "v" ? "h" : "v", _ = ll(S, x)), !_)
      return !1;
    if (!r.current && "changedTouches" in m && (C || E) && (r.current = P), !P)
      return !0;
    var T = r.current || P;
    return o0(T, h, m, T === "h" ? C : E, !0);
  }, []), l = c.useCallback(function(m) {
    var h = m;
    if (!(!bn.length || bn[bn.length - 1] !== a)) {
      var b = "deltaY" in h ? ul(h) : Fr(h), w = t.current.filter(function(P) {
        return P.name === h.type && (P.target === h.target || h.target === P.shadowParent) && a0(P.delta, b);
      })[0];
      if (w && w.should) {
        h.cancelable && h.preventDefault();
        return;
      }
      if (!w) {
        var C = (i.current.shards || []).map(dl).filter(Boolean).filter(function(P) {
          return P.contains(h.target);
        }), E = C.length > 0 ? s(h, C[0]) : !i.current.noIsolation;
        E && h.cancelable && h.preventDefault();
      }
    }
  }, []), u = c.useCallback(function(m, h, b, w) {
    var C = { name: m, delta: h, target: b, should: w, shadowParent: l0(b) };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(E) {
        return E !== C;
      });
    }, 1);
  }, []), d = c.useCallback(function(m) {
    n.current = Fr(m), r.current = void 0;
  }, []), p = c.useCallback(function(m) {
    u(m.type, ul(m), m.target, s(m, e.lockRef.current));
  }, []), v = c.useCallback(function(m) {
    u(m.type, Fr(m), m.target, s(m, e.lockRef.current));
  }, []);
  c.useEffect(function() {
    return bn.push(a), e.setCallbacks({
      onScrollCapture: p,
      onWheelCapture: p,
      onTouchMoveCapture: v
    }), document.addEventListener("wheel", l, gn), document.addEventListener("touchmove", l, gn), document.addEventListener("touchstart", d, gn), function() {
      bn = bn.filter(function(m) {
        return m !== a;
      }), document.removeEventListener("wheel", l, gn), document.removeEventListener("touchmove", l, gn), document.removeEventListener("touchstart", d, gn);
    };
  }, []);
  var y = e.removeScrollBar, g = e.inert;
  return c.createElement(
    c.Fragment,
    null,
    g ? c.createElement(a, { styles: i0(o) }) : null,
    y ? c.createElement(us, { gapMode: e.gapMode }) : null
  );
}
function l0(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const u0 = ds(of, c0);
var lf = c.forwardRef(function(e, t) {
  return c.createElement(ko, Ie({}, e, { ref: t, sideCar: u0 }));
});
lf.classNames = ko.classNames;
const d0 = lf;
var _s = "Dialog", [uf, df] = Re(_s), [f0, gt] = uf(_s), ff = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: i = !0
  } = e, s = c.useRef(null), l = c.useRef(null), [u = !1, d] = Me({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ f(
    f0,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: ze(),
      titleId: ze(),
      descriptionId: ze(),
      open: u,
      onOpenChange: d,
      onOpenToggle: c.useCallback(() => d((p) => !p), [d]),
      modal: i,
      children: n
    }
  );
};
ff.displayName = _s;
var pf = "DialogTrigger", mf = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = gt(pf, n), a = ne(t, o.triggerRef);
    return /* @__PURE__ */ f(
      G.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Rs(o.open),
        ...r,
        ref: a,
        onClick: I(e.onClick, o.onOpenToggle)
      }
    );
  }
);
mf.displayName = pf;
var Ts = "DialogPortal", [p0, vf] = uf(Ts, {
  forceMount: void 0
}), hf = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, a = gt(Ts, t);
  return /* @__PURE__ */ f(p0, { scope: t, forceMount: n, children: c.Children.map(r, (i) => /* @__PURE__ */ f(Fe, { present: n || a.open, children: /* @__PURE__ */ f(rf, { asChild: !0, container: o, children: i }) })) });
};
hf.displayName = Ts;
var so = "DialogOverlay", gf = c.forwardRef(
  (e, t) => {
    const n = vf(so, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = gt(so, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ f(Fe, { present: r || a.open, children: /* @__PURE__ */ f(m0, { ...o, ref: t }) }) : null;
  }
);
gf.displayName = so;
var m0 = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = gt(so, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ f(d0, { as: Tn, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ f(
        G.div,
        {
          "data-state": Rs(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), on = "DialogContent", bf = c.forwardRef(
  (e, t) => {
    const n = vf(on, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = gt(on, e.__scopeDialog);
    return /* @__PURE__ */ f(Fe, { present: r || a.open, children: a.modal ? /* @__PURE__ */ f(v0, { ...o, ref: t }) : /* @__PURE__ */ f(h0, { ...o, ref: t }) });
  }
);
bf.displayName = on;
var v0 = c.forwardRef(
  (e, t) => {
    const n = gt(on, e.__scopeDialog), r = c.useRef(null), o = ne(t, n.contentRef, r);
    return c.useEffect(() => {
      const a = r.current;
      if (a)
        return fs(a);
    }, []), /* @__PURE__ */ f(
      yf,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: I(e.onCloseAutoFocus, (a) => {
          var i;
          a.preventDefault(), (i = n.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: I(e.onPointerDownOutside, (a) => {
          const i = a.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && a.preventDefault();
        }),
        onFocusOutside: I(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), h0 = c.forwardRef(
  (e, t) => {
    const n = gt(on, e.__scopeDialog), r = c.useRef(!1), o = c.useRef(!1);
    return /* @__PURE__ */ f(
      yf,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const i = a.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), yf = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...i } = e, s = gt(on, n), l = c.useRef(null), u = ne(t, l);
    return Ed(), /* @__PURE__ */ X(Oe, { children: [
      /* @__PURE__ */ f(
        tf,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ f(
            Jd,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Rs(s.open),
              ...i,
              ref: u,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ X(Oe, { children: [
        /* @__PURE__ */ f(b0, { titleId: s.titleId }),
        /* @__PURE__ */ f(w0, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Ns = "DialogTitle", wf = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = gt(Ns, n);
    return /* @__PURE__ */ f(G.h2, { id: o.titleId, ...r, ref: t });
  }
);
wf.displayName = Ns;
var Cf = "DialogDescription", Ef = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = gt(Cf, n);
    return /* @__PURE__ */ f(G.p, { id: o.descriptionId, ...r, ref: t });
  }
);
Ef.displayName = Cf;
var Sf = "DialogClose", Pf = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = gt(Sf, n);
    return /* @__PURE__ */ f(
      G.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: I(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Pf.displayName = Sf;
function Rs(e) {
  return e ? "open" : "closed";
}
var xf = "DialogTitleWarning", [g0, _f] = Jy(xf, {
  contentName: on,
  titleName: Ns,
  docsSlug: "dialog"
}), b0 = ({ titleId: e }) => {
  const t = _f(xf), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return c.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, y0 = "DialogDescriptionWarning", w0 = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${_f(y0).contentName}}.`;
  return c.useEffect(() => {
    var a;
    const o = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, C0 = ff, E0 = mf, S0 = hf, P0 = gf, x0 = bf, _0 = wf, T0 = Ef, Tf = Pf, Nf = "AlertDialog", [N0, N8] = Re(Nf, [
  df
]), At = df(), Rf = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = At(t);
  return /* @__PURE__ */ f(C0, { ...r, ...n, modal: !0 });
};
Rf.displayName = Nf;
var R0 = "AlertDialogTrigger", $f = c.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = At(n);
    return /* @__PURE__ */ f(E0, { ...o, ...r, ref: t });
  }
);
$f.displayName = R0;
var $0 = "AlertDialogPortal", Of = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = At(t);
  return /* @__PURE__ */ f(S0, { ...r, ...n });
};
Of.displayName = $0;
var O0 = "AlertDialogOverlay", Mf = c.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = At(n);
    return /* @__PURE__ */ f(P0, { ...o, ...r, ref: t });
  }
);
Mf.displayName = O0;
var xn = "AlertDialogContent", [M0, D0] = N0(xn), Df = c.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, children: r, ...o } = e, a = At(n), i = c.useRef(null), s = ne(t, i), l = c.useRef(null);
    return /* @__PURE__ */ f(
      g0,
      {
        contentName: xn,
        titleName: Af,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ f(M0, { scope: n, cancelRef: l, children: /* @__PURE__ */ X(
          x0,
          {
            role: "alertdialog",
            ...a,
            ...o,
            ref: s,
            onOpenAutoFocus: I(o.onOpenAutoFocus, (u) => {
              var d;
              u.preventDefault(), (d = l.current) == null || d.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (u) => u.preventDefault(),
            onInteractOutside: (u) => u.preventDefault(),
            children: [
              /* @__PURE__ */ f(ew, { children: r }),
              /* @__PURE__ */ f(I0, { contentRef: i })
            ]
          }
        ) })
      }
    );
  }
);
Df.displayName = xn;
var Af = "AlertDialogTitle", If = c.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = At(n);
    return /* @__PURE__ */ f(_0, { ...o, ...r, ref: t });
  }
);
If.displayName = Af;
var kf = "AlertDialogDescription", Lf = c.forwardRef((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = At(n);
  return /* @__PURE__ */ f(T0, { ...o, ...r, ref: t });
});
Lf.displayName = kf;
var A0 = "AlertDialogAction", Ff = c.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = At(n);
    return /* @__PURE__ */ f(Tf, { ...o, ...r, ref: t });
  }
);
Ff.displayName = A0;
var Bf = "AlertDialogCancel", Wf = c.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, { cancelRef: o } = D0(Bf, n), a = At(n), i = ne(t, o);
    return /* @__PURE__ */ f(Tf, { ...a, ...r, ref: i });
  }
);
Wf.displayName = Bf;
var I0 = ({ contentRef: e }) => {
  const t = `\`${xn}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${xn}\` by passing a \`${kf}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${xn}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return c.useEffect(() => {
    var r;
    document.getElementById(
      (r = e.current) == null ? void 0 : r.getAttribute("aria-describedby")
    ) || console.warn(t);
  }, [t, e]), null;
}, k0 = Rf, L0 = $f, F0 = Of, jf = Mf, Hf = Df, Uf = Ff, Vf = Wf, Gf = If, Kf = Lf;
const R8 = k0, $8 = L0, B0 = F0, Yf = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  jf,
  {
    className: $(
      "fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
Yf.displayName = jf.displayName;
const W0 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ X(B0, { children: [
  /* @__PURE__ */ f(Yf, {}),
  /* @__PURE__ */ f(
    Hf,
    {
      ref: n,
      className: $(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...t
    }
  )
] }));
W0.displayName = Hf.displayName;
const j0 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ f(
  "div",
  {
    className: $(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
j0.displayName = "AlertDialogHeader";
const H0 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ f(
  "div",
  {
    className: $(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
H0.displayName = "AlertDialogFooter";
const U0 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Gf,
  {
    ref: n,
    className: $("text-lg font-semibold", e),
    ...t
  }
));
U0.displayName = Gf.displayName;
const V0 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Kf,
  {
    ref: n,
    className: $("text-sm text-muted-foreground", e),
    ...t
  }
));
V0.displayName = Kf.displayName;
const G0 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Uf,
  {
    ref: n,
    className: $(or(), e),
    ...t
  }
));
G0.displayName = Uf.displayName;
const K0 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Vf,
  {
    ref: n,
    className: $(
      or({ variant: "outline" }),
      "mt-2 sm:mt-0",
      e
    ),
    ...t
  }
));
K0.displayName = Vf.displayName;
const Y0 = An(
  "relative w-full rounded-lg border px-4 py-3 text-sm [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), z0 = c.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ f(
  "div",
  {
    ref: r,
    role: "alert",
    className: $(Y0({ variant: t }), e),
    ...n
  }
));
z0.displayName = "Alert";
const q0 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "h5",
  {
    ref: n,
    className: $("mb-1 font-medium leading-none tracking-tight", e),
    ...t
  }
));
q0.displayName = "AlertTitle";
const X0 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "div",
  {
    ref: n,
    className: $("text-sm [&_p]:leading-relaxed", e),
    ...t
  }
));
X0.displayName = "AlertDescription";
var Z0 = "AspectRatio", zf = c.forwardRef(
  (e, t) => {
    const { ratio: n = 1 / 1, style: r, ...o } = e;
    return /* @__PURE__ */ f(
      "div",
      {
        style: {
          // ensures inner element is contained
          position: "relative",
          // ensures padding bottom trick maths works
          width: "100%",
          paddingBottom: `${100 / n}%`
        },
        "data-radix-aspect-ratio-wrapper": "",
        children: /* @__PURE__ */ f(
          G.div,
          {
            ...o,
            ref: t,
            style: {
              ...r,
              // ensures children expand in ratio
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            }
          }
        )
      }
    );
  }
);
zf.displayName = Z0;
var Q0 = zf;
const O8 = Q0, J0 = An(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function M8({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ f("div", { className: $(J0({ variant: t }), e), ...n });
}
const eC = c.forwardRef(({ ...e }, t) => /* @__PURE__ */ f("nav", { ref: t, "aria-label": "breadcrumb", ...e }));
eC.displayName = "Breadcrumb";
const tC = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "ol",
  {
    ref: n,
    className: $(
      "flex flex-wrap items-center gap-1.5 break-words text-sm text-muted-foreground sm:gap-2.5",
      e
    ),
    ...t
  }
));
tC.displayName = "BreadcrumbList";
const nC = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "li",
  {
    ref: n,
    className: $("inline-flex items-center gap-1.5", e),
    ...t
  }
));
nC.displayName = "BreadcrumbItem";
const rC = c.forwardRef(({ asChild: e, className: t, ...n }, r) => /* @__PURE__ */ f(
  e ? Tn : "a",
  {
    ref: r,
    className: $("transition-colors hover:text-foreground", t),
    ...n
  }
));
rC.displayName = "BreadcrumbLink";
const oC = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "span",
  {
    ref: n,
    role: "link",
    "aria-disabled": "true",
    "aria-current": "page",
    className: $("font-normal text-foreground", e),
    ...t
  }
));
oC.displayName = "BreadcrumbPage";
const aC = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ f(
  "li",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: $("[&>svg]:w-3.5 [&>svg]:h-3.5", t),
    ...n,
    children: e ?? /* @__PURE__ */ f(Sr, {})
  }
);
aC.displayName = "BreadcrumbSeparator";
const iC = ({
  className: e,
  ...t
}) => /* @__PURE__ */ X(
  "span",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: $("flex h-9 w-9 items-center justify-center", e),
    ...t,
    children: [
      /* @__PURE__ */ f(Od, { className: "h-4 w-4" }),
      /* @__PURE__ */ f("span", { className: "sr-only", children: "More" })
    ]
  }
);
iC.displayName = "BreadcrumbElipssis";
function ue(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function et(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Ue(e, t) {
  const n = ue(e);
  return isNaN(t) ? et(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function vt(e, t) {
  const n = ue(e);
  if (isNaN(t))
    return et(e, NaN);
  if (!t)
    return n;
  const r = n.getDate(), o = et(e, n.getTime());
  o.setMonth(n.getMonth() + t + 1, 0);
  const a = o.getDate();
  return r >= a ? o : (n.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    r
  ), n);
}
const $s = 6048e5, sC = 864e5;
let cC = {};
function Pr() {
  return cC;
}
function xt(e, t) {
  var s, l, u, d;
  const n = Pr(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((d = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, o = ue(e), a = o.getDay(), i = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - i), o.setHours(0, 0, 0, 0), o;
}
function an(e) {
  return xt(e, { weekStartsOn: 1 });
}
function qf(e) {
  const t = ue(e), n = t.getFullYear(), r = et(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = an(r), a = et(e, 0);
  a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0);
  const i = an(a);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function Nn(e) {
  const t = ue(e);
  return t.setHours(0, 0, 0, 0), t;
}
function co(e) {
  const t = ue(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function St(e, t) {
  const n = Nn(e), r = Nn(t), o = +n - co(n), a = +r - co(r);
  return Math.round((o - a) / sC);
}
function lC(e) {
  const t = qf(e), n = et(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), an(n);
}
function ti(e, t) {
  const n = t * 7;
  return Ue(e, n);
}
function uC(e, t) {
  return vt(e, t * 12);
}
function dC(e) {
  let t;
  return e.forEach(function(n) {
    const r = ue(n);
    (t === void 0 || t < r || isNaN(Number(r))) && (t = r);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function fC(e) {
  let t;
  return e.forEach((n) => {
    const r = ue(n);
    (!t || t > r || isNaN(+r)) && (t = r);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function Ye(e, t) {
  const n = Nn(e), r = Nn(t);
  return +n == +r;
}
function Os(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function pC(e) {
  if (!Os(e) && typeof e != "number")
    return !1;
  const t = ue(e);
  return !isNaN(Number(t));
}
function ar(e, t) {
  const n = ue(e), r = ue(t), o = n.getFullYear() - r.getFullYear(), a = n.getMonth() - r.getMonth();
  return o * 12 + a;
}
function mC(e, t, n) {
  const r = xt(e, n), o = xt(t, n), a = +r - co(r), i = +o - co(o);
  return Math.round((a - i) / $s);
}
function Ms(e) {
  const t = ue(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function qe(e) {
  const t = ue(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Xf(e) {
  const t = ue(e), n = et(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Ds(e, t) {
  var s, l, u, d;
  const n = Pr(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((d = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, o = ue(e), a = o.getDay(), i = (a < r ? -7 : 0) + 6 - (a - r);
  return o.setDate(o.getDate() + i), o.setHours(23, 59, 59, 999), o;
}
function Zf(e) {
  return Ds(e, { weekStartsOn: 1 });
}
const vC = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, hC = (e, t, n) => {
  let r;
  const o = vC[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function ha(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const gC = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, bC = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, yC = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, wC = {
  date: ha({
    formats: gC,
    defaultWidth: "full"
  }),
  time: ha({
    formats: bC,
    defaultWidth: "full"
  }),
  dateTime: ha({
    formats: yC,
    defaultWidth: "full"
  })
}, CC = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, EC = (e, t, n, r) => CC[e];
function Gn(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : i;
      o = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[i];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[a];
  };
}
const SC = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, PC = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, xC = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, _C = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, TC = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, NC = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, RC = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, $C = {
  ordinalNumber: RC,
  era: Gn({
    values: SC,
    defaultWidth: "wide"
  }),
  quarter: Gn({
    values: PC,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Gn({
    values: xC,
    defaultWidth: "wide"
  }),
  day: Gn({
    values: _C,
    defaultWidth: "wide"
  }),
  dayPeriod: Gn({
    values: TC,
    defaultWidth: "wide",
    formattingValues: NC,
    defaultFormattingWidth: "wide"
  })
};
function Kn(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    const i = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? MC(s, (p) => p.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      OC(s, (p) => p.test(i))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(l) : l, u = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(u)
    ) : u;
    const d = t.slice(i.length);
    return { value: u, rest: d };
  };
}
function OC(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function MC(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function DC(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r)
      return null;
    const o = r[0], a = t.match(e.parsePattern);
    if (!a)
      return null;
    let i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const s = t.slice(o.length);
    return { value: i, rest: s };
  };
}
const AC = /^(\d+)(th|st|nd|rd)?/i, IC = /\d+/i, kC = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, LC = {
  any: [/^b/i, /^(a|c)/i]
}, FC = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, BC = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, WC = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, jC = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, HC = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, UC = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, VC = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, GC = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, KC = {
  ordinalNumber: DC({
    matchPattern: AC,
    parsePattern: IC,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Kn({
    matchPatterns: kC,
    defaultMatchWidth: "wide",
    parsePatterns: LC,
    defaultParseWidth: "any"
  }),
  quarter: Kn({
    matchPatterns: FC,
    defaultMatchWidth: "wide",
    parsePatterns: BC,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Kn({
    matchPatterns: WC,
    defaultMatchWidth: "wide",
    parsePatterns: jC,
    defaultParseWidth: "any"
  }),
  day: Kn({
    matchPatterns: HC,
    defaultMatchWidth: "wide",
    parsePatterns: UC,
    defaultParseWidth: "any"
  }),
  dayPeriod: Kn({
    matchPatterns: VC,
    defaultMatchWidth: "any",
    parsePatterns: GC,
    defaultParseWidth: "any"
  })
}, Qf = {
  code: "en-US",
  formatDistance: hC,
  formatLong: wC,
  formatRelative: EC,
  localize: $C,
  match: KC,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function YC(e) {
  const t = ue(e);
  return St(t, Xf(t)) + 1;
}
function Jf(e) {
  const t = ue(e), n = +an(t) - +lC(t);
  return Math.round(n / $s) + 1;
}
function ep(e, t) {
  var d, p, v, y;
  const n = ue(e), r = n.getFullYear(), o = Pr(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((p = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : p.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((y = (v = o.locale) == null ? void 0 : v.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, i = et(e, 0);
  i.setFullYear(r + 1, 0, a), i.setHours(0, 0, 0, 0);
  const s = xt(i, t), l = et(e, 0);
  l.setFullYear(r, 0, a), l.setHours(0, 0, 0, 0);
  const u = xt(l, t);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= u.getTime() ? r : r - 1;
}
function zC(e, t) {
  var s, l, u, d;
  const n = Pr(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((d = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, o = ep(e, t), a = et(e, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), xt(a, t);
}
function tp(e, t) {
  const n = ue(e), r = +xt(n, t) - +zC(n, t);
  return Math.round(r / $s) + 1;
}
function be(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Lt = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return be(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : be(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return be(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return be(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return be(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return be(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return be(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return be(o, t.length);
  }
}, yn = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, fl = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return Lt.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = ep(e, r), a = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const i = a % 100;
      return be(i, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : be(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = qf(e);
    return be(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return be(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return be(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return be(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Lt.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return be(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = tp(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : be(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Jf(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : be(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Lt.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = YC(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : be(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(a);
      case "ee":
        return be(a, 2);
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(a);
      case "cc":
        return be(a, t.length);
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return be(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = yn.noon : r === 0 ? o = yn.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = yn.evening : r >= 12 ? o = yn.afternoon : r >= 4 ? o = yn.morning : o = yn.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Lt.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Lt.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : be(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : be(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Lt.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Lt.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Lt.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return ml(r);
      case "XXXX":
      case "XX":
        return Qt(r);
      case "XXXXX":
      case "XXX":
      default:
        return Qt(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return ml(r);
      case "xxxx":
      case "xx":
        return Qt(r);
      case "xxxxx":
      case "xxx":
      default:
        return Qt(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + pl(r, ":");
      case "OOOO":
      default:
        return "GMT" + Qt(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + pl(r, ":");
      case "zzzz":
      default:
        return "GMT" + Qt(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return be(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return be(r, t.length);
  }
};
function pl(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(o) : n + String(o) + t + be(a, 2);
}
function ml(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + be(Math.abs(e) / 60, 2) : Qt(e, t);
}
function Qt(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = be(Math.trunc(r / 60), 2), a = be(r % 60, 2);
  return n + o + t + a;
}
const vl = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, np = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, qC = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return vl(e, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", vl(r, t)).replace("{{time}}", np(o, t));
}, XC = {
  p: np,
  P: qC
}, ZC = /^D+$/, QC = /^Y+$/, JC = ["D", "DD", "YY", "YYYY"];
function eE(e) {
  return ZC.test(e);
}
function tE(e) {
  return QC.test(e);
}
function nE(e, t, n) {
  const r = rE(e, t, n);
  if (console.warn(r), JC.includes(e))
    throw new RangeError(r);
}
function rE(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const oE = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, aE = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, iE = /^'([^]*?)'?$/, sE = /''/g, cE = /[a-zA-Z]/;
function dn(e, t, n) {
  var d, p, v, y, g, m, h, b;
  const r = Pr(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? Qf, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((p = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : p.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((y = (v = r.locale) == null ? void 0 : v.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, i = (n == null ? void 0 : n.weekStartsOn) ?? ((m = (g = n == null ? void 0 : n.locale) == null ? void 0 : g.options) == null ? void 0 : m.weekStartsOn) ?? r.weekStartsOn ?? ((b = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : b.weekStartsOn) ?? 0, s = ue(e);
  if (!pC(s))
    throw new RangeError("Invalid time value");
  let l = t.match(aE).map((w) => {
    const C = w[0];
    if (C === "p" || C === "P") {
      const E = XC[C];
      return E(w, o.formatLong);
    }
    return w;
  }).join("").match(oE).map((w) => {
    if (w === "''")
      return { isToken: !1, value: "'" };
    const C = w[0];
    if (C === "'")
      return { isToken: !1, value: lE(w) };
    if (fl[C])
      return { isToken: !0, value: w };
    if (C.match(cE))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + C + "`"
      );
    return { isToken: !1, value: w };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const u = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: o
  };
  return l.map((w) => {
    if (!w.isToken)
      return w.value;
    const C = w.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && tE(C) || !(n != null && n.useAdditionalDayOfYearTokens) && eE(C)) && nE(C, t, String(e));
    const E = fl[C[0]];
    return E(s, C, o.localize, u);
  }).join("");
}
function lE(e) {
  const t = e.match(iE);
  return t ? t[1].replace(sE, "'") : e;
}
function uE(e) {
  const t = ue(e), n = t.getFullYear(), r = t.getMonth(), o = et(e, 0);
  return o.setFullYear(n, r + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function dE(e) {
  return Math.trunc(+ue(e) / 1e3);
}
function fE(e) {
  const t = ue(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function pE(e, t) {
  return mC(
    fE(e),
    qe(e),
    t
  ) + 1;
}
function ni(e, t) {
  const n = ue(e), r = ue(t);
  return n.getTime() > r.getTime();
}
function rp(e, t) {
  const n = ue(e), r = ue(t);
  return +n < +r;
}
function As(e, t) {
  const n = ue(e), r = ue(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function mE(e, t) {
  const n = ue(e), r = ue(t);
  return n.getFullYear() === r.getFullYear();
}
function ga(e, t) {
  return Ue(e, -t);
}
function ba(e, t) {
  const n = ue(e), r = n.getFullYear(), o = n.getDate(), a = et(e, 0);
  a.setFullYear(r, t, 15), a.setHours(0, 0, 0, 0);
  const i = uE(a);
  return n.setMonth(t, Math.min(o, i)), n;
}
function hl(e, t) {
  const n = ue(e);
  return isNaN(+n) ? et(e, NaN) : (n.setFullYear(t), n);
}
var te = function() {
  return te = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, te.apply(this, arguments);
};
function vE(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function op(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, a; r < o; r++)
      (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function xr(e) {
  return e.mode === "multiple";
}
function _r(e) {
  return e.mode === "range";
}
function Lo(e) {
  return e.mode === "single";
}
var hE = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function gE(e, t) {
  return dn(e, "LLLL y", t);
}
function bE(e, t) {
  return dn(e, "d", t);
}
function yE(e, t) {
  return dn(e, "LLLL", t);
}
function wE(e) {
  return "".concat(e);
}
function CE(e, t) {
  return dn(e, "cccccc", t);
}
function EE(e, t) {
  return dn(e, "yyyy", t);
}
var SE = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: gE,
  formatDay: bE,
  formatMonthCaption: yE,
  formatWeekNumber: wE,
  formatWeekdayName: CE,
  formatYearCaption: EE
}), PE = function(e, t, n) {
  return dn(e, "do MMMM (EEEE)", n);
}, xE = function() {
  return "Month: ";
}, _E = function() {
  return "Go to next month";
}, TE = function() {
  return "Go to previous month";
}, NE = function(e, t) {
  return dn(e, "cccc", t);
}, RE = function(e) {
  return "Week n. ".concat(e);
}, $E = function() {
  return "Year: ";
}, OE = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: PE,
  labelMonthDropdown: xE,
  labelNext: _E,
  labelPrevious: TE,
  labelWeekNumber: RE,
  labelWeekday: NE,
  labelYearDropdown: $E
});
function ME() {
  var e = "buttons", t = hE, n = Qf, r = {}, o = {}, a = 1, i = {}, s = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: SE,
    labels: OE,
    locale: n,
    modifiersClassNames: r,
    modifiers: o,
    numberOfMonths: a,
    styles: i,
    today: s,
    mode: "default"
  };
}
function DE(e) {
  var t = e.fromYear, n = e.toYear, r = e.fromMonth, o = e.toMonth, a = e.fromDate, i = e.toDate;
  return r ? a = qe(r) : t && (a = new Date(t, 0, 1)), o ? i = Ms(o) : n && (i = new Date(n, 11, 31)), {
    fromDate: a ? Nn(a) : void 0,
    toDate: i ? Nn(i) : void 0
  };
}
var ap = Pt(void 0);
function AE(e) {
  var t, n = e.initialProps, r = ME(), o = DE(n), a = o.fromDate, i = o.toDate, s = (t = n.captionLayout) !== null && t !== void 0 ? t : r.captionLayout;
  s !== "buttons" && (!a || !i) && (s = "buttons");
  var l;
  (Lo(n) || xr(n) || _r(n)) && (l = n.onSelect);
  var u = te(te(te({}, r), n), { captionLayout: s, classNames: te(te({}, r.classNames), n.classNames), components: te({}, n.components), formatters: te(te({}, r.formatters), n.formatters), fromDate: a, labels: te(te({}, r.labels), n.labels), mode: n.mode || r.mode, modifiers: te(te({}, r.modifiers), n.modifiers), modifiersClassNames: te(te({}, r.modifiersClassNames), n.modifiersClassNames), onSelect: l, styles: te(te({}, r.styles), n.styles), toDate: i });
  return f(ap.Provider, { value: u, children: e.children });
}
function we() {
  var e = Mt(ap);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function ip(e) {
  var t = we(), n = t.locale, r = t.classNames, o = t.styles, a = t.formatters.formatCaption;
  return f("div", { className: r.caption_label, style: o.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: a(e.displayMonth, { locale: n }) });
}
function IE(e) {
  return f("svg", te({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: f("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function sp(e) {
  var t, n, r = e.onChange, o = e.value, a = e.children, i = e.caption, s = e.className, l = e.style, u = we(), d = (n = (t = u.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && n !== void 0 ? n : IE;
  return X("div", { className: s, style: l, children: [f("span", { className: u.classNames.vhidden, children: e["aria-label"] }), f("select", { name: e.name, "aria-label": e["aria-label"], className: u.classNames.dropdown, style: u.styles.dropdown, value: o, onChange: r, children: a }), X("div", { className: u.classNames.caption_label, style: u.styles.caption_label, "aria-hidden": "true", children: [i, f(d, { className: u.classNames.dropdown_icon, style: u.styles.dropdown_icon })] })] });
}
function kE(e) {
  var t, n = we(), r = n.fromDate, o = n.toDate, a = n.styles, i = n.locale, s = n.formatters.formatMonthCaption, l = n.classNames, u = n.components, d = n.labels.labelMonthDropdown;
  if (!r)
    return f(Oe, {});
  if (!o)
    return f(Oe, {});
  var p = [];
  if (mE(r, o))
    for (var v = qe(r), y = r.getMonth(); y <= o.getMonth(); y++)
      p.push(ba(v, y));
  else
    for (var v = qe(/* @__PURE__ */ new Date()), y = 0; y <= 11; y++)
      p.push(ba(v, y));
  var g = function(h) {
    var b = Number(h.target.value), w = ba(qe(e.displayMonth), b);
    e.onChange(w);
  }, m = (t = u == null ? void 0 : u.Dropdown) !== null && t !== void 0 ? t : sp;
  return f(m, { name: "months", "aria-label": d(), className: l.dropdown_month, style: a.dropdown_month, onChange: g, value: e.displayMonth.getMonth(), caption: s(e.displayMonth, { locale: i }), children: p.map(function(h) {
    return f("option", { value: h.getMonth(), children: s(h, { locale: i }) }, h.getMonth());
  }) });
}
function LE(e) {
  var t, n = e.displayMonth, r = we(), o = r.fromDate, a = r.toDate, i = r.locale, s = r.styles, l = r.classNames, u = r.components, d = r.formatters.formatYearCaption, p = r.labels.labelYearDropdown, v = [];
  if (!o)
    return f(Oe, {});
  if (!a)
    return f(Oe, {});
  for (var y = o.getFullYear(), g = a.getFullYear(), m = y; m <= g; m++)
    v.push(hl(Xf(/* @__PURE__ */ new Date()), m));
  var h = function(w) {
    var C = hl(qe(n), Number(w.target.value));
    e.onChange(C);
  }, b = (t = u == null ? void 0 : u.Dropdown) !== null && t !== void 0 ? t : sp;
  return f(b, { name: "years", "aria-label": p(), className: l.dropdown_year, style: s.dropdown_year, onChange: h, value: n.getFullYear(), caption: d(n, { locale: i }), children: v.map(function(w) {
    return f("option", { value: w.getFullYear(), children: d(w, { locale: i }) }, w.getFullYear());
  }) });
}
function FE(e, t) {
  var n = Je(e), r = n[0], o = n[1], a = t === void 0 ? r : t;
  return [a, o];
}
function BE(e) {
  var t = e.month, n = e.defaultMonth, r = e.today, o = t || n || r || /* @__PURE__ */ new Date(), a = e.toDate, i = e.fromDate, s = e.numberOfMonths, l = s === void 0 ? 1 : s;
  if (a && ar(a, o) < 0) {
    var u = -1 * (l - 1);
    o = vt(a, u);
  }
  return i && ar(o, i) < 0 && (o = i), qe(o);
}
function WE() {
  var e = we(), t = BE(e), n = FE(t, e.month), r = n[0], o = n[1], a = function(i) {
    var s;
    if (!e.disableNavigation) {
      var l = qe(i);
      o(l), (s = e.onMonthChange) === null || s === void 0 || s.call(e, l);
    }
  };
  return [r, a];
}
function jE(e, t) {
  for (var n = t.reverseMonths, r = t.numberOfMonths, o = qe(e), a = qe(vt(o, r)), i = ar(a, o), s = [], l = 0; l < i; l++) {
    var u = vt(o, l);
    s.push(u);
  }
  return n && (s = s.reverse()), s;
}
function HE(e, t) {
  if (!t.disableNavigation) {
    var n = t.toDate, r = t.pagedNavigation, o = t.numberOfMonths, a = o === void 0 ? 1 : o, i = r ? a : 1, s = qe(e);
    if (!n)
      return vt(s, i);
    var l = ar(n, e);
    if (!(l < a))
      return vt(s, i);
  }
}
function UE(e, t) {
  if (!t.disableNavigation) {
    var n = t.fromDate, r = t.pagedNavigation, o = t.numberOfMonths, a = o === void 0 ? 1 : o, i = r ? a : 1, s = qe(e);
    if (!n)
      return vt(s, -i);
    var l = ar(s, n);
    if (!(l <= 0))
      return vt(s, -i);
  }
}
var cp = Pt(void 0);
function VE(e) {
  var t = we(), n = WE(), r = n[0], o = n[1], a = jE(r, t), i = HE(r, t), s = UE(r, t), l = function(p) {
    return a.some(function(v) {
      return As(p, v);
    });
  }, u = function(p, v) {
    l(p) || (v && rp(p, v) ? o(vt(p, 1 + t.numberOfMonths * -1)) : o(p));
  }, d = {
    currentMonth: r,
    displayMonths: a,
    goToMonth: o,
    goToDate: u,
    previousMonth: s,
    nextMonth: i,
    isDateDisplayed: l
  };
  return f(cp.Provider, { value: d, children: e.children });
}
function Tr() {
  var e = Mt(cp);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function gl(e) {
  var t, n = we(), r = n.classNames, o = n.styles, a = n.components, i = Tr().goToMonth, s = function(d) {
    i(vt(d, e.displayIndex ? -e.displayIndex : 0));
  }, l = (t = a == null ? void 0 : a.CaptionLabel) !== null && t !== void 0 ? t : ip, u = f(l, { id: e.id, displayMonth: e.displayMonth });
  return X("div", { className: r.caption_dropdowns, style: o.caption_dropdowns, children: [f("div", { className: r.vhidden, children: u }), f(kE, { onChange: s, displayMonth: e.displayMonth }), f(LE, { onChange: s, displayMonth: e.displayMonth })] });
}
function GE(e) {
  return f("svg", te({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: f("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function KE(e) {
  return f("svg", te({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: f("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var lo = Xe(function(e, t) {
  var n = we(), r = n.classNames, o = n.styles, a = [r.button_reset, r.button];
  e.className && a.push(e.className);
  var i = a.join(" "), s = te(te({}, o.button_reset), o.button);
  return e.style && Object.assign(s, e.style), f("button", te({}, e, { ref: t, type: "button", className: i, style: s }));
});
function YE(e) {
  var t, n, r = we(), o = r.dir, a = r.locale, i = r.classNames, s = r.styles, l = r.labels, u = l.labelPrevious, d = l.labelNext, p = r.components;
  if (!e.nextMonth && !e.previousMonth)
    return f(Oe, {});
  var v = u(e.previousMonth, { locale: a }), y = [
    i.nav_button,
    i.nav_button_previous
  ].join(" "), g = d(e.nextMonth, { locale: a }), m = [
    i.nav_button,
    i.nav_button_next
  ].join(" "), h = (t = p == null ? void 0 : p.IconRight) !== null && t !== void 0 ? t : KE, b = (n = p == null ? void 0 : p.IconLeft) !== null && n !== void 0 ? n : GE;
  return X("div", { className: i.nav, style: s.nav, children: [!e.hidePrevious && f(lo, { name: "previous-month", "aria-label": v, className: y, style: s.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: o === "rtl" ? f(h, { className: i.nav_icon, style: s.nav_icon }) : f(b, { className: i.nav_icon, style: s.nav_icon }) }), !e.hideNext && f(lo, { name: "next-month", "aria-label": g, className: m, style: s.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: o === "rtl" ? f(b, { className: i.nav_icon, style: s.nav_icon }) : f(h, { className: i.nav_icon, style: s.nav_icon }) })] });
}
function bl(e) {
  var t = we().numberOfMonths, n = Tr(), r = n.previousMonth, o = n.nextMonth, a = n.goToMonth, i = n.displayMonths, s = i.findIndex(function(g) {
    return As(e.displayMonth, g);
  }), l = s === 0, u = s === i.length - 1, d = t > 1 && (l || !u), p = t > 1 && (u || !l), v = function() {
    r && a(r);
  }, y = function() {
    o && a(o);
  };
  return f(YE, { displayMonth: e.displayMonth, hideNext: d, hidePrevious: p, nextMonth: o, previousMonth: r, onPreviousClick: v, onNextClick: y });
}
function zE(e) {
  var t, n = we(), r = n.classNames, o = n.disableNavigation, a = n.styles, i = n.captionLayout, s = n.components, l = (t = s == null ? void 0 : s.CaptionLabel) !== null && t !== void 0 ? t : ip, u;
  return o ? u = f(l, { id: e.id, displayMonth: e.displayMonth }) : i === "dropdown" ? u = f(gl, { displayMonth: e.displayMonth, id: e.id }) : i === "dropdown-buttons" ? u = X(Oe, { children: [f(gl, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), f(bl, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : u = X(Oe, { children: [f(l, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), f(bl, { displayMonth: e.displayMonth, id: e.id })] }), f("div", { className: r.caption, style: a.caption, children: u });
}
function qE(e) {
  var t = we(), n = t.footer, r = t.styles, o = t.classNames.tfoot;
  return n ? f("tfoot", { className: o, style: r.tfoot, children: f("tr", { children: f("td", { colSpan: 8, children: n }) }) }) : f(Oe, {});
}
function XE(e, t, n) {
  for (var r = n ? an(/* @__PURE__ */ new Date()) : xt(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), o = [], a = 0; a < 7; a++) {
    var i = Ue(r, a);
    o.push(i);
  }
  return o;
}
function ZE() {
  var e = we(), t = e.classNames, n = e.styles, r = e.showWeekNumber, o = e.locale, a = e.weekStartsOn, i = e.ISOWeek, s = e.formatters.formatWeekdayName, l = e.labels.labelWeekday, u = XE(o, a, i);
  return X("tr", { style: n.head_row, className: t.head_row, children: [r && f("td", { style: n.head_cell, className: t.head_cell }), u.map(function(d, p) {
    return f("th", { scope: "col", className: t.head_cell, style: n.head_cell, "aria-label": l(d, { locale: o }), children: s(d, { locale: o }) }, p);
  })] });
}
function QE() {
  var e, t = we(), n = t.classNames, r = t.styles, o = t.components, a = (e = o == null ? void 0 : o.HeadRow) !== null && e !== void 0 ? e : ZE;
  return f("thead", { style: r.head, className: n.head, children: f(a, {}) });
}
function JE(e) {
  var t = we(), n = t.locale, r = t.formatters.formatDay;
  return f(Oe, { children: r(e.date, { locale: n }) });
}
var Is = Pt(void 0);
function eS(e) {
  if (!xr(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return f(Is.Provider, { value: t, children: e.children });
  }
  return f(tS, { initialProps: e.initialProps, children: e.children });
}
function tS(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = t.min, a = t.max, i = function(u, d, p) {
    var v, y;
    (v = t.onDayClick) === null || v === void 0 || v.call(t, u, d, p);
    var g = !!(d.selected && o && (r == null ? void 0 : r.length) === o);
    if (!g) {
      var m = !!(!d.selected && a && (r == null ? void 0 : r.length) === a);
      if (!m) {
        var h = r ? op([], r, !0) : [];
        if (d.selected) {
          var b = h.findIndex(function(w) {
            return Ye(u, w);
          });
          h.splice(b, 1);
        } else
          h.push(u);
        (y = t.onSelect) === null || y === void 0 || y.call(t, h, u, d, p);
      }
    }
  }, s = {
    disabled: []
  };
  r && s.disabled.push(function(u) {
    var d = a && r.length > a - 1, p = r.some(function(v) {
      return Ye(v, u);
    });
    return !!(d && !p);
  });
  var l = {
    selected: r,
    onDayClick: i,
    modifiers: s
  };
  return f(Is.Provider, { value: l, children: n });
}
function ks() {
  var e = Mt(Is);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function nS(e, t) {
  var n = t || {}, r = n.from, o = n.to;
  return r && o ? Ye(o, e) && Ye(r, e) ? void 0 : Ye(o, e) ? { from: o, to: void 0 } : Ye(r, e) ? void 0 : ni(r, e) ? { from: e, to: o } : { from: r, to: e } : o ? ni(e, o) ? { from: o, to: e } : { from: e, to: o } : r ? rp(e, r) ? { from: e, to: r } : { from: r, to: e } : { from: e, to: void 0 };
}
var Ls = Pt(void 0);
function rS(e) {
  if (!_r(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return f(Ls.Provider, { value: t, children: e.children });
  }
  return f(oS, { initialProps: e.initialProps, children: e.children });
}
function oS(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = r || {}, a = o.from, i = o.to, s = t.min, l = t.max, u = function(y, g, m) {
    var h, b;
    (h = t.onDayClick) === null || h === void 0 || h.call(t, y, g, m);
    var w = nS(y, r);
    (b = t.onSelect) === null || b === void 0 || b.call(t, w, y, g, m);
  }, d = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (a ? (d.range_start = [a], i ? (d.range_end = [i], Ye(a, i) || (d.range_middle = [
    {
      after: a,
      before: i
    }
  ])) : d.range_end = [a]) : i && (d.range_start = [i], d.range_end = [i]), s && (a && !i && d.disabled.push({
    after: ga(a, s - 1),
    before: Ue(a, s - 1)
  }), a && i && d.disabled.push({
    after: a,
    before: Ue(a, s - 1)
  }), !a && i && d.disabled.push({
    after: ga(i, s - 1),
    before: Ue(i, s - 1)
  })), l) {
    if (a && !i && (d.disabled.push({
      before: Ue(a, -l + 1)
    }), d.disabled.push({
      after: Ue(a, l - 1)
    })), a && i) {
      var p = St(i, a) + 1, v = l - p;
      d.disabled.push({
        before: ga(a, v)
      }), d.disabled.push({
        after: Ue(i, v)
      });
    }
    !a && i && (d.disabled.push({
      before: Ue(i, -l + 1)
    }), d.disabled.push({
      after: Ue(i, l - 1)
    }));
  }
  return f(Ls.Provider, { value: { selected: r, onDayClick: u, modifiers: d }, children: n });
}
function Fs() {
  var e = Mt(Ls);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function eo(e) {
  return Array.isArray(e) ? op([], e, !0) : e !== void 0 ? [e] : [];
}
function aS(e) {
  var t = {};
  return Object.entries(e).forEach(function(n) {
    var r = n[0], o = n[1];
    t[r] = eo(o);
  }), t;
}
var ht;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(ht || (ht = {}));
var iS = ht.Selected, Rt = ht.Disabled, sS = ht.Hidden, cS = ht.Today, ya = ht.RangeEnd, wa = ht.RangeMiddle, Ca = ht.RangeStart, lS = ht.Outside;
function uS(e, t, n) {
  var r, o = (r = {}, r[iS] = eo(e.selected), r[Rt] = eo(e.disabled), r[sS] = eo(e.hidden), r[cS] = [e.today], r[ya] = [], r[wa] = [], r[Ca] = [], r[lS] = [], r);
  return e.fromDate && o[Rt].push({ before: e.fromDate }), e.toDate && o[Rt].push({ after: e.toDate }), xr(e) ? o[Rt] = o[Rt].concat(t.modifiers[Rt]) : _r(e) && (o[Rt] = o[Rt].concat(n.modifiers[Rt]), o[Ca] = n.modifiers[Ca], o[wa] = n.modifiers[wa], o[ya] = n.modifiers[ya]), o;
}
var lp = Pt(void 0);
function dS(e) {
  var t = we(), n = ks(), r = Fs(), o = uS(t, n, r), a = aS(t.modifiers), i = te(te({}, o), a);
  return f(lp.Provider, { value: i, children: e.children });
}
function up() {
  var e = Mt(lp);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function fS(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function pS(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function mS(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function vS(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function hS(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function gS(e, t) {
  var n, r = t.from, o = t.to;
  if (r && o) {
    var a = St(o, r) < 0;
    a && (n = [o, r], r = n[0], o = n[1]);
    var i = St(e, r) >= 0 && St(o, e) >= 0;
    return i;
  }
  return o ? Ye(o, e) : r ? Ye(r, e) : !1;
}
function bS(e) {
  return Os(e);
}
function yS(e) {
  return Array.isArray(e) && e.every(Os);
}
function wS(e, t) {
  return t.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (bS(n))
      return Ye(e, n);
    if (yS(n))
      return n.includes(e);
    if (pS(n))
      return gS(e, n);
    if (hS(n))
      return n.dayOfWeek.includes(e.getDay());
    if (fS(n)) {
      var r = St(n.before, e), o = St(n.after, e), a = r > 0, i = o < 0, s = ni(n.before, n.after);
      return s ? i && a : a || i;
    }
    return mS(n) ? St(e, n.after) > 0 : vS(n) ? St(n.before, e) > 0 : typeof n == "function" ? n(e) : !1;
  });
}
function Bs(e, t, n) {
  var r = Object.keys(t).reduce(function(a, i) {
    var s = t[i];
    return wS(e, s) && a.push(i), a;
  }, []), o = {};
  return r.forEach(function(a) {
    return o[a] = !0;
  }), n && !As(e, n) && (o.outside = !0), o;
}
function CS(e, t) {
  for (var n = qe(e[0]), r = Ms(e[e.length - 1]), o, a, i = n; i <= r; ) {
    var s = Bs(i, t), l = !s.disabled && !s.hidden;
    if (!l) {
      i = Ue(i, 1);
      continue;
    }
    if (s.selected)
      return i;
    s.today && !a && (a = i), o || (o = i), i = Ue(i, 1);
  }
  return a || o;
}
var ES = 365;
function dp(e, t) {
  var n = t.moveBy, r = t.direction, o = t.context, a = t.modifiers, i = t.retry, s = i === void 0 ? { count: 0, lastFocused: e } : i, l = o.weekStartsOn, u = o.fromDate, d = o.toDate, p = o.locale, v = {
    day: Ue,
    week: ti,
    month: vt,
    year: uC,
    startOfWeek: function(h) {
      return o.ISOWeek ? an(h) : xt(h, { locale: p, weekStartsOn: l });
    },
    endOfWeek: function(h) {
      return o.ISOWeek ? Zf(h) : Ds(h, { locale: p, weekStartsOn: l });
    }
  }, y = v[n](e, r === "after" ? 1 : -1);
  r === "before" && u ? y = dC([u, y]) : r === "after" && d && (y = fC([d, y]));
  var g = !0;
  if (a) {
    var m = Bs(y, a);
    g = !m.disabled && !m.hidden;
  }
  return g ? y : s.count > ES ? s.lastFocused : dp(y, {
    moveBy: n,
    direction: r,
    context: o,
    modifiers: a,
    retry: te(te({}, s), { count: s.count + 1 })
  });
}
var fp = Pt(void 0);
function SS(e) {
  var t = Tr(), n = up(), r = Je(), o = r[0], a = r[1], i = Je(), s = i[0], l = i[1], u = CS(t.displayMonths, n), d = o ?? (s && t.isDateDisplayed(s)) ? s : u, p = function() {
    l(o), a(void 0);
  }, v = function(h) {
    a(h);
  }, y = we(), g = function(h, b) {
    if (o) {
      var w = dp(o, {
        moveBy: h,
        direction: b,
        context: y,
        modifiers: n
      });
      Ye(o, w) || (t.goToDate(w, o), v(w));
    }
  }, m = {
    focusedDay: o,
    focusTarget: d,
    blur: p,
    focus: v,
    focusDayAfter: function() {
      return g("day", "after");
    },
    focusDayBefore: function() {
      return g("day", "before");
    },
    focusWeekAfter: function() {
      return g("week", "after");
    },
    focusWeekBefore: function() {
      return g("week", "before");
    },
    focusMonthBefore: function() {
      return g("month", "before");
    },
    focusMonthAfter: function() {
      return g("month", "after");
    },
    focusYearBefore: function() {
      return g("year", "before");
    },
    focusYearAfter: function() {
      return g("year", "after");
    },
    focusStartOfWeek: function() {
      return g("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return g("endOfWeek", "after");
    }
  };
  return f(fp.Provider, { value: m, children: e.children });
}
function Ws() {
  var e = Mt(fp);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function PS(e, t) {
  var n = up(), r = Bs(e, n, t);
  return r;
}
var js = Pt(void 0);
function xS(e) {
  if (!Lo(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return f(js.Provider, { value: t, children: e.children });
  }
  return f(_S, { initialProps: e.initialProps, children: e.children });
}
function _S(e) {
  var t = e.initialProps, n = e.children, r = function(a, i, s) {
    var l, u, d;
    if ((l = t.onDayClick) === null || l === void 0 || l.call(t, a, i, s), i.selected && !t.required) {
      (u = t.onSelect) === null || u === void 0 || u.call(t, void 0, a, i, s);
      return;
    }
    (d = t.onSelect) === null || d === void 0 || d.call(t, a, a, i, s);
  }, o = {
    selected: t.selected,
    onDayClick: r
  };
  return f(js.Provider, { value: o, children: n });
}
function pp() {
  var e = Mt(js);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function TS(e, t) {
  var n = we(), r = pp(), o = ks(), a = Fs(), i = Ws(), s = i.focusDayAfter, l = i.focusDayBefore, u = i.focusWeekAfter, d = i.focusWeekBefore, p = i.blur, v = i.focus, y = i.focusMonthBefore, g = i.focusMonthAfter, m = i.focusYearBefore, h = i.focusYearAfter, b = i.focusStartOfWeek, w = i.focusEndOfWeek, C = function(A) {
    var D, B, Q, q;
    Lo(n) ? (D = r.onDayClick) === null || D === void 0 || D.call(r, e, t, A) : xr(n) ? (B = o.onDayClick) === null || B === void 0 || B.call(o, e, t, A) : _r(n) ? (Q = a.onDayClick) === null || Q === void 0 || Q.call(a, e, t, A) : (q = n.onDayClick) === null || q === void 0 || q.call(n, e, t, A);
  }, E = function(A) {
    var D;
    v(e), (D = n.onDayFocus) === null || D === void 0 || D.call(n, e, t, A);
  }, P = function(A) {
    var D;
    p(), (D = n.onDayBlur) === null || D === void 0 || D.call(n, e, t, A);
  }, x = function(A) {
    var D;
    (D = n.onDayMouseEnter) === null || D === void 0 || D.call(n, e, t, A);
  }, S = function(A) {
    var D;
    (D = n.onDayMouseLeave) === null || D === void 0 || D.call(n, e, t, A);
  }, _ = function(A) {
    var D;
    (D = n.onDayPointerEnter) === null || D === void 0 || D.call(n, e, t, A);
  }, T = function(A) {
    var D;
    (D = n.onDayPointerLeave) === null || D === void 0 || D.call(n, e, t, A);
  }, k = function(A) {
    var D;
    (D = n.onDayTouchCancel) === null || D === void 0 || D.call(n, e, t, A);
  }, L = function(A) {
    var D;
    (D = n.onDayTouchEnd) === null || D === void 0 || D.call(n, e, t, A);
  }, U = function(A) {
    var D;
    (D = n.onDayTouchMove) === null || D === void 0 || D.call(n, e, t, A);
  }, M = function(A) {
    var D;
    (D = n.onDayTouchStart) === null || D === void 0 || D.call(n, e, t, A);
  }, F = function(A) {
    var D;
    (D = n.onDayKeyUp) === null || D === void 0 || D.call(n, e, t, A);
  }, W = function(A) {
    var D;
    switch (A.key) {
      case "ArrowLeft":
        A.preventDefault(), A.stopPropagation(), n.dir === "rtl" ? s() : l();
        break;
      case "ArrowRight":
        A.preventDefault(), A.stopPropagation(), n.dir === "rtl" ? l() : s();
        break;
      case "ArrowDown":
        A.preventDefault(), A.stopPropagation(), u();
        break;
      case "ArrowUp":
        A.preventDefault(), A.stopPropagation(), d();
        break;
      case "PageUp":
        A.preventDefault(), A.stopPropagation(), A.shiftKey ? m() : y();
        break;
      case "PageDown":
        A.preventDefault(), A.stopPropagation(), A.shiftKey ? h() : g();
        break;
      case "Home":
        A.preventDefault(), A.stopPropagation(), b();
        break;
      case "End":
        A.preventDefault(), A.stopPropagation(), w();
        break;
    }
    (D = n.onDayKeyDown) === null || D === void 0 || D.call(n, e, t, A);
  }, H = {
    onClick: C,
    onFocus: E,
    onBlur: P,
    onKeyDown: W,
    onKeyUp: F,
    onMouseEnter: x,
    onMouseLeave: S,
    onPointerEnter: _,
    onPointerLeave: T,
    onTouchCancel: k,
    onTouchEnd: L,
    onTouchMove: U,
    onTouchStart: M
  };
  return H;
}
function NS() {
  var e = we(), t = pp(), n = ks(), r = Fs(), o = Lo(e) ? t.selected : xr(e) ? n.selected : _r(e) ? r.selected : void 0;
  return o;
}
function RS(e) {
  return Object.values(ht).includes(e);
}
function $S(e, t) {
  var n = [e.classNames.day];
  return Object.keys(t).forEach(function(r) {
    var o = e.modifiersClassNames[r];
    if (o)
      n.push(o);
    else if (RS(r)) {
      var a = e.classNames["day_".concat(r)];
      a && n.push(a);
    }
  }), n;
}
function OS(e, t) {
  var n = te({}, e.styles.day);
  return Object.keys(t).forEach(function(r) {
    var o;
    n = te(te({}, n), (o = e.modifiersStyles) === null || o === void 0 ? void 0 : o[r]);
  }), n;
}
function MS(e, t, n) {
  var r, o, a, i = we(), s = Ws(), l = PS(e, t), u = TS(e, l), d = NS(), p = !!(i.onDayClick || i.mode !== "default");
  Ee(function() {
    var x;
    l.outside || s.focusedDay && p && Ye(s.focusedDay, e) && ((x = n.current) === null || x === void 0 || x.focus());
  }, [
    s.focusedDay,
    e,
    n,
    p,
    l.outside
  ]);
  var v = $S(i, l).join(" "), y = OS(i, l), g = !!(l.outside && !i.showOutsideDays || l.hidden), m = (a = (o = i.components) === null || o === void 0 ? void 0 : o.DayContent) !== null && a !== void 0 ? a : JE, h = f(m, { date: e, displayMonth: t, activeModifiers: l }), b = {
    style: y,
    className: v,
    children: h,
    role: "gridcell"
  }, w = s.focusTarget && Ye(s.focusTarget, e) && !l.outside, C = s.focusedDay && Ye(s.focusedDay, e), E = te(te(te({}, b), (r = { disabled: l.disabled, role: "gridcell" }, r["aria-selected"] = l.selected, r.tabIndex = C || w ? 0 : -1, r)), u), P = {
    isButton: p,
    isHidden: g,
    activeModifiers: l,
    selectedDays: d,
    buttonProps: E,
    divProps: b
  };
  return P;
}
function DS(e) {
  var t = Ne(null), n = MS(e.date, e.displayMonth, t);
  return n.isHidden ? f("div", { role: "gridcell" }) : n.isButton ? f(lo, te({ name: "day", ref: t }, n.buttonProps)) : f("div", te({}, n.divProps));
}
function AS(e) {
  var t = e.number, n = e.dates, r = we(), o = r.onWeekNumberClick, a = r.styles, i = r.classNames, s = r.locale, l = r.labels.labelWeekNumber, u = r.formatters.formatWeekNumber, d = u(Number(t), { locale: s });
  if (!o)
    return f("span", { className: i.weeknumber, style: a.weeknumber, children: d });
  var p = l(Number(t), { locale: s }), v = function(y) {
    o(t, n, y);
  };
  return f(lo, { name: "week-number", "aria-label": p, className: i.weeknumber, style: a.weeknumber, onClick: v, children: d });
}
function IS(e) {
  var t, n, r = we(), o = r.styles, a = r.classNames, i = r.showWeekNumber, s = r.components, l = (t = s == null ? void 0 : s.Day) !== null && t !== void 0 ? t : DS, u = (n = s == null ? void 0 : s.WeekNumber) !== null && n !== void 0 ? n : AS, d;
  return i && (d = f("td", { className: a.cell, style: o.cell, children: f(u, { number: e.weekNumber, dates: e.dates }) })), X("tr", { className: a.row, style: o.row, children: [d, e.dates.map(function(p) {
    return f("td", { className: a.cell, style: o.cell, role: "presentation", children: f(l, { displayMonth: e.displayMonth, date: p }) }, dE(p));
  })] });
}
function yl(e, t, n) {
  for (var r = n != null && n.ISOWeek ? Zf(t) : Ds(t, n), o = n != null && n.ISOWeek ? an(e) : xt(e, n), a = St(r, o), i = [], s = 0; s <= a; s++)
    i.push(Ue(o, s));
  var l = i.reduce(function(u, d) {
    var p = n != null && n.ISOWeek ? Jf(d) : tp(d, n), v = u.find(function(y) {
      return y.weekNumber === p;
    });
    return v ? (v.dates.push(d), u) : (u.push({
      weekNumber: p,
      dates: [d]
    }), u);
  }, []);
  return l;
}
function kS(e, t) {
  var n = yl(qe(e), Ms(e), t);
  if (t != null && t.useFixedWeeks) {
    var r = pE(e, t);
    if (r < 6) {
      var o = n[n.length - 1], a = o.dates[o.dates.length - 1], i = ti(a, 6 - r), s = yl(ti(a, 1), i, t);
      n.push.apply(n, s);
    }
  }
  return n;
}
function LS(e) {
  var t, n, r, o = we(), a = o.locale, i = o.classNames, s = o.styles, l = o.hideHead, u = o.fixedWeeks, d = o.components, p = o.weekStartsOn, v = o.firstWeekContainsDate, y = o.ISOWeek, g = kS(e.displayMonth, {
    useFixedWeeks: !!u,
    ISOWeek: y,
    locale: a,
    weekStartsOn: p,
    firstWeekContainsDate: v
  }), m = (t = d == null ? void 0 : d.Head) !== null && t !== void 0 ? t : QE, h = (n = d == null ? void 0 : d.Row) !== null && n !== void 0 ? n : IS, b = (r = d == null ? void 0 : d.Footer) !== null && r !== void 0 ? r : qE;
  return X("table", { id: e.id, className: i.table, style: s.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!l && f(m, {}), f("tbody", { className: i.tbody, style: s.tbody, children: g.map(function(w) {
    return f(h, { displayMonth: e.displayMonth, dates: w.dates, weekNumber: w.weekNumber }, w.weekNumber);
  }) }), f(b, { displayMonth: e.displayMonth })] });
}
function FS() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var BS = FS() ? Oo : Ee, Ea = !1, WS = 0;
function wl() {
  return "react-day-picker-".concat(++WS);
}
function jS(e) {
  var t, n = e ?? (Ea ? wl() : null), r = Je(n), o = r[0], a = r[1];
  return BS(function() {
    o === null && a(wl());
  }, []), Ee(function() {
    Ea === !1 && (Ea = !0);
  }, []), (t = e ?? o) !== null && t !== void 0 ? t : void 0;
}
function HS(e) {
  var t, n, r = we(), o = r.dir, a = r.classNames, i = r.styles, s = r.components, l = Tr().displayMonths, u = jS(r.id ? "".concat(r.id, "-").concat(e.displayIndex) : void 0), d = r.id ? "".concat(r.id, "-grid-").concat(e.displayIndex) : void 0, p = [a.month], v = i.month, y = e.displayIndex === 0, g = e.displayIndex === l.length - 1, m = !y && !g;
  o === "rtl" && (t = [y, g], g = t[0], y = t[1]), y && (p.push(a.caption_start), v = te(te({}, v), i.caption_start)), g && (p.push(a.caption_end), v = te(te({}, v), i.caption_end)), m && (p.push(a.caption_between), v = te(te({}, v), i.caption_between));
  var h = (n = s == null ? void 0 : s.Caption) !== null && n !== void 0 ? n : zE;
  return X("div", { className: p.join(" "), style: v, children: [f(h, { id: u, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), f(LS, { id: d, "aria-labelledby": u, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function US(e) {
  var t = we(), n = t.classNames, r = t.styles;
  return f("div", { className: n.months, style: r.months, children: e.children });
}
function VS(e) {
  var t, n, r = e.initialProps, o = we(), a = Ws(), i = Tr(), s = Je(!1), l = s[0], u = s[1];
  Ee(function() {
    o.initialFocus && a.focusTarget && (l || (a.focus(a.focusTarget), u(!0)));
  }, [
    o.initialFocus,
    l,
    a.focus,
    a.focusTarget,
    a
  ]);
  var d = [o.classNames.root, o.className];
  o.numberOfMonths > 1 && d.push(o.classNames.multiple_months), o.showWeekNumber && d.push(o.classNames.with_weeknumber);
  var p = te(te({}, o.styles.root), o.style), v = Object.keys(r).filter(function(g) {
    return g.startsWith("data-");
  }).reduce(function(g, m) {
    var h;
    return te(te({}, g), (h = {}, h[m] = r[m], h));
  }, {}), y = (n = (t = r.components) === null || t === void 0 ? void 0 : t.Months) !== null && n !== void 0 ? n : US;
  return f("div", te({ className: d.join(" "), style: p, dir: o.dir, id: o.id, nonce: r.nonce, title: r.title, lang: r.lang }, v, { children: f(y, { children: i.displayMonths.map(function(g, m) {
    return f(HS, { displayIndex: m, displayMonth: g }, m);
  }) }) }));
}
function GS(e) {
  var t = e.children, n = vE(e, ["children"]);
  return f(AE, { initialProps: n, children: f(VE, { children: f(xS, { initialProps: n, children: f(eS, { initialProps: n, children: f(rS, { initialProps: n, children: f(dS, { children: f(SS, { children: t }) }) }) }) }) }) });
}
function KS(e) {
  return f(GS, te({}, e, { children: f(VS, { initialProps: e }) }));
}
function YS({
  className: e,
  classNames: t,
  showOutsideDays: n = !0,
  ...r
}) {
  return /* @__PURE__ */ f(
    KS,
    {
      showOutsideDays: n,
      className: $("p-3", e),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-medium",
        nav: "space-x-1 flex items-center",
        nav_button: $(
          or({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "text-muted-foreground rounded-md w-8 font-normal text-[0.8rem]",
        row: "flex w-full mt-2",
        cell: $(
          "relative p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([aria-selected])]:bg-accent [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected].day-range-end)]:rounded-r-md",
          r.mode === "range" ? "[&:has(>.day-range-end)]:rounded-r-md [&:has(>.day-range-start)]:rounded-l-md first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md" : "[&:has([aria-selected])]:rounded-md"
        ),
        day: $(
          or({ variant: "ghost" }),
          "h-8 w-8 p-0 font-normal aria-selected:opacity-100"
        ),
        day_range_start: "day-range-start",
        day_range_end: "day-range-end",
        day_selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_today: "bg-accent text-accent-foreground",
        day_outside: "day-outside text-muted-foreground aria-selected:bg-accent/50 aria-selected:text-muted-foreground",
        day_disabled: "text-muted-foreground opacity-50",
        day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
        day_hidden: "invisible",
        ...t
      },
      components: {
        IconLeft: ({ className: o, ...a }) => /* @__PURE__ */ f(Md, { className: $("h-4 w-4", o), ...a }),
        IconRight: ({ className: o, ...a }) => /* @__PURE__ */ f(Sr, { className: $("h-4 w-4", o), ...a })
      },
      ...r
    }
  );
}
YS.displayName = "Calendar";
const zS = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "div",
  {
    ref: n,
    className: $(
      "rounded-xl border bg-card text-card-foreground shadow",
      e
    ),
    ...t
  }
));
zS.displayName = "Card";
const qS = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "div",
  {
    ref: n,
    className: $("flex flex-col space-y-1.5 p-6", e),
    ...t
  }
));
qS.displayName = "CardHeader";
const XS = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "div",
  {
    ref: n,
    className: $("font-semibold leading-none tracking-tight", e),
    ...t
  }
));
XS.displayName = "CardTitle";
const ZS = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "div",
  {
    ref: n,
    className: $("text-sm text-muted-foreground", e),
    ...t
  }
));
ZS.displayName = "CardDescription";
const QS = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f("div", { ref: n, className: $("p-6 pt-0", e), ...t }));
QS.displayName = "CardContent";
const JS = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "div",
  {
    ref: n,
    className: $("flex items-center p-6 pt-0", e),
    ...t
  }
));
JS.displayName = "CardFooter";
function eP(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Cl(e) {
  return eP(e) || Array.isArray(e);
}
function tP() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Hs(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  const o = JSON.stringify(Object.keys(e.breakpoints || {})), a = JSON.stringify(Object.keys(t.breakpoints || {}));
  return o !== a ? !1 : n.every((i) => {
    const s = e[i], l = t[i];
    return typeof s == "function" ? `${s}` == `${l}` : !Cl(s) || !Cl(l) ? s === l : Hs(s, l);
  });
}
function El(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function nP(e, t) {
  if (e.length !== t.length)
    return !1;
  const n = El(e), r = El(t);
  return n.every((o, a) => {
    const i = r[a];
    return Hs(o, i);
  });
}
function Us(e) {
  return typeof e == "number";
}
function ri(e) {
  return typeof e == "string";
}
function Fo(e) {
  return typeof e == "boolean";
}
function Sl(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Te(e) {
  return Math.abs(e);
}
function Vs(e) {
  return Math.sign(e);
}
function tr(e, t) {
  return Te(e - t);
}
function rP(e, t) {
  if (e === 0 || t === 0 || Te(e) <= Te(t))
    return 0;
  const n = tr(Te(e), Te(t));
  return Te(n / e);
}
function oP(e) {
  return Math.round(e * 100) / 100;
}
function ir(e) {
  return sr(e).map(Number);
}
function pt(e) {
  return e[Nr(e)];
}
function Nr(e) {
  return Math.max(0, e.length - 1);
}
function Gs(e, t) {
  return t === Nr(e);
}
function Pl(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function sr(e) {
  return Object.keys(e);
}
function mp(e, t) {
  return [e, t].reduce((n, r) => (sr(r).forEach((o) => {
    const a = n[o], i = r[o], s = Sl(a) && Sl(i);
    n[o] = s ? mp(a, i) : i;
  }), n), {});
}
function oi(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function aP(e, t) {
  const n = {
    start: r,
    center: o,
    end: a
  };
  function r() {
    return 0;
  }
  function o(l) {
    return a(l) / 2;
  }
  function a(l) {
    return t - l;
  }
  function i(l, u) {
    return ri(e) ? n[e](l) : e(t, l, u);
  }
  return {
    measure: i
  };
}
function cr() {
  let e = [];
  function t(o, a, i, s = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in o)
      o.addEventListener(a, i, s), l = () => o.removeEventListener(a, i, s);
    else {
      const u = o;
      u.addListener(i), l = () => u.removeListener(i);
    }
    return e.push(l), r;
  }
  function n() {
    e = e.filter((o) => o());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function iP(e, t, n, r) {
  const o = cr(), a = 1e3 / 60;
  let i = null, s = 0, l = 0;
  function u() {
    o.add(e, "visibilitychange", () => {
      e.hidden && g();
    });
  }
  function d() {
    y(), o.clear();
  }
  function p(h) {
    if (!l)
      return;
    i || (i = h, n(), n());
    const b = h - i;
    for (i = h, s += b; s >= a; )
      n(), s -= a;
    const w = s / a;
    r(w), l && (l = t.requestAnimationFrame(p));
  }
  function v() {
    l || (l = t.requestAnimationFrame(p));
  }
  function y() {
    t.cancelAnimationFrame(l), i = null, s = 0, l = 0;
  }
  function g() {
    i = null, s = 0;
  }
  return {
    init: u,
    destroy: d,
    start: v,
    stop: y,
    update: n,
    render: r
  };
}
function sP(e, t) {
  const n = t === "rtl", r = e === "y", o = r ? "y" : "x", a = r ? "x" : "y", i = !r && n ? -1 : 1, s = d(), l = p();
  function u(g) {
    const {
      height: m,
      width: h
    } = g;
    return r ? m : h;
  }
  function d() {
    return r ? "top" : n ? "right" : "left";
  }
  function p() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function v(g) {
    return g * i;
  }
  return {
    scroll: o,
    cross: a,
    startEdge: s,
    endEdge: l,
    measureSize: u,
    direction: v
  };
}
function sn(e = 0, t = 0) {
  const n = Te(e - t);
  function r(u) {
    return u < e;
  }
  function o(u) {
    return u > t;
  }
  function a(u) {
    return r(u) || o(u);
  }
  function i(u) {
    return a(u) ? r(u) ? e : t : u;
  }
  function s(u) {
    return n ? u - n * Math.ceil((u - t) / n) : u;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: i,
    reachedAny: a,
    reachedMax: o,
    reachedMin: r,
    removeOffset: s
  };
}
function vp(e, t, n) {
  const {
    constrain: r
  } = sn(0, e), o = e + 1;
  let a = i(t);
  function i(v) {
    return n ? Te((o + v) % o) : r(v);
  }
  function s() {
    return a;
  }
  function l(v) {
    return a = i(v), p;
  }
  function u(v) {
    return d().set(s() + v);
  }
  function d() {
    return vp(e, s(), n);
  }
  const p = {
    get: s,
    set: l,
    add: u,
    clone: d
  };
  return p;
}
function cP(e, t, n, r, o, a, i, s, l, u, d, p, v, y, g, m, h, b, w) {
  const {
    cross: C,
    direction: E
  } = e, P = ["INPUT", "SELECT", "TEXTAREA"], x = {
    passive: !1
  }, S = cr(), _ = cr(), T = sn(50, 225).constrain(y.measure(20)), k = {
    mouse: 300,
    touch: 400
  }, L = {
    mouse: 500,
    touch: 600
  }, U = g ? 43 : 25;
  let M = !1, F = 0, W = 0, H = !1, A = !1, D = !1, B = !1;
  function Q(K) {
    if (!w)
      return;
    function oe(z) {
      (Fo(w) || w(K, z)) && ee(z);
    }
    const N = t;
    S.add(N, "dragstart", (z) => z.preventDefault(), x).add(N, "touchmove", () => {
    }, x).add(N, "touchend", () => {
    }).add(N, "touchstart", oe).add(N, "mousedown", oe).add(N, "touchcancel", re).add(N, "contextmenu", re).add(N, "click", ie, !0);
  }
  function q() {
    S.clear(), _.clear();
  }
  function O() {
    const K = B ? n : t;
    _.add(K, "touchmove", Z, x).add(K, "touchend", re).add(K, "mousemove", Z, x).add(K, "mouseup", re);
  }
  function j(K) {
    const oe = K.nodeName || "";
    return P.includes(oe);
  }
  function Y() {
    return (g ? L : k)[B ? "mouse" : "touch"];
  }
  function V(K, oe) {
    const N = p.add(Vs(K) * -1), z = d.byDistance(K, !g).distance;
    return g || Te(K) < T ? z : h && oe ? z * 0.5 : d.byIndex(N.get(), 0).distance;
  }
  function ee(K) {
    const oe = oi(K, r);
    B = oe, D = g && oe && !K.buttons && M, M = tr(o.get(), i.get()) >= 2, !(oe && K.button !== 0) && (j(K.target) || (H = !0, a.pointerDown(K), u.useFriction(0).useDuration(0), o.set(i), O(), F = a.readPoint(K), W = a.readPoint(K, C), v.emit("pointerDown")));
  }
  function Z(K) {
    if (!oi(K, r) && K.touches.length >= 2)
      return re(K);
    const N = a.readPoint(K), z = a.readPoint(K, C), ce = tr(N, F), fe = tr(z, W);
    if (!A && !B && (!K.cancelable || (A = ce > fe, !A)))
      return re(K);
    const Se = a.pointerMove(K);
    ce > m && (D = !0), u.useFriction(0.3).useDuration(0.75), s.start(), o.add(E(Se)), K.preventDefault();
  }
  function re(K) {
    const N = d.byDistance(0, !1).index !== p.get(), z = a.pointerUp(K) * Y(), ce = V(E(z), N), fe = rP(z, ce), Se = U - 10 * fe, ae = b + fe / 50;
    A = !1, H = !1, _.clear(), u.useDuration(Se).useFriction(ae), l.distance(ce, !g), B = !1, v.emit("pointerUp");
  }
  function ie(K) {
    D && (K.stopPropagation(), K.preventDefault(), D = !1);
  }
  function de() {
    return H;
  }
  return {
    init: Q,
    destroy: q,
    pointerDown: de
  };
}
function lP(e, t) {
  let r, o;
  function a(p) {
    return p.timeStamp;
  }
  function i(p, v) {
    const g = `client${(v || e.scroll) === "x" ? "X" : "Y"}`;
    return (oi(p, t) ? p : p.touches[0])[g];
  }
  function s(p) {
    return r = p, o = p, i(p);
  }
  function l(p) {
    const v = i(p) - i(o), y = a(p) - a(r) > 170;
    return o = p, y && (r = p), v;
  }
  function u(p) {
    if (!r || !o)
      return 0;
    const v = i(o) - i(r), y = a(p) - a(r), g = a(p) - a(o) > 170, m = v / y;
    return y && !g && Te(m) > 0.1 ? m : 0;
  }
  return {
    pointerDown: s,
    pointerMove: l,
    pointerUp: u,
    readPoint: i
  };
}
function uP() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: o,
      offsetWidth: a,
      offsetHeight: i
    } = n;
    return {
      top: r,
      right: o + a,
      bottom: r + i,
      left: o,
      width: a,
      height: i
    };
  }
  return {
    measure: e
  };
}
function dP(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function fP(e, t, n, r, o, a, i) {
  const s = [e].concat(r);
  let l, u, d = [], p = !1;
  function v(h) {
    return o.measureSize(i.measure(h));
  }
  function y(h) {
    if (!a)
      return;
    u = v(e), d = r.map(v);
    function b(w) {
      for (const C of w) {
        if (p)
          return;
        const E = C.target === e, P = r.indexOf(C.target), x = E ? u : d[P], S = v(E ? e : r[P]);
        if (Te(S - x) >= 0.5) {
          h.reInit(), t.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((w) => {
      (Fo(a) || a(h, w)) && b(w);
    }), n.requestAnimationFrame(() => {
      s.forEach((w) => l.observe(w));
    });
  }
  function g() {
    p = !0, l && l.disconnect();
  }
  return {
    init: y,
    destroy: g
  };
}
function pP(e, t, n, r, o, a) {
  let i = 0, s = 0, l = o, u = a, d = e.get(), p = 0;
  function v() {
    const x = r.get() - e.get(), S = !l;
    let _ = 0;
    return S ? (i = 0, n.set(r), e.set(r), _ = x) : (n.set(e), i += x / l, i *= u, d += i, e.add(i), _ = d - p), s = Vs(_), p = d, P;
  }
  function y() {
    const x = r.get() - t.get();
    return Te(x) < 1e-3;
  }
  function g() {
    return l;
  }
  function m() {
    return s;
  }
  function h() {
    return i;
  }
  function b() {
    return C(o);
  }
  function w() {
    return E(a);
  }
  function C(x) {
    return l = x, P;
  }
  function E(x) {
    return u = x, P;
  }
  const P = {
    direction: m,
    duration: g,
    velocity: h,
    seek: v,
    settled: y,
    useBaseFriction: w,
    useBaseDuration: b,
    useFriction: E,
    useDuration: C
  };
  return P;
}
function mP(e, t, n, r, o) {
  const a = o.measure(10), i = o.measure(50), s = sn(0.1, 0.99);
  let l = !1;
  function u() {
    return !(l || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function d(y) {
    if (!u())
      return;
    const g = e.reachedMin(t.get()) ? "min" : "max", m = Te(e[g] - t.get()), h = n.get() - t.get(), b = s.constrain(m / i);
    n.subtract(h * b), !y && Te(h) < a && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function p(y) {
    l = !y;
  }
  return {
    shouldConstrain: u,
    constrain: d,
    toggleActive: p
  };
}
function vP(e, t, n, r, o) {
  const a = sn(-t + e, 0), i = p(), s = d(), l = v();
  function u(g, m) {
    return tr(g, m) <= 1;
  }
  function d() {
    const g = i[0], m = pt(i), h = i.lastIndexOf(g), b = i.indexOf(m) + 1;
    return sn(h, b);
  }
  function p() {
    return n.map((g, m) => {
      const {
        min: h,
        max: b
      } = a, w = a.constrain(g), C = !m, E = Gs(n, m);
      return C ? b : E || u(h, w) ? h : u(b, w) ? b : w;
    }).map((g) => parseFloat(g.toFixed(3)));
  }
  function v() {
    if (t <= e + o)
      return [a.max];
    if (r === "keepSnaps")
      return i;
    const {
      min: g,
      max: m
    } = s;
    return i.slice(g, m);
  }
  return {
    snapsContained: l,
    scrollContainLimit: s
  };
}
function hP(e, t, n) {
  const r = t[0], o = n ? r - e : pt(t);
  return {
    limit: sn(o, r)
  };
}
function gP(e, t, n, r) {
  const a = t.min + 0.1, i = t.max + 0.1, {
    reachedMin: s,
    reachedMax: l
  } = sn(a, i);
  function u(v) {
    return v === 1 ? l(n.get()) : v === -1 ? s(n.get()) : !1;
  }
  function d(v) {
    if (!u(v))
      return;
    const y = e * (v * -1);
    r.forEach((g) => g.add(y));
  }
  return {
    loop: d
  };
}
function bP(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(a) {
    const i = a - t;
    return n ? i / -n : 0;
  }
  return {
    get: r
  };
}
function yP(e, t, n, r, o) {
  const {
    startEdge: a,
    endEdge: i
  } = e, {
    groupSlides: s
  } = o, l = p().map(t.measure), u = v(), d = y();
  function p() {
    return s(r).map((m) => pt(m)[i] - m[0][a]).map(Te);
  }
  function v() {
    return r.map((m) => n[a] - m[a]).map((m) => -Te(m));
  }
  function y() {
    return s(u).map((m) => m[0]).map((m, h) => m + l[h]);
  }
  return {
    snaps: u,
    snapsAligned: d
  };
}
function wP(e, t, n, r, o, a) {
  const {
    groupSlides: i
  } = o, {
    min: s,
    max: l
  } = r, u = d();
  function d() {
    const v = i(a), y = !e || t === "keepSnaps";
    return n.length === 1 ? [a] : y ? v : v.slice(s, l).map((g, m, h) => {
      const b = !m, w = Gs(h, m);
      if (b) {
        const C = pt(h[0]) + 1;
        return Pl(C);
      }
      if (w) {
        const C = Nr(a) - pt(h)[0] + 1;
        return Pl(C, pt(h)[0]);
      }
      return g;
    });
  }
  return {
    slideRegistry: u
  };
}
function CP(e, t, n, r, o) {
  const {
    reachedAny: a,
    removeOffset: i,
    constrain: s
  } = r;
  function l(g) {
    return g.concat().sort((m, h) => Te(m) - Te(h))[0];
  }
  function u(g) {
    const m = e ? i(g) : s(g), h = t.map((w, C) => ({
      diff: d(w - m, 0),
      index: C
    })).sort((w, C) => Te(w.diff) - Te(C.diff)), {
      index: b
    } = h[0];
    return {
      index: b,
      distance: m
    };
  }
  function d(g, m) {
    const h = [g, g + n, g - n];
    if (!e)
      return g;
    if (!m)
      return l(h);
    const b = h.filter((w) => Vs(w) === m);
    return b.length ? l(b) : pt(h) - n;
  }
  function p(g, m) {
    const h = t[g] - o.get(), b = d(h, m);
    return {
      index: g,
      distance: b
    };
  }
  function v(g, m) {
    const h = o.get() + g, {
      index: b,
      distance: w
    } = u(h), C = !e && a(h);
    if (!m || C)
      return {
        index: b,
        distance: g
      };
    const E = t[b] - w, P = g + d(E, 0);
    return {
      index: b,
      distance: P
    };
  }
  return {
    byDistance: v,
    byIndex: p,
    shortcut: d
  };
}
function EP(e, t, n, r, o, a, i) {
  function s(p) {
    const v = p.distance, y = p.index !== t.get();
    a.add(v), v && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), y && (n.set(t.get()), t.set(p.index), i.emit("select"));
  }
  function l(p, v) {
    const y = o.byDistance(p, v);
    s(y);
  }
  function u(p, v) {
    const y = t.clone().set(p), g = o.byIndex(y.get(), v);
    s(g);
  }
  return {
    distance: l,
    index: u
  };
}
function SP(e, t, n, r, o, a, i, s) {
  const l = {
    passive: !0,
    capture: !0
  };
  let u = 0;
  function d(y) {
    if (!s)
      return;
    function g(m) {
      if ((/* @__PURE__ */ new Date()).getTime() - u > 10)
        return;
      i.emit("slideFocusStart"), e.scrollLeft = 0;
      const w = n.findIndex((C) => C.includes(m));
      Us(w) && (o.useDuration(0), r.index(w, 0), i.emit("slideFocus"));
    }
    a.add(document, "keydown", p, !1), t.forEach((m, h) => {
      a.add(m, "focus", (b) => {
        (Fo(s) || s(y, b)) && g(h);
      }, l);
    });
  }
  function p(y) {
    y.code === "Tab" && (u = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: d
  };
}
function Jn(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(l) {
    t = i(l);
  }
  function o(l) {
    t += i(l);
  }
  function a(l) {
    t -= i(l);
  }
  function i(l) {
    return Us(l) ? l : l.get();
  }
  return {
    get: n,
    set: r,
    add: o,
    subtract: a
  };
}
function hp(e, t) {
  const n = e.scroll === "x" ? i : s, r = t.style;
  let o = null, a = !1;
  function i(v) {
    return `translate3d(${v}px,0px,0px)`;
  }
  function s(v) {
    return `translate3d(0px,${v}px,0px)`;
  }
  function l(v) {
    if (a)
      return;
    const y = oP(e.direction(v));
    y !== o && (r.transform = n(y), o = y);
  }
  function u(v) {
    a = !v;
  }
  function d() {
    a || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: d,
    to: l,
    toggleActive: u
  };
}
function PP(e, t, n, r, o, a, i, s, l) {
  const d = ir(o), p = ir(o).reverse(), v = b().concat(w());
  function y(S, _) {
    return S.reduce((T, k) => T - o[k], _);
  }
  function g(S, _) {
    return S.reduce((T, k) => y(T, _) > 0 ? T.concat([k]) : T, []);
  }
  function m(S) {
    return a.map((_, T) => ({
      start: _ - r[T] + 0.5 + S,
      end: _ + t - 0.5 + S
    }));
  }
  function h(S, _, T) {
    const k = m(_);
    return S.map((L) => {
      const U = T ? 0 : -n, M = T ? n : 0, F = T ? "end" : "start", W = k[L][F];
      return {
        index: L,
        loopPoint: W,
        slideLocation: Jn(-1),
        translate: hp(e, l[L]),
        target: () => s.get() > W ? U : M
      };
    });
  }
  function b() {
    const S = i[0], _ = g(p, S);
    return h(_, n, !1);
  }
  function w() {
    const S = t - i[0] - 1, _ = g(d, S);
    return h(_, -n, !0);
  }
  function C() {
    return v.every(({
      index: S
    }) => {
      const _ = d.filter((T) => T !== S);
      return y(_, t) <= 0.1;
    });
  }
  function E() {
    v.forEach((S) => {
      const {
        target: _,
        translate: T,
        slideLocation: k
      } = S, L = _();
      L !== k.get() && (T.to(L), k.set(L));
    });
  }
  function P() {
    v.forEach((S) => S.translate.clear());
  }
  return {
    canLoop: C,
    clear: P,
    loop: E,
    loopPoints: v
  };
}
function xP(e, t, n) {
  let r, o = !1;
  function a(l) {
    if (!n)
      return;
    function u(d) {
      for (const p of d)
        if (p.type === "childList") {
          l.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((d) => {
      o || (Fo(n) || n(l, d)) && u(d);
    }), r.observe(e, {
      childList: !0
    });
  }
  function i() {
    r && r.disconnect(), o = !0;
  }
  return {
    init: a,
    destroy: i
  };
}
function _P(e, t, n, r) {
  const o = {};
  let a = null, i = null, s, l = !1;
  function u() {
    s = new IntersectionObserver((g) => {
      l || (g.forEach((m) => {
        const h = t.indexOf(m.target);
        o[h] = m;
      }), a = null, i = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((g) => s.observe(g));
  }
  function d() {
    s && s.disconnect(), l = !0;
  }
  function p(g) {
    return sr(o).reduce((m, h) => {
      const b = parseInt(h), {
        isIntersecting: w
      } = o[b];
      return (g && w || !g && !w) && m.push(b), m;
    }, []);
  }
  function v(g = !0) {
    if (g && a)
      return a;
    if (!g && i)
      return i;
    const m = p(g);
    return g && (a = m), g || (i = m), m;
  }
  return {
    init: u,
    destroy: d,
    get: v
  };
}
function TP(e, t, n, r, o, a) {
  const {
    measureSize: i,
    startEdge: s,
    endEdge: l
  } = e, u = n[0] && o, d = g(), p = m(), v = n.map(i), y = h();
  function g() {
    if (!u)
      return 0;
    const w = n[0];
    return Te(t[s] - w[s]);
  }
  function m() {
    if (!u)
      return 0;
    const w = a.getComputedStyle(pt(r));
    return parseFloat(w.getPropertyValue(`margin-${l}`));
  }
  function h() {
    return n.map((w, C, E) => {
      const P = !C, x = Gs(E, C);
      return P ? v[C] + d : x ? v[C] + p : E[C + 1][s] - w[s];
    }).map(Te);
  }
  return {
    slideSizes: v,
    slideSizesWithGaps: y,
    startGap: d,
    endGap: p
  };
}
function NP(e, t, n, r, o, a, i, s, l) {
  const {
    startEdge: u,
    endEdge: d,
    direction: p
  } = e, v = Us(n);
  function y(b, w) {
    return ir(b).filter((C) => C % w === 0).map((C) => b.slice(C, C + w));
  }
  function g(b) {
    return b.length ? ir(b).reduce((w, C, E) => {
      const P = pt(w) || 0, x = P === 0, S = C === Nr(b), _ = o[u] - a[P][u], T = o[u] - a[C][d], k = !r && x ? p(i) : 0, L = !r && S ? p(s) : 0, U = Te(T - L - (_ + k));
      return E && U > t + l && w.push(C), S && w.push(b.length), w;
    }, []).map((w, C, E) => {
      const P = Math.max(E[C - 1] || 0);
      return b.slice(P, w);
    }) : [];
  }
  function m(b) {
    return v ? y(b, n) : g(b);
  }
  return {
    groupSlides: m
  };
}
function RP(e, t, n, r, o, a, i) {
  const {
    align: s,
    axis: l,
    direction: u,
    startIndex: d,
    loop: p,
    duration: v,
    dragFree: y,
    dragThreshold: g,
    inViewThreshold: m,
    slidesToScroll: h,
    skipSnaps: b,
    containScroll: w,
    watchResize: C,
    watchSlides: E,
    watchDrag: P,
    watchFocus: x
  } = a, S = 2, _ = uP(), T = _.measure(t), k = n.map(_.measure), L = sP(l, u), U = L.measureSize(T), M = dP(U), F = aP(s, U), W = !p && !!w, H = p || !!w, {
    slideSizes: A,
    slideSizesWithGaps: D,
    startGap: B,
    endGap: Q
  } = TP(L, T, k, n, H, o), q = NP(L, U, h, p, T, k, B, Q, S), {
    snaps: O,
    snapsAligned: j
  } = yP(L, F, T, k, q), Y = -pt(O) + pt(D), {
    snapsContained: V,
    scrollContainLimit: ee
  } = vP(U, Y, j, w, S), Z = W ? V : j, {
    limit: re
  } = hP(Y, Z, p), ie = vp(Nr(Z), d, p), de = ie.clone(), se = ir(n), K = ({
    dragHandler: lt,
    scrollBody: zt,
    scrollBounds: ut,
    options: {
      loop: He
    }
  }) => {
    He || ut.constrain(lt.pointerDown()), zt.seek();
  }, oe = ({
    scrollBody: lt,
    translate: zt,
    location: ut,
    offsetLocation: He,
    previousLocation: qt,
    scrollLooper: Vn,
    slideLooper: ua,
    dragHandler: da,
    animation: fa,
    eventHandler: J,
    scrollBounds: pe,
    options: {
      loop: ge
    }
  }, le) => {
    const Pe = lt.settled(), Be = !pe.shouldConstrain(), Ae = ge ? Pe : Pe && Be;
    Ae && !da.pointerDown() && (fa.stop(), J.emit("settle")), Ae || J.emit("scroll");
    const Ct = ut.get() * le + qt.get() * (1 - le);
    He.set(Ct), ge && (Vn.loop(lt.direction()), ua.loop()), zt.to(He.get());
  }, N = iP(r, o, () => K(It), (lt) => oe(It, lt)), z = 0.68, ce = Z[ie.get()], fe = Jn(ce), Se = Jn(ce), ae = Jn(ce), ye = Jn(ce), Qe = pP(fe, ae, Se, ye, v, z), ke = CP(p, Z, Y, re, ye), Le = EP(N, ie, de, Qe, ke, ye, i), Ge = bP(re), Ke = cr(), tt = _P(t, n, i, m), {
    slideRegistry: nt
  } = wP(W, w, Z, ee, q, se), Nt = SP(e, n, nt, Le, Qe, Ke, i, x), It = {
    ownerDocument: r,
    ownerWindow: o,
    eventHandler: i,
    containerRect: T,
    slideRects: k,
    animation: N,
    axis: L,
    dragHandler: cP(L, e, r, o, ye, lP(L, o), fe, N, Le, Qe, ke, ie, i, M, y, g, b, z, P),
    eventStore: Ke,
    percentOfView: M,
    index: ie,
    indexPrevious: de,
    limit: re,
    location: fe,
    offsetLocation: ae,
    previousLocation: Se,
    options: a,
    resizeHandler: fP(t, i, o, n, L, C, _),
    scrollBody: Qe,
    scrollBounds: mP(re, ae, ye, Qe, M),
    scrollLooper: gP(Y, re, ae, [fe, ae, Se, ye]),
    scrollProgress: Ge,
    scrollSnapList: Z.map(Ge.get),
    scrollSnaps: Z,
    scrollTarget: ke,
    scrollTo: Le,
    slideLooper: PP(L, U, Y, A, D, O, Z, ae, n),
    slideFocus: Nt,
    slidesHandler: xP(t, i, E),
    slidesInView: tt,
    slideIndexes: se,
    slideRegistry: nt,
    slidesToScroll: q,
    target: ye,
    translate: hp(L, t)
  };
  return It;
}
function $P() {
  let e = {}, t;
  function n(u) {
    t = u;
  }
  function r(u) {
    return e[u] || [];
  }
  function o(u) {
    return r(u).forEach((d) => d(t, u)), l;
  }
  function a(u, d) {
    return e[u] = r(u).concat([d]), l;
  }
  function i(u, d) {
    return e[u] = r(u).filter((p) => p !== d), l;
  }
  function s() {
    e = {};
  }
  const l = {
    init: n,
    emit: o,
    off: i,
    on: a,
    clear: s
  };
  return l;
}
const OP = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function MP(e) {
  function t(a, i) {
    return mp(a, i || {});
  }
  function n(a) {
    const i = a.breakpoints || {}, s = sr(i).filter((l) => e.matchMedia(l).matches).map((l) => i[l]).reduce((l, u) => t(l, u), {});
    return t(a, s);
  }
  function r(a) {
    return a.map((i) => sr(i.breakpoints || {})).reduce((i, s) => i.concat(s), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function DP(e) {
  let t = [];
  function n(a, i) {
    return t = i.filter(({
      options: s
    }) => e.optionsAtMedia(s).active !== !1), t.forEach((s) => s.init(a, e)), i.reduce((s, l) => Object.assign(s, {
      [l.name]: l
    }), {});
  }
  function r() {
    t = t.filter((a) => a.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function uo(e, t, n) {
  const r = e.ownerDocument, o = r.defaultView, a = MP(o), i = DP(a), s = cr(), l = $P(), {
    mergeOptions: u,
    optionsAtMedia: d,
    optionsMediaQueries: p
  } = a, {
    on: v,
    off: y,
    emit: g
  } = l, m = L;
  let h = !1, b, w = u(OP, uo.globalOptions), C = u(w), E = [], P, x, S;
  function _() {
    const {
      container: se,
      slides: K
    } = C;
    x = (ri(se) ? e.querySelector(se) : se) || e.children[0];
    const N = ri(K) ? x.querySelectorAll(K) : K;
    S = [].slice.call(N || x.children);
  }
  function T(se) {
    const K = RP(e, x, S, r, o, se, l);
    if (se.loop && !K.slideLooper.canLoop()) {
      const oe = Object.assign({}, se, {
        loop: !1
      });
      return T(oe);
    }
    return K;
  }
  function k(se, K) {
    h || (w = u(w, se), C = d(w), E = K || E, _(), b = T(C), p([w, ...E.map(({
      options: oe
    }) => oe)]).forEach((oe) => s.add(oe, "change", L)), C.active && (b.translate.to(b.location.get()), b.animation.init(), b.slidesInView.init(), b.slideFocus.init(de), b.eventHandler.init(de), b.resizeHandler.init(de), b.slidesHandler.init(de), b.options.loop && b.slideLooper.loop(), x.offsetParent && S.length && b.dragHandler.init(de), P = i.init(de, E)));
  }
  function L(se, K) {
    const oe = q();
    U(), k(u({
      startIndex: oe
    }, se), K), l.emit("reInit");
  }
  function U() {
    b.dragHandler.destroy(), b.eventStore.clear(), b.translate.clear(), b.slideLooper.clear(), b.resizeHandler.destroy(), b.slidesHandler.destroy(), b.slidesInView.destroy(), b.animation.destroy(), i.destroy(), s.clear();
  }
  function M() {
    h || (h = !0, s.clear(), U(), l.emit("destroy"), l.clear());
  }
  function F(se, K, oe) {
    !C.active || h || (b.scrollBody.useBaseFriction().useDuration(K === !0 ? 0 : C.duration), b.scrollTo.index(se, oe || 0));
  }
  function W(se) {
    const K = b.index.add(1).get();
    F(K, se, -1);
  }
  function H(se) {
    const K = b.index.add(-1).get();
    F(K, se, 1);
  }
  function A() {
    return b.index.add(1).get() !== q();
  }
  function D() {
    return b.index.add(-1).get() !== q();
  }
  function B() {
    return b.scrollSnapList;
  }
  function Q() {
    return b.scrollProgress.get(b.location.get());
  }
  function q() {
    return b.index.get();
  }
  function O() {
    return b.indexPrevious.get();
  }
  function j() {
    return b.slidesInView.get();
  }
  function Y() {
    return b.slidesInView.get(!1);
  }
  function V() {
    return P;
  }
  function ee() {
    return b;
  }
  function Z() {
    return e;
  }
  function re() {
    return x;
  }
  function ie() {
    return S;
  }
  const de = {
    canScrollNext: A,
    canScrollPrev: D,
    containerNode: re,
    internalEngine: ee,
    destroy: M,
    off: y,
    on: v,
    emit: g,
    plugins: V,
    previousScrollSnap: O,
    reInit: m,
    rootNode: Z,
    scrollNext: W,
    scrollPrev: H,
    scrollProgress: Q,
    scrollSnapList: B,
    scrollTo: F,
    selectedScrollSnap: q,
    slideNodes: ie,
    slidesInView: j,
    slidesNotInView: Y
  };
  return k(t, n), setTimeout(() => l.emit("init"), 0), de;
}
uo.globalOptions = void 0;
function Ks(e = {}, t = []) {
  const n = Ne(e), r = Ne(t), [o, a] = Je(), [i, s] = Je(), l = un(() => {
    o && o.reInit(n.current, r.current);
  }, [o]);
  return Ee(() => {
    Hs(n.current, e) || (n.current = e, l());
  }, [e, l]), Ee(() => {
    nP(r.current, t) || (r.current = t, l());
  }, [t, l]), Ee(() => {
    if (tP() && i) {
      uo.globalOptions = Ks.globalOptions;
      const u = uo(i, n.current, r.current);
      return a(u), () => u.destroy();
    } else
      a(void 0);
  }, [i, a]), [s, o];
}
Ks.globalOptions = void 0;
const gp = c.createContext(null);
function Bo() {
  const e = c.useContext(gp);
  if (!e)
    throw new Error("useCarousel must be used within a <Carousel />");
  return e;
}
const AP = c.forwardRef(
  ({
    orientation: e = "horizontal",
    opts: t,
    setApi: n,
    plugins: r,
    className: o,
    children: a,
    ...i
  }, s) => {
    const [l, u] = Ks(
      {
        ...t,
        axis: e === "horizontal" ? "x" : "y"
      },
      r
    ), [d, p] = c.useState(!1), [v, y] = c.useState(!1), g = c.useCallback((w) => {
      w && (p(w.canScrollPrev()), y(w.canScrollNext()));
    }, []), m = c.useCallback(() => {
      u == null || u.scrollPrev();
    }, [u]), h = c.useCallback(() => {
      u == null || u.scrollNext();
    }, [u]), b = c.useCallback(
      (w) => {
        w.key === "ArrowLeft" ? (w.preventDefault(), m()) : w.key === "ArrowRight" && (w.preventDefault(), h());
      },
      [m, h]
    );
    return c.useEffect(() => {
      !u || !n || n(u);
    }, [u, n]), c.useEffect(() => {
      if (u)
        return g(u), u.on("reInit", g), u.on("select", g), () => {
          u == null || u.off("select", g);
        };
    }, [u, g]), /* @__PURE__ */ f(
      gp.Provider,
      {
        value: {
          carouselRef: l,
          api: u,
          opts: t,
          orientation: e || ((t == null ? void 0 : t.axis) === "y" ? "vertical" : "horizontal"),
          scrollPrev: m,
          scrollNext: h,
          canScrollPrev: d,
          canScrollNext: v
        },
        children: /* @__PURE__ */ f(
          "div",
          {
            ref: s,
            onKeyDownCapture: b,
            className: $("relative", o),
            role: "region",
            "aria-roledescription": "carousel",
            ...i,
            children: a
          }
        )
      }
    );
  }
);
AP.displayName = "Carousel";
const IP = c.forwardRef(({ className: e, ...t }, n) => {
  const { carouselRef: r, orientation: o } = Bo();
  return /* @__PURE__ */ f("div", { ref: r, className: "overflow-hidden", children: /* @__PURE__ */ f(
    "div",
    {
      ref: n,
      className: $(
        "flex",
        o === "horizontal" ? "-ml-4" : "-mt-4 flex-col",
        e
      ),
      ...t
    }
  ) });
});
IP.displayName = "CarouselContent";
const kP = c.forwardRef(({ className: e, ...t }, n) => {
  const { orientation: r } = Bo();
  return /* @__PURE__ */ f(
    "div",
    {
      ref: n,
      role: "group",
      "aria-roledescription": "slide",
      className: $(
        "min-w-0 shrink-0 grow-0 basis-full",
        r === "horizontal" ? "pl-4" : "pt-4",
        e
      ),
      ...t
    }
  );
});
kP.displayName = "CarouselItem";
const LP = c.forwardRef(({ className: e, variant: t = "outline", size: n = "icon", ...r }, o) => {
  const { orientation: a, scrollPrev: i, canScrollPrev: s } = Bo();
  return /* @__PURE__ */ X(
    Sd,
    {
      ref: o,
      variant: t,
      size: n,
      className: $(
        "absolute  h-8 w-8 rounded-full",
        a === "horizontal" ? "-left-12 top-1/2 -translate-y-1/2" : "-top-12 left-1/2 -translate-x-1/2 rotate-90",
        e
      ),
      disabled: !s,
      onClick: i,
      ...r,
      children: [
        /* @__PURE__ */ f(dw, { className: "h-4 w-4" }),
        /* @__PURE__ */ f("span", { className: "sr-only", children: "Previous slide" })
      ]
    }
  );
});
LP.displayName = "CarouselPrevious";
const FP = c.forwardRef(({ className: e, variant: t = "outline", size: n = "icon", ...r }, o) => {
  const { orientation: a, scrollNext: i, canScrollNext: s } = Bo();
  return /* @__PURE__ */ X(
    Sd,
    {
      ref: o,
      variant: t,
      size: n,
      className: $(
        "absolute h-8 w-8 rounded-full",
        a === "horizontal" ? "-right-12 top-1/2 -translate-y-1/2" : "-bottom-12 left-1/2 -translate-x-1/2 rotate-90",
        e
      ),
      disabled: !s,
      onClick: i,
      ...r,
      children: [
        /* @__PURE__ */ f(fw, { className: "h-4 w-4" }),
        /* @__PURE__ */ f("span", { className: "sr-only", children: "Next slide" })
      ]
    }
  );
});
FP.displayName = "CarouselNext";
var Br = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _t(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var BP = Array.isArray, bt = BP, WP = typeof Br == "object" && Br && Br.Object === Object && Br, bp = WP, jP = bp, HP = typeof self == "object" && self && self.Object === Object && self, UP = jP || HP || Function("return this")(), Tt = UP, VP = Tt, GP = VP.Symbol, Rr = GP, xl = Rr, yp = Object.prototype, KP = yp.hasOwnProperty, YP = yp.toString, Yn = xl ? xl.toStringTag : void 0;
function zP(e) {
  var t = KP.call(e, Yn), n = e[Yn];
  try {
    e[Yn] = void 0;
    var r = !0;
  } catch {
  }
  var o = YP.call(e);
  return r && (t ? e[Yn] = n : delete e[Yn]), o;
}
var qP = zP, XP = Object.prototype, ZP = XP.toString;
function QP(e) {
  return ZP.call(e);
}
var JP = QP, _l = Rr, ex = qP, tx = JP, nx = "[object Null]", rx = "[object Undefined]", Tl = _l ? _l.toStringTag : void 0;
function ox(e) {
  return e == null ? e === void 0 ? rx : nx : Tl && Tl in Object(e) ? ex(e) : tx(e);
}
var fn = ox;
function ax(e) {
  return e != null && typeof e == "object";
}
var pn = ax, ix = fn, sx = pn, cx = "[object Symbol]";
function lx(e) {
  return typeof e == "symbol" || sx(e) && ix(e) == cx;
}
var $r = lx, ux = bt, dx = $r, fx = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, px = /^\w*$/;
function mx(e, t) {
  if (ux(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || dx(e) ? !0 : px.test(e) || !fx.test(e) || t != null && e in Object(t);
}
var Ys = mx;
function vx(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Gt = vx;
const wp = /* @__PURE__ */ _t(Gt);
var hx = fn, gx = Gt, bx = "[object AsyncFunction]", yx = "[object Function]", wx = "[object GeneratorFunction]", Cx = "[object Proxy]";
function Ex(e) {
  if (!gx(e))
    return !1;
  var t = hx(e);
  return t == yx || t == wx || t == bx || t == Cx;
}
var zs = Ex;
const fo = /* @__PURE__ */ _t(zs);
var Sx = Tt, Px = Sx["__core-js_shared__"], xx = Px, Sa = xx, Nl = function() {
  var e = /[^.]+$/.exec(Sa && Sa.keys && Sa.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function _x(e) {
  return !!Nl && Nl in e;
}
var Tx = _x, Nx = Function.prototype, Rx = Nx.toString;
function $x(e) {
  if (e != null) {
    try {
      return Rx.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Cp = $x, Ox = zs, Mx = Tx, Dx = Gt, Ax = Cp, Ix = /[\\^$.*+?()[\]{}|]/g, kx = /^\[object .+?Constructor\]$/, Lx = Function.prototype, Fx = Object.prototype, Bx = Lx.toString, Wx = Fx.hasOwnProperty, jx = RegExp(
  "^" + Bx.call(Wx).replace(Ix, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Hx(e) {
  if (!Dx(e) || Mx(e))
    return !1;
  var t = Ox(e) ? jx : kx;
  return t.test(Ax(e));
}
var Ux = Hx;
function Vx(e, t) {
  return e == null ? void 0 : e[t];
}
var Gx = Vx, Kx = Ux, Yx = Gx;
function zx(e, t) {
  var n = Yx(e, t);
  return Kx(n) ? n : void 0;
}
var mn = zx, qx = mn, Xx = qx(Object, "create"), Wo = Xx, Rl = Wo;
function Zx() {
  this.__data__ = Rl ? Rl(null) : {}, this.size = 0;
}
var Qx = Zx;
function Jx(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var e_ = Jx, t_ = Wo, n_ = "__lodash_hash_undefined__", r_ = Object.prototype, o_ = r_.hasOwnProperty;
function a_(e) {
  var t = this.__data__;
  if (t_) {
    var n = t[e];
    return n === n_ ? void 0 : n;
  }
  return o_.call(t, e) ? t[e] : void 0;
}
var i_ = a_, s_ = Wo, c_ = Object.prototype, l_ = c_.hasOwnProperty;
function u_(e) {
  var t = this.__data__;
  return s_ ? t[e] !== void 0 : l_.call(t, e);
}
var d_ = u_, f_ = Wo, p_ = "__lodash_hash_undefined__";
function m_(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = f_ && t === void 0 ? p_ : t, this;
}
var v_ = m_, h_ = Qx, g_ = e_, b_ = i_, y_ = d_, w_ = v_;
function In(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
In.prototype.clear = h_;
In.prototype.delete = g_;
In.prototype.get = b_;
In.prototype.has = y_;
In.prototype.set = w_;
var C_ = In;
function E_() {
  this.__data__ = [], this.size = 0;
}
var S_ = E_;
function P_(e, t) {
  return e === t || e !== e && t !== t;
}
var qs = P_, x_ = qs;
function __(e, t) {
  for (var n = e.length; n--; )
    if (x_(e[n][0], t))
      return n;
  return -1;
}
var jo = __, T_ = jo, N_ = Array.prototype, R_ = N_.splice;
function $_(e) {
  var t = this.__data__, n = T_(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : R_.call(t, n, 1), --this.size, !0;
}
var O_ = $_, M_ = jo;
function D_(e) {
  var t = this.__data__, n = M_(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var A_ = D_, I_ = jo;
function k_(e) {
  return I_(this.__data__, e) > -1;
}
var L_ = k_, F_ = jo;
function B_(e, t) {
  var n = this.__data__, r = F_(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var W_ = B_, j_ = S_, H_ = O_, U_ = A_, V_ = L_, G_ = W_;
function kn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
kn.prototype.clear = j_;
kn.prototype.delete = H_;
kn.prototype.get = U_;
kn.prototype.has = V_;
kn.prototype.set = G_;
var Ho = kn, K_ = mn, Y_ = Tt, z_ = K_(Y_, "Map"), Xs = z_, $l = C_, q_ = Ho, X_ = Xs;
function Z_() {
  this.size = 0, this.__data__ = {
    hash: new $l(),
    map: new (X_ || q_)(),
    string: new $l()
  };
}
var Q_ = Z_;
function J_(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var e1 = J_, t1 = e1;
function n1(e, t) {
  var n = e.__data__;
  return t1(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Uo = n1, r1 = Uo;
function o1(e) {
  var t = r1(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var a1 = o1, i1 = Uo;
function s1(e) {
  return i1(this, e).get(e);
}
var c1 = s1, l1 = Uo;
function u1(e) {
  return l1(this, e).has(e);
}
var d1 = u1, f1 = Uo;
function p1(e, t) {
  var n = f1(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var m1 = p1, v1 = Q_, h1 = a1, g1 = c1, b1 = d1, y1 = m1;
function Ln(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ln.prototype.clear = v1;
Ln.prototype.delete = h1;
Ln.prototype.get = g1;
Ln.prototype.has = b1;
Ln.prototype.set = y1;
var Zs = Ln, Ep = Zs, w1 = "Expected a function";
function Qs(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(w1);
  var n = function() {
    var r = arguments, o = t ? t.apply(this, r) : r[0], a = n.cache;
    if (a.has(o))
      return a.get(o);
    var i = e.apply(this, r);
    return n.cache = a.set(o, i) || a, i;
  };
  return n.cache = new (Qs.Cache || Ep)(), n;
}
Qs.Cache = Ep;
var C1 = Qs, E1 = C1, S1 = 500;
function P1(e) {
  var t = E1(e, function(r) {
    return n.size === S1 && n.clear(), r;
  }), n = t.cache;
  return t;
}
var x1 = P1, _1 = x1, T1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, N1 = /\\(\\)?/g, R1 = _1(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(T1, function(n, r, o, a) {
    t.push(o ? a.replace(N1, "$1") : r || n);
  }), t;
}), $1 = R1;
function O1(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = Array(r); ++n < r; )
    o[n] = t(e[n], n, e);
  return o;
}
var Sp = O1, Ol = Rr, M1 = Sp, D1 = bt, A1 = $r, I1 = 1 / 0, Ml = Ol ? Ol.prototype : void 0, Dl = Ml ? Ml.toString : void 0;
function Pp(e) {
  if (typeof e == "string")
    return e;
  if (D1(e))
    return M1(e, Pp) + "";
  if (A1(e))
    return Dl ? Dl.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -I1 ? "-0" : t;
}
var k1 = Pp, L1 = k1;
function F1(e) {
  return e == null ? "" : L1(e);
}
var xp = F1, B1 = bt, W1 = Ys, j1 = $1, H1 = xp;
function U1(e, t) {
  return B1(e) ? e : W1(e, t) ? [e] : j1(H1(e));
}
var _p = U1, V1 = $r, G1 = 1 / 0;
function K1(e) {
  if (typeof e == "string" || V1(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -G1 ? "-0" : t;
}
var Vo = K1, Y1 = _p, z1 = Vo;
function q1(e, t) {
  t = Y1(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[z1(t[n++])];
  return n && n == r ? e : void 0;
}
var Js = q1, X1 = Js;
function Z1(e, t, n) {
  var r = e == null ? void 0 : X1(e, t);
  return r === void 0 ? n : r;
}
var Q1 = Z1;
function J1(e) {
  return e == null;
}
var eT = J1;
const tT = /* @__PURE__ */ _t(eT);
var nT = fn, rT = bt, oT = pn, aT = "[object String]";
function iT(e) {
  return typeof e == "string" || !rT(e) && oT(e) && nT(e) == aT;
}
var sT = iT;
const Tp = /* @__PURE__ */ _t(sT);
var ve = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Al;
function cT() {
  if (Al)
    return ve;
  Al = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function m(h) {
    if (typeof h == "object" && h !== null) {
      var b = h.$$typeof;
      switch (b) {
        case e:
          switch (h = h.type, h) {
            case n:
            case o:
            case r:
            case u:
            case d:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case s:
                case i:
                case l:
                case v:
                case p:
                case a:
                  return h;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return ve.ContextConsumer = i, ve.ContextProvider = a, ve.Element = e, ve.ForwardRef = l, ve.Fragment = n, ve.Lazy = v, ve.Memo = p, ve.Portal = t, ve.Profiler = o, ve.StrictMode = r, ve.Suspense = u, ve.SuspenseList = d, ve.isAsyncMode = function() {
    return !1;
  }, ve.isConcurrentMode = function() {
    return !1;
  }, ve.isContextConsumer = function(h) {
    return m(h) === i;
  }, ve.isContextProvider = function(h) {
    return m(h) === a;
  }, ve.isElement = function(h) {
    return typeof h == "object" && h !== null && h.$$typeof === e;
  }, ve.isForwardRef = function(h) {
    return m(h) === l;
  }, ve.isFragment = function(h) {
    return m(h) === n;
  }, ve.isLazy = function(h) {
    return m(h) === v;
  }, ve.isMemo = function(h) {
    return m(h) === p;
  }, ve.isPortal = function(h) {
    return m(h) === t;
  }, ve.isProfiler = function(h) {
    return m(h) === o;
  }, ve.isStrictMode = function(h) {
    return m(h) === r;
  }, ve.isSuspense = function(h) {
    return m(h) === u;
  }, ve.isSuspenseList = function(h) {
    return m(h) === d;
  }, ve.isValidElementType = function(h) {
    return typeof h == "string" || typeof h == "function" || h === n || h === o || h === r || h === u || h === d || h === y || typeof h == "object" && h !== null && (h.$$typeof === v || h.$$typeof === p || h.$$typeof === a || h.$$typeof === i || h.$$typeof === l || h.$$typeof === g || h.getModuleId !== void 0);
  }, ve.typeOf = m, ve;
}
var he = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Il;
function lT() {
  return Il || (Il = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), g = !1, m = !1, h = !1, b = !1, w = !1, C;
    C = Symbol.for("react.module.reference");
    function E(N) {
      return !!(typeof N == "string" || typeof N == "function" || N === n || N === o || w || N === r || N === u || N === d || b || N === y || g || m || h || typeof N == "object" && N !== null && (N.$$typeof === v || N.$$typeof === p || N.$$typeof === a || N.$$typeof === i || N.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      N.$$typeof === C || N.getModuleId !== void 0));
    }
    function P(N) {
      if (typeof N == "object" && N !== null) {
        var z = N.$$typeof;
        switch (z) {
          case e:
            var ce = N.type;
            switch (ce) {
              case n:
              case o:
              case r:
              case u:
              case d:
                return ce;
              default:
                var fe = ce && ce.$$typeof;
                switch (fe) {
                  case s:
                  case i:
                  case l:
                  case v:
                  case p:
                  case a:
                    return fe;
                  default:
                    return z;
                }
            }
          case t:
            return z;
        }
      }
    }
    var x = i, S = a, _ = e, T = l, k = n, L = v, U = p, M = t, F = o, W = r, H = u, A = d, D = !1, B = !1;
    function Q(N) {
      return D || (D = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function q(N) {
      return B || (B = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function O(N) {
      return P(N) === i;
    }
    function j(N) {
      return P(N) === a;
    }
    function Y(N) {
      return typeof N == "object" && N !== null && N.$$typeof === e;
    }
    function V(N) {
      return P(N) === l;
    }
    function ee(N) {
      return P(N) === n;
    }
    function Z(N) {
      return P(N) === v;
    }
    function re(N) {
      return P(N) === p;
    }
    function ie(N) {
      return P(N) === t;
    }
    function de(N) {
      return P(N) === o;
    }
    function se(N) {
      return P(N) === r;
    }
    function K(N) {
      return P(N) === u;
    }
    function oe(N) {
      return P(N) === d;
    }
    he.ContextConsumer = x, he.ContextProvider = S, he.Element = _, he.ForwardRef = T, he.Fragment = k, he.Lazy = L, he.Memo = U, he.Portal = M, he.Profiler = F, he.StrictMode = W, he.Suspense = H, he.SuspenseList = A, he.isAsyncMode = Q, he.isConcurrentMode = q, he.isContextConsumer = O, he.isContextProvider = j, he.isElement = Y, he.isForwardRef = V, he.isFragment = ee, he.isLazy = Z, he.isMemo = re, he.isPortal = ie, he.isProfiler = de, he.isStrictMode = se, he.isSuspense = K, he.isSuspenseList = oe, he.isValidElementType = E, he.typeOf = P;
  }()), he;
}
process.env.NODE_ENV === "production" ? cT() : lT();
var uT = fn, dT = pn, fT = "[object Number]";
function pT(e) {
  return typeof e == "number" || dT(e) && uT(e) == fT;
}
var Np = pT;
const mT = /* @__PURE__ */ _t(Np);
var vT = Np;
function hT(e) {
  return vT(e) && e != +e;
}
var gT = hT;
const bT = /* @__PURE__ */ _t(gT);
var Wr = function(t) {
  return Tp(t) && t.indexOf("%") === t.length - 1;
}, ft = function(t) {
  return mT(t) && !bT(t);
}, po = function(t) {
  return ft(t) || Tp(t);
};
function ai(e) {
  "@babel/helpers - typeof";
  return ai = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ai(e);
}
var yT = ["viewBox", "children"], wT = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], kl = ["points", "pathLength"], Pa = {
  svg: yT,
  polygon: kl,
  polyline: kl
}, Rp = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], CT = function(t, n, r) {
  return function(o) {
    return t(n, r, o), null;
  };
}, ET = function(t, n, r) {
  if (!wp(t) || ai(t) !== "object")
    return null;
  var o = null;
  return Object.keys(t).forEach(function(a) {
    var i = t[a];
    Rp.includes(a) && typeof i == "function" && (o || (o = {}), o[a] = CT(i, n, r));
  }), o;
}, ST = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, PT = function(t, n, r, o) {
  var a, i = (a = Pa == null ? void 0 : Pa[o]) !== null && a !== void 0 ? a : [];
  return !fo(t) && (o && i.includes(n) || wT.includes(n)) || r && Rp.includes(n);
}, $p = function(t, n, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var o = t;
  if (/* @__PURE__ */ rr(t) && (o = t.props), !wp(o))
    return null;
  var a = {};
  return Object.keys(o).forEach(function(i) {
    var s;
    PT((s = o) === null || s === void 0 ? void 0 : s[i], i, n, r) && (a[i] = o[i]);
  }), a;
}, xT = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function ii() {
  return ii = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ii.apply(this, arguments);
}
function _T(e, t) {
  if (e == null)
    return {};
  var n = TT(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      r = a[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function TT(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0)
        continue;
      n[r] = e[r];
    }
  return n;
}
function NT(e) {
  var t = e.children, n = e.width, r = e.height, o = e.viewBox, a = e.className, i = e.style, s = e.title, l = e.desc, u = _T(e, xT), d = o || {
    width: n,
    height: r,
    x: 0,
    y: 0
  }, p = rn("recharts-surface", a);
  return /* @__PURE__ */ R.createElement("svg", ii({}, $p(u, !0, "svg"), {
    className: p,
    width: n,
    height: r,
    style: i,
    viewBox: "".concat(d.x, " ").concat(d.y, " ").concat(d.width, " ").concat(d.height)
  }), /* @__PURE__ */ R.createElement("title", null, s), /* @__PURE__ */ R.createElement("desc", null, l), t);
}
var RT = process.env.NODE_ENV !== "production", to = function(t, n) {
  for (var r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    o[a - 2] = arguments[a];
  if (RT && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var i = 0;
      console.warn(n.replace(/%s/g, function() {
        return o[i++];
      }));
    }
};
function $T(e, t, n) {
  var r = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), n = n > o ? o : n, n < 0 && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var a = Array(o); ++r < o; )
    a[r] = e[r + t];
  return a;
}
var OT = $T, MT = OT;
function DT(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : MT(e, t, n);
}
var AT = DT, IT = "\\ud800-\\udfff", kT = "\\u0300-\\u036f", LT = "\\ufe20-\\ufe2f", FT = "\\u20d0-\\u20ff", BT = kT + LT + FT, WT = "\\ufe0e\\ufe0f", jT = "\\u200d", HT = RegExp("[" + jT + IT + BT + WT + "]");
function UT(e) {
  return HT.test(e);
}
var Op = UT;
function VT(e) {
  return e.split("");
}
var GT = VT, Mp = "\\ud800-\\udfff", KT = "\\u0300-\\u036f", YT = "\\ufe20-\\ufe2f", zT = "\\u20d0-\\u20ff", qT = KT + YT + zT, XT = "\\ufe0e\\ufe0f", ZT = "[" + Mp + "]", si = "[" + qT + "]", ci = "\\ud83c[\\udffb-\\udfff]", QT = "(?:" + si + "|" + ci + ")", Dp = "[^" + Mp + "]", Ap = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ip = "[\\ud800-\\udbff][\\udc00-\\udfff]", JT = "\\u200d", kp = QT + "?", Lp = "[" + XT + "]?", eN = "(?:" + JT + "(?:" + [Dp, Ap, Ip].join("|") + ")" + Lp + kp + ")*", tN = Lp + kp + eN, nN = "(?:" + [Dp + si + "?", si, Ap, Ip, ZT].join("|") + ")", rN = RegExp(ci + "(?=" + ci + ")|" + nN + tN, "g");
function oN(e) {
  return e.match(rN) || [];
}
var aN = oN, iN = GT, sN = Op, cN = aN;
function lN(e) {
  return sN(e) ? cN(e) : iN(e);
}
var uN = lN, dN = AT, fN = Op, pN = uN, mN = xp;
function vN(e) {
  return function(t) {
    t = mN(t);
    var n = fN(t) ? pN(t) : void 0, r = n ? n[0] : t.charAt(0), o = n ? dN(n, 1).join("") : t.slice(1);
    return r[e]() + o;
  };
}
var hN = vN, gN = hN, bN = gN("toUpperCase"), yN = bN;
const Fp = /* @__PURE__ */ _t(yN);
function jr(e) {
  return function() {
    return e;
  };
}
const Bp = Math.cos, mo = Math.sin, yt = Math.sqrt, vo = Math.PI, Go = 2 * vo, li = Math.PI, ui = 2 * li, Jt = 1e-6, wN = ui - Jt;
function Wp(e) {
  this._ += e[0];
  for (let t = 1, n = e.length; t < n; ++t)
    this._ += arguments[t] + e[t];
}
function CN(e) {
  let t = Math.floor(e);
  if (!(t >= 0))
    throw new Error(`invalid digits: ${e}`);
  if (t > 15)
    return Wp;
  const n = 10 ** t;
  return function(r) {
    this._ += r[0];
    for (let o = 1, a = r.length; o < a; ++o)
      this._ += Math.round(arguments[o] * n) / n + r[o];
  };
}
class EN {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? Wp : CN(t);
  }
  moveTo(t, n) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, n) {
    this._append`L${this._x1 = +t},${this._y1 = +n}`;
  }
  quadraticCurveTo(t, n, r, o) {
    this._append`Q${+t},${+n},${this._x1 = +r},${this._y1 = +o}`;
  }
  bezierCurveTo(t, n, r, o, a, i) {
    this._append`C${+t},${+n},${+r},${+o},${this._x1 = +a},${this._y1 = +i}`;
  }
  arcTo(t, n, r, o, a) {
    if (t = +t, n = +n, r = +r, o = +o, a = +a, a < 0)
      throw new Error(`negative radius: ${a}`);
    let i = this._x1, s = this._y1, l = r - t, u = o - n, d = i - t, p = s - n, v = d * d + p * p;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = n}`;
    else if (v > Jt)
      if (!(Math.abs(p * l - u * d) > Jt) || !a)
        this._append`L${this._x1 = t},${this._y1 = n}`;
      else {
        let y = r - i, g = o - s, m = l * l + u * u, h = y * y + g * g, b = Math.sqrt(m), w = Math.sqrt(v), C = a * Math.tan((li - Math.acos((m + v - h) / (2 * b * w))) / 2), E = C / w, P = C / b;
        Math.abs(E - 1) > Jt && this._append`L${t + E * d},${n + E * p}`, this._append`A${a},${a},0,0,${+(p * y > d * g)},${this._x1 = t + P * l},${this._y1 = n + P * u}`;
      }
  }
  arc(t, n, r, o, a, i) {
    if (t = +t, n = +n, r = +r, i = !!i, r < 0)
      throw new Error(`negative radius: ${r}`);
    let s = r * Math.cos(o), l = r * Math.sin(o), u = t + s, d = n + l, p = 1 ^ i, v = i ? o - a : a - o;
    this._x1 === null ? this._append`M${u},${d}` : (Math.abs(this._x1 - u) > Jt || Math.abs(this._y1 - d) > Jt) && this._append`L${u},${d}`, r && (v < 0 && (v = v % ui + ui), v > wN ? this._append`A${r},${r},0,1,${p},${t - s},${n - l}A${r},${r},0,1,${p},${this._x1 = u},${this._y1 = d}` : v > Jt && this._append`A${r},${r},0,${+(v >= li)},${p},${this._x1 = t + r * Math.cos(a)},${this._y1 = n + r * Math.sin(a)}`);
  }
  rect(t, n, r, o) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${r = +r}v${+o}h${-r}Z`;
  }
  toString() {
    return this._;
  }
}
function SN(e) {
  let t = 3;
  return e.digits = function(n) {
    if (!arguments.length)
      return t;
    if (n == null)
      t = null;
    else {
      const r = Math.floor(n);
      if (!(r >= 0))
        throw new RangeError(`invalid digits: ${n}`);
      t = r;
    }
    return e;
  }, () => new EN(t);
}
const ec = {
  draw(e, t) {
    const n = yt(t / vo);
    e.moveTo(n, 0), e.arc(0, 0, n, 0, Go);
  }
}, PN = {
  draw(e, t) {
    const n = yt(t / 5) / 2;
    e.moveTo(-3 * n, -n), e.lineTo(-n, -n), e.lineTo(-n, -3 * n), e.lineTo(n, -3 * n), e.lineTo(n, -n), e.lineTo(3 * n, -n), e.lineTo(3 * n, n), e.lineTo(n, n), e.lineTo(n, 3 * n), e.lineTo(-n, 3 * n), e.lineTo(-n, n), e.lineTo(-3 * n, n), e.closePath();
  }
}, jp = yt(1 / 3), xN = jp * 2, _N = {
  draw(e, t) {
    const n = yt(t / xN), r = n * jp;
    e.moveTo(0, -n), e.lineTo(r, 0), e.lineTo(0, n), e.lineTo(-r, 0), e.closePath();
  }
}, TN = {
  draw(e, t) {
    const n = yt(t), r = -n / 2;
    e.rect(r, r, n, n);
  }
}, NN = 0.8908130915292852, Hp = mo(vo / 10) / mo(7 * vo / 10), RN = mo(Go / 10) * Hp, $N = -Bp(Go / 10) * Hp, ON = {
  draw(e, t) {
    const n = yt(t * NN), r = RN * n, o = $N * n;
    e.moveTo(0, -n), e.lineTo(r, o);
    for (let a = 1; a < 5; ++a) {
      const i = Go * a / 5, s = Bp(i), l = mo(i);
      e.lineTo(l * n, -s * n), e.lineTo(s * r - l * o, l * r + s * o);
    }
    e.closePath();
  }
}, xa = yt(3), MN = {
  draw(e, t) {
    const n = -yt(t / (xa * 3));
    e.moveTo(0, n * 2), e.lineTo(-xa * n, -n), e.lineTo(xa * n, -n), e.closePath();
  }
}, rt = -0.5, ot = yt(3) / 2, di = 1 / yt(12), DN = (di / 2 + 1) * 3, AN = {
  draw(e, t) {
    const n = yt(t / DN), r = n / 2, o = n * di, a = r, i = n * di + n, s = -a, l = i;
    e.moveTo(r, o), e.lineTo(a, i), e.lineTo(s, l), e.lineTo(rt * r - ot * o, ot * r + rt * o), e.lineTo(rt * a - ot * i, ot * a + rt * i), e.lineTo(rt * s - ot * l, ot * s + rt * l), e.lineTo(rt * r + ot * o, rt * o - ot * r), e.lineTo(rt * a + ot * i, rt * i - ot * a), e.lineTo(rt * s + ot * l, rt * l - ot * s), e.closePath();
  }
};
function IN(e, t) {
  let n = null, r = SN(o);
  e = typeof e == "function" ? e : jr(e || ec), t = typeof t == "function" ? t : jr(t === void 0 ? 64 : +t);
  function o() {
    let a;
    if (n || (n = a = r()), e.apply(this, arguments).draw(n, +t.apply(this, arguments)), a)
      return n = null, a + "" || null;
  }
  return o.type = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : jr(a), o) : e;
  }, o.size = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : jr(+a), o) : t;
  }, o.context = function(a) {
    return arguments.length ? (n = a ?? null, o) : n;
  }, o;
}
function lr(e) {
  "@babel/helpers - typeof";
  return lr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lr(e);
}
var kN = ["type", "size", "sizeType"];
function fi() {
  return fi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fi.apply(this, arguments);
}
function Ll(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Fl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ll(Object(n), !0).forEach(function(r) {
      LN(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ll(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function LN(e, t, n) {
  return t = FN(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function FN(e) {
  var t = BN(e, "string");
  return lr(t) == "symbol" ? t : t + "";
}
function BN(e, t) {
  if (lr(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (lr(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function WN(e, t) {
  if (e == null)
    return {};
  var n = jN(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      r = a[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function jN(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0)
        continue;
      n[r] = e[r];
    }
  return n;
}
var Up = {
  symbolCircle: ec,
  symbolCross: PN,
  symbolDiamond: _N,
  symbolSquare: TN,
  symbolStar: ON,
  symbolTriangle: MN,
  symbolWye: AN
}, HN = Math.PI / 180, UN = function(t) {
  var n = "symbol".concat(Fp(t));
  return Up[n] || ec;
}, VN = function(t, n, r) {
  if (n === "area")
    return t;
  switch (r) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var o = 18 * HN;
      return 1.25 * t * t * (Math.tan(o) - Math.tan(o * 2) * Math.pow(Math.tan(o), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, GN = function(t, n) {
  Up["symbol".concat(Fp(t))] = n;
}, Vp = function(t) {
  var n = t.type, r = n === void 0 ? "circle" : n, o = t.size, a = o === void 0 ? 64 : o, i = t.sizeType, s = i === void 0 ? "area" : i, l = WN(t, kN), u = Fl(Fl({}, l), {}, {
    type: r,
    size: a,
    sizeType: s
  }), d = function() {
    var h = UN(r), b = IN().type(h).size(VN(a, s, r));
    return b();
  }, p = u.className, v = u.cx, y = u.cy, g = $p(u, !0);
  return v === +v && y === +y && a === +a ? /* @__PURE__ */ R.createElement("path", fi({}, g, {
    className: rn("recharts-symbols", p),
    transform: "translate(".concat(v, ", ").concat(y, ")"),
    d: d()
  })) : null;
};
Vp.registerSymbol = GN;
function Rn(e) {
  "@babel/helpers - typeof";
  return Rn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rn(e);
}
function pi() {
  return pi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pi.apply(this, arguments);
}
function Bl(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function KN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bl(Object(n), !0).forEach(function(r) {
      ur(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Bl(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function YN(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Wl(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Kp(r.key), r);
  }
}
function zN(e, t, n) {
  return t && Wl(e.prototype, t), n && Wl(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function qN(e, t, n) {
  return t = ho(t), XN(e, Gp() ? Reflect.construct(t, n || [], ho(e).constructor) : t.apply(e, n));
}
function XN(e, t) {
  if (t && (Rn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ZN(e);
}
function ZN(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Gp() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Gp = function() {
    return !!e;
  })();
}
function ho(e) {
  return ho = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ho(e);
}
function QN(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && mi(e, t);
}
function mi(e, t) {
  return mi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, mi(e, t);
}
function ur(e, t, n) {
  return t = Kp(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Kp(e) {
  var t = JN(e, "string");
  return Rn(t) == "symbol" ? t : t + "";
}
function JN(e, t) {
  if (Rn(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Rn(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var at = 32, tc = /* @__PURE__ */ function(e) {
  function t() {
    return YN(this, t), qN(this, t, arguments);
  }
  return QN(t, e), zN(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(r) {
        var o = this.props.inactiveColor, a = at / 2, i = at / 6, s = at / 3, l = r.inactive ? o : r.color;
        if (r.type === "plainline")
          return /* @__PURE__ */ R.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            strokeDasharray: r.payload.strokeDasharray,
            x1: 0,
            y1: a,
            x2: at,
            y2: a,
            className: "recharts-legend-icon"
          });
        if (r.type === "line")
          return /* @__PURE__ */ R.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            d: "M0,".concat(a, "h").concat(s, `
            A`).concat(i, ",").concat(i, ",0,1,1,").concat(2 * s, ",").concat(a, `
            H`).concat(at, "M").concat(2 * s, ",").concat(a, `
            A`).concat(i, ",").concat(i, ",0,1,1,").concat(s, ",").concat(a),
            className: "recharts-legend-icon"
          });
        if (r.type === "rect")
          return /* @__PURE__ */ R.createElement("path", {
            stroke: "none",
            fill: l,
            d: "M0,".concat(at / 8, "h").concat(at, "v").concat(at * 3 / 4, "h").concat(-at, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ R.isValidElement(r.legendIcon)) {
          var u = KN({}, r);
          return delete u.legendIcon, /* @__PURE__ */ R.cloneElement(r.legendIcon, u);
        }
        return /* @__PURE__ */ R.createElement(Vp, {
          fill: l,
          cx: a,
          cy: a,
          size: at,
          sizeType: "diameter",
          type: r.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var r = this, o = this.props, a = o.payload, i = o.iconSize, s = o.layout, l = o.formatter, u = o.inactiveColor, d = {
        x: 0,
        y: 0,
        width: at,
        height: at
      }, p = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, v = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return a.map(function(y, g) {
        var m = y.formatter || l, h = rn(ur(ur({
          "recharts-legend-item": !0
        }, "legend-item-".concat(g), !0), "inactive", y.inactive));
        if (y.type === "none")
          return null;
        var b = fo(y.value) ? null : y.value;
        to(
          !fo(y.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var w = y.inactive ? u : y.color;
        return /* @__PURE__ */ R.createElement("li", pi({
          className: h,
          style: p,
          key: "legend-item-".concat(g)
        }, ET(r.props, y, g)), /* @__PURE__ */ R.createElement(NT, {
          width: i,
          height: i,
          viewBox: d,
          style: v
        }, r.renderIcon(y)), /* @__PURE__ */ R.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: w
          }
        }, m ? m(b, y, g) : b));
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, o = r.payload, a = r.layout, i = r.align;
      if (!o || !o.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: a === "horizontal" ? i : "left"
      };
      return /* @__PURE__ */ R.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
}(Mo);
ur(tc, "displayName", "Legend");
ur(tc, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var eR = Ho;
function tR() {
  this.__data__ = new eR(), this.size = 0;
}
var nR = tR;
function rR(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var oR = rR;
function aR(e) {
  return this.__data__.get(e);
}
var iR = aR;
function sR(e) {
  return this.__data__.has(e);
}
var cR = sR, lR = Ho, uR = Xs, dR = Zs, fR = 200;
function pR(e, t) {
  var n = this.__data__;
  if (n instanceof lR) {
    var r = n.__data__;
    if (!uR || r.length < fR - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new dR(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var mR = pR, vR = Ho, hR = nR, gR = oR, bR = iR, yR = cR, wR = mR;
function Fn(e) {
  var t = this.__data__ = new vR(e);
  this.size = t.size;
}
Fn.prototype.clear = hR;
Fn.prototype.delete = gR;
Fn.prototype.get = bR;
Fn.prototype.has = yR;
Fn.prototype.set = wR;
var Yp = Fn, CR = "__lodash_hash_undefined__";
function ER(e) {
  return this.__data__.set(e, CR), this;
}
var SR = ER;
function PR(e) {
  return this.__data__.has(e);
}
var xR = PR, _R = Zs, TR = SR, NR = xR;
function go(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new _R(); ++t < n; )
    this.add(e[t]);
}
go.prototype.add = go.prototype.push = TR;
go.prototype.has = NR;
var zp = go;
function RR(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var $R = RR;
function OR(e, t) {
  return e.has(t);
}
var qp = OR, MR = zp, DR = $R, AR = qp, IR = 1, kR = 2;
function LR(e, t, n, r, o, a) {
  var i = n & IR, s = e.length, l = t.length;
  if (s != l && !(i && l > s))
    return !1;
  var u = a.get(e), d = a.get(t);
  if (u && d)
    return u == t && d == e;
  var p = -1, v = !0, y = n & kR ? new MR() : void 0;
  for (a.set(e, t), a.set(t, e); ++p < s; ) {
    var g = e[p], m = t[p];
    if (r)
      var h = i ? r(m, g, p, t, e, a) : r(g, m, p, e, t, a);
    if (h !== void 0) {
      if (h)
        continue;
      v = !1;
      break;
    }
    if (y) {
      if (!DR(t, function(b, w) {
        if (!AR(y, w) && (g === b || o(g, b, n, r, a)))
          return y.push(w);
      })) {
        v = !1;
        break;
      }
    } else if (!(g === m || o(g, m, n, r, a))) {
      v = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), v;
}
var Xp = LR, FR = Tt, BR = FR.Uint8Array, WR = BR;
function jR(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, o) {
    n[++t] = [o, r];
  }), n;
}
var HR = jR;
function UR(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var nc = UR, jl = Rr, Hl = WR, VR = qs, GR = Xp, KR = HR, YR = nc, zR = 1, qR = 2, XR = "[object Boolean]", ZR = "[object Date]", QR = "[object Error]", JR = "[object Map]", e$ = "[object Number]", t$ = "[object RegExp]", n$ = "[object Set]", r$ = "[object String]", o$ = "[object Symbol]", a$ = "[object ArrayBuffer]", i$ = "[object DataView]", Ul = jl ? jl.prototype : void 0, _a = Ul ? Ul.valueOf : void 0;
function s$(e, t, n, r, o, a, i) {
  switch (n) {
    case i$:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case a$:
      return !(e.byteLength != t.byteLength || !a(new Hl(e), new Hl(t)));
    case XR:
    case ZR:
    case e$:
      return VR(+e, +t);
    case QR:
      return e.name == t.name && e.message == t.message;
    case t$:
    case r$:
      return e == t + "";
    case JR:
      var s = KR;
    case n$:
      var l = r & zR;
      if (s || (s = YR), e.size != t.size && !l)
        return !1;
      var u = i.get(e);
      if (u)
        return u == t;
      r |= qR, i.set(e, t);
      var d = GR(s(e), s(t), r, o, a, i);
      return i.delete(e), d;
    case o$:
      if (_a)
        return _a.call(e) == _a.call(t);
  }
  return !1;
}
var c$ = s$;
function l$(e, t) {
  for (var n = -1, r = t.length, o = e.length; ++n < r; )
    e[o + n] = t[n];
  return e;
}
var Zp = l$, u$ = Zp, d$ = bt;
function f$(e, t, n) {
  var r = t(e);
  return d$(e) ? r : u$(r, n(e));
}
var p$ = f$;
function m$(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = 0, a = []; ++n < r; ) {
    var i = e[n];
    t(i, n, e) && (a[o++] = i);
  }
  return a;
}
var v$ = m$;
function h$() {
  return [];
}
var g$ = h$, b$ = v$, y$ = g$, w$ = Object.prototype, C$ = w$.propertyIsEnumerable, Vl = Object.getOwnPropertySymbols, E$ = Vl ? function(e) {
  return e == null ? [] : (e = Object(e), b$(Vl(e), function(t) {
    return C$.call(e, t);
  }));
} : y$, S$ = E$;
function P$(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var x$ = P$, _$ = fn, T$ = pn, N$ = "[object Arguments]";
function R$(e) {
  return T$(e) && _$(e) == N$;
}
var $$ = R$, Gl = $$, O$ = pn, Qp = Object.prototype, M$ = Qp.hasOwnProperty, D$ = Qp.propertyIsEnumerable, A$ = Gl(function() {
  return arguments;
}()) ? Gl : function(e) {
  return O$(e) && M$.call(e, "callee") && !D$.call(e, "callee");
}, rc = A$, bo = { exports: {} };
function I$() {
  return !1;
}
var k$ = I$;
bo.exports;
(function(e, t) {
  var n = Tt, r = k$, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, i = a && a.exports === o, s = i ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, u = l || r;
  e.exports = u;
})(bo, bo.exports);
var Jp = bo.exports, L$ = 9007199254740991, F$ = /^(?:0|[1-9]\d*)$/;
function B$(e, t) {
  var n = typeof e;
  return t = t ?? L$, !!t && (n == "number" || n != "symbol" && F$.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var oc = B$, W$ = 9007199254740991;
function j$(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= W$;
}
var ac = j$, H$ = fn, U$ = ac, V$ = pn, G$ = "[object Arguments]", K$ = "[object Array]", Y$ = "[object Boolean]", z$ = "[object Date]", q$ = "[object Error]", X$ = "[object Function]", Z$ = "[object Map]", Q$ = "[object Number]", J$ = "[object Object]", eO = "[object RegExp]", tO = "[object Set]", nO = "[object String]", rO = "[object WeakMap]", oO = "[object ArrayBuffer]", aO = "[object DataView]", iO = "[object Float32Array]", sO = "[object Float64Array]", cO = "[object Int8Array]", lO = "[object Int16Array]", uO = "[object Int32Array]", dO = "[object Uint8Array]", fO = "[object Uint8ClampedArray]", pO = "[object Uint16Array]", mO = "[object Uint32Array]", Ce = {};
Ce[iO] = Ce[sO] = Ce[cO] = Ce[lO] = Ce[uO] = Ce[dO] = Ce[fO] = Ce[pO] = Ce[mO] = !0;
Ce[G$] = Ce[K$] = Ce[oO] = Ce[Y$] = Ce[aO] = Ce[z$] = Ce[q$] = Ce[X$] = Ce[Z$] = Ce[Q$] = Ce[J$] = Ce[eO] = Ce[tO] = Ce[nO] = Ce[rO] = !1;
function vO(e) {
  return V$(e) && U$(e.length) && !!Ce[H$(e)];
}
var hO = vO;
function gO(e) {
  return function(t) {
    return e(t);
  };
}
var em = gO, yo = { exports: {} };
yo.exports;
(function(e, t) {
  var n = bp, r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, a = o && o.exports === r, i = a && n.process, s = function() {
    try {
      var l = o && o.require && o.require("util").types;
      return l || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(yo, yo.exports);
var bO = yo.exports, yO = hO, wO = em, Kl = bO, Yl = Kl && Kl.isTypedArray, CO = Yl ? wO(Yl) : yO, tm = CO, EO = x$, SO = rc, PO = bt, xO = Jp, _O = oc, TO = tm, NO = Object.prototype, RO = NO.hasOwnProperty;
function $O(e, t) {
  var n = PO(e), r = !n && SO(e), o = !n && !r && xO(e), a = !n && !r && !o && TO(e), i = n || r || o || a, s = i ? EO(e.length, String) : [], l = s.length;
  for (var u in e)
    (t || RO.call(e, u)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    _O(u, l))) && s.push(u);
  return s;
}
var OO = $O, MO = Object.prototype;
function DO(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || MO;
  return e === n;
}
var AO = DO;
function IO(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var kO = IO, LO = kO, FO = LO(Object.keys, Object), BO = FO, WO = AO, jO = BO, HO = Object.prototype, UO = HO.hasOwnProperty;
function VO(e) {
  if (!WO(e))
    return jO(e);
  var t = [];
  for (var n in Object(e))
    UO.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var GO = VO, KO = zs, YO = ac;
function zO(e) {
  return e != null && YO(e.length) && !KO(e);
}
var Ko = zO, qO = OO, XO = GO, ZO = Ko;
function QO(e) {
  return ZO(e) ? qO(e) : XO(e);
}
var ic = QO, JO = p$, eM = S$, tM = ic;
function nM(e) {
  return JO(e, tM, eM);
}
var rM = nM, zl = rM, oM = 1, aM = Object.prototype, iM = aM.hasOwnProperty;
function sM(e, t, n, r, o, a) {
  var i = n & oM, s = zl(e), l = s.length, u = zl(t), d = u.length;
  if (l != d && !i)
    return !1;
  for (var p = l; p--; ) {
    var v = s[p];
    if (!(i ? v in t : iM.call(t, v)))
      return !1;
  }
  var y = a.get(e), g = a.get(t);
  if (y && g)
    return y == t && g == e;
  var m = !0;
  a.set(e, t), a.set(t, e);
  for (var h = i; ++p < l; ) {
    v = s[p];
    var b = e[v], w = t[v];
    if (r)
      var C = i ? r(w, b, v, t, e, a) : r(b, w, v, e, t, a);
    if (!(C === void 0 ? b === w || o(b, w, n, r, a) : C)) {
      m = !1;
      break;
    }
    h || (h = v == "constructor");
  }
  if (m && !h) {
    var E = e.constructor, P = t.constructor;
    E != P && "constructor" in e && "constructor" in t && !(typeof E == "function" && E instanceof E && typeof P == "function" && P instanceof P) && (m = !1);
  }
  return a.delete(e), a.delete(t), m;
}
var cM = sM, lM = mn, uM = Tt, dM = lM(uM, "DataView"), fM = dM, pM = mn, mM = Tt, vM = pM(mM, "Promise"), hM = vM, gM = mn, bM = Tt, yM = gM(bM, "Set"), nm = yM, wM = mn, CM = Tt, EM = wM(CM, "WeakMap"), SM = EM, vi = fM, hi = Xs, gi = hM, bi = nm, yi = SM, rm = fn, Bn = Cp, ql = "[object Map]", PM = "[object Object]", Xl = "[object Promise]", Zl = "[object Set]", Ql = "[object WeakMap]", Jl = "[object DataView]", xM = Bn(vi), _M = Bn(hi), TM = Bn(gi), NM = Bn(bi), RM = Bn(yi), en = rm;
(vi && en(new vi(new ArrayBuffer(1))) != Jl || hi && en(new hi()) != ql || gi && en(gi.resolve()) != Xl || bi && en(new bi()) != Zl || yi && en(new yi()) != Ql) && (en = function(e) {
  var t = rm(e), n = t == PM ? e.constructor : void 0, r = n ? Bn(n) : "";
  if (r)
    switch (r) {
      case xM:
        return Jl;
      case _M:
        return ql;
      case TM:
        return Xl;
      case NM:
        return Zl;
      case RM:
        return Ql;
    }
  return t;
});
var $M = en, Ta = Yp, OM = Xp, MM = c$, DM = cM, eu = $M, tu = bt, nu = Jp, AM = tm, IM = 1, ru = "[object Arguments]", ou = "[object Array]", Hr = "[object Object]", kM = Object.prototype, au = kM.hasOwnProperty;
function LM(e, t, n, r, o, a) {
  var i = tu(e), s = tu(t), l = i ? ou : eu(e), u = s ? ou : eu(t);
  l = l == ru ? Hr : l, u = u == ru ? Hr : u;
  var d = l == Hr, p = u == Hr, v = l == u;
  if (v && nu(e)) {
    if (!nu(t))
      return !1;
    i = !0, d = !1;
  }
  if (v && !d)
    return a || (a = new Ta()), i || AM(e) ? OM(e, t, n, r, o, a) : MM(e, t, l, n, r, o, a);
  if (!(n & IM)) {
    var y = d && au.call(e, "__wrapped__"), g = p && au.call(t, "__wrapped__");
    if (y || g) {
      var m = y ? e.value() : e, h = g ? t.value() : t;
      return a || (a = new Ta()), o(m, h, n, r, a);
    }
  }
  return v ? (a || (a = new Ta()), DM(e, t, n, r, o, a)) : !1;
}
var FM = LM, BM = FM, iu = pn;
function om(e, t, n, r, o) {
  return e === t ? !0 : e == null || t == null || !iu(e) && !iu(t) ? e !== e && t !== t : BM(e, t, n, r, om, o);
}
var am = om, WM = Yp, jM = am, HM = 1, UM = 2;
function VM(e, t, n, r) {
  var o = n.length, a = o, i = !r;
  if (e == null)
    return !a;
  for (e = Object(e); o--; ) {
    var s = n[o];
    if (i && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++o < a; ) {
    s = n[o];
    var l = s[0], u = e[l], d = s[1];
    if (i && s[2]) {
      if (u === void 0 && !(l in e))
        return !1;
    } else {
      var p = new WM();
      if (r)
        var v = r(u, d, l, e, t, p);
      if (!(v === void 0 ? jM(d, u, HM | UM, r, p) : v))
        return !1;
    }
  }
  return !0;
}
var GM = VM, KM = Gt;
function YM(e) {
  return e === e && !KM(e);
}
var im = YM, zM = im, qM = ic;
function XM(e) {
  for (var t = qM(e), n = t.length; n--; ) {
    var r = t[n], o = e[r];
    t[n] = [r, o, zM(o)];
  }
  return t;
}
var ZM = XM;
function QM(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var sm = QM, JM = GM, eD = ZM, tD = sm;
function nD(e) {
  var t = eD(e);
  return t.length == 1 && t[0][2] ? tD(t[0][0], t[0][1]) : function(n) {
    return n === e || JM(n, e, t);
  };
}
var rD = nD;
function oD(e, t) {
  return e != null && t in Object(e);
}
var aD = oD, iD = _p, sD = rc, cD = bt, lD = oc, uD = ac, dD = Vo;
function fD(e, t, n) {
  t = iD(t, e);
  for (var r = -1, o = t.length, a = !1; ++r < o; ) {
    var i = dD(t[r]);
    if (!(a = e != null && n(e, i)))
      break;
    e = e[i];
  }
  return a || ++r != o ? a : (o = e == null ? 0 : e.length, !!o && uD(o) && lD(i, o) && (cD(e) || sD(e)));
}
var pD = fD, mD = aD, vD = pD;
function hD(e, t) {
  return e != null && vD(e, t, mD);
}
var gD = hD, bD = am, yD = Q1, wD = gD, CD = Ys, ED = im, SD = sm, PD = Vo, xD = 1, _D = 2;
function TD(e, t) {
  return CD(e) && ED(t) ? SD(PD(e), t) : function(n) {
    var r = yD(n, e);
    return r === void 0 && r === t ? wD(n, e) : bD(t, r, xD | _D);
  };
}
var ND = TD;
function RD(e) {
  return e;
}
var Yo = RD;
function $D(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var OD = $D, MD = Js;
function DD(e) {
  return function(t) {
    return MD(t, e);
  };
}
var AD = DD, ID = OD, kD = AD, LD = Ys, FD = Vo;
function BD(e) {
  return LD(e) ? ID(FD(e)) : kD(e);
}
var WD = BD, jD = rD, HD = ND, UD = Yo, VD = bt, GD = WD;
function KD(e) {
  return typeof e == "function" ? e : e == null ? UD : typeof e == "object" ? VD(e) ? HD(e[0], e[1]) : jD(e) : GD(e);
}
var cm = KD;
function YD(e, t, n, r) {
  for (var o = e.length, a = n + (r ? 1 : -1); r ? a-- : ++a < o; )
    if (t(e[a], a, e))
      return a;
  return -1;
}
var zD = YD;
function qD(e) {
  return e !== e;
}
var XD = qD;
function ZD(e, t, n) {
  for (var r = n - 1, o = e.length; ++r < o; )
    if (e[r] === t)
      return r;
  return -1;
}
var QD = ZD, JD = zD, eA = XD, tA = QD;
function nA(e, t, n) {
  return t === t ? tA(e, t, n) : JD(e, eA, n);
}
var rA = nA, oA = rA;
function aA(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && oA(e, t, 0) > -1;
}
var iA = aA;
function sA(e, t, n) {
  for (var r = -1, o = e == null ? 0 : e.length; ++r < o; )
    if (n(t, e[r]))
      return !0;
  return !1;
}
var cA = sA;
function lA() {
}
var uA = lA, Na = nm, dA = uA, fA = nc, pA = 1 / 0, mA = Na && 1 / fA(new Na([, -0]))[1] == pA ? function(e) {
  return new Na(e);
} : dA, vA = mA, hA = zp, gA = iA, bA = cA, yA = qp, wA = vA, CA = nc, EA = 200;
function SA(e, t, n) {
  var r = -1, o = gA, a = e.length, i = !0, s = [], l = s;
  if (n)
    i = !1, o = bA;
  else if (a >= EA) {
    var u = t ? null : wA(e);
    if (u)
      return CA(u);
    i = !1, o = yA, l = new hA();
  } else
    l = t ? [] : s;
  e:
    for (; ++r < a; ) {
      var d = e[r], p = t ? t(d) : d;
      if (d = n || d !== 0 ? d : 0, i && p === p) {
        for (var v = l.length; v--; )
          if (l[v] === p)
            continue e;
        t && l.push(p), s.push(d);
      } else
        o(l, p, n) || (l !== s && l.push(p), s.push(d));
    }
  return s;
}
var PA = SA, xA = cm, _A = PA;
function TA(e, t) {
  return e && e.length ? _A(e, xA(t)) : [];
}
var NA = TA;
const su = /* @__PURE__ */ _t(NA);
function lm(e, t, n) {
  return t === !0 ? su(e, n) : fo(t) ? su(e, t) : e;
}
function $n(e) {
  "@babel/helpers - typeof";
  return $n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $n(e);
}
var RA = ["ref"];
function cu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $t(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cu(Object(n), !0).forEach(function(r) {
      zo(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function $A(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function lu(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, dm(r.key), r);
  }
}
function OA(e, t, n) {
  return t && lu(e.prototype, t), n && lu(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function MA(e, t, n) {
  return t = wo(t), DA(e, um() ? Reflect.construct(t, n || [], wo(e).constructor) : t.apply(e, n));
}
function DA(e, t) {
  if (t && ($n(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return AA(e);
}
function AA(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function um() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (um = function() {
    return !!e;
  })();
}
function wo(e) {
  return wo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, wo(e);
}
function IA(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && wi(e, t);
}
function wi(e, t) {
  return wi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, wi(e, t);
}
function zo(e, t, n) {
  return t = dm(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function dm(e) {
  var t = kA(e, "string");
  return $n(t) == "symbol" ? t : t + "";
}
function kA(e, t) {
  if ($n(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if ($n(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function LA(e, t) {
  if (e == null)
    return {};
  var n = FA(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      r = a[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function FA(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0)
        continue;
      n[r] = e[r];
    }
  return n;
}
function BA(e) {
  return e.value;
}
function WA(e, t) {
  if (/* @__PURE__ */ R.isValidElement(e))
    return /* @__PURE__ */ R.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ R.createElement(e, t);
  t.ref;
  var n = LA(t, RA);
  return /* @__PURE__ */ R.createElement(tc, n);
}
var uu = 1, sc = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    $A(this, t);
    for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++)
      o[a] = arguments[a];
    return n = MA(this, t, [].concat(o)), zo(n, "lastBoundingBox", {
      width: -1,
      height: -1
    }), n;
  }
  return IA(t, e), OA(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        return r.height = this.wrapperNode.offsetHeight, r.width = this.wrapperNode.offsetWidth, r;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var r = this.props.onBBoxUpdate, o = this.getBBox();
      o ? (Math.abs(o.width - this.lastBoundingBox.width) > uu || Math.abs(o.height - this.lastBoundingBox.height) > uu) && (this.lastBoundingBox.width = o.width, this.lastBoundingBox.height = o.height, r && r(o)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, r && r(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? $t({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(r) {
      var o = this.props, a = o.layout, i = o.align, s = o.verticalAlign, l = o.margin, u = o.chartWidth, d = o.chartHeight, p, v;
      if (!r || (r.left === void 0 || r.left === null) && (r.right === void 0 || r.right === null))
        if (i === "center" && a === "vertical") {
          var y = this.getBBoxSnapshot();
          p = {
            left: ((u || 0) - y.width) / 2
          };
        } else
          p = i === "right" ? {
            right: l && l.right || 0
          } : {
            left: l && l.left || 0
          };
      if (!r || (r.top === void 0 || r.top === null) && (r.bottom === void 0 || r.bottom === null))
        if (s === "middle") {
          var g = this.getBBoxSnapshot();
          v = {
            top: ((d || 0) - g.height) / 2
          };
        } else
          v = s === "bottom" ? {
            bottom: l && l.bottom || 0
          } : {
            top: l && l.top || 0
          };
      return $t($t({}, p), v);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, o = this.props, a = o.content, i = o.width, s = o.height, l = o.wrapperStyle, u = o.payloadUniqBy, d = o.payload, p = $t($t({
        position: "absolute",
        width: i || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(l)), l);
      return /* @__PURE__ */ R.createElement("div", {
        className: "recharts-legend-wrapper",
        style: p,
        ref: function(y) {
          r.wrapperNode = y;
        }
      }, WA(a, $t($t({}, this.props), {}, {
        payload: lm(d, u, BA)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(r, o) {
      var a = $t($t({}, this.defaultProps), r.props), i = a.layout;
      return i === "vertical" && ft(r.props.height) ? {
        height: r.props.height
      } : i === "horizontal" ? {
        width: r.props.width || o
      } : null;
    }
  }]);
}(Mo);
zo(sc, "displayName", "Legend");
zo(sc, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var du = Rr, jA = rc, HA = bt, fu = du ? du.isConcatSpreadable : void 0;
function UA(e) {
  return HA(e) || jA(e) || !!(fu && e && e[fu]);
}
var VA = UA, GA = Zp, KA = VA;
function fm(e, t, n, r, o) {
  var a = -1, i = e.length;
  for (n || (n = KA), o || (o = []); ++a < i; ) {
    var s = e[a];
    t > 0 && n(s) ? t > 1 ? fm(s, t - 1, n, r, o) : GA(o, s) : r || (o[o.length] = s);
  }
  return o;
}
var YA = fm;
function zA(e) {
  return function(t, n, r) {
    for (var o = -1, a = Object(t), i = r(t), s = i.length; s--; ) {
      var l = i[e ? s : ++o];
      if (n(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var qA = zA, XA = qA, ZA = XA(), QA = ZA, JA = QA, eI = ic;
function tI(e, t) {
  return e && JA(e, t, eI);
}
var nI = tI, rI = Ko;
function oI(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!rI(n))
      return e(n, r);
    for (var o = n.length, a = t ? o : -1, i = Object(n); (t ? a-- : ++a < o) && r(i[a], a, i) !== !1; )
      ;
    return n;
  };
}
var aI = oI, iI = nI, sI = aI, cI = sI(iI), lI = cI, uI = lI, dI = Ko;
function fI(e, t) {
  var n = -1, r = dI(e) ? Array(e.length) : [];
  return uI(e, function(o, a, i) {
    r[++n] = t(o, a, i);
  }), r;
}
var pI = fI;
function mI(e, t) {
  var n = e.length;
  for (e.sort(t); n--; )
    e[n] = e[n].value;
  return e;
}
var vI = mI, pu = $r;
function hI(e, t) {
  if (e !== t) {
    var n = e !== void 0, r = e === null, o = e === e, a = pu(e), i = t !== void 0, s = t === null, l = t === t, u = pu(t);
    if (!s && !u && !a && e > t || a && i && l && !s && !u || r && i && l || !n && l || !o)
      return 1;
    if (!r && !a && !u && e < t || u && n && o && !r && !a || s && n && o || !i && o || !l)
      return -1;
  }
  return 0;
}
var gI = hI, bI = gI;
function yI(e, t, n) {
  for (var r = -1, o = e.criteria, a = t.criteria, i = o.length, s = n.length; ++r < i; ) {
    var l = bI(o[r], a[r]);
    if (l) {
      if (r >= s)
        return l;
      var u = n[r];
      return l * (u == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var wI = yI, Ra = Sp, CI = Js, EI = cm, SI = pI, PI = vI, xI = em, _I = wI, TI = Yo, NI = bt;
function RI(e, t, n) {
  t.length ? t = Ra(t, function(a) {
    return NI(a) ? function(i) {
      return CI(i, a.length === 1 ? a[0] : a);
    } : a;
  }) : t = [TI];
  var r = -1;
  t = Ra(t, xI(EI));
  var o = SI(e, function(a, i, s) {
    var l = Ra(t, function(u) {
      return u(a);
    });
    return { criteria: l, index: ++r, value: a };
  });
  return PI(o, function(a, i) {
    return _I(a, i, n);
  });
}
var $I = RI;
function OI(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var MI = OI, DI = MI, mu = Math.max;
function AI(e, t, n) {
  return t = mu(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, o = -1, a = mu(r.length - t, 0), i = Array(a); ++o < a; )
      i[o] = r[t + o];
    o = -1;
    for (var s = Array(t + 1); ++o < t; )
      s[o] = r[o];
    return s[t] = n(i), DI(e, this, s);
  };
}
var II = AI;
function kI(e) {
  return function() {
    return e;
  };
}
var LI = kI, FI = mn, BI = function() {
  try {
    var e = FI(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), WI = BI, jI = LI, vu = WI, HI = Yo, UI = vu ? function(e, t) {
  return vu(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: jI(t),
    writable: !0
  });
} : HI, VI = UI, GI = 800, KI = 16, YI = Date.now;
function zI(e) {
  var t = 0, n = 0;
  return function() {
    var r = YI(), o = KI - (r - n);
    if (n = r, o > 0) {
      if (++t >= GI)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var qI = zI, XI = VI, ZI = qI, QI = ZI(XI), JI = QI, ek = Yo, tk = II, nk = JI;
function rk(e, t) {
  return nk(tk(e, t, ek), e + "");
}
var ok = rk, ak = qs, ik = Ko, sk = oc, ck = Gt;
function lk(e, t, n) {
  if (!ck(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? ik(n) && sk(t, n.length) : r == "string" && t in n) ? ak(n[t], e) : !1;
}
var uk = lk, dk = YA, fk = $I, pk = ok, hu = uk, mk = pk(function(e, t) {
  if (e == null)
    return [];
  var n = t.length;
  return n > 1 && hu(e, t[0], t[1]) ? t = [] : n > 2 && hu(t[0], t[1], t[2]) && (t = [t[0]]), fk(e, dk(t, 1), []);
}), vk = mk;
const hk = /* @__PURE__ */ _t(vk);
function dr(e) {
  "@babel/helpers - typeof";
  return dr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, dr(e);
}
function Ci() {
  return Ci = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ci.apply(this, arguments);
}
function gk(e, t) {
  return Ck(e) || wk(e, t) || yk(e, t) || bk();
}
function bk() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yk(e, t) {
  if (e) {
    if (typeof e == "string")
      return gu(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return gu(e, t);
  }
}
function gu(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function wk(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, a, i, s = [], l = !0, u = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (d) {
      u = !0, o = d;
    } finally {
      try {
        if (!l && n.return != null && (i = n.return(), Object(i) !== i))
          return;
      } finally {
        if (u)
          throw o;
      }
    }
    return s;
  }
}
function Ck(e) {
  if (Array.isArray(e))
    return e;
}
function bu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $a(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bu(Object(n), !0).forEach(function(r) {
      Ek(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ek(e, t, n) {
  return t = Sk(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Sk(e) {
  var t = Pk(e, "string");
  return dr(t) == "symbol" ? t : t + "";
}
function Pk(e, t) {
  if (dr(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (dr(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function xk(e) {
  return Array.isArray(e) && po(e[0]) && po(e[1]) ? e.join(" ~ ") : e;
}
var _k = function(t) {
  var n = t.separator, r = n === void 0 ? " : " : n, o = t.contentStyle, a = o === void 0 ? {} : o, i = t.itemStyle, s = i === void 0 ? {} : i, l = t.labelStyle, u = l === void 0 ? {} : l, d = t.payload, p = t.formatter, v = t.itemSorter, y = t.wrapperClassName, g = t.labelClassName, m = t.label, h = t.labelFormatter, b = t.accessibilityLayer, w = b === void 0 ? !1 : b, C = function() {
    if (d && d.length) {
      var U = {
        padding: 0,
        margin: 0
      }, M = (v ? hk(d, v) : d).map(function(F, W) {
        if (F.type === "none")
          return null;
        var H = $a({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: F.color || "#000"
        }, s), A = F.formatter || p || xk, D = F.value, B = F.name, Q = D, q = B;
        if (A && Q != null && q != null) {
          var O = A(D, B, F, W, d);
          if (Array.isArray(O)) {
            var j = gk(O, 2);
            Q = j[0], q = j[1];
          } else
            Q = O;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ R.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(W),
            style: H
          }, po(q) ? /* @__PURE__ */ R.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, q) : null, po(q) ? /* @__PURE__ */ R.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, r) : null, /* @__PURE__ */ R.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, Q), /* @__PURE__ */ R.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, F.unit || ""))
        );
      });
      return /* @__PURE__ */ R.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: U
      }, M);
    }
    return null;
  }, E = $a({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, a), P = $a({
    margin: 0
  }, u), x = !tT(m), S = x ? m : "", _ = rn("recharts-default-tooltip", y), T = rn("recharts-tooltip-label", g);
  x && h && d !== void 0 && d !== null && (S = h(m, d));
  var k = w ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ R.createElement("div", Ci({
    className: _,
    style: E
  }, k), /* @__PURE__ */ R.createElement("p", {
    className: T,
    style: P
  }, /* @__PURE__ */ R.isValidElement(S) ? S : "".concat(S)), C());
};
function fr(e) {
  "@babel/helpers - typeof";
  return fr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fr(e);
}
function Ur(e, t, n) {
  return t = Tk(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Tk(e) {
  var t = Nk(e, "string");
  return fr(t) == "symbol" ? t : t + "";
}
function Nk(e, t) {
  if (fr(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (fr(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var zn = "recharts-tooltip-wrapper", Rk = {
  visibility: "hidden"
};
function $k(e) {
  var t = e.coordinate, n = e.translateX, r = e.translateY;
  return rn(zn, Ur(Ur(Ur(Ur({}, "".concat(zn, "-right"), ft(n) && t && ft(t.x) && n >= t.x), "".concat(zn, "-left"), ft(n) && t && ft(t.x) && n < t.x), "".concat(zn, "-bottom"), ft(r) && t && ft(t.y) && r >= t.y), "".concat(zn, "-top"), ft(r) && t && ft(t.y) && r < t.y));
}
function yu(e) {
  var t = e.allowEscapeViewBox, n = e.coordinate, r = e.key, o = e.offsetTopLeft, a = e.position, i = e.reverseDirection, s = e.tooltipDimension, l = e.viewBox, u = e.viewBoxDimension;
  if (a && ft(a[r]))
    return a[r];
  var d = n[r] - s - o, p = n[r] + o;
  if (t[r])
    return i[r] ? d : p;
  if (i[r]) {
    var v = d, y = l[r];
    return v < y ? Math.max(p, l[r]) : Math.max(d, l[r]);
  }
  var g = p + s, m = l[r] + u;
  return g > m ? Math.max(d, l[r]) : Math.max(p, l[r]);
}
function Ok(e) {
  var t = e.translateX, n = e.translateY, r = e.useTranslate3d;
  return {
    transform: r ? "translate3d(".concat(t, "px, ").concat(n, "px, 0)") : "translate(".concat(t, "px, ").concat(n, "px)")
  };
}
function Mk(e) {
  var t = e.allowEscapeViewBox, n = e.coordinate, r = e.offsetTopLeft, o = e.position, a = e.reverseDirection, i = e.tooltipBox, s = e.useTranslate3d, l = e.viewBox, u, d, p;
  return i.height > 0 && i.width > 0 && n ? (d = yu({
    allowEscapeViewBox: t,
    coordinate: n,
    key: "x",
    offsetTopLeft: r,
    position: o,
    reverseDirection: a,
    tooltipDimension: i.width,
    viewBox: l,
    viewBoxDimension: l.width
  }), p = yu({
    allowEscapeViewBox: t,
    coordinate: n,
    key: "y",
    offsetTopLeft: r,
    position: o,
    reverseDirection: a,
    tooltipDimension: i.height,
    viewBox: l,
    viewBoxDimension: l.height
  }), u = Ok({
    translateX: d,
    translateY: p,
    useTranslate3d: s
  })) : u = Rk, {
    cssProperties: u,
    cssClasses: $k({
      translateX: d,
      translateY: p,
      coordinate: n
    })
  };
}
function On(e) {
  "@babel/helpers - typeof";
  return On = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, On(e);
}
function wu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Cu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wu(Object(n), !0).forEach(function(r) {
      Si(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Dk(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Eu(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, mm(r.key), r);
  }
}
function Ak(e, t, n) {
  return t && Eu(e.prototype, t), n && Eu(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Ik(e, t, n) {
  return t = Co(t), kk(e, pm() ? Reflect.construct(t, n || [], Co(e).constructor) : t.apply(e, n));
}
function kk(e, t) {
  if (t && (On(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Lk(e);
}
function Lk(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function pm() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (pm = function() {
    return !!e;
  })();
}
function Co(e) {
  return Co = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Co(e);
}
function Fk(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ei(e, t);
}
function Ei(e, t) {
  return Ei = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Ei(e, t);
}
function Si(e, t, n) {
  return t = mm(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function mm(e) {
  var t = Bk(e, "string");
  return On(t) == "symbol" ? t : t + "";
}
function Bk(e, t) {
  if (On(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (On(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Su = 1, Wk = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    Dk(this, t);
    for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++)
      o[a] = arguments[a];
    return n = Ik(this, t, [].concat(o)), Si(n, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), Si(n, "handleKeyDown", function(i) {
      if (i.key === "Escape") {
        var s, l, u, d;
        n.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (l = n.props.coordinate) === null || l === void 0 ? void 0 : l.x) !== null && s !== void 0 ? s : 0,
            y: (u = (d = n.props.coordinate) === null || d === void 0 ? void 0 : d.y) !== null && u !== void 0 ? u : 0
          }
        });
      }
    }), n;
  }
  return Fk(t, e), Ak(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        (Math.abs(r.width - this.state.lastBoundingBox.width) > Su || Math.abs(r.height - this.state.lastBoundingBox.height) > Su) && this.setState({
          lastBoundingBox: {
            width: r.width,
            height: r.height
          }
        });
      } else
        (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
          lastBoundingBox: {
            width: -1,
            height: -1
          }
        });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var r, o;
      this.props.active && this.updateBBox(), this.state.dismissed && (((r = this.props.coordinate) === null || r === void 0 ? void 0 : r.x) !== this.state.dismissedAtCoordinate.x || ((o = this.props.coordinate) === null || o === void 0 ? void 0 : o.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, o = this.props, a = o.active, i = o.allowEscapeViewBox, s = o.animationDuration, l = o.animationEasing, u = o.children, d = o.coordinate, p = o.hasPayload, v = o.isAnimationActive, y = o.offset, g = o.position, m = o.reverseDirection, h = o.useTranslate3d, b = o.viewBox, w = o.wrapperStyle, C = Mk({
        allowEscapeViewBox: i,
        coordinate: d,
        offsetTopLeft: y,
        position: g,
        reverseDirection: m,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: h,
        viewBox: b
      }), E = C.cssClasses, P = C.cssProperties, x = Cu(Cu({
        transition: v && a ? "transform ".concat(s, "ms ").concat(l) : void 0
      }, P), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && a && p ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, w);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ R.createElement("div", {
          tabIndex: -1,
          className: E,
          style: x,
          ref: function(_) {
            r.wrapperNode = _;
          }
        }, u)
      );
    }
  }]);
}(Mo), jk = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, no = {
  isSsr: jk(),
  get: function(t) {
    return no[t];
  },
  set: function(t, n) {
    if (typeof t == "string")
      no[t] = n;
    else {
      var r = Object.keys(t);
      r && r.length && r.forEach(function(o) {
        no[o] = t[o];
      });
    }
  }
};
function Mn(e) {
  "@babel/helpers - typeof";
  return Mn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mn(e);
}
function Pu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pu(Object(n), !0).forEach(function(r) {
      cc(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Hk(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _u(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, hm(r.key), r);
  }
}
function Uk(e, t, n) {
  return t && _u(e.prototype, t), n && _u(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Vk(e, t, n) {
  return t = Eo(t), Gk(e, vm() ? Reflect.construct(t, n || [], Eo(e).constructor) : t.apply(e, n));
}
function Gk(e, t) {
  if (t && (Mn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Kk(e);
}
function Kk(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function vm() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (vm = function() {
    return !!e;
  })();
}
function Eo(e) {
  return Eo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Eo(e);
}
function Yk(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Pi(e, t);
}
function Pi(e, t) {
  return Pi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Pi(e, t);
}
function cc(e, t, n) {
  return t = hm(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function hm(e) {
  var t = zk(e, "string");
  return Mn(t) == "symbol" ? t : t + "";
}
function zk(e, t) {
  if (Mn(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Mn(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function qk(e) {
  return e.dataKey;
}
function Xk(e, t) {
  return /* @__PURE__ */ R.isValidElement(e) ? /* @__PURE__ */ R.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ R.createElement(e, t) : /* @__PURE__ */ R.createElement(_k, t);
}
var lc = /* @__PURE__ */ function(e) {
  function t() {
    return Hk(this, t), Vk(this, t, arguments);
  }
  return Yk(t, e), Uk(t, [{
    key: "render",
    value: function() {
      var r = this, o = this.props, a = o.active, i = o.allowEscapeViewBox, s = o.animationDuration, l = o.animationEasing, u = o.content, d = o.coordinate, p = o.filterNull, v = o.isAnimationActive, y = o.offset, g = o.payload, m = o.payloadUniqBy, h = o.position, b = o.reverseDirection, w = o.useTranslate3d, C = o.viewBox, E = o.wrapperStyle, P = g ?? [];
      p && P.length && (P = lm(g.filter(function(S) {
        return S.value != null && (S.hide !== !0 || r.props.includeHidden);
      }), m, qk));
      var x = P.length > 0;
      return /* @__PURE__ */ R.createElement(Wk, {
        allowEscapeViewBox: i,
        animationDuration: s,
        animationEasing: l,
        isAnimationActive: v,
        active: a,
        coordinate: d,
        hasPayload: x,
        offset: y,
        position: h,
        reverseDirection: b,
        useTranslate3d: w,
        viewBox: C,
        wrapperStyle: E
      }, Xk(u, xu(xu({}, this.props), {}, {
        payload: P
      })));
    }
  }]);
}(Mo);
cc(lc, "displayName", "Tooltip");
cc(lc, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !no.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var Zk = Tt, Qk = function() {
  return Zk.Date.now();
}, Jk = Qk, eL = /\s/;
function tL(e) {
  for (var t = e.length; t-- && eL.test(e.charAt(t)); )
    ;
  return t;
}
var nL = tL, rL = nL, oL = /^\s+/;
function aL(e) {
  return e && e.slice(0, rL(e) + 1).replace(oL, "");
}
var iL = aL, sL = iL, Tu = Gt, cL = $r, Nu = 0 / 0, lL = /^[-+]0x[0-9a-f]+$/i, uL = /^0b[01]+$/i, dL = /^0o[0-7]+$/i, fL = parseInt;
function pL(e) {
  if (typeof e == "number")
    return e;
  if (cL(e))
    return Nu;
  if (Tu(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Tu(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = sL(e);
  var n = uL.test(e);
  return n || dL.test(e) ? fL(e.slice(2), n ? 2 : 8) : lL.test(e) ? Nu : +e;
}
var mL = pL, vL = Gt, Oa = Jk, Ru = mL, hL = "Expected a function", gL = Math.max, bL = Math.min;
function yL(e, t, n) {
  var r, o, a, i, s, l, u = 0, d = !1, p = !1, v = !0;
  if (typeof e != "function")
    throw new TypeError(hL);
  t = Ru(t) || 0, vL(n) && (d = !!n.leading, p = "maxWait" in n, a = p ? gL(Ru(n.maxWait) || 0, t) : a, v = "trailing" in n ? !!n.trailing : v);
  function y(x) {
    var S = r, _ = o;
    return r = o = void 0, u = x, i = e.apply(_, S), i;
  }
  function g(x) {
    return u = x, s = setTimeout(b, t), d ? y(x) : i;
  }
  function m(x) {
    var S = x - l, _ = x - u, T = t - S;
    return p ? bL(T, a - _) : T;
  }
  function h(x) {
    var S = x - l, _ = x - u;
    return l === void 0 || S >= t || S < 0 || p && _ >= a;
  }
  function b() {
    var x = Oa();
    if (h(x))
      return w(x);
    s = setTimeout(b, m(x));
  }
  function w(x) {
    return s = void 0, v && r ? y(x) : (r = o = void 0, i);
  }
  function C() {
    s !== void 0 && clearTimeout(s), u = 0, r = l = o = s = void 0;
  }
  function E() {
    return s === void 0 ? i : w(Oa());
  }
  function P() {
    var x = Oa(), S = h(x);
    if (r = arguments, o = this, l = x, S) {
      if (s === void 0)
        return g(l);
      if (p)
        return clearTimeout(s), s = setTimeout(b, t), y(l);
    }
    return s === void 0 && (s = setTimeout(b, t)), i;
  }
  return P.cancel = C, P.flush = E, P;
}
var wL = yL, CL = wL, EL = Gt, SL = "Expected a function";
function PL(e, t, n) {
  var r = !0, o = !0;
  if (typeof e != "function")
    throw new TypeError(SL);
  return EL(n) && (r = "leading" in n ? !!n.leading : r, o = "trailing" in n ? !!n.trailing : o), CL(e, t, {
    leading: r,
    maxWait: t,
    trailing: o
  });
}
var xL = PL;
const _L = /* @__PURE__ */ _t(xL);
function pr(e) {
  "@babel/helpers - typeof";
  return pr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pr(e);
}
function $u(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Vr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $u(Object(n), !0).forEach(function(r) {
      TL(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $u(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function TL(e, t, n) {
  return t = NL(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function NL(e) {
  var t = RL(e, "string");
  return pr(t) == "symbol" ? t : t + "";
}
function RL(e, t) {
  if (pr(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (pr(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function $L(e, t) {
  return AL(e) || DL(e, t) || ML(e, t) || OL();
}
function OL() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ML(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ou(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Ou(e, t);
  }
}
function Ou(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function DL(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, a, i, s = [], l = !0, u = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (d) {
      u = !0, o = d;
    } finally {
      try {
        if (!l && n.return != null && (i = n.return(), Object(i) !== i))
          return;
      } finally {
        if (u)
          throw o;
      }
    }
    return s;
  }
}
function AL(e) {
  if (Array.isArray(e))
    return e;
}
var IL = /* @__PURE__ */ Xe(function(e, t) {
  var n = e.aspect, r = e.initialDimension, o = r === void 0 ? {
    width: -1,
    height: -1
  } : r, a = e.width, i = a === void 0 ? "100%" : a, s = e.height, l = s === void 0 ? "100%" : s, u = e.minWidth, d = u === void 0 ? 0 : u, p = e.minHeight, v = e.maxHeight, y = e.children, g = e.debounce, m = g === void 0 ? 0 : g, h = e.id, b = e.className, w = e.onResize, C = e.style, E = C === void 0 ? {} : C, P = Ne(null), x = Ne();
  x.current = w, Zy(t, function() {
    return Object.defineProperty(P.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), P.current;
      },
      configurable: !0
    });
  });
  var S = Je({
    containerWidth: o.width,
    containerHeight: o.height
  }), _ = $L(S, 2), T = _[0], k = _[1], L = un(function(M, F) {
    k(function(W) {
      var H = Math.round(M), A = Math.round(F);
      return W.containerWidth === H && W.containerHeight === A ? W : {
        containerWidth: H,
        containerHeight: A
      };
    });
  }, []);
  Ee(function() {
    var M = function(B) {
      var Q, q = B[0].contentRect, O = q.width, j = q.height;
      L(O, j), (Q = x.current) === null || Q === void 0 || Q.call(x, O, j);
    };
    m > 0 && (M = _L(M, m, {
      trailing: !0,
      leading: !1
    }));
    var F = new ResizeObserver(M), W = P.current.getBoundingClientRect(), H = W.width, A = W.height;
    return L(H, A), F.observe(P.current), function() {
      F.disconnect();
    };
  }, [L, m]);
  var U = Ht(function() {
    var M = T.containerWidth, F = T.containerHeight;
    if (M < 0 || F < 0)
      return null;
    to(Wr(i) || Wr(l), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, i, l), to(!n || n > 0, "The aspect(%s) must be greater than zero.", n);
    var W = Wr(i) ? M : i, H = Wr(l) ? F : l;
    n && n > 0 && (W ? H = W / n : H && (W = H * n), v && H > v && (H = v)), to(W > 0 || H > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, W, H, i, l, d, p, n);
    var A = !Array.isArray(y) && ST(y.type).endsWith("Chart");
    return R.Children.map(y, function(D) {
      return /* @__PURE__ */ R.isValidElement(D) ? /* @__PURE__ */ Do(D, Vr({
        width: W,
        height: H
      }, A ? {
        style: Vr({
          height: "100%",
          width: "100%",
          maxHeight: H,
          maxWidth: W
        }, D.props.style)
      } : {})) : D;
    });
  }, [n, y, l, v, p, d, T, i]);
  return /* @__PURE__ */ R.createElement("div", {
    id: h ? "".concat(h) : void 0,
    className: rn("recharts-responsive-container", b),
    style: Vr(Vr({}, E), {}, {
      width: i,
      height: l,
      minWidth: d,
      minHeight: p,
      maxHeight: v
    }),
    ref: P
  }, U);
});
function Ve() {
  return Ve = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ve.apply(null, arguments);
}
const kL = { light: "", dark: ".dark" }, gm = c.createContext(null);
function bm() {
  const e = c.useContext(gm);
  if (!e)
    throw new Error("useChart must be used within a <ChartContainer />");
  return e;
}
const LL = c.forwardRef(({ id: e, className: t, children: n, config: r, ...o }, a) => {
  const i = c.useId(), s = `chart-${e || i.replace(/:/g, "")}`;
  return /* @__PURE__ */ f(gm.Provider, { value: { config: r }, children: /* @__PURE__ */ X(
    "div",
    {
      "data-chart": s,
      ref: a,
      className: $(
        "flex aspect-video justify-center text-xs [&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-none [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none",
        t
      ),
      ...o,
      children: [
        /* @__PURE__ */ f(FL, { id: s, config: r }),
        /* @__PURE__ */ f(IL, { children: n })
      ]
    }
  ) });
});
LL.displayName = "Chart";
const FL = ({ id: e, config: t }) => {
  const n = Object.entries(t).filter(
    ([, r]) => r.theme || r.color
  );
  return n.length ? /* @__PURE__ */ f(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: Object.entries(kL).map(
          ([r, o]) => `
${o} [data-chart=${e}] {
${n.map(([a, i]) => {
            var l;
            const s = ((l = i.theme) == null ? void 0 : l[r]) || i.color;
            return s ? `  --color-${a}: ${s};` : null;
          }).join(`
`)}
}
`
        ).join(`
`)
      }
    }
  ) : null;
}, D8 = lc, BL = c.forwardRef(
  ({
    active: e,
    payload: t,
    className: n,
    indicator: r = "dot",
    hideLabel: o = !1,
    hideIndicator: a = !1,
    label: i,
    labelFormatter: s,
    labelClassName: l,
    formatter: u,
    color: d,
    nameKey: p,
    labelKey: v
  }, y) => {
    const { config: g } = bm(), m = c.useMemo(() => {
      var P;
      if (o || !(t != null && t.length))
        return null;
      const [b] = t, w = `${v || b.dataKey || b.name || "value"}`, C = xi(g, b, w), E = !v && typeof i == "string" ? ((P = g[i]) == null ? void 0 : P.label) || i : C == null ? void 0 : C.label;
      return s ? /* @__PURE__ */ f("div", { className: $("font-medium", l), children: s(E, t) }) : E ? /* @__PURE__ */ f("div", { className: $("font-medium", l), children: E }) : null;
    }, [
      i,
      s,
      t,
      o,
      l,
      g,
      v
    ]);
    if (!e || !(t != null && t.length))
      return null;
    const h = t.length === 1 && r !== "dot";
    return /* @__PURE__ */ X(
      "div",
      {
        ref: y,
        className: $(
          "grid min-w-[8rem] items-start gap-1.5 rounded-lg border border-border/50 bg-background px-2.5 py-1.5 text-xs shadow-xl",
          n
        ),
        children: [
          h ? null : m,
          /* @__PURE__ */ f("div", { className: "grid gap-1.5", children: t.map((b, w) => {
            const C = `${p || b.name || b.dataKey || "value"}`, E = xi(g, b, C), P = d || b.payload.fill || b.color;
            return /* @__PURE__ */ f(
              "div",
              {
                className: $(
                  "flex w-full flex-wrap items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5 [&>svg]:text-muted-foreground",
                  r === "dot" && "items-center"
                ),
                children: u && (b == null ? void 0 : b.value) !== void 0 && b.name ? u(b.value, b.name, b, w, b.payload) : /* @__PURE__ */ X(Oe, { children: [
                  E != null && E.icon ? /* @__PURE__ */ f(E.icon, {}) : !a && /* @__PURE__ */ f(
                    "div",
                    {
                      className: $(
                        "shrink-0 rounded-[2px] border-[--color-border] bg-[--color-bg]",
                        {
                          "h-2.5 w-2.5": r === "dot",
                          "w-1": r === "line",
                          "w-0 border-[1.5px] border-dashed bg-transparent": r === "dashed",
                          "my-0.5": h && r === "dashed"
                        }
                      ),
                      style: {
                        "--color-bg": P,
                        "--color-border": P
                      }
                    }
                  ),
                  /* @__PURE__ */ X(
                    "div",
                    {
                      className: $(
                        "flex flex-1 justify-between leading-none",
                        h ? "items-end" : "items-center"
                      ),
                      children: [
                        /* @__PURE__ */ X("div", { className: "grid gap-1.5", children: [
                          h ? m : null,
                          /* @__PURE__ */ f("span", { className: "text-muted-foreground", children: (E == null ? void 0 : E.label) || b.name })
                        ] }),
                        b.value && /* @__PURE__ */ f("span", { className: "font-mono font-medium tabular-nums text-foreground", children: b.value.toLocaleString() })
                      ]
                    }
                  )
                ] })
              },
              b.dataKey
            );
          }) })
        ]
      }
    );
  }
);
BL.displayName = "ChartTooltip";
const A8 = sc, WL = c.forwardRef(
  ({ className: e, hideIcon: t = !1, payload: n, verticalAlign: r = "bottom", nameKey: o }, a) => {
    const { config: i } = bm();
    return n != null && n.length ? /* @__PURE__ */ f(
      "div",
      {
        ref: a,
        className: $(
          "flex items-center justify-center gap-4",
          r === "top" ? "pb-3" : "pt-3",
          e
        ),
        children: n.map((s) => {
          const l = `${o || s.dataKey || "value"}`, u = xi(i, s, l);
          return /* @__PURE__ */ X(
            "div",
            {
              className: $(
                "flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:text-muted-foreground"
              ),
              children: [
                u != null && u.icon && !t ? /* @__PURE__ */ f(u.icon, {}) : /* @__PURE__ */ f(
                  "div",
                  {
                    className: "h-2 w-2 shrink-0 rounded-[2px]",
                    style: {
                      backgroundColor: s.color
                    }
                  }
                ),
                u == null ? void 0 : u.label
              ]
            },
            s.value
          );
        })
      }
    ) : null;
  }
);
WL.displayName = "ChartLegend";
function xi(e, t, n) {
  if (typeof t != "object" || t === null)
    return;
  const r = "payload" in t && typeof t.payload == "object" && t.payload !== null ? t.payload : void 0;
  let o = n;
  return n in t && typeof t[n] == "string" ? o = t[n] : r && n in r && typeof r[n] == "string" && (o = r[n]), o in e ? e[o] : e[n];
}
var uc = "Checkbox", [jL, I8] = Re(uc), [HL, UL] = jL(uc), ym = c.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: l = "on",
      onCheckedChange: u,
      form: d,
      ...p
    } = e, [v, y] = c.useState(null), g = ne(t, (E) => y(E)), m = c.useRef(!1), h = v ? d || !!v.closest("form") : !0, [b = !1, w] = Me({
      prop: o,
      defaultProp: a,
      onChange: u
    }), C = c.useRef(b);
    return c.useEffect(() => {
      const E = v == null ? void 0 : v.form;
      if (E) {
        const P = () => w(C.current);
        return E.addEventListener("reset", P), () => E.removeEventListener("reset", P);
      }
    }, [v, w]), /* @__PURE__ */ X(HL, { scope: n, state: b, disabled: s, children: [
      /* @__PURE__ */ f(
        G.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": jt(b) ? "mixed" : b,
          "aria-required": i,
          "data-state": Em(b),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...p,
          ref: g,
          onKeyDown: I(e.onKeyDown, (E) => {
            E.key === "Enter" && E.preventDefault();
          }),
          onClick: I(e.onClick, (E) => {
            w((P) => jt(P) ? !0 : !P), h && (m.current = E.isPropagationStopped(), m.current || E.stopPropagation());
          })
        }
      ),
      h && /* @__PURE__ */ f(
        VL,
        {
          control: v,
          bubbles: !m.current,
          name: r,
          value: l,
          checked: b,
          required: i,
          disabled: s,
          form: d,
          style: { transform: "translateX(-100%)" },
          defaultChecked: jt(a) ? !1 : a
        }
      )
    ] });
  }
);
ym.displayName = uc;
var wm = "CheckboxIndicator", Cm = c.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, a = UL(wm, n);
    return /* @__PURE__ */ f(Fe, { present: r || jt(a.state) || a.state === !0, children: /* @__PURE__ */ f(
      G.span,
      {
        "data-state": Em(a.state),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
Cm.displayName = wm;
var VL = (e) => {
  const { control: t, checked: n, bubbles: r = !0, defaultChecked: o, ...a } = e, i = c.useRef(null), s = Cr(n), l = yr(t);
  c.useEffect(() => {
    const d = i.current, p = window.HTMLInputElement.prototype, y = Object.getOwnPropertyDescriptor(p, "checked").set;
    if (s !== n && y) {
      const g = new Event("click", { bubbles: r });
      d.indeterminate = jt(n), y.call(d, jt(n) ? !1 : n), d.dispatchEvent(g);
    }
  }, [s, n, r]);
  const u = c.useRef(jt(n) ? !1 : n);
  return /* @__PURE__ */ f(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: o ?? u.current,
      ...a,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function jt(e) {
  return e === "indeterminate";
}
function Em(e) {
  return jt(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var Sm = ym, GL = Cm;
const KL = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Sm,
  {
    ref: n,
    className: $(
      "peer h-4 w-4 shrink-0 rounded-sm border border-primary shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      e
    ),
    ...t,
    children: /* @__PURE__ */ f(
      GL,
      {
        className: $("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ f(gs, { className: "h-4 w-4" })
      }
    )
  }
));
KL.displayName = Sm.displayName;
var Pm = c.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = c.Children.toArray(n), a = o.find(zL);
  if (a) {
    const i = a.props.children, s = o.map((l) => l === a ? c.Children.count(i) > 1 ? c.Children.only(null) : c.isValidElement(i) ? i.props.children : null : l);
    return /* @__PURE__ */ f(_i, { ...r, ref: t, children: c.isValidElement(i) ? c.cloneElement(i, void 0, s) : null });
  }
  return /* @__PURE__ */ f(_i, { ...r, ref: t, children: n });
});
Pm.displayName = "Slot";
var _i = c.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (c.isValidElement(n)) {
    const o = XL(n);
    return c.cloneElement(n, {
      ...qL(r, n.props),
      // @ts-ignore
      ref: t ? wr(t, o) : o
    });
  }
  return c.Children.count(n) > 1 ? c.Children.only(null) : null;
});
_i.displayName = "SlotClone";
var YL = ({ children: e }) => /* @__PURE__ */ f(Oe, { children: e });
function zL(e) {
  return c.isValidElement(e) && e.type === YL;
}
function qL(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function XL(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var ZL = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], dc = ZL.reduce((e, t) => {
  const n = c.forwardRef((r, o) => {
    const { asChild: a, ...i } = r, s = a ? Pm : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(s, { ...i, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), fc = "Collapsible", [QL, k8] = Re(fc), [JL, pc] = QL(fc), xm = c.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: o,
      disabled: a,
      onOpenChange: i,
      ...s
    } = e, [l = !1, u] = Me({
      prop: r,
      defaultProp: o,
      onChange: i
    });
    return /* @__PURE__ */ f(
      JL,
      {
        scope: n,
        disabled: a,
        contentId: ze(),
        open: l,
        onOpenToggle: c.useCallback(() => u((d) => !d), [u]),
        children: /* @__PURE__ */ f(
          dc.div,
          {
            "data-state": vc(l),
            "data-disabled": a ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
xm.displayName = fc;
var _m = "CollapsibleTrigger", Tm = c.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, o = pc(_m, n);
    return /* @__PURE__ */ f(
      dc.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": vc(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: t,
        onClick: I(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Tm.displayName = _m;
var mc = "CollapsibleContent", Nm = c.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = pc(mc, e.__scopeCollapsible);
    return /* @__PURE__ */ f(Fe, { present: n || o.open, children: ({ present: a }) => /* @__PURE__ */ f(e2, { ...r, ref: t, present: a }) });
  }
);
Nm.displayName = mc;
var e2 = c.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...a } = e, i = pc(mc, n), [s, l] = c.useState(r), u = c.useRef(null), d = ne(t, u), p = c.useRef(0), v = p.current, y = c.useRef(0), g = y.current, m = i.open || s, h = c.useRef(m), b = c.useRef(void 0);
  return c.useEffect(() => {
    const w = requestAnimationFrame(() => h.current = !1);
    return () => cancelAnimationFrame(w);
  }, []), mt(() => {
    const w = u.current;
    if (w) {
      b.current = b.current || {
        transitionDuration: w.style.transitionDuration,
        animationName: w.style.animationName
      }, w.style.transitionDuration = "0s", w.style.animationName = "none";
      const C = w.getBoundingClientRect();
      p.current = C.height, y.current = C.width, h.current || (w.style.transitionDuration = b.current.transitionDuration, w.style.animationName = b.current.animationName), l(r);
    }
  }, [i.open, r]), /* @__PURE__ */ f(
    dc.div,
    {
      "data-state": vc(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !m,
      ...a,
      ref: d,
      style: {
        "--radix-collapsible-content-height": v ? `${v}px` : void 0,
        "--radix-collapsible-content-width": g ? `${g}px` : void 0,
        ...e.style
      },
      children: m && o
    }
  );
});
function vc(e) {
  return e ? "open" : "closed";
}
var t2 = xm;
const L8 = t2, F8 = Tm, B8 = Nm;
var Mu = 1, n2 = 0.9, r2 = 0.8, o2 = 0.17, Ma = 0.1, Da = 0.999, a2 = 0.9999, i2 = 0.99, s2 = /[\\\/_+.#"@\[\(\{&]/, c2 = /[\\\/_+.#"@\[\(\{&]/g, l2 = /[\s-]/, Rm = /[\s-]/g;
function Ti(e, t, n, r, o, a, i) {
  if (a === t.length)
    return o === e.length ? Mu : i2;
  var s = `${o},${a}`;
  if (i[s] !== void 0)
    return i[s];
  for (var l = r.charAt(a), u = n.indexOf(l, o), d = 0, p, v, y, g; u >= 0; )
    p = Ti(e, t, n, r, u + 1, a + 1, i), p > d && (u === o ? p *= Mu : s2.test(e.charAt(u - 1)) ? (p *= r2, y = e.slice(o, u - 1).match(c2), y && o > 0 && (p *= Math.pow(Da, y.length))) : l2.test(e.charAt(u - 1)) ? (p *= n2, g = e.slice(o, u - 1).match(Rm), g && o > 0 && (p *= Math.pow(Da, g.length))) : (p *= o2, o > 0 && (p *= Math.pow(Da, u - o))), e.charAt(u) !== t.charAt(a) && (p *= a2)), (p < Ma && n.charAt(u - 1) === r.charAt(a + 1) || r.charAt(a + 1) === r.charAt(a) && n.charAt(u - 1) !== r.charAt(a)) && (v = Ti(e, t, n, r, u + 1, a + 2, i), v * Ma > p && (p = v * Ma)), p > d && (d = p), u = n.indexOf(l, u + 1);
  return i[s] = d, d;
}
function Du(e) {
  return e.toLowerCase().replace(Rm, " ");
}
function u2(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, Ti(e, t, Du(e), Du(t), 0, 0, {});
}
function _n(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function d2(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function $m(...e) {
  return (t) => e.forEach(
    (n) => d2(n, t)
  );
}
function Or(...e) {
  return un($m(...e), e);
}
function f2(e, t = []) {
  let n = [];
  function r(a, i) {
    const s = /* @__PURE__ */ Pt(i), l = n.length;
    n = [
      ...n,
      i
    ];
    function u(p) {
      const { scope: v, children: y, ...g } = p, m = (v == null ? void 0 : v[e][l]) || s, h = Ht(
        () => g,
        Object.values(g)
      );
      return /* @__PURE__ */ xe(m.Provider, {
        value: h
      }, y);
    }
    function d(p, v) {
      const y = (v == null ? void 0 : v[e][l]) || s, g = Mt(y);
      if (g)
        return g;
      if (i !== void 0)
        return i;
      throw new Error(`\`${p}\` must be used within \`${a}\``);
    }
    return u.displayName = a + "Provider", [
      u,
      d
    ];
  }
  const o = () => {
    const a = n.map((i) => /* @__PURE__ */ Pt(i));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || a;
      return Ht(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: l
          }
        }),
        [
          s,
          l
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    p2(o, ...t)
  ];
}
function p2(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(a) {
      const i = r.reduce((s, { useScope: l, scopeName: u }) => {
        const p = l(a)[`__scope${u}`];
        return {
          ...s,
          ...p
        };
      }, {});
      return Ht(
        () => ({
          [`__scope${t.scopeName}`]: i
        }),
        [
          i
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const m2 = globalThis != null && globalThis.document ? Oo : () => {
}, v2 = c["useId".toString()] || (() => {
});
let h2 = 0;
function Aa(e) {
  const [t, n] = c.useState(v2());
  return m2(() => {
    e || n(
      (r) => r ?? String(h2++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function Om(e) {
  const t = Ne(e);
  return Ee(() => {
    t.current = e;
  }), Ht(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function g2({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = b2({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, i = a ? e : r, s = Om(n), l = un((u) => {
    if (a) {
      const p = typeof u == "function" ? u(e) : u;
      p !== e && s(p);
    } else
      o(u);
  }, [
    a,
    e,
    o,
    s
  ]);
  return [
    i,
    l
  ];
}
function b2({ defaultProp: e, onChange: t }) {
  const n = Je(e), [r] = n, o = Ne(r), a = Om(t);
  return Ee(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
const hc = /* @__PURE__ */ Xe((e, t) => {
  const { children: n, ...r } = e, o = nn.toArray(n), a = o.find(w2);
  if (a) {
    const i = a.props.children, s = o.map((l) => l === a ? nn.count(i) > 1 ? nn.only(null) : /* @__PURE__ */ rr(i) ? i.props.children : null : l);
    return /* @__PURE__ */ xe(Ni, Ve({}, r, {
      ref: t
    }), /* @__PURE__ */ rr(i) ? /* @__PURE__ */ Do(i, void 0, s) : null);
  }
  return /* @__PURE__ */ xe(Ni, Ve({}, r, {
    ref: t
  }), n);
});
hc.displayName = "Slot";
const Ni = /* @__PURE__ */ Xe((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ rr(n) ? /* @__PURE__ */ Do(n, {
    ...C2(r, n.props),
    ref: t ? $m(t, n.ref) : n.ref
  }) : nn.count(n) > 1 ? nn.only(null) : null;
});
Ni.displayName = "SlotClone";
const y2 = ({ children: e }) => /* @__PURE__ */ xe(Cd, null, e);
function w2(e) {
  return /* @__PURE__ */ rr(e) && e.type === y2;
}
function C2(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...a
    } : r === "className" && (n[r] = [
      o,
      a
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const E2 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], st = E2.reduce((e, t) => {
  const n = /* @__PURE__ */ Xe((r, o) => {
    const { asChild: a, ...i } = r, s = a ? hc : t;
    return Ee(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ xe(s, Ve({}, i, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function S2(e, t) {
  e && Rd(
    () => e.dispatchEvent(t)
  );
}
function gc(e) {
  const t = Ne(e);
  return Ee(() => {
    t.current = e;
  }), Ht(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function P2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = gc(e);
  Ee(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const Ri = "dismissableLayer.update", x2 = "dismissableLayer.pointerDownOutside", _2 = "dismissableLayer.focusOutside";
let Au;
const T2 = /* @__PURE__ */ Pt({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), N2 = /* @__PURE__ */ Xe((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: a, onFocusOutside: i, onInteractOutside: s, onDismiss: l, ...u } = e, d = Mt(T2), [p, v] = Je(null), y = (n = p == null ? void 0 : p.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, g] = Je({}), m = Or(
    t,
    (_) => v(_)
  ), h = Array.from(d.layers), [b] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), w = h.indexOf(b), C = p ? h.indexOf(p) : -1, E = d.layersWithOutsidePointerEventsDisabled.size > 0, P = C >= w, x = R2((_) => {
    const T = _.target, k = [
      ...d.branches
    ].some(
      (L) => L.contains(T)
    );
    !P || k || (a == null || a(_), s == null || s(_), _.defaultPrevented || l == null || l());
  }, y), S = $2((_) => {
    const T = _.target;
    [
      ...d.branches
    ].some(
      (L) => L.contains(T)
    ) || (i == null || i(_), s == null || s(_), _.defaultPrevented || l == null || l());
  }, y);
  return P2((_) => {
    C === d.layers.size - 1 && (o == null || o(_), !_.defaultPrevented && l && (_.preventDefault(), l()));
  }, y), Ee(() => {
    if (p)
      return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Au = y.body.style.pointerEvents, y.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(p)), d.layers.add(p), Iu(), () => {
        r && d.layersWithOutsidePointerEventsDisabled.size === 1 && (y.body.style.pointerEvents = Au);
      };
  }, [
    p,
    y,
    r,
    d
  ]), Ee(() => () => {
    p && (d.layers.delete(p), d.layersWithOutsidePointerEventsDisabled.delete(p), Iu());
  }, [
    p,
    d
  ]), Ee(() => {
    const _ = () => g({});
    return document.addEventListener(Ri, _), () => document.removeEventListener(Ri, _);
  }, []), /* @__PURE__ */ xe(st.div, Ve({}, u, {
    ref: m,
    style: {
      pointerEvents: E ? P ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: _n(e.onFocusCapture, S.onFocusCapture),
    onBlurCapture: _n(e.onBlurCapture, S.onBlurCapture),
    onPointerDownCapture: _n(e.onPointerDownCapture, x.onPointerDownCapture)
  }));
});
function R2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = gc(e), r = Ne(!1), o = Ne(() => {
  });
  return Ee(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let u = function() {
          Mm(x2, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, {
          once: !0
        })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function $2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = gc(e), r = Ne(!1);
  return Ee(() => {
    const o = (a) => {
      a.target && !r.current && Mm(_2, n, {
        originalEvent: a
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Iu() {
  const e = new CustomEvent(Ri);
  document.dispatchEvent(e);
}
function Mm(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? S2(o, a) : o.dispatchEvent(a);
}
function ku(e) {
  const t = Ne(e);
  return Ee(() => {
    t.current = e;
  }), Ht(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
const Ia = "focusScope.autoFocusOnMount", ka = "focusScope.autoFocusOnUnmount", Lu = {
  bubbles: !1,
  cancelable: !0
}, O2 = /* @__PURE__ */ Xe((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: a, ...i } = e, [s, l] = Je(null), u = ku(o), d = ku(a), p = Ne(null), v = Or(
    t,
    (m) => l(m)
  ), y = Ne({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Ee(() => {
    if (r) {
      let m = function(C) {
        if (y.paused || !s)
          return;
        const E = C.target;
        s.contains(E) ? p.current = E : Bt(p.current, {
          select: !0
        });
      }, h = function(C) {
        if (y.paused || !s)
          return;
        const E = C.relatedTarget;
        E !== null && (s.contains(E) || Bt(p.current, {
          select: !0
        }));
      }, b = function(C) {
        if (document.activeElement === document.body)
          for (const P of C)
            P.removedNodes.length > 0 && Bt(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", h);
      const w = new MutationObserver(b);
      return s && w.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", h), w.disconnect();
      };
    }
  }, [
    r,
    s,
    y.paused
  ]), Ee(() => {
    if (s) {
      Bu.add(y);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const b = new CustomEvent(Ia, Lu);
        s.addEventListener(Ia, u), s.dispatchEvent(b), b.defaultPrevented || (M2(L2(Dm(s)), {
          select: !0
        }), document.activeElement === m && Bt(s));
      }
      return () => {
        s.removeEventListener(Ia, u), setTimeout(() => {
          const b = new CustomEvent(ka, Lu);
          s.addEventListener(ka, d), s.dispatchEvent(b), b.defaultPrevented || Bt(m ?? document.body, {
            select: !0
          }), s.removeEventListener(ka, d), Bu.remove(y);
        }, 0);
      };
    }
  }, [
    s,
    u,
    d,
    y
  ]);
  const g = un((m) => {
    if (!n && !r || y.paused)
      return;
    const h = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, b = document.activeElement;
    if (h && b) {
      const w = m.currentTarget, [C, E] = D2(w);
      C && E ? !m.shiftKey && b === E ? (m.preventDefault(), n && Bt(C, {
        select: !0
      })) : m.shiftKey && b === C && (m.preventDefault(), n && Bt(E, {
        select: !0
      })) : b === w && m.preventDefault();
    }
  }, [
    n,
    r,
    y.paused
  ]);
  return /* @__PURE__ */ xe(st.div, Ve({
    tabIndex: -1
  }, i, {
    ref: v,
    onKeyDown: g
  }));
});
function M2(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Bt(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function D2(e) {
  const t = Dm(e), n = Fu(t, e), r = Fu(t.reverse(), e);
  return [
    n,
    r
  ];
}
function Dm(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Fu(e, t) {
  for (const n of e)
    if (!A2(n, {
      upTo: t
    }))
      return n;
}
function A2(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function I2(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Bt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && I2(e) && t && e.select();
  }
}
const Bu = k2();
function k2() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Wu(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Wu(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Wu(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function L2(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const F2 = /* @__PURE__ */ Xe((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ Er.createPortal(/* @__PURE__ */ xe(st.div, Ve({}, o, {
    ref: t
  })), r) : null;
}), ju = globalThis != null && globalThis.document ? Oo : () => {
};
function B2(e, t) {
  return Qy((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const qo = (e) => {
  const { present: t, children: n } = e, r = W2(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : nn.only(n), a = Or(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Do(o, {
    ref: a
  }) : null;
};
qo.displayName = "Presence";
function W2(e) {
  const [t, n] = Je(), r = Ne({}), o = Ne(e), a = Ne("none"), i = e ? "mounted" : "unmounted", [s, l] = B2(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Ee(() => {
    const u = Gr(r.current);
    a.current = s === "mounted" ? u : "none";
  }, [
    s
  ]), ju(() => {
    const u = r.current, d = o.current;
    if (d !== e) {
      const v = a.current, y = Gr(u);
      e ? l("MOUNT") : y === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(d && v !== y ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    l
  ]), ju(() => {
    if (t) {
      const u = (p) => {
        const y = Gr(r.current).includes(p.animationName);
        p.target === t && y && Rd(
          () => l("ANIMATION_END")
        );
      }, d = (p) => {
        p.target === t && (a.current = Gr(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      l("ANIMATION_END");
  }, [
    t,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: un((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function Gr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
let La = 0;
function j2() {
  Ee(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : Hu()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : Hu()), La++, () => {
      La === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), La--;
    };
  }, []);
}
function Hu() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var Am = rs(), Fa = function() {
}, Xo = c.forwardRef(function(e, t) {
  var n = c.useRef(null), r = c.useState({
    onScrollCapture: Fa,
    onWheelCapture: Fa,
    onTouchMoveCapture: Fa
  }), o = r[0], a = r[1], i = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, d = e.enabled, p = e.shards, v = e.sideCar, y = e.noIsolation, g = e.inert, m = e.allowPinchZoom, h = e.as, b = h === void 0 ? "div" : h, w = os(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), C = v, E = as([n, t]), P = Ie(Ie({}, w), o);
  return c.createElement(
    c.Fragment,
    null,
    d && c.createElement(C, { sideCar: Am, removeScrollBar: u, shards: p, noIsolation: y, inert: g, setCallbacks: a, allowPinchZoom: !!m, lockRef: n }),
    i ? c.cloneElement(c.Children.only(s), Ie(Ie({}, P), { ref: E })) : c.createElement(b, Ie({}, P, { className: l, ref: E }), s)
  );
});
Xo.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Xo.classNames = {
  fullWidth: is,
  zeroRight: ss
};
var $i = !1;
if (typeof window < "u")
  try {
    var Kr = Object.defineProperty({}, "passive", {
      get: function() {
        return $i = !0, !0;
      }
    });
    window.addEventListener("test", Kr, Kr), window.removeEventListener("test", Kr, Kr);
  } catch {
    $i = !1;
  }
var wn = $i ? { passive: !1 } : !1, H2 = function(e) {
  return e.tagName === "TEXTAREA";
}, Im = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !H2(e) && n[t] === "visible")
  );
}, U2 = function(e) {
  return Im(e, "overflowY");
}, V2 = function(e) {
  return Im(e, "overflowX");
}, Uu = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = km(e, n);
    if (r) {
      var o = Lm(e, n), a = o[1], i = o[2];
      if (a > i)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, G2 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, K2 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, km = function(e, t) {
  return e === "v" ? U2(t) : V2(t);
}, Lm = function(e, t) {
  return e === "v" ? G2(t) : K2(t);
}, Y2 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, z2 = function(e, t, n, r, o) {
  var a = Y2(e, window.getComputedStyle(t).direction), i = a * r, s = n.target, l = t.contains(s), u = !1, d = i > 0, p = 0, v = 0;
  do {
    var y = Lm(e, s), g = y[0], m = y[1], h = y[2], b = m - h - a * g;
    (g || b) && km(e, s) && (p += b, v += g), s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (d && (o && p === 0 || !o && i > p) || !d && (o && v === 0 || !o && -i > v)) && (u = !0), u;
}, Yr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Vu = function(e) {
  return [e.deltaX, e.deltaY];
}, Gu = function(e) {
  return e && "current" in e ? e.current : e;
}, q2 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, X2 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Z2 = 0, Cn = [];
function Q2(e) {
  var t = c.useRef([]), n = c.useRef([0, 0]), r = c.useRef(), o = c.useState(Z2++)[0], a = c.useState(function() {
    return cs();
  })[0], i = c.useRef(e);
  c.useEffect(function() {
    i.current = e;
  }, [e]), c.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var m = ls([e.lockRef.current], (e.shards || []).map(Gu), !0).filter(Boolean);
      return m.forEach(function(h) {
        return h.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), m.forEach(function(h) {
          return h.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = c.useCallback(function(m, h) {
    if ("touches" in m && m.touches.length === 2)
      return !i.current.allowPinchZoom;
    var b = Yr(m), w = n.current, C = "deltaX" in m ? m.deltaX : w[0] - b[0], E = "deltaY" in m ? m.deltaY : w[1] - b[1], P, x = m.target, S = Math.abs(C) > Math.abs(E) ? "h" : "v";
    if ("touches" in m && S === "h" && x.type === "range")
      return !1;
    var _ = Uu(S, x);
    if (!_)
      return !0;
    if (_ ? P = S : (P = S === "v" ? "h" : "v", _ = Uu(S, x)), !_)
      return !1;
    if (!r.current && "changedTouches" in m && (C || E) && (r.current = P), !P)
      return !0;
    var T = r.current || P;
    return z2(T, h, m, T === "h" ? C : E, !0);
  }, []), l = c.useCallback(function(m) {
    var h = m;
    if (!(!Cn.length || Cn[Cn.length - 1] !== a)) {
      var b = "deltaY" in h ? Vu(h) : Yr(h), w = t.current.filter(function(P) {
        return P.name === h.type && P.target === h.target && q2(P.delta, b);
      })[0];
      if (w && w.should) {
        h.cancelable && h.preventDefault();
        return;
      }
      if (!w) {
        var C = (i.current.shards || []).map(Gu).filter(Boolean).filter(function(P) {
          return P.contains(h.target);
        }), E = C.length > 0 ? s(h, C[0]) : !i.current.noIsolation;
        E && h.cancelable && h.preventDefault();
      }
    }
  }, []), u = c.useCallback(function(m, h, b, w) {
    var C = { name: m, delta: h, target: b, should: w };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(E) {
        return E !== C;
      });
    }, 1);
  }, []), d = c.useCallback(function(m) {
    n.current = Yr(m), r.current = void 0;
  }, []), p = c.useCallback(function(m) {
    u(m.type, Vu(m), m.target, s(m, e.lockRef.current));
  }, []), v = c.useCallback(function(m) {
    u(m.type, Yr(m), m.target, s(m, e.lockRef.current));
  }, []);
  c.useEffect(function() {
    return Cn.push(a), e.setCallbacks({
      onScrollCapture: p,
      onWheelCapture: p,
      onTouchMoveCapture: v
    }), document.addEventListener("wheel", l, wn), document.addEventListener("touchmove", l, wn), document.addEventListener("touchstart", d, wn), function() {
      Cn = Cn.filter(function(m) {
        return m !== a;
      }), document.removeEventListener("wheel", l, wn), document.removeEventListener("touchmove", l, wn), document.removeEventListener("touchstart", d, wn);
    };
  }, []);
  var y = e.removeScrollBar, g = e.inert;
  return c.createElement(
    c.Fragment,
    null,
    g ? c.createElement(a, { styles: X2(o) }) : null,
    y ? c.createElement(us, { gapMode: "margin" }) : null
  );
}
const J2 = ds(Am, Q2);
var Fm = c.forwardRef(function(e, t) {
  return c.createElement(Xo, Ie({}, e, { ref: t, sideCar: J2 }));
});
Fm.classNames = Xo.classNames;
const eF = Fm, Bm = "Dialog", [Wm, W8] = f2(Bm), [tF, vn] = Wm(Bm), nF = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: o, onOpenChange: a, modal: i = !0 } = e, s = Ne(null), l = Ne(null), [u = !1, d] = g2({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ xe(tF, {
    scope: t,
    triggerRef: s,
    contentRef: l,
    contentId: Aa(),
    titleId: Aa(),
    descriptionId: Aa(),
    open: u,
    onOpenChange: d,
    onOpenToggle: un(
      () => d(
        (p) => !p
      ),
      [
        d
      ]
    ),
    modal: i
  }, n);
}, jm = "DialogPortal", [rF, Hm] = Wm(jm, {
  forceMount: void 0
}), oF = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, a = vn(jm, t);
  return /* @__PURE__ */ xe(rF, {
    scope: t,
    forceMount: n
  }, nn.map(
    r,
    (i) => /* @__PURE__ */ xe(qo, {
      present: n || a.open
    }, /* @__PURE__ */ xe(F2, {
      asChild: !0,
      container: o
    }, i))
  ));
}, Oi = "DialogOverlay", aF = /* @__PURE__ */ Xe((e, t) => {
  const n = Hm(Oi, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = vn(Oi, e.__scopeDialog);
  return a.modal ? /* @__PURE__ */ xe(qo, {
    present: r || a.open
  }, /* @__PURE__ */ xe(iF, Ve({}, o, {
    ref: t
  }))) : null;
}), iF = /* @__PURE__ */ Xe((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = vn(Oi, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ xe(eF, {
      as: hc,
      allowPinchZoom: !0,
      shards: [
        o.contentRef
      ]
    }, /* @__PURE__ */ xe(st.div, Ve({
      "data-state": Vm(o.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), mr = "DialogContent", sF = /* @__PURE__ */ Xe((e, t) => {
  const n = Hm(mr, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = vn(mr, e.__scopeDialog);
  return /* @__PURE__ */ xe(qo, {
    present: r || a.open
  }, a.modal ? /* @__PURE__ */ xe(cF, Ve({}, o, {
    ref: t
  })) : /* @__PURE__ */ xe(lF, Ve({}, o, {
    ref: t
  })));
}), cF = /* @__PURE__ */ Xe((e, t) => {
  const n = vn(mr, e.__scopeDialog), r = Ne(null), o = Or(t, n.contentRef, r);
  return Ee(() => {
    const a = r.current;
    if (a)
      return fs(a);
  }, []), /* @__PURE__ */ xe(Um, Ve({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: _n(e.onCloseAutoFocus, (a) => {
      var i;
      a.preventDefault(), (i = n.triggerRef.current) === null || i === void 0 || i.focus();
    }),
    onPointerDownOutside: _n(e.onPointerDownOutside, (a) => {
      const i = a.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
      (i.button === 2 || s) && a.preventDefault();
    }),
    onFocusOutside: _n(
      e.onFocusOutside,
      (a) => a.preventDefault()
    )
  }));
}), lF = /* @__PURE__ */ Xe((e, t) => {
  const n = vn(mr, e.__scopeDialog), r = Ne(!1), o = Ne(!1);
  return /* @__PURE__ */ xe(Um, Ve({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (a) => {
      var i;
      if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, a), !a.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), a.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (a) => {
      var i, s;
      (i = e.onInteractOutside) === null || i === void 0 || i.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const l = a.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(l)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
    }
  }));
}), Um = /* @__PURE__ */ Xe((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...i } = e, s = vn(mr, n), l = Ne(null), u = Or(t, l);
  return j2(), /* @__PURE__ */ xe(Cd, null, /* @__PURE__ */ xe(O2, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a
  }, /* @__PURE__ */ xe(N2, Ve({
    role: "dialog",
    id: s.contentId,
    "aria-describedby": s.descriptionId,
    "aria-labelledby": s.titleId,
    "data-state": Vm(s.open)
  }, i, {
    ref: u,
    onDismiss: () => s.onOpenChange(!1)
  }))), !1);
});
function Vm(e) {
  return e ? "open" : "closed";
}
const uF = nF, dF = oF, fF = aF, pF = sF;
var qn = '[cmdk-group=""]', Ba = '[cmdk-group-items=""]', mF = '[cmdk-group-heading=""]', bc = '[cmdk-item=""]', Ku = `${bc}:not([aria-disabled="true"])`, Mi = "cmdk-item-select", tn = "data-value", vF = (e, t, n) => u2(e, t, n), Gm = c.createContext(void 0), Mr = () => c.useContext(Gm), Km = c.createContext(void 0), yc = () => c.useContext(Km), Ym = c.createContext(void 0), zm = c.forwardRef((e, t) => {
  let n = Pn(() => {
    var O, j;
    return { search: "", value: (j = (O = e.value) != null ? O : e.defaultValue) != null ? j : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = Pn(() => /* @__PURE__ */ new Set()), o = Pn(() => /* @__PURE__ */ new Map()), a = Pn(() => /* @__PURE__ */ new Map()), i = Pn(() => /* @__PURE__ */ new Set()), s = qm(e), { label: l, children: u, value: d, onValueChange: p, filter: v, shouldFilter: y, loop: g, disablePointerSelection: m = !1, vimBindings: h = !0, ...b } = e, w = c.useId(), C = c.useId(), E = c.useId(), P = c.useRef(null), x = _F();
  cn(() => {
    if (d !== void 0) {
      let O = d.trim();
      n.current.value = O, S.emit();
    }
  }, [d]), cn(() => {
    x(6, M);
  }, []);
  let S = c.useMemo(() => ({ subscribe: (O) => (i.current.add(O), () => i.current.delete(O)), snapshot: () => n.current, setState: (O, j, Y) => {
    var V, ee, Z;
    if (!Object.is(n.current[O], j)) {
      if (n.current[O] = j, O === "search")
        U(), k(), x(1, L);
      else if (O === "value" && (Y || x(5, M), ((V = s.current) == null ? void 0 : V.value) !== void 0)) {
        let re = j ?? "";
        (Z = (ee = s.current).onValueChange) == null || Z.call(ee, re);
        return;
      }
      S.emit();
    }
  }, emit: () => {
    i.current.forEach((O) => O());
  } }), []), _ = c.useMemo(() => ({ value: (O, j, Y) => {
    var V;
    j !== ((V = a.current.get(O)) == null ? void 0 : V.value) && (a.current.set(O, { value: j, keywords: Y }), n.current.filtered.items.set(O, T(j, Y)), x(2, () => {
      k(), S.emit();
    }));
  }, item: (O, j) => (r.current.add(O), j && (o.current.has(j) ? o.current.get(j).add(O) : o.current.set(j, /* @__PURE__ */ new Set([O]))), x(3, () => {
    U(), k(), n.current.value || L(), S.emit();
  }), () => {
    a.current.delete(O), r.current.delete(O), n.current.filtered.items.delete(O);
    let Y = F();
    x(4, () => {
      U(), (Y == null ? void 0 : Y.getAttribute("id")) === O && L(), S.emit();
    });
  }), group: (O) => (o.current.has(O) || o.current.set(O, /* @__PURE__ */ new Set()), () => {
    a.current.delete(O), o.current.delete(O);
  }), filter: () => s.current.shouldFilter, label: l || e["aria-label"], disablePointerSelection: m, listId: w, inputId: E, labelId: C, listInnerRef: P }), []);
  function T(O, j) {
    var Y, V;
    let ee = (V = (Y = s.current) == null ? void 0 : Y.filter) != null ? V : vF;
    return O ? ee(O, n.current.search, j) : 0;
  }
  function k() {
    if (!n.current.search || s.current.shouldFilter === !1)
      return;
    let O = n.current.filtered.items, j = [];
    n.current.filtered.groups.forEach((V) => {
      let ee = o.current.get(V), Z = 0;
      ee.forEach((re) => {
        let ie = O.get(re);
        Z = Math.max(ie, Z);
      }), j.push([V, Z]);
    });
    let Y = P.current;
    W().sort((V, ee) => {
      var Z, re;
      let ie = V.getAttribute("id"), de = ee.getAttribute("id");
      return ((Z = O.get(de)) != null ? Z : 0) - ((re = O.get(ie)) != null ? re : 0);
    }).forEach((V) => {
      let ee = V.closest(Ba);
      ee ? ee.appendChild(V.parentElement === ee ? V : V.closest(`${Ba} > *`)) : Y.appendChild(V.parentElement === Y ? V : V.closest(`${Ba} > *`));
    }), j.sort((V, ee) => ee[1] - V[1]).forEach((V) => {
      let ee = P.current.querySelector(`${qn}[${tn}="${encodeURIComponent(V[0])}"]`);
      ee == null || ee.parentElement.appendChild(ee);
    });
  }
  function L() {
    let O = W().find((Y) => Y.getAttribute("aria-disabled") !== "true"), j = O == null ? void 0 : O.getAttribute(tn);
    S.setState("value", j || void 0);
  }
  function U() {
    var O, j, Y, V;
    if (!n.current.search || s.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let ee = 0;
    for (let Z of r.current) {
      let re = (j = (O = a.current.get(Z)) == null ? void 0 : O.value) != null ? j : "", ie = (V = (Y = a.current.get(Z)) == null ? void 0 : Y.keywords) != null ? V : [], de = T(re, ie);
      n.current.filtered.items.set(Z, de), de > 0 && ee++;
    }
    for (let [Z, re] of o.current)
      for (let ie of re)
        if (n.current.filtered.items.get(ie) > 0) {
          n.current.filtered.groups.add(Z);
          break;
        }
    n.current.filtered.count = ee;
  }
  function M() {
    var O, j, Y;
    let V = F();
    V && (((O = V.parentElement) == null ? void 0 : O.firstChild) === V && ((Y = (j = V.closest(qn)) == null ? void 0 : j.querySelector(mF)) == null || Y.scrollIntoView({ block: "nearest" })), V.scrollIntoView({ block: "nearest" }));
  }
  function F() {
    var O;
    return (O = P.current) == null ? void 0 : O.querySelector(`${bc}[aria-selected="true"]`);
  }
  function W() {
    var O;
    return Array.from((O = P.current) == null ? void 0 : O.querySelectorAll(Ku));
  }
  function H(O) {
    let j = W()[O];
    j && S.setState("value", j.getAttribute(tn));
  }
  function A(O) {
    var j;
    let Y = F(), V = W(), ee = V.findIndex((re) => re === Y), Z = V[ee + O];
    (j = s.current) != null && j.loop && (Z = ee + O < 0 ? V[V.length - 1] : ee + O === V.length ? V[0] : V[ee + O]), Z && S.setState("value", Z.getAttribute(tn));
  }
  function D(O) {
    let j = F(), Y = j == null ? void 0 : j.closest(qn), V;
    for (; Y && !V; )
      Y = O > 0 ? PF(Y, qn) : xF(Y, qn), V = Y == null ? void 0 : Y.querySelector(Ku);
    V ? S.setState("value", V.getAttribute(tn)) : A(O);
  }
  let B = () => H(W().length - 1), Q = (O) => {
    O.preventDefault(), O.metaKey ? B() : O.altKey ? D(1) : A(1);
  }, q = (O) => {
    O.preventDefault(), O.metaKey ? H(0) : O.altKey ? D(-1) : A(-1);
  };
  return c.createElement(st.div, { ref: t, tabIndex: -1, ...b, "cmdk-root": "", onKeyDown: (O) => {
    var j;
    if ((j = b.onKeyDown) == null || j.call(b, O), !O.defaultPrevented)
      switch (O.key) {
        case "n":
        case "j": {
          h && O.ctrlKey && Q(O);
          break;
        }
        case "ArrowDown": {
          Q(O);
          break;
        }
        case "p":
        case "k": {
          h && O.ctrlKey && q(O);
          break;
        }
        case "ArrowUp": {
          q(O);
          break;
        }
        case "Home": {
          O.preventDefault(), H(0);
          break;
        }
        case "End": {
          O.preventDefault(), B();
          break;
        }
        case "Enter":
          if (!O.nativeEvent.isComposing && O.keyCode !== 229) {
            O.preventDefault();
            let Y = F();
            if (Y) {
              let V = new Event(Mi);
              Y.dispatchEvent(V);
            }
          }
      }
  } }, c.createElement("label", { "cmdk-label": "", htmlFor: _.inputId, id: _.labelId, style: NF }, l), Zo(e, (O) => c.createElement(Km.Provider, { value: S }, c.createElement(Gm.Provider, { value: _ }, O))));
}), hF = c.forwardRef((e, t) => {
  var n, r;
  let o = c.useId(), a = c.useRef(null), i = c.useContext(Ym), s = Mr(), l = qm(e), u = (r = (n = l.current) == null ? void 0 : n.forceMount) != null ? r : i == null ? void 0 : i.forceMount;
  cn(() => {
    if (!u)
      return s.item(o, i == null ? void 0 : i.id);
  }, [u]);
  let d = Xm(o, a, [e.value, e.children, a], e.keywords), p = yc(), v = ln((x) => x.value && x.value === d.current), y = ln((x) => u || s.filter() === !1 ? !0 : x.search ? x.filtered.items.get(o) > 0 : !0);
  c.useEffect(() => {
    let x = a.current;
    if (!(!x || e.disabled))
      return x.addEventListener(Mi, g), () => x.removeEventListener(Mi, g);
  }, [y, e.onSelect, e.disabled]);
  function g() {
    var x, S;
    m(), (S = (x = l.current).onSelect) == null || S.call(x, d.current);
  }
  function m() {
    p.setState("value", d.current, !0);
  }
  if (!y)
    return null;
  let { disabled: h, value: b, onSelect: w, forceMount: C, keywords: E, ...P } = e;
  return c.createElement(st.div, { ref: vr([a, t]), ...P, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!h, "aria-selected": !!v, "data-disabled": !!h, "data-selected": !!v, onPointerMove: h || s.disablePointerSelection ? void 0 : m, onClick: h ? void 0 : g }, e.children);
}), gF = c.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: o, ...a } = e, i = c.useId(), s = c.useRef(null), l = c.useRef(null), u = c.useId(), d = Mr(), p = ln((y) => o || d.filter() === !1 ? !0 : y.search ? y.filtered.groups.has(i) : !0);
  cn(() => d.group(i), []), Xm(i, s, [e.value, e.heading, l]);
  let v = c.useMemo(() => ({ id: i, forceMount: o }), [o]);
  return c.createElement(st.div, { ref: vr([s, t]), ...a, "cmdk-group": "", role: "presentation", hidden: p ? void 0 : !0 }, n && c.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: u }, n), Zo(e, (y) => c.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? u : void 0 }, c.createElement(Ym.Provider, { value: v }, y))));
}), bF = c.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, o = c.useRef(null), a = ln((i) => !i.search);
  return !n && !a ? null : c.createElement(st.div, { ref: vr([o, t]), ...r, "cmdk-separator": "", role: "separator" });
}), yF = c.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, o = e.value != null, a = yc(), i = ln((d) => d.search), s = ln((d) => d.value), l = Mr(), u = c.useMemo(() => {
    var d;
    let p = (d = l.listInnerRef.current) == null ? void 0 : d.querySelector(`${bc}[${tn}="${encodeURIComponent(s)}"]`);
    return p == null ? void 0 : p.getAttribute("id");
  }, []);
  return c.useEffect(() => {
    e.value != null && a.setState("search", e.value);
  }, [e.value]), c.createElement(st.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": u, id: l.inputId, type: "text", value: o ? e.value : i, onChange: (d) => {
    o || a.setState("search", d.target.value), n == null || n(d.target.value);
  } });
}), wF = c.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...o } = e, a = c.useRef(null), i = c.useRef(null), s = Mr();
  return c.useEffect(() => {
    if (i.current && a.current) {
      let l = i.current, u = a.current, d, p = new ResizeObserver(() => {
        d = requestAnimationFrame(() => {
          let v = l.offsetHeight;
          u.style.setProperty("--cmdk-list-height", v.toFixed(1) + "px");
        });
      });
      return p.observe(l), () => {
        cancelAnimationFrame(d), p.unobserve(l);
      };
    }
  }, []), c.createElement(st.div, { ref: vr([a, t]), ...o, "cmdk-list": "", role: "listbox", "aria-label": r, id: s.listId }, Zo(e, (l) => c.createElement("div", { ref: vr([i, s.listInnerRef]), "cmdk-list-sizer": "" }, l)));
}), CF = c.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: o, contentClassName: a, container: i, ...s } = e;
  return c.createElement(uF, { open: n, onOpenChange: r }, c.createElement(dF, { container: i }, c.createElement(fF, { "cmdk-overlay": "", className: o }), c.createElement(pF, { "aria-label": e.label, "cmdk-dialog": "", className: a }, c.createElement(zm, { ref: t, ...s }))));
}), EF = c.forwardRef((e, t) => ln((n) => n.filtered.count === 0) ? c.createElement(st.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), SF = c.forwardRef((e, t) => {
  let { progress: n, children: r, label: o = "Loading...", ...a } = e;
  return c.createElement(st.div, { ref: t, ...a, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, Zo(e, (i) => c.createElement("div", { "aria-hidden": !0 }, i)));
}), Ze = Object.assign(zm, { List: wF, Item: hF, Input: yF, Group: gF, Separator: bF, Dialog: CF, Empty: EF, Loading: SF });
function PF(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t))
      return n;
    n = n.nextElementSibling;
  }
}
function xF(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t))
      return n;
    n = n.previousElementSibling;
  }
}
function qm(e) {
  let t = c.useRef(e);
  return cn(() => {
    t.current = e;
  }), t;
}
var cn = typeof window > "u" ? c.useEffect : c.useLayoutEffect;
function Pn(e) {
  let t = c.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function vr(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
function ln(e) {
  let t = yc(), n = () => e(t.snapshot());
  return c.useSyncExternalStore(t.subscribe, n, n);
}
function Xm(e, t, n, r = []) {
  let o = c.useRef(), a = Mr();
  return cn(() => {
    var i;
    let s = (() => {
      var u;
      for (let d of n) {
        if (typeof d == "string")
          return d.trim();
        if (typeof d == "object" && "current" in d)
          return d.current ? (u = d.current.textContent) == null ? void 0 : u.trim() : o.current;
      }
    })(), l = r.map((u) => u.trim());
    a.value(e, s, l), (i = t.current) == null || i.setAttribute(tn, s), o.current = s;
  }), o;
}
var _F = () => {
  let [e, t] = c.useState(), n = Pn(() => /* @__PURE__ */ new Map());
  return cn(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function TF(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function Zo({ asChild: e, children: t }, n) {
  return e && c.isValidElement(t) ? c.cloneElement(TF(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var NF = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const RF = _d, $F = xd, Zm = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  ps,
  {
    ref: n,
    className: $(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
Zm.displayName = ps.displayName;
const Qm = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ X($F, { children: [
  /* @__PURE__ */ f(Zm, {}),
  /* @__PURE__ */ X(
    ms,
    {
      ref: r,
      className: $(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ X(Pd, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ f(Dd, { className: "h-4 w-4" }),
          /* @__PURE__ */ f("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
Qm.displayName = ms.displayName;
const OF = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  vs,
  {
    ref: n,
    className: $(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
OF.displayName = vs.displayName;
const MF = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  hs,
  {
    ref: n,
    className: $("text-sm text-muted-foreground", e),
    ...t
  }
));
MF.displayName = hs.displayName;
const Jm = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Ze,
  {
    ref: n,
    className: $(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      e
    ),
    ...t
  }
));
Jm.displayName = Ze.displayName;
const j8 = ({ children: e, ...t }) => /* @__PURE__ */ f(RF, { ...t, children: /* @__PURE__ */ f(Qm, { className: "overflow-hidden p-0", children: /* @__PURE__ */ f(Jm, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children: e }) }) }), DF = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ X("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ f(pw, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
  /* @__PURE__ */ f(
    Ze.Input,
    {
      ref: n,
      className: $(
        "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t
    }
  )
] }));
DF.displayName = Ze.Input.displayName;
const AF = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Ze.List,
  {
    ref: n,
    className: $("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...t
  }
));
AF.displayName = Ze.List.displayName;
const IF = c.forwardRef((e, t) => /* @__PURE__ */ f(
  Ze.Empty,
  {
    ref: t,
    className: "py-6 text-center text-sm",
    ...e
  }
));
IF.displayName = Ze.Empty.displayName;
const kF = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Ze.Group,
  {
    ref: n,
    className: $(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      e
    ),
    ...t
  }
));
kF.displayName = Ze.Group.displayName;
const LF = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Ze.Separator,
  {
    ref: n,
    className: $("-mx-1 h-px bg-border", e),
    ...t
  }
));
LF.displayName = Ze.Separator.displayName;
const FF = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Ze.Item,
  {
    ref: n,
    className: $(
      "relative flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      e
    ),
    ...t
  }
));
FF.displayName = Ze.Item.displayName;
const BF = ({
  className: e,
  ...t
}) => /* @__PURE__ */ f(
  "span",
  {
    className: $(
      "ml-auto text-xs tracking-widest text-muted-foreground",
      e
    ),
    ...t
  }
);
BF.displayName = "CommandShortcut";
var WF = "DismissableLayer", Di = "dismissableLayer.update", jF = "dismissableLayer.pointerDownOutside", HF = "dismissableLayer.focusOutside", Yu, ev = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), tv = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, u = c.useContext(ev), [d, p] = c.useState(null), v = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, y] = c.useState({}), g = ne(t, (S) => p(S)), m = Array.from(u.layers), [h] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), b = m.indexOf(h), w = d ? m.indexOf(d) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, E = w >= b, P = GF((S) => {
      const _ = S.target, T = [...u.branches].some((k) => k.contains(_));
      !E || T || (o == null || o(S), i == null || i(S), S.defaultPrevented || s == null || s());
    }, v), x = KF((S) => {
      const _ = S.target;
      [...u.branches].some((k) => k.contains(_)) || (a == null || a(S), i == null || i(S), S.defaultPrevented || s == null || s());
    }, v);
    return br((S) => {
      w === u.layers.size - 1 && (r == null || r(S), !S.defaultPrevented && s && (S.preventDefault(), s()));
    }, v), c.useEffect(() => {
      if (d)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Yu = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), zu(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (v.body.style.pointerEvents = Yu);
        };
    }, [d, v, n, u]), c.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), zu());
    }, [d, u]), c.useEffect(() => {
      const S = () => y({});
      return document.addEventListener(Di, S), () => document.removeEventListener(Di, S);
    }, []), /* @__PURE__ */ f(
      G.div,
      {
        ...l,
        ref: g,
        style: {
          pointerEvents: C ? E ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: I(e.onFocusCapture, x.onFocusCapture),
        onBlurCapture: I(e.onBlurCapture, x.onBlurCapture),
        onPointerDownCapture: I(
          e.onPointerDownCapture,
          P.onPointerDownCapture
        )
      }
    );
  }
);
tv.displayName = WF;
var UF = "DismissableLayerBranch", VF = c.forwardRef((e, t) => {
  const n = c.useContext(ev), r = c.useRef(null), o = ne(t, r);
  return c.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ f(G.div, { ...e, ref: o });
});
VF.displayName = UF;
function GF(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = me(e), r = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          nv(
            jF,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function KF(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = me(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && nv(HF, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function zu() {
  const e = new CustomEvent(Di);
  document.dispatchEvent(e);
}
function nv(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Ot(o, a) : o.dispatchEvent(a);
}
var Wa = "focusScope.autoFocusOnMount", ja = "focusScope.autoFocusOnUnmount", qu = { bubbles: !1, cancelable: !0 }, YF = "FocusScope", rv = c.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...i
  } = e, [s, l] = c.useState(null), u = me(o), d = me(a), p = c.useRef(null), v = ne(t, (m) => l(m)), y = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (r) {
      let m = function(C) {
        if (y.paused || !s)
          return;
        const E = C.target;
        s.contains(E) ? p.current = E : Wt(p.current, { select: !0 });
      }, h = function(C) {
        if (y.paused || !s)
          return;
        const E = C.relatedTarget;
        E !== null && (s.contains(E) || Wt(p.current, { select: !0 }));
      }, b = function(C) {
        if (document.activeElement === document.body)
          for (const P of C)
            P.removedNodes.length > 0 && Wt(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", h);
      const w = new MutationObserver(b);
      return s && w.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", h), w.disconnect();
      };
    }
  }, [r, s, y.paused]), c.useEffect(() => {
    if (s) {
      Zu.add(y);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const b = new CustomEvent(Wa, qu);
        s.addEventListener(Wa, u), s.dispatchEvent(b), b.defaultPrevented || (zF(JF(ov(s)), { select: !0 }), document.activeElement === m && Wt(s));
      }
      return () => {
        s.removeEventListener(Wa, u), setTimeout(() => {
          const b = new CustomEvent(ja, qu);
          s.addEventListener(ja, d), s.dispatchEvent(b), b.defaultPrevented || Wt(m ?? document.body, { select: !0 }), s.removeEventListener(ja, d), Zu.remove(y);
        }, 0);
      };
    }
  }, [s, u, d, y]);
  const g = c.useCallback(
    (m) => {
      if (!n && !r || y.paused)
        return;
      const h = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, b = document.activeElement;
      if (h && b) {
        const w = m.currentTarget, [C, E] = qF(w);
        C && E ? !m.shiftKey && b === E ? (m.preventDefault(), n && Wt(C, { select: !0 })) : m.shiftKey && b === C && (m.preventDefault(), n && Wt(E, { select: !0 })) : b === w && m.preventDefault();
      }
    },
    [n, r, y.paused]
  );
  return /* @__PURE__ */ f(G.div, { tabIndex: -1, ...i, ref: v, onKeyDown: g });
});
rv.displayName = YF;
function zF(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Wt(r, { select: t }), document.activeElement !== n)
      return;
}
function qF(e) {
  const t = ov(e), n = Xu(t, e), r = Xu(t.reverse(), e);
  return [n, r];
}
function ov(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Xu(e, t) {
  for (const n of e)
    if (!XF(n, { upTo: t }))
      return n;
}
function XF(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function ZF(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Wt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && ZF(e) && t && e.select();
  }
}
var Zu = QF();
function QF() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Qu(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Qu(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Qu(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function JF(e) {
  return e.filter((t) => t.tagName !== "A");
}
var eB = "Arrow", av = c.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ f(
    G.svg,
    {
      ...a,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ f("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
av.displayName = eB;
var tB = av, wc = "Popper", [iv, Qo] = Re(wc), [nB, sv] = iv(wc), cv = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = c.useState(null);
  return /* @__PURE__ */ f(nB, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
cv.displayName = wc;
var lv = "PopperAnchor", uv = c.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, a = sv(lv, n), i = c.useRef(null), s = ne(t, i);
    return c.useEffect(() => {
      a.onAnchorChange((r == null ? void 0 : r.current) || i.current);
    }), r ? null : /* @__PURE__ */ f(G.div, { ...o, ref: s });
  }
);
uv.displayName = lv;
var Cc = "PopperContent", [rB, oB] = iv(Cc), dv = c.forwardRef(
  (e, t) => {
    var Z, re, ie, de, se, K;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: d = 0,
      sticky: p = "partial",
      hideWhenDetached: v = !1,
      updatePositionStrategy: y = "optimized",
      onPlaced: g,
      ...m
    } = e, h = sv(Cc, n), [b, w] = c.useState(null), C = ne(t, (oe) => w(oe)), [E, P] = c.useState(null), x = yr(E), S = (x == null ? void 0 : x.width) ?? 0, _ = (x == null ? void 0 : x.height) ?? 0, T = r + (a !== "center" ? "-" + a : ""), k = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, L = Array.isArray(u) ? u : [u], U = L.length > 0, M = {
      padding: k,
      boundary: L.filter(iB),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: U
    }, { refs: F, floatingStyles: W, placement: H, isPositioned: A, middlewareData: D } = tw({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: T,
      whileElementsMounted: (...oe) => nw(...oe, {
        animationFrame: y === "always"
      }),
      elements: {
        reference: h.anchor
      },
      middleware: [
        rw({ mainAxis: o + _, alignmentAxis: i }),
        l && ow({
          mainAxis: !0,
          crossAxis: !1,
          limiter: p === "partial" ? lw() : void 0,
          ...M
        }),
        l && aw({ ...M }),
        iw({
          ...M,
          apply: ({ elements: oe, rects: N, availableWidth: z, availableHeight: ce }) => {
            const { width: fe, height: Se } = N.reference, ae = oe.floating.style;
            ae.setProperty("--radix-popper-available-width", `${z}px`), ae.setProperty("--radix-popper-available-height", `${ce}px`), ae.setProperty("--radix-popper-anchor-width", `${fe}px`), ae.setProperty("--radix-popper-anchor-height", `${Se}px`);
          }
        }),
        E && sw({ element: E, padding: s }),
        sB({ arrowWidth: S, arrowHeight: _ }),
        v && cw({ strategy: "referenceHidden", ...M })
      ]
    }), [B, Q] = mv(H), q = me(g);
    mt(() => {
      A && (q == null || q());
    }, [A, q]);
    const O = (Z = D.arrow) == null ? void 0 : Z.x, j = (re = D.arrow) == null ? void 0 : re.y, Y = ((ie = D.arrow) == null ? void 0 : ie.centerOffset) !== 0, [V, ee] = c.useState();
    return mt(() => {
      b && ee(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ f(
      "div",
      {
        ref: F.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...W,
          transform: A ? W.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: V,
          "--radix-popper-transform-origin": [
            (de = D.transformOrigin) == null ? void 0 : de.x,
            (se = D.transformOrigin) == null ? void 0 : se.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((K = D.hide) == null ? void 0 : K.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ f(
          rB,
          {
            scope: n,
            placedSide: B,
            onArrowChange: P,
            arrowX: O,
            arrowY: j,
            shouldHideArrow: Y,
            children: /* @__PURE__ */ f(
              G.div,
              {
                "data-side": B,
                "data-align": Q,
                ...m,
                ref: C,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: A ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
dv.displayName = Cc;
var fv = "PopperArrow", aB = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, pv = c.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, a = oB(fv, r), i = aB[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ f(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ f(
          tB,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
pv.displayName = fv;
function iB(e) {
  return e !== null;
}
var sB = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var h, b, w;
    const { placement: n, rects: r, middlewareData: o } = t, i = ((h = o.arrow) == null ? void 0 : h.centerOffset) !== 0, s = i ? 0 : e.arrowWidth, l = i ? 0 : e.arrowHeight, [u, d] = mv(n), p = { start: "0%", center: "50%", end: "100%" }[d], v = (((b = o.arrow) == null ? void 0 : b.x) ?? 0) + s / 2, y = (((w = o.arrow) == null ? void 0 : w.y) ?? 0) + l / 2;
    let g = "", m = "";
    return u === "bottom" ? (g = i ? p : `${v}px`, m = `${-l}px`) : u === "top" ? (g = i ? p : `${v}px`, m = `${r.floating.height + l}px`) : u === "right" ? (g = `${-l}px`, m = i ? p : `${y}px`) : u === "left" && (g = `${r.floating.width + l}px`, m = i ? p : `${y}px`), { data: { x: g, y: m } };
  }
});
function mv(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Ec = cv, vv = uv, hv = dv, gv = pv, cB = "Portal", bv = c.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [o, a] = c.useState(!1);
  mt(() => a(!0), []);
  const i = n || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? Er.createPortal(/* @__PURE__ */ f(G.div, { ...r, ref: t }), i) : null;
});
bv.displayName = cB;
var Ha = "rovingFocusGroup.onEntryFocus", lB = { bubbles: !1, cancelable: !0 }, Jo = "RovingFocusGroup", [Ai, yv, uB] = Vt(Jo), [dB, Kt] = Re(
  Jo,
  [uB]
), [fB, pB] = dB(Jo), wv = c.forwardRef(
  (e, t) => /* @__PURE__ */ f(Ai.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ f(Ai.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ f(mB, { ...e, ref: t }) }) })
);
wv.displayName = Jo;
var mB = c.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: u,
    preventScrollOnEntryFocus: d = !1,
    ...p
  } = e, v = c.useRef(null), y = ne(t, v), g = Ut(a), [m = null, h] = Me({
    prop: i,
    defaultProp: s,
    onChange: l
  }), [b, w] = c.useState(!1), C = me(u), E = yv(n), P = c.useRef(!1), [x, S] = c.useState(0);
  return c.useEffect(() => {
    const _ = v.current;
    if (_)
      return _.addEventListener(Ha, C), () => _.removeEventListener(Ha, C);
  }, [C]), /* @__PURE__ */ f(
    fB,
    {
      scope: n,
      orientation: r,
      dir: g,
      loop: o,
      currentTabStopId: m,
      onItemFocus: c.useCallback(
        (_) => h(_),
        [h]
      ),
      onItemShiftTab: c.useCallback(() => w(!0), []),
      onFocusableItemAdd: c.useCallback(
        () => S((_) => _ + 1),
        []
      ),
      onFocusableItemRemove: c.useCallback(
        () => S((_) => _ - 1),
        []
      ),
      children: /* @__PURE__ */ f(
        G.div,
        {
          tabIndex: b || x === 0 ? -1 : 0,
          "data-orientation": r,
          ...p,
          ref: y,
          style: { outline: "none", ...e.style },
          onMouseDown: I(e.onMouseDown, () => {
            P.current = !0;
          }),
          onFocus: I(e.onFocus, (_) => {
            const T = !P.current;
            if (_.target === _.currentTarget && T && !b) {
              const k = new CustomEvent(Ha, lB);
              if (_.currentTarget.dispatchEvent(k), !k.defaultPrevented) {
                const L = E().filter((H) => H.focusable), U = L.find((H) => H.active), M = L.find((H) => H.id === m), W = [U, M, ...L].filter(
                  Boolean
                ).map((H) => H.ref.current);
                Sv(W, d);
              }
            }
            P.current = !1;
          }),
          onBlur: I(e.onBlur, () => w(!1))
        }
      )
    }
  );
}), Cv = "RovingFocusGroupItem", Ev = c.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: a,
      ...i
    } = e, s = ze(), l = a || s, u = pB(Cv, n), d = u.currentTabStopId === l, p = yv(n), { onFocusableItemAdd: v, onFocusableItemRemove: y } = u;
    return c.useEffect(() => {
      if (r)
        return v(), () => y();
    }, [r, v, y]), /* @__PURE__ */ f(
      Ai.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ f(
          G.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...i,
            ref: t,
            onMouseDown: I(e.onMouseDown, (g) => {
              r ? u.onItemFocus(l) : g.preventDefault();
            }),
            onFocus: I(e.onFocus, () => u.onItemFocus(l)),
            onKeyDown: I(e.onKeyDown, (g) => {
              if (g.key === "Tab" && g.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (g.target !== g.currentTarget)
                return;
              const m = gB(g, u.orientation, u.dir);
              if (m !== void 0) {
                if (g.metaKey || g.ctrlKey || g.altKey || g.shiftKey)
                  return;
                g.preventDefault();
                let b = p().filter((w) => w.focusable).map((w) => w.ref.current);
                if (m === "last")
                  b.reverse();
                else if (m === "prev" || m === "next") {
                  m === "prev" && b.reverse();
                  const w = b.indexOf(g.currentTarget);
                  b = u.loop ? bB(b, w + 1) : b.slice(w + 1);
                }
                setTimeout(() => Sv(b));
              }
            })
          }
        )
      }
    );
  }
);
Ev.displayName = Cv;
var vB = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function hB(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function gB(e, t, n) {
  const r = hB(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return vB[r];
}
function Sv(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n))
      return;
}
function bB(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var ea = wv, ta = Ev, Pv = rs(), Ua = function() {
}, na = c.forwardRef(function(e, t) {
  var n = c.useRef(null), r = c.useState({
    onScrollCapture: Ua,
    onWheelCapture: Ua,
    onTouchMoveCapture: Ua
  }), o = r[0], a = r[1], i = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, d = e.enabled, p = e.shards, v = e.sideCar, y = e.noIsolation, g = e.inert, m = e.allowPinchZoom, h = e.as, b = h === void 0 ? "div" : h, w = e.gapMode, C = os(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = v, P = as([n, t]), x = Ie(Ie({}, C), o);
  return c.createElement(
    c.Fragment,
    null,
    d && c.createElement(E, { sideCar: Pv, removeScrollBar: u, shards: p, noIsolation: y, inert: g, setCallbacks: a, allowPinchZoom: !!m, lockRef: n, gapMode: w }),
    i ? c.cloneElement(c.Children.only(s), Ie(Ie({}, x), { ref: P })) : c.createElement(b, Ie({}, x, { className: l, ref: P }), s)
  );
});
na.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
na.classNames = {
  fullWidth: is,
  zeroRight: ss
};
var Ii = !1;
if (typeof window < "u")
  try {
    var zr = Object.defineProperty({}, "passive", {
      get: function() {
        return Ii = !0, !0;
      }
    });
    window.addEventListener("test", zr, zr), window.removeEventListener("test", zr, zr);
  } catch {
    Ii = !1;
  }
var En = Ii ? { passive: !1 } : !1, yB = function(e) {
  return e.tagName === "TEXTAREA";
}, xv = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !yB(e) && n[t] === "visible")
  );
}, wB = function(e) {
  return xv(e, "overflowY");
}, CB = function(e) {
  return xv(e, "overflowX");
}, Ju = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = _v(e, r);
    if (o) {
      var a = Tv(e, r), i = a[1], s = a[2];
      if (i > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, EB = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, SB = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, _v = function(e, t) {
  return e === "v" ? wB(t) : CB(t);
}, Tv = function(e, t) {
  return e === "v" ? EB(t) : SB(t);
}, PB = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, xB = function(e, t, n, r, o) {
  var a = PB(e, window.getComputedStyle(t).direction), i = a * r, s = n.target, l = t.contains(s), u = !1, d = i > 0, p = 0, v = 0;
  do {
    var y = Tv(e, s), g = y[0], m = y[1], h = y[2], b = m - h - a * g;
    (g || b) && _v(e, s) && (p += b, v += g), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (d && (o && Math.abs(p) < 1 || !o && i > p) || !d && (o && Math.abs(v) < 1 || !o && -i > v)) && (u = !0), u;
}, qr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ed = function(e) {
  return [e.deltaX, e.deltaY];
}, td = function(e) {
  return e && "current" in e ? e.current : e;
}, _B = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, TB = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, NB = 0, Sn = [];
function RB(e) {
  var t = c.useRef([]), n = c.useRef([0, 0]), r = c.useRef(), o = c.useState(NB++)[0], a = c.useState(cs)[0], i = c.useRef(e);
  c.useEffect(function() {
    i.current = e;
  }, [e]), c.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var m = ls([e.lockRef.current], (e.shards || []).map(td), !0).filter(Boolean);
      return m.forEach(function(h) {
        return h.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), m.forEach(function(h) {
          return h.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = c.useCallback(function(m, h) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !i.current.allowPinchZoom;
    var b = qr(m), w = n.current, C = "deltaX" in m ? m.deltaX : w[0] - b[0], E = "deltaY" in m ? m.deltaY : w[1] - b[1], P, x = m.target, S = Math.abs(C) > Math.abs(E) ? "h" : "v";
    if ("touches" in m && S === "h" && x.type === "range")
      return !1;
    var _ = Ju(S, x);
    if (!_)
      return !0;
    if (_ ? P = S : (P = S === "v" ? "h" : "v", _ = Ju(S, x)), !_)
      return !1;
    if (!r.current && "changedTouches" in m && (C || E) && (r.current = P), !P)
      return !0;
    var T = r.current || P;
    return xB(T, h, m, T === "h" ? C : E, !0);
  }, []), l = c.useCallback(function(m) {
    var h = m;
    if (!(!Sn.length || Sn[Sn.length - 1] !== a)) {
      var b = "deltaY" in h ? ed(h) : qr(h), w = t.current.filter(function(P) {
        return P.name === h.type && (P.target === h.target || h.target === P.shadowParent) && _B(P.delta, b);
      })[0];
      if (w && w.should) {
        h.cancelable && h.preventDefault();
        return;
      }
      if (!w) {
        var C = (i.current.shards || []).map(td).filter(Boolean).filter(function(P) {
          return P.contains(h.target);
        }), E = C.length > 0 ? s(h, C[0]) : !i.current.noIsolation;
        E && h.cancelable && h.preventDefault();
      }
    }
  }, []), u = c.useCallback(function(m, h, b, w) {
    var C = { name: m, delta: h, target: b, should: w, shadowParent: $B(b) };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(E) {
        return E !== C;
      });
    }, 1);
  }, []), d = c.useCallback(function(m) {
    n.current = qr(m), r.current = void 0;
  }, []), p = c.useCallback(function(m) {
    u(m.type, ed(m), m.target, s(m, e.lockRef.current));
  }, []), v = c.useCallback(function(m) {
    u(m.type, qr(m), m.target, s(m, e.lockRef.current));
  }, []);
  c.useEffect(function() {
    return Sn.push(a), e.setCallbacks({
      onScrollCapture: p,
      onWheelCapture: p,
      onTouchMoveCapture: v
    }), document.addEventListener("wheel", l, En), document.addEventListener("touchmove", l, En), document.addEventListener("touchstart", d, En), function() {
      Sn = Sn.filter(function(m) {
        return m !== a;
      }), document.removeEventListener("wheel", l, En), document.removeEventListener("touchmove", l, En), document.removeEventListener("touchstart", d, En);
    };
  }, []);
  var y = e.removeScrollBar, g = e.inert;
  return c.createElement(
    c.Fragment,
    null,
    g ? c.createElement(a, { styles: TB(o) }) : null,
    y ? c.createElement(us, { gapMode: e.gapMode }) : null
  );
}
function $B(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const OB = ds(Pv, RB);
var Nv = c.forwardRef(function(e, t) {
  return c.createElement(na, Ie({}, e, { ref: t, sideCar: OB }));
});
Nv.classNames = na.classNames;
const MB = Nv;
var ki = ["Enter", " "], DB = ["ArrowDown", "PageUp", "Home"], Rv = ["ArrowUp", "PageDown", "End"], AB = [...DB, ...Rv], IB = {
  ltr: [...ki, "ArrowRight"],
  rtl: [...ki, "ArrowLeft"]
}, kB = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Dr = "Menu", [hr, LB, FB] = Vt(Dr), [hn, Sc] = Re(Dr, [
  FB,
  Qo,
  Kt
]), Ar = Qo(), $v = Kt(), [Ov, Yt] = hn(Dr), [BB, Ir] = hn(Dr), Mv = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: a, modal: i = !0 } = e, s = Ar(t), [l, u] = c.useState(null), d = c.useRef(!1), p = me(a), v = Ut(o);
  return c.useEffect(() => {
    const y = () => {
      d.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => d.current = !1;
    return document.addEventListener("keydown", y, { capture: !0 }), () => {
      document.removeEventListener("keydown", y, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ f(Ec, { ...s, children: /* @__PURE__ */ f(
    Ov,
    {
      scope: t,
      open: n,
      onOpenChange: p,
      content: l,
      onContentChange: u,
      children: /* @__PURE__ */ f(
        BB,
        {
          scope: t,
          onClose: c.useCallback(() => p(!1), [p]),
          isUsingKeyboardRef: d,
          dir: v,
          modal: i,
          children: r
        }
      )
    }
  ) });
};
Mv.displayName = Dr;
var WB = "MenuAnchor", Pc = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Ar(n);
    return /* @__PURE__ */ f(vv, { ...o, ...r, ref: t });
  }
);
Pc.displayName = WB;
var xc = "MenuPortal", [jB, Dv] = hn(xc, {
  forceMount: void 0
}), Av = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, a = Yt(xc, t);
  return /* @__PURE__ */ f(jB, { scope: t, forceMount: n, children: /* @__PURE__ */ f(Fe, { present: n || a.open, children: /* @__PURE__ */ f(bv, { asChild: !0, container: o, children: r }) }) });
};
Av.displayName = xc;
var it = "MenuContent", [HB, _c] = hn(it), Iv = c.forwardRef(
  (e, t) => {
    const n = Dv(it, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Yt(it, e.__scopeMenu), i = Ir(it, e.__scopeMenu);
    return /* @__PURE__ */ f(hr.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ f(Fe, { present: r || a.open, children: /* @__PURE__ */ f(hr.Slot, { scope: e.__scopeMenu, children: i.modal ? /* @__PURE__ */ f(UB, { ...o, ref: t }) : /* @__PURE__ */ f(VB, { ...o, ref: t }) }) }) });
  }
), UB = c.forwardRef(
  (e, t) => {
    const n = Yt(it, e.__scopeMenu), r = c.useRef(null), o = ne(t, r);
    return c.useEffect(() => {
      const a = r.current;
      if (a)
        return fs(a);
    }, []), /* @__PURE__ */ f(
      Tc,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: I(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), VB = c.forwardRef((e, t) => {
  const n = Yt(it, e.__scopeMenu);
  return /* @__PURE__ */ f(
    Tc,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Tc = c.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: a,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEntryFocus: l,
      onEscapeKeyDown: u,
      onPointerDownOutside: d,
      onFocusOutside: p,
      onInteractOutside: v,
      onDismiss: y,
      disableOutsideScroll: g,
      ...m
    } = e, h = Yt(it, n), b = Ir(it, n), w = Ar(n), C = $v(n), E = LB(n), [P, x] = c.useState(null), S = c.useRef(null), _ = ne(t, S, h.onContentChange), T = c.useRef(0), k = c.useRef(""), L = c.useRef(0), U = c.useRef(null), M = c.useRef("right"), F = c.useRef(0), W = g ? MB : c.Fragment, H = g ? { as: Tn, allowPinchZoom: !0 } : void 0, A = (B) => {
      var Z, re;
      const Q = k.current + B, q = E().filter((ie) => !ie.disabled), O = document.activeElement, j = (Z = q.find((ie) => ie.ref.current === O)) == null ? void 0 : Z.textValue, Y = q.map((ie) => ie.textValue), V = n3(Y, Q, j), ee = (re = q.find((ie) => ie.textValue === V)) == null ? void 0 : re.ref.current;
      (function ie(de) {
        k.current = de, window.clearTimeout(T.current), de !== "" && (T.current = window.setTimeout(() => ie(""), 1e3));
      })(Q), ee && setTimeout(() => ee.focus());
    };
    c.useEffect(() => () => window.clearTimeout(T.current), []), Ed();
    const D = c.useCallback((B) => {
      var q, O;
      return M.current === ((q = U.current) == null ? void 0 : q.side) && o3(B, (O = U.current) == null ? void 0 : O.area);
    }, []);
    return /* @__PURE__ */ f(
      HB,
      {
        scope: n,
        searchRef: k,
        onItemEnter: c.useCallback(
          (B) => {
            D(B) && B.preventDefault();
          },
          [D]
        ),
        onItemLeave: c.useCallback(
          (B) => {
            var Q;
            D(B) || ((Q = S.current) == null || Q.focus(), x(null));
          },
          [D]
        ),
        onTriggerLeave: c.useCallback(
          (B) => {
            D(B) && B.preventDefault();
          },
          [D]
        ),
        pointerGraceTimerRef: L,
        onPointerGraceIntentChange: c.useCallback((B) => {
          U.current = B;
        }, []),
        children: /* @__PURE__ */ f(W, { ...H, children: /* @__PURE__ */ f(
          rv,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: I(a, (B) => {
              var Q;
              B.preventDefault(), (Q = S.current) == null || Q.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ f(
              tv,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: u,
                onPointerDownOutside: d,
                onFocusOutside: p,
                onInteractOutside: v,
                onDismiss: y,
                children: /* @__PURE__ */ f(
                  ea,
                  {
                    asChild: !0,
                    ...C,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: P,
                    onCurrentTabStopIdChange: x,
                    onEntryFocus: I(l, (B) => {
                      b.isUsingKeyboardRef.current || B.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ f(
                      hv,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Qv(h.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...w,
                        ...m,
                        ref: _,
                        style: { outline: "none", ...m.style },
                        onKeyDown: I(m.onKeyDown, (B) => {
                          const q = B.target.closest("[data-radix-menu-content]") === B.currentTarget, O = B.ctrlKey || B.altKey || B.metaKey, j = B.key.length === 1;
                          q && (B.key === "Tab" && B.preventDefault(), !O && j && A(B.key));
                          const Y = S.current;
                          if (B.target !== Y || !AB.includes(B.key))
                            return;
                          B.preventDefault();
                          const ee = E().filter((Z) => !Z.disabled).map((Z) => Z.ref.current);
                          Rv.includes(B.key) && ee.reverse(), e3(ee);
                        }),
                        onBlur: I(e.onBlur, (B) => {
                          B.currentTarget.contains(B.target) || (window.clearTimeout(T.current), k.current = "");
                        }),
                        onPointerMove: I(
                          e.onPointerMove,
                          gr((B) => {
                            const Q = B.target, q = F.current !== B.clientX;
                            if (B.currentTarget.contains(Q) && q) {
                              const O = B.clientX > F.current ? "right" : "left";
                              M.current = O, F.current = B.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Iv.displayName = it;
var GB = "MenuGroup", Nc = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ f(G.div, { role: "group", ...r, ref: t });
  }
);
Nc.displayName = GB;
var KB = "MenuLabel", kv = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ f(G.div, { ...r, ref: t });
  }
);
kv.displayName = KB;
var So = "MenuItem", nd = "menu.itemSelect", ra = c.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, a = c.useRef(null), i = Ir(So, e.__scopeMenu), s = _c(So, e.__scopeMenu), l = ne(t, a), u = c.useRef(!1), d = () => {
      const p = a.current;
      if (!n && p) {
        const v = new CustomEvent(nd, { bubbles: !0, cancelable: !0 });
        p.addEventListener(nd, (y) => r == null ? void 0 : r(y), { once: !0 }), Ot(p, v), v.defaultPrevented ? u.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ f(
      Lv,
      {
        ...o,
        ref: l,
        disabled: n,
        onClick: I(e.onClick, d),
        onPointerDown: (p) => {
          var v;
          (v = e.onPointerDown) == null || v.call(e, p), u.current = !0;
        },
        onPointerUp: I(e.onPointerUp, (p) => {
          var v;
          u.current || (v = p.currentTarget) == null || v.click();
        }),
        onKeyDown: I(e.onKeyDown, (p) => {
          const v = s.searchRef.current !== "";
          n || v && p.key === " " || ki.includes(p.key) && (p.currentTarget.click(), p.preventDefault());
        })
      }
    );
  }
);
ra.displayName = So;
var Lv = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...a } = e, i = _c(So, n), s = $v(n), l = c.useRef(null), u = ne(t, l), [d, p] = c.useState(!1), [v, y] = c.useState("");
    return c.useEffect(() => {
      const g = l.current;
      g && y((g.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ f(
      hr.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? v,
        children: /* @__PURE__ */ f(ta, { asChild: !0, ...s, focusable: !r, children: /* @__PURE__ */ f(
          G.div,
          {
            role: "menuitem",
            "data-highlighted": d ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...a,
            ref: u,
            onPointerMove: I(
              e.onPointerMove,
              gr((g) => {
                r ? i.onItemLeave(g) : (i.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: I(
              e.onPointerLeave,
              gr((g) => i.onItemLeave(g))
            ),
            onFocus: I(e.onFocus, () => p(!0)),
            onBlur: I(e.onBlur, () => p(!1))
          }
        ) })
      }
    );
  }
), YB = "MenuCheckboxItem", Fv = c.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ f(Uv, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ f(
      ra,
      {
        role: "menuitemcheckbox",
        "aria-checked": Po(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": Oc(n),
        onSelect: I(
          o.onSelect,
          () => r == null ? void 0 : r(Po(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Fv.displayName = YB;
var Bv = "MenuRadioGroup", [zB, qB] = hn(
  Bv,
  { value: void 0, onValueChange: () => {
  } }
), Wv = c.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, a = me(r);
    return /* @__PURE__ */ f(zB, { scope: e.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ f(Nc, { ...o, ref: t }) });
  }
);
Wv.displayName = Bv;
var jv = "MenuRadioItem", Hv = c.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = qB(jv, e.__scopeMenu), a = n === o.value;
    return /* @__PURE__ */ f(Uv, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ f(
      ra,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...r,
        ref: t,
        "data-state": Oc(a),
        onSelect: I(
          r.onSelect,
          () => {
            var i;
            return (i = o.onValueChange) == null ? void 0 : i.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Hv.displayName = jv;
var Rc = "MenuItemIndicator", [Uv, XB] = hn(
  Rc,
  { checked: !1 }
), Vv = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, a = XB(Rc, n);
    return /* @__PURE__ */ f(
      Fe,
      {
        present: r || Po(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ f(
          G.span,
          {
            ...o,
            ref: t,
            "data-state": Oc(a.checked)
          }
        )
      }
    );
  }
);
Vv.displayName = Rc;
var ZB = "MenuSeparator", Gv = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ f(
      G.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
Gv.displayName = ZB;
var QB = "MenuArrow", Kv = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Ar(n);
    return /* @__PURE__ */ f(gv, { ...o, ...r, ref: t });
  }
);
Kv.displayName = QB;
var $c = "MenuSub", [JB, Yv] = hn($c), zv = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, a = Yt($c, t), i = Ar(t), [s, l] = c.useState(null), [u, d] = c.useState(null), p = me(o);
  return c.useEffect(() => (a.open === !1 && p(!1), () => p(!1)), [a.open, p]), /* @__PURE__ */ f(Ec, { ...i, children: /* @__PURE__ */ f(
    Ov,
    {
      scope: t,
      open: r,
      onOpenChange: p,
      content: u,
      onContentChange: d,
      children: /* @__PURE__ */ f(
        JB,
        {
          scope: t,
          contentId: ze(),
          triggerId: ze(),
          trigger: s,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
zv.displayName = $c;
var er = "MenuSubTrigger", qv = c.forwardRef(
  (e, t) => {
    const n = Yt(er, e.__scopeMenu), r = Ir(er, e.__scopeMenu), o = Yv(er, e.__scopeMenu), a = _c(er, e.__scopeMenu), i = c.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: l } = a, u = { __scopeMenu: e.__scopeMenu }, d = c.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    return c.useEffect(() => d, [d]), c.useEffect(() => {
      const p = s.current;
      return () => {
        window.clearTimeout(p), l(null);
      };
    }, [s, l]), /* @__PURE__ */ f(Pc, { asChild: !0, ...u, children: /* @__PURE__ */ f(
      Lv,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": Qv(n.open),
        ...e,
        ref: wr(t, o.onTriggerChange),
        onClick: (p) => {
          var v;
          (v = e.onClick) == null || v.call(e, p), !(e.disabled || p.defaultPrevented) && (p.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: I(
          e.onPointerMove,
          gr((p) => {
            a.onItemEnter(p), !p.defaultPrevented && !e.disabled && !n.open && !i.current && (a.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              n.onOpenChange(!0), d();
            }, 100));
          })
        ),
        onPointerLeave: I(
          e.onPointerLeave,
          gr((p) => {
            var y, g;
            d();
            const v = (y = n.content) == null ? void 0 : y.getBoundingClientRect();
            if (v) {
              const m = (g = n.content) == null ? void 0 : g.dataset.side, h = m === "right", b = h ? -5 : 5, w = v[h ? "left" : "right"], C = v[h ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: p.clientX + b, y: p.clientY },
                  { x: w, y: v.top },
                  { x: C, y: v.top },
                  { x: C, y: v.bottom },
                  { x: w, y: v.bottom }
                ],
                side: m
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(p), p.defaultPrevented)
                return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: I(e.onKeyDown, (p) => {
          var y;
          const v = a.searchRef.current !== "";
          e.disabled || v && p.key === " " || IB[r.dir].includes(p.key) && (n.onOpenChange(!0), (y = n.content) == null || y.focus(), p.preventDefault());
        })
      }
    ) });
  }
);
qv.displayName = er;
var Xv = "MenuSubContent", Zv = c.forwardRef(
  (e, t) => {
    const n = Dv(it, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Yt(it, e.__scopeMenu), i = Ir(it, e.__scopeMenu), s = Yv(Xv, e.__scopeMenu), l = c.useRef(null), u = ne(t, l);
    return /* @__PURE__ */ f(hr.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ f(Fe, { present: r || a.open, children: /* @__PURE__ */ f(hr.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ f(
      Tc,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...o,
        ref: u,
        align: "start",
        side: i.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (d) => {
          var p;
          i.isUsingKeyboardRef.current && ((p = l.current) == null || p.focus()), d.preventDefault();
        },
        onCloseAutoFocus: (d) => d.preventDefault(),
        onFocusOutside: I(e.onFocusOutside, (d) => {
          d.target !== s.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: I(e.onEscapeKeyDown, (d) => {
          i.onClose(), d.preventDefault();
        }),
        onKeyDown: I(e.onKeyDown, (d) => {
          var y;
          const p = d.currentTarget.contains(d.target), v = kB[i.dir].includes(d.key);
          p && v && (a.onOpenChange(!1), (y = s.trigger) == null || y.focus(), d.preventDefault());
        })
      }
    ) }) }) });
  }
);
Zv.displayName = Xv;
function Qv(e) {
  return e ? "open" : "closed";
}
function Po(e) {
  return e === "indeterminate";
}
function Oc(e) {
  return Po(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function e3(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function t3(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function n3(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = t3(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter((u) => u !== n));
  const l = i.find(
    (u) => u.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function r3(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a].x, l = t[a].y, u = t[i].x, d = t[i].y;
    l > r != d > r && n < (u - s) * (r - l) / (d - l) + s && (o = !o);
  }
  return o;
}
function o3(e, t) {
  if (!t)
    return !1;
  const n = { x: e.clientX, y: e.clientY };
  return r3(n, t);
}
function gr(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Jv = Mv, eh = Pc, th = Av, nh = Iv, rh = Nc, oh = kv, ah = ra, ih = Fv, sh = Wv, ch = Hv, lh = Vv, uh = Gv, dh = Kv, fh = zv, ph = qv, mh = Zv, Mc = "ContextMenu", [a3, H8] = Re(Mc, [
  Sc
]), We = Sc(), [i3, vh] = a3(Mc), hh = (e) => {
  const { __scopeContextMenu: t, children: n, onOpenChange: r, dir: o, modal: a = !0 } = e, [i, s] = c.useState(!1), l = We(t), u = me(r), d = c.useCallback(
    (p) => {
      s(p), u(p);
    },
    [u]
  );
  return /* @__PURE__ */ f(
    i3,
    {
      scope: t,
      open: i,
      onOpenChange: d,
      modal: a,
      children: /* @__PURE__ */ f(
        Jv,
        {
          ...l,
          dir: o,
          open: i,
          onOpenChange: d,
          modal: a,
          children: n
        }
      )
    }
  );
};
hh.displayName = Mc;
var gh = "ContextMenuTrigger", bh = c.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, disabled: r = !1, ...o } = e, a = vh(gh, n), i = We(n), s = c.useRef({ x: 0, y: 0 }), l = c.useRef({
      getBoundingClientRect: () => DOMRect.fromRect({ width: 0, height: 0, ...s.current })
    }), u = c.useRef(0), d = c.useCallback(
      () => window.clearTimeout(u.current),
      []
    ), p = (v) => {
      s.current = { x: v.clientX, y: v.clientY }, a.onOpenChange(!0);
    };
    return c.useEffect(() => d, [d]), c.useEffect(() => void (r && d()), [r, d]), /* @__PURE__ */ X(Oe, { children: [
      /* @__PURE__ */ f(eh, { ...i, virtualRef: l }),
      /* @__PURE__ */ f(
        G.span,
        {
          "data-state": a.open ? "open" : "closed",
          "data-disabled": r ? "" : void 0,
          ...o,
          ref: t,
          style: { WebkitTouchCallout: "none", ...e.style },
          onContextMenu: r ? e.onContextMenu : I(e.onContextMenu, (v) => {
            d(), p(v), v.preventDefault();
          }),
          onPointerDown: r ? e.onPointerDown : I(
            e.onPointerDown,
            Xr((v) => {
              d(), u.current = window.setTimeout(() => p(v), 700);
            })
          ),
          onPointerMove: r ? e.onPointerMove : I(e.onPointerMove, Xr(d)),
          onPointerCancel: r ? e.onPointerCancel : I(e.onPointerCancel, Xr(d)),
          onPointerUp: r ? e.onPointerUp : I(e.onPointerUp, Xr(d))
        }
      )
    ] });
  }
);
bh.displayName = gh;
var s3 = "ContextMenuPortal", yh = (e) => {
  const { __scopeContextMenu: t, ...n } = e, r = We(t);
  return /* @__PURE__ */ f(th, { ...r, ...n });
};
yh.displayName = s3;
var wh = "ContextMenuContent", Ch = c.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...r } = e, o = vh(wh, n), a = We(n), i = c.useRef(!1);
    return /* @__PURE__ */ f(
      nh,
      {
        ...a,
        ...r,
        ref: t,
        side: "right",
        sideOffset: 2,
        align: "start",
        onCloseAutoFocus: (s) => {
          var l;
          (l = e.onCloseAutoFocus) == null || l.call(e, s), !s.defaultPrevented && i.current && s.preventDefault(), i.current = !1;
        },
        onInteractOutside: (s) => {
          var l;
          (l = e.onInteractOutside) == null || l.call(e, s), !s.defaultPrevented && !o.modal && (i.current = !0);
        },
        style: {
          ...e.style,
          "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Ch.displayName = wh;
var c3 = "ContextMenuGroup", Eh = c.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...r } = e, o = We(n);
    return /* @__PURE__ */ f(rh, { ...o, ...r, ref: t });
  }
);
Eh.displayName = c3;
var l3 = "ContextMenuLabel", Sh = c.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...r } = e, o = We(n);
    return /* @__PURE__ */ f(oh, { ...o, ...r, ref: t });
  }
);
Sh.displayName = l3;
var u3 = "ContextMenuItem", Ph = c.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...r } = e, o = We(n);
    return /* @__PURE__ */ f(ah, { ...o, ...r, ref: t });
  }
);
Ph.displayName = u3;
var d3 = "ContextMenuCheckboxItem", xh = c.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...r } = e, o = We(n);
  return /* @__PURE__ */ f(ih, { ...o, ...r, ref: t });
});
xh.displayName = d3;
var f3 = "ContextMenuRadioGroup", _h = c.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...r } = e, o = We(n);
  return /* @__PURE__ */ f(sh, { ...o, ...r, ref: t });
});
_h.displayName = f3;
var p3 = "ContextMenuRadioItem", Th = c.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...r } = e, o = We(n);
  return /* @__PURE__ */ f(ch, { ...o, ...r, ref: t });
});
Th.displayName = p3;
var m3 = "ContextMenuItemIndicator", Nh = c.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...r } = e, o = We(n);
  return /* @__PURE__ */ f(lh, { ...o, ...r, ref: t });
});
Nh.displayName = m3;
var v3 = "ContextMenuSeparator", Rh = c.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...r } = e, o = We(n);
  return /* @__PURE__ */ f(uh, { ...o, ...r, ref: t });
});
Rh.displayName = v3;
var h3 = "ContextMenuArrow", g3 = c.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...r } = e, o = We(n);
    return /* @__PURE__ */ f(dh, { ...o, ...r, ref: t });
  }
);
g3.displayName = h3;
var b3 = "ContextMenuSub", $h = (e) => {
  const { __scopeContextMenu: t, children: n, onOpenChange: r, open: o, defaultOpen: a } = e, i = We(t), [s, l] = Me({
    prop: o,
    defaultProp: a,
    onChange: r
  });
  return /* @__PURE__ */ f(fh, { ...i, open: s, onOpenChange: l, children: n });
};
$h.displayName = b3;
var y3 = "ContextMenuSubTrigger", Oh = c.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...r } = e, o = We(n);
  return /* @__PURE__ */ f(ph, { ...o, ...r, ref: t });
});
Oh.displayName = y3;
var w3 = "ContextMenuSubContent", Mh = c.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...r } = e, o = We(n);
  return /* @__PURE__ */ f(
    mh,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Mh.displayName = w3;
function Xr(e) {
  return (t) => t.pointerType !== "mouse" ? e(t) : void 0;
}
var C3 = hh, E3 = bh, Dh = yh, Ah = Ch, S3 = Eh, Ih = Sh, kh = Ph, Lh = xh, P3 = _h, Fh = Th, Bh = Nh, Wh = Rh, x3 = $h, jh = Oh, Hh = Mh;
const U8 = C3, V8 = E3, G8 = S3, K8 = Dh, Y8 = x3, z8 = P3, _3 = c.forwardRef(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ X(
  jh,
  {
    ref: o,
    className: $(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ f(Sr, { className: "ml-auto h-4 w-4" })
    ]
  }
));
_3.displayName = jh.displayName;
const T3 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Hh,
  {
    ref: n,
    className: $(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
T3.displayName = Hh.displayName;
const N3 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(Dh, { children: /* @__PURE__ */ f(
  Ah,
  {
    ref: n,
    className: $(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
) }));
N3.displayName = Ah.displayName;
const R3 = c.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ f(
  kh,
  {
    ref: r,
    className: $(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t && "pl-8",
      e
    ),
    ...n
  }
));
R3.displayName = kh.displayName;
const $3 = c.forwardRef(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ X(
  Lh,
  {
    ref: o,
    className: $(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ f("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ f(Bh, { children: /* @__PURE__ */ f(gs, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
$3.displayName = Lh.displayName;
const O3 = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ X(
  Fh,
  {
    ref: r,
    className: $(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ f("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ f(Bh, { children: /* @__PURE__ */ f(bs, { className: "h-4 w-4 fill-current" }) }) }),
      t
    ]
  }
));
O3.displayName = Fh.displayName;
const M3 = c.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ f(
  Ih,
  {
    ref: r,
    className: $(
      "px-2 py-1.5 text-sm font-semibold text-foreground",
      t && "pl-8",
      e
    ),
    ...n
  }
));
M3.displayName = Ih.displayName;
const D3 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Wh,
  {
    ref: n,
    className: $("-mx-1 my-1 h-px bg-border", e),
    ...t
  }
));
D3.displayName = Wh.displayName;
const A3 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ f(
  "span",
  {
    className: $(
      "ml-auto text-xs tracking-widest text-muted-foreground",
      e
    ),
    ...t
  }
);
A3.displayName = "ContextMenuShortcut";
function I3(e) {
  if (!e || typeof document > "u")
    return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const Uh = R.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), Wn = () => {
  const e = R.useContext(Uh);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
I3(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function k3() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function L3() {
  return Dc(/^Mac/);
}
function F3() {
  return Dc(/^iPhone/);
}
function rd() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function B3() {
  return Dc(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  L3() && navigator.maxTouchPoints > 1;
}
function Vh() {
  return F3() || B3();
}
function Dc(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const W3 = 24, j3 = typeof window < "u" ? Oo : Ee;
function od(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const Va = typeof document < "u" && window.visualViewport;
function ad(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function Gh(e) {
  for (ad(e) && (e = e.parentElement); e && !ad(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const H3 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let Zr = 0, Ga;
function U3(e = {}) {
  let { isDisabled: t } = e;
  j3(() => {
    if (!t)
      return Zr++, Zr === 1 && Vh() && (Ga = V3()), () => {
        Zr--, Zr === 0 && (Ga == null || Ga());
      };
  }, [
    t
  ]);
}
function V3() {
  let e, t = 0, n = (p) => {
    e = Gh(p.target), !(e === document.documentElement && e === document.body) && (t = p.changedTouches[0].pageY);
  }, r = (p) => {
    if (!e || e === document.documentElement || e === document.body) {
      p.preventDefault();
      return;
    }
    let v = p.changedTouches[0].pageY, y = e.scrollTop, g = e.scrollHeight - e.clientHeight;
    g !== 0 && ((y <= 0 && v > t || y >= g && v < t) && p.preventDefault(), t = v);
  }, o = (p) => {
    let v = p.target;
    Li(v) && v !== document.activeElement && (p.preventDefault(), v.style.transform = "translateY(-2000px)", v.focus(), requestAnimationFrame(() => {
      v.style.transform = "";
    }));
  }, a = (p) => {
    let v = p.target;
    Li(v) && (v.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      v.style.transform = "", Va && (Va.height < window.innerHeight ? requestAnimationFrame(() => {
        id(v);
      }) : Va.addEventListener("resize", () => id(v), {
        once: !0
      }));
    }));
  }, i = () => {
    window.scrollTo(0, 0);
  }, s = window.pageXOffset, l = window.pageYOffset, u = od(G3(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let d = od(Xn(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), Xn(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), Xn(document, "touchend", o, {
    passive: !1,
    capture: !0
  }), Xn(document, "focus", a, !0), Xn(window, "scroll", i));
  return () => {
    u(), d(), window.scrollTo(s, l);
  };
}
function G3(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function Xn(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function id(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = Gh(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, o = e.getBoundingClientRect().top, a = e.getBoundingClientRect().bottom;
      const i = n.getBoundingClientRect().bottom + W3;
      a > i && (n.scrollTop += o - r);
    }
    e = n.parentElement;
  }
}
function Li(e) {
  return e instanceof HTMLInputElement && !H3.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function K3(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Y3(...e) {
  return (t) => e.forEach((n) => K3(n, t));
}
function Kh(...e) {
  return c.useCallback(Y3(...e), e);
}
const Yh = /* @__PURE__ */ new WeakMap();
function De(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement))
    return;
  let r = {};
  Object.entries(t).forEach(([o, a]) => {
    if (o.startsWith("--")) {
      e.style.setProperty(o, a);
      return;
    }
    r[o] = e.style[o], e.style[o] = a;
  }), !n && Yh.set(e, r);
}
function z3(e, t) {
  if (!e || !(e instanceof HTMLElement))
    return;
  let n = Yh.get(e);
  n && (e.style[t] = n[t]);
}
const $e = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function Qr(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let o = r.match(/^matrix3d\((.+)\)$/);
  return o ? parseFloat(o[1].split(", ")[$e(t) ? 13 : 12]) : (o = r.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[$e(t) ? 5 : 4]) : null);
}
function q3(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function Ka(e, t) {
  if (!e)
    return () => {
    };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function X3(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const _e = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, zh = 0.4, Z3 = 0.25, Q3 = 100, qh = 8, Zt = 16, Fi = 26, Ya = "vaul-dragging";
function Xh(e) {
  const t = R.useRef(e);
  return R.useEffect(() => {
    t.current = e;
  }), R.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function J3({ defaultProp: e, onChange: t }) {
  const n = R.useState(e), [r] = n, o = R.useRef(r), a = Xh(t);
  return R.useEffect(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
function Zh({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = J3({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, i = a ? e : r, s = Xh(n), l = R.useCallback((u) => {
    if (a) {
      const p = typeof u == "function" ? u(e) : u;
      p !== e && s(p);
    } else
      o(u);
  }, [
    a,
    e,
    o,
    s
  ]);
  return [
    i,
    l
  ];
}
function e5({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: o, fadeFromIndex: a, onSnapPointChange: i, direction: s = "bottom", container: l, snapToSequentialPoint: u }) {
  const [d, p] = Zh({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [v, y] = R.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  R.useEffect(() => {
    function S() {
      y({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", S), () => window.removeEventListener("resize", S);
  }, []);
  const g = R.useMemo(() => d === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    d
  ]), m = R.useMemo(() => {
    var S;
    return (S = n == null ? void 0 : n.findIndex((_) => _ === d)) != null ? S : null;
  }, [
    n,
    d
  ]), h = n && n.length > 0 && (a || a === 0) && !Number.isNaN(a) && n[a] === d || !n, b = R.useMemo(() => {
    const S = l ? {
      width: l.getBoundingClientRect().width,
      height: l.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var _;
    return (_ = n == null ? void 0 : n.map((T) => {
      const k = typeof T == "string";
      let L = 0;
      if (k && (L = parseInt(T, 10)), $e(s)) {
        const M = k ? L : v ? T * S.height : 0;
        return v ? s === "bottom" ? S.height - M : -S.height + M : M;
      }
      const U = k ? L : v ? T * S.width : 0;
      return v ? s === "right" ? S.width - U : -S.width + U : U;
    })) != null ? _ : [];
  }, [
    n,
    v,
    l
  ]), w = R.useMemo(() => m !== null ? b == null ? void 0 : b[m] : null, [
    b,
    m
  ]), C = R.useCallback((S) => {
    var _;
    const T = (_ = b == null ? void 0 : b.findIndex((k) => k === S)) != null ? _ : null;
    i(T), De(r.current, {
      transition: `transform ${_e.DURATION}s cubic-bezier(${_e.EASE.join(",")})`,
      transform: $e(s) ? `translate3d(0, ${S}px, 0)` : `translate3d(${S}px, 0, 0)`
    }), b && T !== b.length - 1 && a !== void 0 && T !== a && T < a ? De(o.current, {
      transition: `opacity ${_e.DURATION}s cubic-bezier(${_e.EASE.join(",")})`,
      opacity: "0"
    }) : De(o.current, {
      transition: `opacity ${_e.DURATION}s cubic-bezier(${_e.EASE.join(",")})`,
      opacity: "1"
    }), p(n == null ? void 0 : n[Math.max(T, 0)]);
  }, [
    r.current,
    n,
    b,
    a,
    o,
    p
  ]);
  R.useEffect(() => {
    if (d || e) {
      var S;
      const _ = (S = n == null ? void 0 : n.findIndex((T) => T === e || T === d)) != null ? S : -1;
      b && _ !== -1 && typeof b[_] == "number" && C(b[_]);
    }
  }, [
    d,
    e,
    n,
    b,
    C
  ]);
  function E({ draggedDistance: S, closeDrawer: _, velocity: T, dismissible: k }) {
    if (a === void 0)
      return;
    const L = s === "bottom" || s === "right" ? (w ?? 0) - S : (w ?? 0) + S, U = m === a - 1, M = m === 0, F = S > 0;
    if (U && De(o.current, {
      transition: `opacity ${_e.DURATION}s cubic-bezier(${_e.EASE.join(",")})`
    }), !u && T > 2 && !F) {
      k ? _() : C(b[0]);
      return;
    }
    if (!u && T > 2 && F && b && n) {
      C(b[n.length - 1]);
      return;
    }
    const W = b == null ? void 0 : b.reduce((A, D) => typeof A != "number" || typeof D != "number" ? A : Math.abs(D - L) < Math.abs(A - L) ? D : A), H = $e(s) ? window.innerHeight : window.innerWidth;
    if (T > zh && Math.abs(S) < H * 0.4) {
      const A = F ? 1 : -1;
      if (A > 0 && g && n) {
        C(b[n.length - 1]);
        return;
      }
      if (M && A < 0 && k && _(), m === null)
        return;
      C(b[m + A]);
      return;
    }
    C(W);
  }
  function P({ draggedDistance: S }) {
    if (w === null)
      return;
    const _ = s === "bottom" || s === "right" ? w - S : w + S;
    (s === "bottom" || s === "right") && _ < b[b.length - 1] || (s === "top" || s === "left") && _ > b[b.length - 1] || De(r.current, {
      transform: $e(s) ? `translate3d(0, ${_}px, 0)` : `translate3d(${_}px, 0, 0)`
    });
  }
  function x(S, _) {
    if (!n || typeof m != "number" || !b || a === void 0)
      return null;
    const T = m === a - 1;
    if (m >= a && _)
      return 0;
    if (T && !_)
      return 1;
    if (!h && !T)
      return null;
    const L = T ? m + 1 : m - 1, U = T ? b[L] - b[L - 1] : b[L + 1] - b[L], M = S / Math.abs(U);
    return T ? 1 - M : M;
  }
  return {
    isLastSnapPoint: g,
    activeSnapPoint: d,
    shouldFade: h,
    getPercentageDragged: x,
    setActiveSnapPoint: p,
    activeSnapPointIndex: m,
    onRelease: E,
    onDrag: P,
    snapPointsOffset: b
  };
}
const t5 = () => () => {
};
function n5() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: o } = Wn(), a = R.useRef(null), i = Ht(() => document.body.style.backgroundColor, []);
  function s() {
    return (window.innerWidth - Fi) / window.innerWidth;
  }
  R.useEffect(() => {
    if (t && n) {
      a.current && clearTimeout(a.current);
      const l = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!l)
        return;
      X3(r && !o ? Ka(document.body, {
        background: "black"
      }) : t5, Ka(l, {
        transformOrigin: $e(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${_e.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${_e.EASE.join(",")})`
      }));
      const u = Ka(l, {
        borderRadius: `${qh}px`,
        overflow: "hidden",
        ...$e(e) ? {
          transform: `scale(${s()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${s()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        u(), a.current = window.setTimeout(() => {
          i ? document.body.style.background = i : document.body.style.removeProperty("background");
        }, _e.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    i
  ]);
}
let Zn = null;
function r5({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: o, noBodyStyles: a }) {
  const [i, s] = R.useState(() => typeof window < "u" ? window.location.href : ""), l = R.useRef(0), u = R.useCallback(() => {
    if (rd() && Zn === null && e && !a) {
      Zn = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: p, innerHeight: v } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-l.current}px`,
        left: `${-p}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const y = v - window.innerHeight;
        y && l.current >= v && (document.body.style.top = `${-(l.current + y)}px`);
      }), 300);
    }
  }, [
    e
  ]), d = R.useCallback(() => {
    if (rd() && Zn !== null && !a) {
      const p = -parseInt(document.body.style.top, 10), v = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, Zn), window.requestAnimationFrame(() => {
        if (o && i !== window.location.href) {
          s(window.location.href);
          return;
        }
        window.scrollTo(v, p);
      }), Zn = null;
    }
  }, [
    i
  ]);
  return R.useEffect(() => {
    function p() {
      l.current = window.scrollY;
    }
    return p(), window.addEventListener("scroll", p), () => {
      window.removeEventListener("scroll", p);
    };
  }, []), R.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || d();
      };
  }, [
    t,
    d
  ]), R.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && u(), t || window.setTimeout(() => {
      d();
    }, 500)) : d());
  }, [
    e,
    r,
    i,
    t,
    n,
    u,
    d
  ]), {
    restorePositionSetting: d
  };
}
function Qh({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: o, snapPoints: a, shouldScaleBackground: i = !1, setBackgroundColorOnScale: s = !0, closeThreshold: l = Z3, scrollLockTimeout: u = Q3, dismissible: d = !0, handleOnly: p = !1, fadeFromIndex: v = a && a.length - 1, activeSnapPoint: y, setActiveSnapPoint: g, fixed: m, modal: h = !0, onClose: b, nested: w, noBodyStyles: C = !1, direction: E = "bottom", defaultOpen: P = !1, disablePreventScroll: x = !0, snapToSequentialPoint: S = !1, preventScrollRestoration: _ = !1, repositionInputs: T = !0, onAnimationEnd: k, container: L, autoFocus: U = !1 }) {
  var M, F;
  const [W = !1, H] = Zh({
    defaultProp: P,
    prop: e,
    onChange: (J) => {
      t == null || t(J), !J && !w && nt(), setTimeout(() => {
        k == null || k(J);
      }, _e.DURATION * 1e3), J && !h && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), J || (document.body.style.pointerEvents = "auto");
    }
  }), [A, D] = R.useState(!1), [B, Q] = R.useState(!1), [q, O] = R.useState(!1), j = R.useRef(null), Y = R.useRef(null), V = R.useRef(null), ee = R.useRef(null), Z = R.useRef(null), re = R.useRef(!1), ie = R.useRef(null), de = R.useRef(0), se = R.useRef(!1), K = R.useRef(!P), oe = R.useRef(0), N = R.useRef(null), z = R.useRef(((M = N.current) == null ? void 0 : M.getBoundingClientRect().height) || 0), ce = R.useRef(((F = N.current) == null ? void 0 : F.getBoundingClientRect().width) || 0), fe = R.useRef(0), Se = R.useCallback((J) => {
    a && J === Le.length - 1 && (Y.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: ae, activeSnapPointIndex: ye, setActiveSnapPoint: Qe, onRelease: ke, snapPointsOffset: Le, onDrag: Ge, shouldFade: Ke, getPercentageDragged: tt } = e5({
    snapPoints: a,
    activeSnapPointProp: y,
    setActiveSnapPointProp: g,
    drawerRef: N,
    fadeFromIndex: v,
    overlayRef: j,
    onSnapPointChange: Se,
    direction: E,
    container: L,
    snapToSequentialPoint: S
  });
  U3({
    isDisabled: !W || B || !h || q || !A || !T || !x
  });
  const { restorePositionSetting: nt } = r5({
    isOpen: W,
    modal: h,
    nested: w ?? !1,
    hasBeenOpened: A,
    preventScrollRestoration: _,
    noBodyStyles: C
  });
  function Nt() {
    return (window.innerWidth - Fi) / window.innerWidth;
  }
  function It(J) {
    var pe, ge;
    !d && !a || N.current && !N.current.contains(J.target) || (z.current = ((pe = N.current) == null ? void 0 : pe.getBoundingClientRect().height) || 0, ce.current = ((ge = N.current) == null ? void 0 : ge.getBoundingClientRect().width) || 0, Q(!0), V.current = /* @__PURE__ */ new Date(), Vh() && window.addEventListener("touchend", () => re.current = !1, {
      once: !0
    }), J.target.setPointerCapture(J.pointerId), de.current = $e(E) ? J.pageY : J.pageX);
  }
  function lt(J, pe) {
    var ge;
    let le = J;
    const Pe = (ge = window.getSelection()) == null ? void 0 : ge.toString(), Be = N.current ? Qr(N.current, E) : null, Ae = /* @__PURE__ */ new Date();
    if (le.tagName === "SELECT" || le.hasAttribute("data-vaul-no-drag") || le.closest("[data-vaul-no-drag]"))
      return !1;
    if (E === "right" || E === "left")
      return !0;
    if (Y.current && Ae.getTime() - Y.current.getTime() < 500)
      return !1;
    if (Be !== null && (E === "bottom" ? Be > 0 : Be < 0))
      return !0;
    if (Pe && Pe.length > 0)
      return !1;
    if (Z.current && Ae.getTime() - Z.current.getTime() < u && Be === 0 || pe)
      return Z.current = Ae, !1;
    for (; le; ) {
      if (le.scrollHeight > le.clientHeight) {
        if (le.scrollTop !== 0)
          return Z.current = /* @__PURE__ */ new Date(), !1;
        if (le.getAttribute("role") === "dialog")
          return !0;
      }
      le = le.parentNode;
    }
    return !0;
  }
  function zt(J) {
    if (N.current && B) {
      const pe = E === "bottom" || E === "right" ? 1 : -1, ge = (de.current - ($e(E) ? J.pageY : J.pageX)) * pe, le = ge > 0, Pe = a && !d && !le;
      if (Pe && ye === 0)
        return;
      const Be = Math.abs(ge), Ae = document.querySelector("[data-vaul-drawer-wrapper]"), Ct = E === "bottom" || E === "top" ? z.current : ce.current;
      let dt = Be / Ct;
      const Xt = tt(Be, le);
      if (Xt !== null && (dt = Xt), Pe && dt >= 1 || !re.current && !lt(J.target, le))
        return;
      if (N.current.classList.add(Ya), re.current = !0, De(N.current, {
        transition: "none"
      }), De(j.current, {
        transition: "none"
      }), a && Ge({
        draggedDistance: ge
      }), le && !a) {
        const Et = q3(ge), kr = Math.min(Et * -1, 0) * pe;
        De(N.current, {
          transform: $e(E) ? `translate3d(0, ${kr}px, 0)` : `translate3d(${kr}px, 0, 0)`
        });
        return;
      }
      const kt = 1 - dt;
      if ((Ke || v && ye === v - 1) && (r == null || r(J, dt), De(j.current, {
        opacity: `${kt}`,
        transition: "none"
      }, !0)), Ae && j.current && i) {
        const Et = Math.min(Nt() + dt * (1 - Nt()), 1), kr = 8 - dt * 8, nl = Math.max(0, 14 - dt * 14);
        De(Ae, {
          borderRadius: `${kr}px`,
          transform: $e(E) ? `scale(${Et}) translate3d(0, ${nl}px, 0)` : `scale(${Et}) translate3d(${nl}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!a) {
        const Et = Be * pe;
        De(N.current, {
          transform: $e(E) ? `translate3d(0, ${Et}px, 0)` : `translate3d(${Et}px, 0, 0)`
        });
      }
    }
  }
  R.useEffect(() => {
    window.requestAnimationFrame(() => {
      K.current = !0;
    });
  }, []), R.useEffect(() => {
    var J;
    function pe() {
      if (!N.current || !T)
        return;
      const ge = document.activeElement;
      if (Li(ge) || se.current) {
        var le;
        const Pe = ((le = window.visualViewport) == null ? void 0 : le.height) || 0, Be = window.innerHeight;
        let Ae = Be - Pe;
        const Ct = N.current.getBoundingClientRect().height || 0, dt = Ct > Be * 0.8;
        fe.current || (fe.current = Ct);
        const Xt = N.current.getBoundingClientRect().top;
        if (Math.abs(oe.current - Ae) > 60 && (se.current = !se.current), a && a.length > 0 && Le && ye) {
          const kt = Le[ye] || 0;
          Ae += kt;
        }
        if (oe.current = Ae, Ct > Pe || se.current) {
          const kt = N.current.getBoundingClientRect().height;
          let Et = kt;
          kt > Pe && (Et = Pe - (dt ? Xt : Fi)), m ? N.current.style.height = `${kt - Math.max(Ae, 0)}px` : N.current.style.height = `${Math.max(Et, Pe - Xt)}px`;
        } else
          k3() || (N.current.style.height = `${fe.current}px`);
        a && a.length > 0 && !se.current ? N.current.style.bottom = "0px" : N.current.style.bottom = `${Math.max(Ae, 0)}px`;
      }
    }
    return (J = window.visualViewport) == null || J.addEventListener("resize", pe), () => {
      var ge;
      return (ge = window.visualViewport) == null ? void 0 : ge.removeEventListener("resize", pe);
    };
  }, [
    ye,
    a,
    Le
  ]);
  function ut(J) {
    qt(), b == null || b(), J || H(!1), setTimeout(() => {
      a && Qe(a[0]);
    }, _e.DURATION * 1e3);
  }
  function He() {
    if (!N.current)
      return;
    const J = document.querySelector("[data-vaul-drawer-wrapper]"), pe = Qr(N.current, E);
    De(N.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${_e.DURATION}s cubic-bezier(${_e.EASE.join(",")})`
    }), De(j.current, {
      transition: `opacity ${_e.DURATION}s cubic-bezier(${_e.EASE.join(",")})`,
      opacity: "1"
    }), i && pe && pe > 0 && W && De(J, {
      borderRadius: `${qh}px`,
      overflow: "hidden",
      ...$e(E) ? {
        transform: `scale(${Nt()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${Nt()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${_e.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${_e.EASE.join(",")})`
    }, !0);
  }
  function qt() {
    !B || !N.current || (N.current.classList.remove(Ya), re.current = !1, Q(!1), ee.current = /* @__PURE__ */ new Date());
  }
  function Vn(J) {
    if (!B || !N.current)
      return;
    N.current.classList.remove(Ya), re.current = !1, Q(!1), ee.current = /* @__PURE__ */ new Date();
    const pe = Qr(N.current, E);
    if (!J || !lt(J.target, !1) || !pe || Number.isNaN(pe) || V.current === null)
      return;
    const ge = ee.current.getTime() - V.current.getTime(), le = de.current - ($e(E) ? J.pageY : J.pageX), Pe = Math.abs(le) / ge;
    if (Pe > 0.05 && (O(!0), setTimeout(() => {
      O(!1);
    }, 200)), a) {
      ke({
        draggedDistance: le * (E === "bottom" || E === "right" ? 1 : -1),
        closeDrawer: ut,
        velocity: Pe,
        dismissible: d
      }), o == null || o(J, !0);
      return;
    }
    if (E === "bottom" || E === "right" ? le > 0 : le < 0) {
      He(), o == null || o(J, !0);
      return;
    }
    if (Pe > zh) {
      ut(), o == null || o(J, !1);
      return;
    }
    var Be;
    const Ae = Math.min((Be = N.current.getBoundingClientRect().height) != null ? Be : 0, window.innerHeight);
    var Ct;
    const dt = Math.min((Ct = N.current.getBoundingClientRect().width) != null ? Ct : 0, window.innerWidth), Xt = E === "left" || E === "right";
    if (Math.abs(pe) >= (Xt ? dt : Ae) * l) {
      ut(), o == null || o(J, !1);
      return;
    }
    o == null || o(J, !0), He();
  }
  R.useEffect(() => (W && (De(document.documentElement, {
    scrollBehavior: "auto"
  }), Y.current = /* @__PURE__ */ new Date()), () => {
    z3(document.documentElement, "scrollBehavior");
  }), [
    W
  ]);
  function ua(J) {
    const pe = J ? (window.innerWidth - Zt) / window.innerWidth : 1, ge = J ? -Zt : 0;
    ie.current && window.clearTimeout(ie.current), De(N.current, {
      transition: `transform ${_e.DURATION}s cubic-bezier(${_e.EASE.join(",")})`,
      transform: $e(E) ? `scale(${pe}) translate3d(0, ${ge}px, 0)` : `scale(${pe}) translate3d(${ge}, 0, 0)`
    }), !J && N.current && (ie.current = setTimeout(() => {
      const le = Qr(N.current, E);
      De(N.current, {
        transition: "none",
        transform: $e(E) ? `translate3d(0, ${le}px, 0)` : `translate3d(${le}px, 0, 0)`
      });
    }, 500));
  }
  function da(J, pe) {
    if (pe < 0)
      return;
    const ge = (window.innerWidth - Zt) / window.innerWidth, le = ge + pe * (1 - ge), Pe = -Zt + pe * Zt;
    De(N.current, {
      transform: $e(E) ? `scale(${le}) translate3d(0, ${Pe}px, 0)` : `scale(${le}) translate3d(${Pe}px, 0, 0)`,
      transition: "none"
    });
  }
  function fa(J, pe) {
    const ge = $e(E) ? window.innerHeight : window.innerWidth, le = pe ? (ge - Zt) / ge : 1, Pe = pe ? -Zt : 0;
    pe && De(N.current, {
      transition: `transform ${_e.DURATION}s cubic-bezier(${_e.EASE.join(",")})`,
      transform: $e(E) ? `scale(${le}) translate3d(0, ${Pe}px, 0)` : `scale(${le}) translate3d(${Pe}px, 0, 0)`
    });
  }
  return R.useEffect(() => {
    h || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    h
  ]), /* @__PURE__ */ R.createElement(_d, {
    defaultOpen: P,
    onOpenChange: (J) => {
      !d && !J || (J ? D(!0) : ut(!0), H(J));
    },
    open: W
  }, /* @__PURE__ */ R.createElement(Uh.Provider, {
    value: {
      activeSnapPoint: ae,
      snapPoints: a,
      setActiveSnapPoint: Qe,
      drawerRef: N,
      overlayRef: j,
      onOpenChange: t,
      onPress: It,
      onRelease: Vn,
      onDrag: zt,
      dismissible: d,
      shouldAnimate: K,
      handleOnly: p,
      isOpen: W,
      isDragging: B,
      shouldFade: Ke,
      closeDrawer: ut,
      onNestedDrag: da,
      onNestedOpenChange: ua,
      onNestedRelease: fa,
      keyboardIsOpen: se,
      modal: h,
      snapPointsOffset: Le,
      activeSnapPointIndex: ye,
      direction: E,
      shouldScaleBackground: i,
      setBackgroundColorOnScale: s,
      noBodyStyles: C,
      container: L,
      autoFocus: U
    }
  }, n));
}
const Jh = /* @__PURE__ */ R.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: o, shouldFade: a, isOpen: i, modal: s, shouldAnimate: l } = Wn(), u = Kh(t, n), d = r && r.length > 0;
  if (!s)
    return null;
  const p = R.useCallback((v) => o(v), [
    o
  ]);
  return /* @__PURE__ */ R.createElement(ps, {
    onMouseUp: p,
    ref: u,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": i && d ? "true" : "false",
    "data-vaul-snap-points-overlay": i && a ? "true" : "false",
    "data-vaul-animate": l != null && l.current ? "true" : "false",
    ...e
  });
});
Jh.displayName = "Drawer.Overlay";
const eg = /* @__PURE__ */ R.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, o) {
  const { drawerRef: a, onPress: i, onRelease: s, onDrag: l, keyboardIsOpen: u, snapPointsOffset: d, activeSnapPointIndex: p, modal: v, isOpen: y, direction: g, snapPoints: m, container: h, handleOnly: b, shouldAnimate: w, autoFocus: C } = Wn(), [E, P] = R.useState(!1), x = Kh(o, a), S = R.useRef(null), _ = R.useRef(null), T = R.useRef(!1), k = m && m.length > 0;
  n5();
  const L = (M, F, W = 0) => {
    if (T.current)
      return !0;
    const H = Math.abs(M.y), A = Math.abs(M.x), D = A > H, B = [
      "bottom",
      "right"
    ].includes(F) ? 1 : -1;
    if (F === "left" || F === "right") {
      if (!(M.x * B < 0) && A >= 0 && A <= W)
        return D;
    } else if (!(M.y * B < 0) && H >= 0 && H <= W)
      return !D;
    return T.current = !0, !0;
  };
  R.useEffect(() => {
    k && window.requestAnimationFrame(() => {
      P(!0);
    });
  }, []);
  function U(M) {
    S.current = null, T.current = !1, s(M);
  }
  return /* @__PURE__ */ R.createElement(ms, {
    "data-vaul-drawer-direction": g,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": E ? "true" : "false",
    "data-vaul-snap-points": y && k ? "true" : "false",
    "data-vaul-custom-container": h ? "true" : "false",
    "data-vaul-animate": w != null && w.current ? "true" : "false",
    ...r,
    ref: x,
    style: d && d.length > 0 ? {
      "--snap-point-height": `${d[p ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (M) => {
      b || (r.onPointerDown == null || r.onPointerDown.call(r, M), S.current = {
        x: M.pageX,
        y: M.pageY
      }, i(M));
    },
    onOpenAutoFocus: (M) => {
      n == null || n(M), C || M.preventDefault();
    },
    onPointerDownOutside: (M) => {
      if (e == null || e(M), !v || M.defaultPrevented) {
        M.preventDefault();
        return;
      }
      u.current && (u.current = !1);
    },
    onFocusOutside: (M) => {
      if (!v) {
        M.preventDefault();
        return;
      }
    },
    onPointerMove: (M) => {
      if (_.current = M, b || (r.onPointerMove == null || r.onPointerMove.call(r, M), !S.current))
        return;
      const F = M.pageY - S.current.y, W = M.pageX - S.current.x, H = M.pointerType === "touch" ? 10 : 2;
      L({
        x: W,
        y: F
      }, g, H) ? l(M) : (Math.abs(W) > H || Math.abs(F) > H) && (S.current = null);
    },
    onPointerUp: (M) => {
      r.onPointerUp == null || r.onPointerUp.call(r, M), S.current = null, T.current = !1, s(M);
    },
    onPointerOut: (M) => {
      r.onPointerOut == null || r.onPointerOut.call(r, M), U(_.current);
    },
    onContextMenu: (M) => {
      r.onContextMenu == null || r.onContextMenu.call(r, M), _.current && U(_.current);
    }
  });
});
eg.displayName = "Drawer.Content";
const o5 = 250, a5 = 120, tg = /* @__PURE__ */ R.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: o, isDragging: a, snapPoints: i, activeSnapPoint: s, setActiveSnapPoint: l, dismissible: u, handleOnly: d, isOpen: p, onPress: v, onDrag: y } = Wn(), g = R.useRef(null), m = R.useRef(!1);
  function h() {
    if (m.current) {
      C();
      return;
    }
    window.setTimeout(() => {
      b();
    }, a5);
  }
  function b() {
    if (a || e || m.current) {
      C();
      return;
    }
    if (C(), !i || i.length === 0) {
      u || o();
      return;
    }
    if (s === i[i.length - 1] && u) {
      o();
      return;
    }
    const P = i.findIndex((S) => S === s);
    if (P === -1)
      return;
    const x = i[P + 1];
    l(x);
  }
  function w() {
    g.current = window.setTimeout(() => {
      m.current = !0;
    }, o5);
  }
  function C() {
    g.current && window.clearTimeout(g.current), m.current = !1;
  }
  return /* @__PURE__ */ R.createElement("div", {
    onClick: h,
    onPointerCancel: C,
    onPointerDown: (E) => {
      d && v(E), w();
    },
    onPointerMove: (E) => {
      d && y(E);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": p ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ R.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
tg.displayName = "Drawer.Handle";
function i5({ onDrag: e, onOpenChange: t, ...n }) {
  const { onNestedDrag: r, onNestedOpenChange: o, onNestedRelease: a } = Wn();
  if (!r)
    throw new Error("Drawer.NestedRoot must be placed in another drawer");
  return /* @__PURE__ */ R.createElement(Qh, {
    nested: !0,
    onClose: () => {
      o(!1);
    },
    onDrag: (i, s) => {
      r(i, s), e == null || e(i, s);
    },
    onOpenChange: (i) => {
      i && o(i);
    },
    onRelease: a,
    ...n
  });
}
function s5(e) {
  const t = Wn(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ R.createElement(xd, {
    container: n,
    ...r
  });
}
const wt = {
  Root: Qh,
  NestedRoot: i5,
  Content: eg,
  Overlay: Jh,
  Trigger: uw,
  Portal: s5,
  Handle: tg,
  Close: Pd,
  Title: vs,
  Description: hs
}, c5 = ({
  shouldScaleBackground: e = !0,
  ...t
}) => /* @__PURE__ */ f(
  wt.Root,
  {
    shouldScaleBackground: e,
    ...t
  }
);
c5.displayName = "Drawer";
const q8 = wt.Trigger, l5 = wt.Portal, X8 = wt.Close, ng = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  wt.Overlay,
  {
    ref: n,
    className: $("fixed inset-0 z-50 bg-black/80", e),
    ...t
  }
));
ng.displayName = wt.Overlay.displayName;
const u5 = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ X(l5, { children: [
  /* @__PURE__ */ f(ng, {}),
  /* @__PURE__ */ X(
    wt.Content,
    {
      ref: r,
      className: $(
        "fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-t-[10px] border bg-background",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ f("div", { className: "mx-auto mt-4 h-2 w-[100px] rounded-full bg-muted" }),
        t
      ]
    }
  )
] }));
u5.displayName = "DrawerContent";
const d5 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ f(
  "div",
  {
    className: $("grid gap-1.5 p-4 text-center sm:text-left", e),
    ...t
  }
);
d5.displayName = "DrawerHeader";
const f5 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ f(
  "div",
  {
    className: $("mt-auto flex flex-col gap-2 p-4", e),
    ...t
  }
);
f5.displayName = "DrawerFooter";
const p5 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  wt.Title,
  {
    ref: n,
    className: $(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
p5.displayName = wt.Title.displayName;
const m5 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  wt.Description,
  {
    ref: n,
    className: $("text-sm text-muted-foreground", e),
    ...t
  }
));
m5.displayName = wt.Description.displayName;
var v5 = "DismissableLayer", Bi = "dismissableLayer.update", h5 = "dismissableLayer.pointerDownOutside", g5 = "dismissableLayer.focusOutside", sd, rg = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), og = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, u = c.useContext(rg), [d, p] = c.useState(null), v = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, y] = c.useState({}), g = ne(t, (S) => p(S)), m = Array.from(u.layers), [h] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), b = m.indexOf(h), w = d ? m.indexOf(d) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, E = w >= b, P = w5((S) => {
      const _ = S.target, T = [...u.branches].some((k) => k.contains(_));
      !E || T || (o == null || o(S), i == null || i(S), S.defaultPrevented || s == null || s());
    }, v), x = C5((S) => {
      const _ = S.target;
      [...u.branches].some((k) => k.contains(_)) || (a == null || a(S), i == null || i(S), S.defaultPrevented || s == null || s());
    }, v);
    return br((S) => {
      w === u.layers.size - 1 && (r == null || r(S), !S.defaultPrevented && s && (S.preventDefault(), s()));
    }, v), c.useEffect(() => {
      if (d)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (sd = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), cd(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (v.body.style.pointerEvents = sd);
        };
    }, [d, v, n, u]), c.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), cd());
    }, [d, u]), c.useEffect(() => {
      const S = () => y({});
      return document.addEventListener(Bi, S), () => document.removeEventListener(Bi, S);
    }, []), /* @__PURE__ */ f(
      G.div,
      {
        ...l,
        ref: g,
        style: {
          pointerEvents: C ? E ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: I(e.onFocusCapture, x.onFocusCapture),
        onBlurCapture: I(e.onBlurCapture, x.onBlurCapture),
        onPointerDownCapture: I(
          e.onPointerDownCapture,
          P.onPointerDownCapture
        )
      }
    );
  }
);
og.displayName = v5;
var b5 = "DismissableLayerBranch", y5 = c.forwardRef((e, t) => {
  const n = c.useContext(rg), r = c.useRef(null), o = ne(t, r);
  return c.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ f(G.div, { ...e, ref: o });
});
y5.displayName = b5;
function w5(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = me(e), r = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          ag(
            h5,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function C5(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = me(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && ag(g5, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function cd() {
  const e = new CustomEvent(Bi);
  document.dispatchEvent(e);
}
function ag(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Ot(o, a) : o.dispatchEvent(a);
}
var za, Ac = "HoverCard", [ig, Z8] = Re(Ac, [
  Qo
]), oa = Qo(), [E5, Ic] = ig(Ac), sg = (e) => {
  const {
    __scopeHoverCard: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    openDelay: i = 700,
    closeDelay: s = 300
  } = e, l = oa(t), u = c.useRef(0), d = c.useRef(0), p = c.useRef(!1), v = c.useRef(!1), [y = !1, g] = Me({
    prop: r,
    defaultProp: o,
    onChange: a
  }), m = c.useCallback(() => {
    clearTimeout(d.current), u.current = window.setTimeout(() => g(!0), i);
  }, [i, g]), h = c.useCallback(() => {
    clearTimeout(u.current), !p.current && !v.current && (d.current = window.setTimeout(() => g(!1), s));
  }, [s, g]), b = c.useCallback(() => g(!1), [g]);
  return c.useEffect(() => () => {
    clearTimeout(u.current), clearTimeout(d.current);
  }, []), /* @__PURE__ */ f(
    E5,
    {
      scope: t,
      open: y,
      onOpenChange: g,
      onOpen: m,
      onClose: h,
      onDismiss: b,
      hasSelectionRef: p,
      isPointerDownOnContentRef: v,
      children: /* @__PURE__ */ f(Ec, { ...l, children: n })
    }
  );
};
sg.displayName = Ac;
var cg = "HoverCardTrigger", lg = c.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...r } = e, o = Ic(cg, n), a = oa(n);
    return /* @__PURE__ */ f(vv, { asChild: !0, ...a, children: /* @__PURE__ */ f(
      G.a,
      {
        "data-state": o.open ? "open" : "closed",
        ...r,
        ref: t,
        onPointerEnter: I(e.onPointerEnter, _o(o.onOpen)),
        onPointerLeave: I(e.onPointerLeave, _o(o.onClose)),
        onFocus: I(e.onFocus, o.onOpen),
        onBlur: I(e.onBlur, o.onClose),
        onTouchStart: I(e.onTouchStart, (i) => i.preventDefault())
      }
    ) });
  }
);
lg.displayName = cg;
var S5 = "HoverCardPortal", [Q8, P5] = ig(S5, {
  forceMount: void 0
}), xo = "HoverCardContent", ug = c.forwardRef(
  (e, t) => {
    const n = P5(xo, e.__scopeHoverCard), { forceMount: r = n.forceMount, ...o } = e, a = Ic(xo, e.__scopeHoverCard);
    return /* @__PURE__ */ f(Fe, { present: r || a.open, children: /* @__PURE__ */ f(
      x5,
      {
        "data-state": a.open ? "open" : "closed",
        ...o,
        onPointerEnter: I(e.onPointerEnter, _o(a.onOpen)),
        onPointerLeave: I(e.onPointerLeave, _o(a.onClose)),
        ref: t
      }
    ) });
  }
);
ug.displayName = xo;
var x5 = c.forwardRef((e, t) => {
  const {
    __scopeHoverCard: n,
    onEscapeKeyDown: r,
    onPointerDownOutside: o,
    onFocusOutside: a,
    onInteractOutside: i,
    ...s
  } = e, l = Ic(xo, n), u = oa(n), d = c.useRef(null), p = ne(t, d), [v, y] = c.useState(!1);
  return c.useEffect(() => {
    if (v) {
      const g = document.body;
      return za = g.style.userSelect || g.style.webkitUserSelect, g.style.userSelect = "none", g.style.webkitUserSelect = "none", () => {
        g.style.userSelect = za, g.style.webkitUserSelect = za;
      };
    }
  }, [v]), c.useEffect(() => {
    if (d.current) {
      const g = () => {
        y(!1), l.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var h;
          ((h = document.getSelection()) == null ? void 0 : h.toString()) !== "" && (l.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", g), () => {
        document.removeEventListener("pointerup", g), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [l.isPointerDownOnContentRef, l.hasSelectionRef]), c.useEffect(() => {
    d.current && N5(d.current).forEach((m) => m.setAttribute("tabindex", "-1"));
  }), /* @__PURE__ */ f(
    og,
    {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: i,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: I(a, (g) => {
        g.preventDefault();
      }),
      onDismiss: l.onDismiss,
      children: /* @__PURE__ */ f(
        hv,
        {
          ...u,
          ...s,
          onPointerDown: I(s.onPointerDown, (g) => {
            g.currentTarget.contains(g.target) && y(!0), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !0;
          }),
          ref: p,
          style: {
            ...s.style,
            userSelect: v ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: v ? "text" : void 0,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      )
    }
  );
}), _5 = "HoverCardArrow", T5 = c.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...r } = e, o = oa(n);
    return /* @__PURE__ */ f(gv, { ...o, ...r, ref: t });
  }
);
T5.displayName = _5;
function _o(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function N5(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
var R5 = sg, $5 = lg, dg = ug;
const J8 = R5, eH = $5, O5 = c.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, o) => /* @__PURE__ */ f(
  dg,
  {
    ref: o,
    align: t,
    sideOffset: n,
    className: $(
      "z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...r
  }
));
O5.displayName = dg.displayName;
var M5 = Object.defineProperty, D5 = Object.defineProperties, A5 = Object.getOwnPropertyDescriptors, To = Object.getOwnPropertySymbols, fg = Object.prototype.hasOwnProperty, pg = Object.prototype.propertyIsEnumerable, ld = (e, t, n) => t in e ? M5(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, I5 = (e, t) => {
  for (var n in t || (t = {}))
    fg.call(t, n) && ld(e, n, t[n]);
  if (To)
    for (var n of To(t))
      pg.call(t, n) && ld(e, n, t[n]);
  return e;
}, k5 = (e, t) => D5(e, A5(t)), L5 = (e, t) => {
  var n = {};
  for (var r in e)
    fg.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && To)
    for (var r of To(e))
      t.indexOf(r) < 0 && pg.call(e, r) && (n[r] = e[r]);
  return n;
};
function F5(e) {
  let t = setTimeout(e, 0), n = setTimeout(e, 10), r = setTimeout(e, 50);
  return [t, n, r];
}
function B5(e) {
  let t = c.useRef();
  return c.useEffect(() => {
    t.current = e;
  }), t.current;
}
var W5 = 18, mg = 40, j5 = `${mg}px`, H5 = ["[data-lastpass-icon-root]", "com-1password-button", "[data-dashlanecreated]", '[style$="2147483647 !important;"]'].join(",");
function U5({ containerRef: e, inputRef: t, pushPasswordManagerStrategy: n, isFocused: r }) {
  let [o, a] = c.useState(!1), [i, s] = c.useState(!1), [l, u] = c.useState(!1), d = c.useMemo(() => n === "none" ? !1 : (n === "increase-width" || n === "experimental-no-flickering") && o && i, [o, i, n]), p = c.useCallback(() => {
    let v = e.current, y = t.current;
    if (!v || !y || l || n === "none")
      return;
    let g = v, m = g.getBoundingClientRect().left + g.offsetWidth, h = g.getBoundingClientRect().top + g.offsetHeight / 2, b = m - W5, w = h;
    document.querySelectorAll(H5).length === 0 && document.elementFromPoint(b, w) === v || (a(!0), u(!0));
  }, [e, t, l, n]);
  return c.useEffect(() => {
    let v = e.current;
    if (!v || n === "none")
      return;
    function y() {
      let m = window.innerWidth - v.getBoundingClientRect().right;
      s(m >= mg);
    }
    y();
    let g = setInterval(y, 1e3);
    return () => {
      clearInterval(g);
    };
  }, [e, n]), c.useEffect(() => {
    let v = r || document.activeElement === t.current;
    if (n === "none" || !v)
      return;
    let y = setTimeout(p, 0), g = setTimeout(p, 2e3), m = setTimeout(p, 5e3), h = setTimeout(() => {
      u(!0);
    }, 6e3);
    return () => {
      clearTimeout(y), clearTimeout(g), clearTimeout(m), clearTimeout(h);
    };
  }, [t, r, n, p]), { hasPWMBadge: o, willPushPWMBadge: d, PWM_BADGE_SPACE_WIDTH: j5 };
}
var vg = c.createContext({}), hg = c.forwardRef((e, t) => {
  var n = e, { value: r, onChange: o, maxLength: a, textAlign: i = "left", pattern: s, placeholder: l, inputMode: u = "numeric", onComplete: d, pushPasswordManagerStrategy: p = "increase-width", pasteTransformer: v, containerClassName: y, noScriptCSSFallback: g = V5, render: m, children: h } = n, b = L5(n, ["value", "onChange", "maxLength", "textAlign", "pattern", "placeholder", "inputMode", "onComplete", "pushPasswordManagerStrategy", "pasteTransformer", "containerClassName", "noScriptCSSFallback", "render", "children"]), w, C, E, P, x;
  let [S, _] = c.useState(typeof b.defaultValue == "string" ? b.defaultValue : ""), T = r ?? S, k = B5(T), L = c.useCallback((N) => {
    o == null || o(N), _(N);
  }, [o]), U = c.useMemo(() => s ? typeof s == "string" ? new RegExp(s) : s : null, [s]), M = c.useRef(null), F = c.useRef(null), W = c.useRef({ value: T, onChange: L, isIOS: typeof window < "u" && ((C = (w = window == null ? void 0 : window.CSS) == null ? void 0 : w.supports) == null ? void 0 : C.call(w, "-webkit-touch-callout", "none")) }), H = c.useRef({ prev: [(E = M.current) == null ? void 0 : E.selectionStart, (P = M.current) == null ? void 0 : P.selectionEnd, (x = M.current) == null ? void 0 : x.selectionDirection] });
  c.useImperativeHandle(t, () => M.current, []), c.useEffect(() => {
    let N = M.current, z = F.current;
    if (!N || !z)
      return;
    W.current.value !== N.value && W.current.onChange(N.value), H.current.prev = [N.selectionStart, N.selectionEnd, N.selectionDirection];
    function ce() {
      if (document.activeElement !== N) {
        O(null), Y(null);
        return;
      }
      let ae = N.selectionStart, ye = N.selectionEnd, Qe = N.selectionDirection, ke = N.maxLength, Le = N.value, Ge = H.current.prev, Ke = -1, tt = -1, nt;
      if (Le.length !== 0 && ae !== null && ye !== null) {
        let zt = ae === ye, ut = ae === Le.length && Le.length < ke;
        if (zt && !ut) {
          let He = ae;
          if (He === 0)
            Ke = 0, tt = 1, nt = "forward";
          else if (He === ke)
            Ke = He - 1, tt = He, nt = "backward";
          else if (ke > 1 && Le.length > 1) {
            let qt = 0;
            if (Ge[0] !== null && Ge[1] !== null) {
              nt = He < Ge[1] ? "backward" : "forward";
              let Vn = Ge[0] === Ge[1] && Ge[0] < ke;
              nt === "backward" && !Vn && (qt = -1);
            }
            Ke = qt + He, tt = qt + He + 1;
          }
        }
        Ke !== -1 && tt !== -1 && Ke !== tt && M.current.setSelectionRange(Ke, tt, nt);
      }
      let Nt = Ke !== -1 ? Ke : ae, It = tt !== -1 ? tt : ye, lt = nt ?? Qe;
      O(Nt), Y(It), H.current.prev = [Nt, It, lt];
    }
    if (document.addEventListener("selectionchange", ce, { capture: !0 }), ce(), document.activeElement === N && Q(!0), !document.getElementById("input-otp-style")) {
      let ae = document.createElement("style");
      if (ae.id = "input-otp-style", document.head.appendChild(ae), ae.sheet) {
        let ye = "background: transparent !important; color: transparent !important; border-color: transparent !important; opacity: 0 !important; box-shadow: none !important; -webkit-box-shadow: none !important; -webkit-text-fill-color: transparent !important;";
        Qn(ae.sheet, "[data-input-otp]::selection { background: transparent !important; color: transparent !important; }"), Qn(ae.sheet, `[data-input-otp]:autofill { ${ye} }`), Qn(ae.sheet, `[data-input-otp]:-webkit-autofill { ${ye} }`), Qn(ae.sheet, "@supports (-webkit-touch-callout: none) { [data-input-otp] { letter-spacing: -.6em !important; font-weight: 100 !important; font-stretch: ultra-condensed; font-optical-sizing: none !important; left: -1px !important; right: 1px !important; } }"), Qn(ae.sheet, "[data-input-otp] + * { pointer-events: all !important; }");
      }
    }
    let fe = () => {
      z && z.style.setProperty("--root-height", `${N.clientHeight}px`);
    };
    fe();
    let Se = new ResizeObserver(fe);
    return Se.observe(N), () => {
      document.removeEventListener("selectionchange", ce, { capture: !0 }), Se.disconnect();
    };
  }, []);
  let [A, D] = c.useState(!1), [B, Q] = c.useState(!1), [q, O] = c.useState(null), [j, Y] = c.useState(null);
  c.useEffect(() => {
    F5(() => {
      var N, z, ce, fe;
      (N = M.current) == null || N.dispatchEvent(new Event("input"));
      let Se = (z = M.current) == null ? void 0 : z.selectionStart, ae = (ce = M.current) == null ? void 0 : ce.selectionEnd, ye = (fe = M.current) == null ? void 0 : fe.selectionDirection;
      Se !== null && ae !== null && (O(Se), Y(ae), H.current.prev = [Se, ae, ye]);
    });
  }, [T, B]), c.useEffect(() => {
    k !== void 0 && T !== k && k.length < a && T.length === a && (d == null || d(T));
  }, [a, d, k, T]);
  let V = U5({ containerRef: F, inputRef: M, pushPasswordManagerStrategy: p, isFocused: B }), ee = c.useCallback((N) => {
    let z = N.currentTarget.value.slice(0, a);
    if (z.length > 0 && U && !U.test(z)) {
      N.preventDefault();
      return;
    }
    typeof k == "string" && z.length < k.length && document.dispatchEvent(new Event("selectionchange")), L(z);
  }, [a, L, k, U]), Z = c.useCallback(() => {
    var N;
    if (M.current) {
      let z = Math.min(M.current.value.length, a - 1), ce = M.current.value.length;
      (N = M.current) == null || N.setSelectionRange(z, ce), O(z), Y(ce);
    }
    Q(!0);
  }, [a]), re = c.useCallback((N) => {
    var z, ce;
    let fe = M.current;
    if (!v && (!W.current.isIOS || !N.clipboardData || !fe))
      return;
    let Se = N.clipboardData.getData("text/plain"), ae = v ? v(Se) : Se;
    N.preventDefault();
    let ye = (z = M.current) == null ? void 0 : z.selectionStart, Qe = (ce = M.current) == null ? void 0 : ce.selectionEnd, ke = (ye !== Qe ? T.slice(0, ye) + ae + T.slice(Qe) : T.slice(0, ye) + ae + T.slice(ye)).slice(0, a);
    if (ke.length > 0 && U && !U.test(ke))
      return;
    fe.value = ke, L(ke);
    let Le = Math.min(ke.length, a - 1), Ge = ke.length;
    fe.setSelectionRange(Le, Ge), O(Le), Y(Ge);
  }, [a, L, U, T]), ie = c.useMemo(() => ({ position: "relative", cursor: b.disabled ? "default" : "text", userSelect: "none", WebkitUserSelect: "none", pointerEvents: "none" }), [b.disabled]), de = c.useMemo(() => ({ position: "absolute", inset: 0, width: V.willPushPWMBadge ? `calc(100% + ${V.PWM_BADGE_SPACE_WIDTH})` : "100%", clipPath: V.willPushPWMBadge ? `inset(0 ${V.PWM_BADGE_SPACE_WIDTH} 0 0)` : void 0, height: "100%", display: "flex", textAlign: i, opacity: "1", color: "transparent", pointerEvents: "all", background: "transparent", caretColor: "transparent", border: "0 solid transparent", outline: "0 solid transparent", boxShadow: "none", lineHeight: "1", letterSpacing: "-.5em", fontSize: "var(--root-height)", fontFamily: "monospace", fontVariantNumeric: "tabular-nums" }), [V.PWM_BADGE_SPACE_WIDTH, V.willPushPWMBadge, i]), se = c.useMemo(() => c.createElement("input", k5(I5({ autoComplete: b.autoComplete || "one-time-code" }, b), { "data-input-otp": !0, "data-input-otp-placeholder-shown": T.length === 0 || void 0, "data-input-otp-mss": q, "data-input-otp-mse": j, inputMode: u, pattern: U == null ? void 0 : U.source, "aria-placeholder": l, style: de, maxLength: a, value: T, ref: M, onPaste: (N) => {
    var z;
    re(N), (z = b.onPaste) == null || z.call(b, N);
  }, onChange: ee, onMouseOver: (N) => {
    var z;
    D(!0), (z = b.onMouseOver) == null || z.call(b, N);
  }, onMouseLeave: (N) => {
    var z;
    D(!1), (z = b.onMouseLeave) == null || z.call(b, N);
  }, onFocus: (N) => {
    var z;
    Z(), (z = b.onFocus) == null || z.call(b, N);
  }, onBlur: (N) => {
    var z;
    Q(!1), (z = b.onBlur) == null || z.call(b, N);
  } })), [ee, Z, re, u, de, a, j, q, b, U == null ? void 0 : U.source, T]), K = c.useMemo(() => ({ slots: Array.from({ length: a }).map((N, z) => {
    var ce;
    let fe = B && q !== null && j !== null && (q === j && z === q || z >= q && z < j), Se = T[z] !== void 0 ? T[z] : null, ae = T[0] !== void 0 ? null : (ce = l == null ? void 0 : l[z]) != null ? ce : null;
    return { char: Se, placeholderChar: ae, isActive: fe, hasFakeCaret: fe && Se === null };
  }), isFocused: B, isHovering: !b.disabled && A }), [B, A, a, j, q, b.disabled, T]), oe = c.useMemo(() => m ? m(K) : c.createElement(vg.Provider, { value: K }, h), [h, K, m]);
  return c.createElement(c.Fragment, null, g !== null && c.createElement("noscript", null, c.createElement("style", null, g)), c.createElement("div", { ref: F, "data-input-otp-container": !0, style: ie, className: y }, oe, c.createElement("div", { style: { position: "absolute", inset: 0, pointerEvents: "none" } }, se)));
});
hg.displayName = "Input";
function Qn(e, t) {
  try {
    e.insertRule(t);
  } catch {
    console.error("input-otp could not insert CSS rule:", t);
  }
}
var V5 = `
[data-input-otp] {
  --nojs-bg: white !important;
  --nojs-fg: black !important;

  background-color: var(--nojs-bg) !important;
  color: var(--nojs-fg) !important;
  caret-color: var(--nojs-fg) !important;
  letter-spacing: .25em !important;
  text-align: center !important;
  border: 1px solid var(--nojs-fg) !important;
  border-radius: 4px !important;
  width: 100% !important;
}
@media (prefers-color-scheme: dark) {
  [data-input-otp] {
    --nojs-bg: black !important;
    --nojs-fg: white !important;
  }
}`;
const G5 = c.forwardRef(({ className: e, containerClassName: t, ...n }, r) => /* @__PURE__ */ f(
  hg,
  {
    ref: r,
    containerClassName: $(
      "flex items-center gap-2 has-[:disabled]:opacity-50",
      t
    ),
    className: $("disabled:cursor-not-allowed", e),
    ...n
  }
));
G5.displayName = "InputOTP";
const K5 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f("div", { ref: n, className: $("flex items-center", e), ...t }));
K5.displayName = "InputOTPGroup";
const Y5 = c.forwardRef(({ index: e, className: t, ...n }, r) => {
  const o = c.useContext(vg), { char: a, hasFakeCaret: i, isActive: s } = o.slots[e];
  return /* @__PURE__ */ X(
    "div",
    {
      ref: r,
      className: $(
        "relative flex h-9 w-9 items-center justify-center border-y border-r border-input text-sm shadow-sm transition-all first:rounded-l-md first:border-l last:rounded-r-md",
        s && "z-10 ring-1 ring-ring",
        t
      ),
      ...n,
      children: [
        a,
        i && /* @__PURE__ */ f("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ f("div", { className: "h-4 w-px animate-caret-blink bg-foreground duration-1000" }) })
      ]
    }
  );
});
Y5.displayName = "InputOTPSlot";
const z5 = c.forwardRef(({ ...e }, t) => /* @__PURE__ */ f("div", { ref: t, role: "separator", ...e, children: /* @__PURE__ */ f(mw, {}) }));
z5.displayName = "InputOTPSeparator";
var gg = c.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = c.Children.toArray(n), a = o.find(X5);
  if (a) {
    const i = a.props.children, s = o.map((l) => l === a ? c.Children.count(i) > 1 ? c.Children.only(null) : c.isValidElement(i) ? i.props.children : null : l);
    return /* @__PURE__ */ f(Wi, { ...r, ref: t, children: c.isValidElement(i) ? c.cloneElement(i, void 0, s) : null });
  }
  return /* @__PURE__ */ f(Wi, { ...r, ref: t, children: n });
});
gg.displayName = "Slot";
var Wi = c.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (c.isValidElement(n)) {
    const o = Q5(n);
    return c.cloneElement(n, {
      ...Z5(r, n.props),
      // @ts-ignore
      ref: t ? wr(t, o) : o
    });
  }
  return c.Children.count(n) > 1 ? c.Children.only(null) : null;
});
Wi.displayName = "SlotClone";
var q5 = ({ children: e }) => /* @__PURE__ */ f(Oe, { children: e });
function X5(e) {
  return c.isValidElement(e) && e.type === q5;
}
function Z5(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Q5(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var J5 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], e4 = J5.reduce((e, t) => {
  const n = c.forwardRef((r, o) => {
    const { asChild: a, ...i } = r, s = a ? gg : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(s, { ...i, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), t4 = "Label", bg = c.forwardRef((e, t) => /* @__PURE__ */ f(
  e4.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var o;
      n.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
bg.displayName = t4;
var yg = bg;
const n4 = An(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), r4 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  yg,
  {
    ref: n,
    className: $(n4(), e),
    ...t
  }
));
r4.displayName = yg.displayName;
var aa = "Menubar", [ji, o4, a4] = Vt(aa), [wg, tH] = Re(aa, [
  a4,
  Kt
]), je = Sc(), Cg = Kt(), [i4, kc] = wg(aa), Eg = c.forwardRef(
  (e, t) => {
    const {
      __scopeMenubar: n,
      value: r,
      onValueChange: o,
      defaultValue: a,
      loop: i = !0,
      dir: s,
      ...l
    } = e, u = Ut(s), d = Cg(n), [p = "", v] = Me({
      prop: r,
      onChange: o,
      defaultProp: a
    }), [y, g] = c.useState(null);
    return /* @__PURE__ */ f(
      i4,
      {
        scope: n,
        value: p,
        onMenuOpen: c.useCallback(
          (m) => {
            v(m), g(m);
          },
          [v]
        ),
        onMenuClose: c.useCallback(() => v(""), [v]),
        onMenuToggle: c.useCallback(
          (m) => {
            v((h) => h ? "" : m), g(m);
          },
          [v]
        ),
        dir: u,
        loop: i,
        children: /* @__PURE__ */ f(ji.Provider, { scope: n, children: /* @__PURE__ */ f(ji.Slot, { scope: n, children: /* @__PURE__ */ f(
          ea,
          {
            asChild: !0,
            ...d,
            orientation: "horizontal",
            loop: i,
            dir: u,
            currentTabStopId: y,
            onCurrentTabStopIdChange: g,
            children: /* @__PURE__ */ f(G.div, { role: "menubar", ...l, ref: t })
          }
        ) }) })
      }
    );
  }
);
Eg.displayName = aa;
var Lc = "MenubarMenu", [s4, Sg] = wg(Lc), Pg = (e) => {
  const { __scopeMenubar: t, value: n, ...r } = e, o = ze(), a = n || o || "LEGACY_REACT_AUTO_VALUE", i = kc(Lc, t), s = je(t), l = c.useRef(null), u = c.useRef(!1), d = i.value === a;
  return c.useEffect(() => {
    d || (u.current = !1);
  }, [d]), /* @__PURE__ */ f(
    s4,
    {
      scope: t,
      value: a,
      triggerId: ze(),
      triggerRef: l,
      contentId: ze(),
      wasKeyboardTriggerOpenRef: u,
      children: /* @__PURE__ */ f(
        Jv,
        {
          ...s,
          open: d,
          onOpenChange: (p) => {
            p || i.onMenuClose();
          },
          modal: !1,
          dir: i.dir,
          ...r
        }
      )
    }
  );
};
Pg.displayName = Lc;
var Hi = "MenubarTrigger", xg = c.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, disabled: r = !1, ...o } = e, a = Cg(n), i = je(n), s = kc(Hi, n), l = Sg(Hi, n), u = c.useRef(null), d = ne(t, u, l.triggerRef), [p, v] = c.useState(!1), y = s.value === l.value;
    return /* @__PURE__ */ f(ji.ItemSlot, { scope: n, value: l.value, disabled: r, children: /* @__PURE__ */ f(
      ta,
      {
        asChild: !0,
        ...a,
        focusable: !r,
        tabStopId: l.value,
        children: /* @__PURE__ */ f(eh, { asChild: !0, ...i, children: /* @__PURE__ */ f(
          G.button,
          {
            type: "button",
            role: "menuitem",
            id: l.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": y,
            "aria-controls": y ? l.contentId : void 0,
            "data-highlighted": p ? "" : void 0,
            "data-state": y ? "open" : "closed",
            "data-disabled": r ? "" : void 0,
            disabled: r,
            ...o,
            ref: d,
            onPointerDown: I(e.onPointerDown, (g) => {
              !r && g.button === 0 && g.ctrlKey === !1 && (s.onMenuOpen(l.value), y || g.preventDefault());
            }),
            onPointerEnter: I(e.onPointerEnter, () => {
              var m;
              !!s.value && !y && (s.onMenuOpen(l.value), (m = u.current) == null || m.focus());
            }),
            onKeyDown: I(e.onKeyDown, (g) => {
              r || (["Enter", " "].includes(g.key) && s.onMenuToggle(l.value), g.key === "ArrowDown" && s.onMenuOpen(l.value), ["Enter", " ", "ArrowDown"].includes(g.key) && (l.wasKeyboardTriggerOpenRef.current = !0, g.preventDefault()));
            }),
            onFocus: I(e.onFocus, () => v(!0)),
            onBlur: I(e.onBlur, () => v(!1))
          }
        ) })
      }
    ) });
  }
);
xg.displayName = Hi;
var c4 = "MenubarPortal", _g = (e) => {
  const { __scopeMenubar: t, ...n } = e, r = je(t);
  return /* @__PURE__ */ f(th, { ...r, ...n });
};
_g.displayName = c4;
var Ui = "MenubarContent", Tg = c.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, align: r = "start", ...o } = e, a = je(n), i = kc(Ui, n), s = Sg(Ui, n), l = o4(n), u = c.useRef(!1);
    return /* @__PURE__ */ f(
      nh,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        "data-radix-menubar-content": "",
        ...a,
        ...o,
        ref: t,
        align: r,
        onCloseAutoFocus: I(e.onCloseAutoFocus, (d) => {
          var v;
          !!!i.value && !u.current && ((v = s.triggerRef.current) == null || v.focus()), u.current = !1, d.preventDefault();
        }),
        onFocusOutside: I(e.onFocusOutside, (d) => {
          const p = d.target;
          l().some((y) => {
            var g;
            return (g = y.ref.current) == null ? void 0 : g.contains(p);
          }) && d.preventDefault();
        }),
        onInteractOutside: I(e.onInteractOutside, () => {
          u.current = !0;
        }),
        onEntryFocus: (d) => {
          s.wasKeyboardTriggerOpenRef.current || d.preventDefault();
        },
        onKeyDown: I(
          e.onKeyDown,
          (d) => {
            if (["ArrowRight", "ArrowLeft"].includes(d.key)) {
              const p = d.target, v = p.hasAttribute("data-radix-menubar-subtrigger"), y = p.closest("[data-radix-menubar-content]") !== d.currentTarget, m = (i.dir === "rtl" ? "ArrowRight" : "ArrowLeft") === d.key;
              if (!m && v || y && m)
                return;
              let w = l().filter((P) => !P.disabled).map((P) => P.value);
              m && w.reverse();
              const C = w.indexOf(s.value);
              w = i.loop ? E4(w, C + 1) : w.slice(C + 1);
              const [E] = w;
              E && i.onMenuOpen(E);
            }
          },
          { checkForDefaultPrevented: !1 }
        ),
        style: {
          ...e.style,
          "--radix-menubar-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-menubar-content-available-width": "var(--radix-popper-available-width)",
          "--radix-menubar-content-available-height": "var(--radix-popper-available-height)",
          "--radix-menubar-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-menubar-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Tg.displayName = Ui;
var l4 = "MenubarGroup", Ng = c.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = je(n);
    return /* @__PURE__ */ f(rh, { ...o, ...r, ref: t });
  }
);
Ng.displayName = l4;
var u4 = "MenubarLabel", Rg = c.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = je(n);
    return /* @__PURE__ */ f(oh, { ...o, ...r, ref: t });
  }
);
Rg.displayName = u4;
var d4 = "MenubarItem", $g = c.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = je(n);
    return /* @__PURE__ */ f(ah, { ...o, ...r, ref: t });
  }
);
$g.displayName = d4;
var f4 = "MenubarCheckboxItem", Og = c.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = je(n);
    return /* @__PURE__ */ f(ih, { ...o, ...r, ref: t });
  }
);
Og.displayName = f4;
var p4 = "MenubarRadioGroup", Mg = c.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = je(n);
    return /* @__PURE__ */ f(sh, { ...o, ...r, ref: t });
  }
);
Mg.displayName = p4;
var m4 = "MenubarRadioItem", Dg = c.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = je(n);
    return /* @__PURE__ */ f(ch, { ...o, ...r, ref: t });
  }
);
Dg.displayName = m4;
var v4 = "MenubarItemIndicator", Ag = c.forwardRef((e, t) => {
  const { __scopeMenubar: n, ...r } = e, o = je(n);
  return /* @__PURE__ */ f(lh, { ...o, ...r, ref: t });
});
Ag.displayName = v4;
var h4 = "MenubarSeparator", Ig = c.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = je(n);
    return /* @__PURE__ */ f(uh, { ...o, ...r, ref: t });
  }
);
Ig.displayName = h4;
var g4 = "MenubarArrow", b4 = c.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = je(n);
    return /* @__PURE__ */ f(dh, { ...o, ...r, ref: t });
  }
);
b4.displayName = g4;
var y4 = "MenubarSub", kg = (e) => {
  const { __scopeMenubar: t, children: n, open: r, onOpenChange: o, defaultOpen: a } = e, i = je(t), [s = !1, l] = Me({
    prop: r,
    defaultProp: a,
    onChange: o
  });
  return /* @__PURE__ */ f(fh, { ...i, open: s, onOpenChange: l, children: n });
};
kg.displayName = y4;
var w4 = "MenubarSubTrigger", Lg = c.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = je(n);
    return /* @__PURE__ */ f(
      ph,
      {
        "data-radix-menubar-subtrigger": "",
        ...o,
        ...r,
        ref: t
      }
    );
  }
);
Lg.displayName = w4;
var C4 = "MenubarSubContent", Fg = c.forwardRef(
  (e, t) => {
    const { __scopeMenubar: n, ...r } = e, o = je(n);
    return /* @__PURE__ */ f(
      mh,
      {
        ...o,
        "data-radix-menubar-content": "",
        ...r,
        ref: t,
        style: {
          ...e.style,
          "--radix-menubar-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-menubar-content-available-width": "var(--radix-popper-available-width)",
          "--radix-menubar-content-available-height": "var(--radix-popper-available-height)",
          "--radix-menubar-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-menubar-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Fg.displayName = C4;
function E4(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Bg = Eg, S4 = Pg, Wg = xg, jg = _g, Hg = Tg, P4 = Ng, Ug = Rg, Vg = $g, Gg = Og, x4 = Mg, Kg = Dg, Yg = Ag, zg = Ig, _4 = kg, qg = Lg, Xg = Fg;
function nH({
  ...e
}) {
  return /* @__PURE__ */ f(S4, { ...e });
}
function rH({
  ...e
}) {
  return /* @__PURE__ */ f(P4, { ...e });
}
function oH({
  ...e
}) {
  return /* @__PURE__ */ f(jg, { ...e });
}
function aH({
  ...e
}) {
  return /* @__PURE__ */ f(x4, { ...e });
}
function iH({
  ...e
}) {
  return /* @__PURE__ */ f(_4, { "data-slot": "menubar-sub", ...e });
}
const T4 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Bg,
  {
    ref: n,
    className: $(
      "flex h-9 items-center space-x-1 rounded-md border bg-background p-1 shadow-sm",
      e
    ),
    ...t
  }
));
T4.displayName = Bg.displayName;
const N4 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Wg,
  {
    ref: n,
    className: $(
      "flex cursor-default select-none items-center rounded-sm px-3 py-1 text-sm font-medium outline-none focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground",
      e
    ),
    ...t
  }
));
N4.displayName = Wg.displayName;
const R4 = c.forwardRef(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ X(
  qg,
  {
    ref: o,
    className: $(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ f(Sr, { className: "ml-auto h-4 w-4" })
    ]
  }
));
R4.displayName = qg.displayName;
const $4 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Xg,
  {
    ref: n,
    className: $(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
$4.displayName = Xg.displayName;
const O4 = c.forwardRef(
  ({ className: e, align: t = "start", alignOffset: n = -4, sideOffset: r = 8, ...o }, a) => /* @__PURE__ */ f(jg, { children: /* @__PURE__ */ f(
    Hg,
    {
      ref: a,
      align: t,
      alignOffset: n,
      sideOffset: r,
      className: $(
        "z-50 min-w-[12rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        e
      ),
      ...o
    }
  ) })
);
O4.displayName = Hg.displayName;
const M4 = c.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ f(
  Vg,
  {
    ref: r,
    className: $(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t && "pl-8",
      e
    ),
    ...n
  }
));
M4.displayName = Vg.displayName;
const D4 = c.forwardRef(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ X(
  Gg,
  {
    ref: o,
    className: $(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ f("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ f(Yg, { children: /* @__PURE__ */ f(gs, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
D4.displayName = Gg.displayName;
const A4 = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ X(
  Kg,
  {
    ref: r,
    className: $(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ f("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ f(Yg, { children: /* @__PURE__ */ f(bs, { className: "h-4 w-4 fill-current" }) }) }),
      t
    ]
  }
));
A4.displayName = Kg.displayName;
const I4 = c.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ f(
  Ug,
  {
    ref: r,
    className: $(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...n
  }
));
I4.displayName = Ug.displayName;
const k4 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  zg,
  {
    ref: n,
    className: $("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
k4.displayName = zg.displayName;
const L4 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ f(
  "span",
  {
    className: $(
      "ml-auto text-xs tracking-widest text-muted-foreground",
      e
    ),
    ...t
  }
);
L4.displayname = "MenubarShortcut";
var F4 = "DismissableLayer", Vi = "dismissableLayer.update", B4 = "dismissableLayer.pointerDownOutside", W4 = "dismissableLayer.focusOutside", ud, Zg = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Qg = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, u = c.useContext(Zg), [d, p] = c.useState(null), v = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, y] = c.useState({}), g = ne(t, (S) => p(S)), m = Array.from(u.layers), [h] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), b = m.indexOf(h), w = d ? m.indexOf(d) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, E = w >= b, P = U4((S) => {
      const _ = S.target, T = [...u.branches].some((k) => k.contains(_));
      !E || T || (o == null || o(S), i == null || i(S), S.defaultPrevented || s == null || s());
    }, v), x = V4((S) => {
      const _ = S.target;
      [...u.branches].some((k) => k.contains(_)) || (a == null || a(S), i == null || i(S), S.defaultPrevented || s == null || s());
    }, v);
    return br((S) => {
      w === u.layers.size - 1 && (r == null || r(S), !S.defaultPrevented && s && (S.preventDefault(), s()));
    }, v), c.useEffect(() => {
      if (d)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (ud = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), dd(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (v.body.style.pointerEvents = ud);
        };
    }, [d, v, n, u]), c.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), dd());
    }, [d, u]), c.useEffect(() => {
      const S = () => y({});
      return document.addEventListener(Vi, S), () => document.removeEventListener(Vi, S);
    }, []), /* @__PURE__ */ f(
      G.div,
      {
        ...l,
        ref: g,
        style: {
          pointerEvents: C ? E ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: I(e.onFocusCapture, x.onFocusCapture),
        onBlurCapture: I(e.onBlurCapture, x.onBlurCapture),
        onPointerDownCapture: I(
          e.onPointerDownCapture,
          P.onPointerDownCapture
        )
      }
    );
  }
);
Qg.displayName = F4;
var j4 = "DismissableLayerBranch", H4 = c.forwardRef((e, t) => {
  const n = c.useContext(Zg), r = c.useRef(null), o = ne(t, r);
  return c.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ f(G.div, { ...e, ref: o });
});
H4.displayName = j4;
function U4(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = me(e), r = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Jg(
            B4,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function V4(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = me(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && Jg(W4, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function dd() {
  const e = new CustomEvent(Vi);
  document.dispatchEvent(e);
}
function Jg(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Ot(o, a) : o.dispatchEvent(a);
}
var G4 = "VisuallyHidden", ia = c.forwardRef(
  (e, t) => /* @__PURE__ */ f(
    G.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
ia.displayName = G4;
var K4 = ia, jn = "NavigationMenu", [Fc, eb, Y4] = Vt(jn), [Gi, z4, q4] = Vt(jn), [Bc, sH] = Re(
  jn,
  [Y4, q4]
), [X4, ct] = Bc(jn), [Z4, Q4] = Bc(jn), tb = c.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: r,
      onValueChange: o,
      defaultValue: a,
      delayDuration: i = 200,
      skipDelayDuration: s = 300,
      orientation: l = "horizontal",
      dir: u,
      ...d
    } = e, [p, v] = c.useState(null), y = ne(t, (T) => v(T)), g = Ut(u), m = c.useRef(0), h = c.useRef(0), b = c.useRef(0), [w, C] = c.useState(!0), [E = "", P] = Me({
      prop: r,
      onChange: (T) => {
        const k = T !== "", L = s > 0;
        k ? (window.clearTimeout(b.current), L && C(!1)) : (window.clearTimeout(b.current), b.current = window.setTimeout(
          () => C(!0),
          s
        )), o == null || o(T);
      },
      defaultProp: a
    }), x = c.useCallback(() => {
      window.clearTimeout(h.current), h.current = window.setTimeout(() => P(""), 150);
    }, [P]), S = c.useCallback(
      (T) => {
        window.clearTimeout(h.current), P(T);
      },
      [P]
    ), _ = c.useCallback(
      (T) => {
        E === T ? window.clearTimeout(h.current) : m.current = window.setTimeout(() => {
          window.clearTimeout(h.current), P(T);
        }, i);
      },
      [E, P, i]
    );
    return c.useEffect(() => () => {
      window.clearTimeout(m.current), window.clearTimeout(h.current), window.clearTimeout(b.current);
    }, []), /* @__PURE__ */ f(
      rb,
      {
        scope: n,
        isRootMenu: !0,
        value: E,
        dir: g,
        orientation: l,
        rootNavigationMenu: p,
        onTriggerEnter: (T) => {
          window.clearTimeout(m.current), w ? _(T) : S(T);
        },
        onTriggerLeave: () => {
          window.clearTimeout(m.current), x();
        },
        onContentEnter: () => window.clearTimeout(h.current),
        onContentLeave: x,
        onItemSelect: (T) => {
          P((k) => k === T ? "" : T);
        },
        onItemDismiss: () => P(""),
        children: /* @__PURE__ */ f(
          G.nav,
          {
            "aria-label": "Main",
            "data-orientation": l,
            dir: g,
            ...d,
            ref: y
          }
        )
      }
    );
  }
);
tb.displayName = jn;
var nb = "NavigationMenuSub", J4 = c.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: r,
      onValueChange: o,
      defaultValue: a,
      orientation: i = "horizontal",
      ...s
    } = e, l = ct(nb, n), [u = "", d] = Me({
      prop: r,
      onChange: o,
      defaultProp: a
    });
    return /* @__PURE__ */ f(
      rb,
      {
        scope: n,
        isRootMenu: !1,
        value: u,
        dir: l.dir,
        orientation: i,
        rootNavigationMenu: l.rootNavigationMenu,
        onTriggerEnter: (p) => d(p),
        onItemSelect: (p) => d(p),
        onItemDismiss: () => d(""),
        children: /* @__PURE__ */ f(G.div, { "data-orientation": i, ...s, ref: t })
      }
    );
  }
);
J4.displayName = nb;
var rb = (e) => {
  const {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: r,
    dir: o,
    orientation: a,
    children: i,
    value: s,
    onItemSelect: l,
    onItemDismiss: u,
    onTriggerEnter: d,
    onTriggerLeave: p,
    onContentEnter: v,
    onContentLeave: y
  } = e, [g, m] = c.useState(null), [h, b] = c.useState(/* @__PURE__ */ new Map()), [w, C] = c.useState(null);
  return /* @__PURE__ */ f(
    X4,
    {
      scope: t,
      isRootMenu: n,
      rootNavigationMenu: r,
      value: s,
      previousValue: Cr(s),
      baseId: ze(),
      dir: o,
      orientation: a,
      viewport: g,
      onViewportChange: m,
      indicatorTrack: w,
      onIndicatorTrackChange: C,
      onTriggerEnter: me(d),
      onTriggerLeave: me(p),
      onContentEnter: me(v),
      onContentLeave: me(y),
      onItemSelect: me(l),
      onItemDismiss: me(u),
      onViewportContentChange: c.useCallback((E, P) => {
        b((x) => (x.set(E, P), new Map(x)));
      }, []),
      onViewportContentRemove: c.useCallback((E) => {
        b((P) => P.has(E) ? (P.delete(E), new Map(P)) : P);
      }, []),
      children: /* @__PURE__ */ f(Fc.Provider, { scope: t, children: /* @__PURE__ */ f(Z4, { scope: t, items: h, children: i }) })
    }
  );
}, ob = "NavigationMenuList", ab = c.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, o = ct(ob, n), a = /* @__PURE__ */ f(G.ul, { "data-orientation": o.orientation, ...r, ref: t });
    return /* @__PURE__ */ f(G.div, { style: { position: "relative" }, ref: o.onIndicatorTrackChange, children: /* @__PURE__ */ f(Fc.Slot, { scope: n, children: o.isRootMenu ? /* @__PURE__ */ f(vb, { asChild: !0, children: a }) : a }) });
  }
);
ab.displayName = ob;
var ib = "NavigationMenuItem", [eW, sb] = Bc(ib), cb = c.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, value: r, ...o } = e, a = ze(), i = r || a || "LEGACY_REACT_AUTO_VALUE", s = c.useRef(null), l = c.useRef(null), u = c.useRef(null), d = c.useRef(() => {
    }), p = c.useRef(!1), v = c.useCallback((g = "start") => {
      if (s.current) {
        d.current();
        const m = Yi(s.current);
        m.length && Hc(g === "start" ? m : m.reverse());
      }
    }, []), y = c.useCallback(() => {
      if (s.current) {
        const g = Yi(s.current);
        g.length && (d.current = sW(g));
      }
    }, []);
    return /* @__PURE__ */ f(
      eW,
      {
        scope: n,
        value: i,
        triggerRef: l,
        contentRef: s,
        focusProxyRef: u,
        wasEscapeCloseRef: p,
        onEntryKeyDown: v,
        onFocusProxyEnter: v,
        onRootContentClose: y,
        onContentFocusOutside: y,
        children: /* @__PURE__ */ f(G.li, { ...o, ref: t })
      }
    );
  }
);
cb.displayName = ib;
var Ki = "NavigationMenuTrigger", lb = c.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, disabled: r, ...o } = e, a = ct(Ki, e.__scopeNavigationMenu), i = sb(Ki, e.__scopeNavigationMenu), s = c.useRef(null), l = ne(s, i.triggerRef, t), u = gb(a.baseId, i.value), d = bb(a.baseId, i.value), p = c.useRef(!1), v = c.useRef(!1), y = i.value === a.value;
  return /* @__PURE__ */ X(Oe, { children: [
    /* @__PURE__ */ f(Fc.ItemSlot, { scope: n, value: i.value, children: /* @__PURE__ */ f(hb, { asChild: !0, children: /* @__PURE__ */ f(
      G.button,
      {
        id: u,
        disabled: r,
        "data-disabled": r ? "" : void 0,
        "data-state": Uc(y),
        "aria-expanded": y,
        "aria-controls": d,
        ...o,
        ref: l,
        onPointerEnter: I(e.onPointerEnter, () => {
          v.current = !1, i.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: I(
          e.onPointerMove,
          No(() => {
            r || v.current || i.wasEscapeCloseRef.current || p.current || (a.onTriggerEnter(i.value), p.current = !0);
          })
        ),
        onPointerLeave: I(
          e.onPointerLeave,
          No(() => {
            r || (a.onTriggerLeave(), p.current = !1);
          })
        ),
        onClick: I(e.onClick, () => {
          a.onItemSelect(i.value), v.current = y;
        }),
        onKeyDown: I(e.onKeyDown, (g) => {
          const h = { horizontal: "ArrowDown", vertical: a.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[a.orientation];
          y && g.key === h && (i.onEntryKeyDown(), g.preventDefault());
        })
      }
    ) }) }),
    y && /* @__PURE__ */ X(Oe, { children: [
      /* @__PURE__ */ f(
        K4,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: i.focusProxyRef,
          onFocus: (g) => {
            const m = i.contentRef.current, h = g.relatedTarget, b = h === s.current, w = m == null ? void 0 : m.contains(h);
            (b || !w) && i.onFocusProxyEnter(b ? "start" : "end");
          }
        }
      ),
      a.viewport && /* @__PURE__ */ f("span", { "aria-owns": d })
    ] })
  ] });
});
lb.displayName = Ki;
var tW = "NavigationMenuLink", fd = "navigationMenu.linkSelect", ub = c.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, active: r, onSelect: o, ...a } = e;
    return /* @__PURE__ */ f(hb, { asChild: !0, children: /* @__PURE__ */ f(
      G.a,
      {
        "data-active": r ? "" : void 0,
        "aria-current": r ? "page" : void 0,
        ...a,
        ref: t,
        onClick: I(
          e.onClick,
          (i) => {
            const s = i.target, l = new CustomEvent(fd, {
              bubbles: !0,
              cancelable: !0
            });
            if (s.addEventListener(fd, (u) => o == null ? void 0 : o(u), { once: !0 }), Ot(s, l), !l.defaultPrevented && !i.metaKey) {
              const u = new CustomEvent(ro, {
                bubbles: !0,
                cancelable: !0
              });
              Ot(s, u);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
ub.displayName = tW;
var Wc = "NavigationMenuIndicator", db = c.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = ct(Wc, e.__scopeNavigationMenu), a = !!o.value;
  return o.indicatorTrack ? Er.createPortal(
    /* @__PURE__ */ f(Fe, { present: n || a, children: /* @__PURE__ */ f(nW, { ...r, ref: t }) }),
    o.indicatorTrack
  ) : null;
});
db.displayName = Wc;
var nW = c.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, ...r } = e, o = ct(Wc, n), a = eb(n), [i, s] = c.useState(
    null
  ), [l, u] = c.useState(null), d = o.orientation === "horizontal", p = !!o.value;
  c.useEffect(() => {
    var m;
    const g = (m = a().find((h) => h.value === o.value)) == null ? void 0 : m.ref.current;
    g && s(g);
  }, [a, o.value]);
  const v = () => {
    i && u({
      size: d ? i.offsetWidth : i.offsetHeight,
      offset: d ? i.offsetLeft : i.offsetTop
    });
  };
  return zi(i, v), zi(o.indicatorTrack, v), l ? /* @__PURE__ */ f(
    G.div,
    {
      "aria-hidden": !0,
      "data-state": p ? "visible" : "hidden",
      "data-orientation": o.orientation,
      ...r,
      ref: t,
      style: {
        position: "absolute",
        ...d ? {
          left: 0,
          width: l.size + "px",
          transform: `translateX(${l.offset}px)`
        } : {
          top: 0,
          height: l.size + "px",
          transform: `translateY(${l.offset}px)`
        },
        ...r.style
      }
    }
  ) : null;
}), Dn = "NavigationMenuContent", fb = c.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = ct(Dn, e.__scopeNavigationMenu), a = sb(Dn, e.__scopeNavigationMenu), i = ne(a.contentRef, t), s = a.value === o.value, l = {
    value: a.value,
    triggerRef: a.triggerRef,
    focusProxyRef: a.focusProxyRef,
    wasEscapeCloseRef: a.wasEscapeCloseRef,
    onContentFocusOutside: a.onContentFocusOutside,
    onRootContentClose: a.onRootContentClose,
    ...r
  };
  return o.viewport ? /* @__PURE__ */ f(rW, { forceMount: n, ...l, ref: i }) : /* @__PURE__ */ f(Fe, { present: n || s, children: /* @__PURE__ */ f(
    pb,
    {
      "data-state": Uc(s),
      ...l,
      ref: i,
      onPointerEnter: I(e.onPointerEnter, o.onContentEnter),
      onPointerLeave: I(
        e.onPointerLeave,
        No(o.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !s && o.isRootMenu ? "none" : void 0,
        ...l.style
      }
    }
  ) });
});
fb.displayName = Dn;
var rW = c.forwardRef((e, t) => {
  const n = ct(Dn, e.__scopeNavigationMenu), { onViewportContentChange: r, onViewportContentRemove: o } = n;
  return mt(() => {
    r(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, r]), mt(() => () => o(e.value), [e.value, o]), null;
}), ro = "navigationMenu.rootContentDismiss", pb = c.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: n,
    value: r,
    triggerRef: o,
    focusProxyRef: a,
    wasEscapeCloseRef: i,
    onRootContentClose: s,
    onContentFocusOutside: l,
    ...u
  } = e, d = ct(Dn, n), p = c.useRef(null), v = ne(p, t), y = gb(d.baseId, r), g = bb(d.baseId, r), m = eb(n), h = c.useRef(null), { onItemDismiss: b } = d;
  c.useEffect(() => {
    const C = p.current;
    if (d.isRootMenu && C) {
      const E = () => {
        var P;
        b(), s(), C.contains(document.activeElement) && ((P = o.current) == null || P.focus());
      };
      return C.addEventListener(ro, E), () => C.removeEventListener(ro, E);
    }
  }, [d.isRootMenu, e.value, o, b, s]);
  const w = c.useMemo(() => {
    const E = m().map((k) => k.value);
    d.dir === "rtl" && E.reverse();
    const P = E.indexOf(d.value), x = E.indexOf(d.previousValue), S = r === d.value, _ = x === E.indexOf(r);
    if (!S && !_)
      return h.current;
    const T = (() => {
      if (P !== x) {
        if (S && x !== -1)
          return P > x ? "from-end" : "from-start";
        if (_ && P !== -1)
          return P > x ? "to-start" : "to-end";
      }
      return null;
    })();
    return h.current = T, T;
  }, [d.previousValue, d.value, d.dir, m, r]);
  return /* @__PURE__ */ f(vb, { asChild: !0, children: /* @__PURE__ */ f(
    Qg,
    {
      id: g,
      "aria-labelledby": y,
      "data-motion": w,
      "data-orientation": d.orientation,
      ...u,
      ref: v,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        var E;
        const C = new Event(ro, {
          bubbles: !0,
          cancelable: !0
        });
        (E = p.current) == null || E.dispatchEvent(C);
      },
      onFocusOutside: I(e.onFocusOutside, (C) => {
        var P;
        l();
        const E = C.target;
        (P = d.rootNavigationMenu) != null && P.contains(E) && C.preventDefault();
      }),
      onPointerDownOutside: I(e.onPointerDownOutside, (C) => {
        var S;
        const E = C.target, P = m().some((_) => {
          var T;
          return (T = _.ref.current) == null ? void 0 : T.contains(E);
        }), x = d.isRootMenu && ((S = d.viewport) == null ? void 0 : S.contains(E));
        (P || x || !d.isRootMenu) && C.preventDefault();
      }),
      onKeyDown: I(e.onKeyDown, (C) => {
        var x;
        const E = C.altKey || C.ctrlKey || C.metaKey;
        if (C.key === "Tab" && !E) {
          const S = Yi(C.currentTarget), _ = document.activeElement, T = S.findIndex((U) => U === _), L = C.shiftKey ? S.slice(0, T).reverse() : S.slice(T + 1, S.length);
          Hc(L) ? C.preventDefault() : (x = a.current) == null || x.focus();
        }
      }),
      onEscapeKeyDown: I(e.onEscapeKeyDown, (C) => {
        i.current = !0;
      })
    }
  ) });
}), jc = "NavigationMenuViewport", mb = c.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, a = !!ct(jc, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ f(Fe, { present: n || a, children: /* @__PURE__ */ f(oW, { ...r, ref: t }) });
});
mb.displayName = jc;
var oW = c.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, children: r, ...o } = e, a = ct(jc, n), i = ne(t, a.onViewportChange), s = Q4(
    Dn,
    e.__scopeNavigationMenu
  ), [l, u] = c.useState(null), [d, p] = c.useState(null), v = l ? (l == null ? void 0 : l.width) + "px" : void 0, y = l ? (l == null ? void 0 : l.height) + "px" : void 0, g = !!a.value, m = g ? a.value : a.previousValue;
  return zi(d, () => {
    d && u({ width: d.offsetWidth, height: d.offsetHeight });
  }), /* @__PURE__ */ f(
    G.div,
    {
      "data-state": Uc(g),
      "data-orientation": a.orientation,
      ...o,
      ref: i,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !g && a.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": v,
        "--radix-navigation-menu-viewport-height": y,
        ...o.style
      },
      onPointerEnter: I(e.onPointerEnter, a.onContentEnter),
      onPointerLeave: I(e.onPointerLeave, No(a.onContentLeave)),
      children: Array.from(s.items).map(([b, { ref: w, forceMount: C, ...E }]) => {
        const P = m === b;
        return /* @__PURE__ */ f(Fe, { present: C || P, children: /* @__PURE__ */ f(
          pb,
          {
            ...E,
            ref: wr(w, (x) => {
              P && x && p(x);
            })
          }
        ) }, b);
      })
    }
  );
}), aW = "FocusGroup", vb = c.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, o = ct(aW, n);
    return /* @__PURE__ */ f(Gi.Provider, { scope: n, children: /* @__PURE__ */ f(Gi.Slot, { scope: n, children: /* @__PURE__ */ f(G.div, { dir: o.dir, ...r, ref: t }) }) });
  }
), pd = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], iW = "FocusGroupItem", hb = c.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, o = z4(n), a = ct(iW, n);
    return /* @__PURE__ */ f(Gi.ItemSlot, { scope: n, children: /* @__PURE__ */ f(
      G.button,
      {
        ...r,
        ref: t,
        onKeyDown: I(e.onKeyDown, (i) => {
          if (["Home", "End", ...pd].includes(i.key)) {
            let l = o().map((p) => p.ref.current);
            if ([a.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(i.key) && l.reverse(), pd.includes(i.key)) {
              const p = l.indexOf(i.currentTarget);
              l = l.slice(p + 1);
            }
            setTimeout(() => Hc(l)), i.preventDefault();
          }
        })
      }
    ) });
  }
);
function Yi(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Hc(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function sW(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function zi(e, t) {
  const n = me(t);
  mt(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [e, n]);
}
function Uc(e) {
  return e ? "open" : "closed";
}
function gb(e, t) {
  return `${e}-trigger-${t}`;
}
function bb(e, t) {
  return `${e}-content-${t}`;
}
function No(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var yb = tb, wb = ab, cW = cb, Cb = lb, lW = ub, Eb = db, Sb = fb, Pb = mb;
const uW = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ X(
  yb,
  {
    ref: r,
    className: $(
      "relative z-10 flex max-w-max flex-1 items-center justify-center",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ f(xb, {})
    ]
  }
));
uW.displayName = yb.displayName;
const dW = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  wb,
  {
    ref: n,
    className: $(
      "group flex flex-1 list-none items-center justify-center space-x-1",
      e
    ),
    ...t
  }
));
dW.displayName = wb.displayName;
const cH = cW, fW = An(
  "group inline-flex h-9 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50"
), pW = c.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ X(
  Cb,
  {
    ref: r,
    className: $(fW(), "group", e),
    ...n,
    children: [
      t,
      " ",
      /* @__PURE__ */ f(
        $d,
        {
          className: "relative top-[1px] ml-1 h-3 w-3 transition duration-300 group-data-[state=open]:rotate-180",
          "aria-hidden": "true"
        }
      )
    ]
  }
));
pW.displayName = Cb.displayName;
const mW = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Sb,
  {
    ref: n,
    className: $(
      "left-0 top-0 w-full data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 md:absolute md:w-auto ",
      e
    ),
    ...t
  }
));
mW.displayName = Sb.displayName;
const lH = lW, xb = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f("div", { className: $("absolute left-0 top-full flex justify-center"), children: /* @__PURE__ */ f(
  Pb,
  {
    className: $(
      "origin-top-center relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden rounded-md border bg-popover text-popover-foreground shadow data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90 md:w-[var(--radix-navigation-menu-viewport-width)]",
      e
    ),
    ref: n,
    ...t
  }
) }));
xb.displayName = Pb.displayName;
const vW = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Eb,
  {
    ref: n,
    className: $(
      "top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:fade-in",
      e
    ),
    ...t,
    children: /* @__PURE__ */ f("div", { className: "relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm bg-border shadow-md" })
  }
));
vW.displayName = Eb.displayName;
const hW = ({ className: e, ...t }) => /* @__PURE__ */ f(
  "nav",
  {
    role: "navigation",
    "aria-label": "pagination",
    className: $("mx-auto flex w-full justify-center", e),
    ...t
  }
);
hW.displayName = "Pagination";
const gW = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "ul",
  {
    ref: n,
    className: $("flex flex-row items-center gap-1", e),
    ...t
  }
));
gW.displayName = "PaginationContent";
const bW = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f("li", { ref: n, className: $("", e), ...t }));
bW.displayName = "PaginationItem";
const Vc = ({
  className: e,
  isActive: t,
  size: n = "icon",
  ...r
}) => /* @__PURE__ */ f(
  "a",
  {
    "aria-current": t ? "page" : void 0,
    className: $(
      or({
        variant: t ? "outline" : "ghost",
        size: n
      }),
      e
    ),
    ...r
  }
);
Vc.displayName = "PaginationLink";
const yW = ({
  className: e,
  ...t
}) => /* @__PURE__ */ X(
  Vc,
  {
    "aria-label": "Go to previous page",
    size: "default",
    className: $("gap-1 pl-2.5", e),
    ...t,
    children: [
      /* @__PURE__ */ f(Md, { className: "h-4 w-4" }),
      /* @__PURE__ */ f("span", { children: "Previous" })
    ]
  }
);
yW.displayName = "PaginationPrevious";
const wW = ({
  className: e,
  ...t
}) => /* @__PURE__ */ X(
  Vc,
  {
    "aria-label": "Go to next page",
    size: "default",
    className: $("gap-1 pr-2.5", e),
    ...t,
    children: [
      /* @__PURE__ */ f("span", { children: "Next" }),
      /* @__PURE__ */ f(Sr, { className: "h-4 w-4" })
    ]
  }
);
wW.displayName = "PaginationNext";
const CW = ({
  className: e,
  ...t
}) => /* @__PURE__ */ X(
  "span",
  {
    "aria-hidden": !0,
    className: $("flex h-9 w-9 items-center justify-center", e),
    ...t,
    children: [
      /* @__PURE__ */ f(Od, { className: "h-4 w-4" }),
      /* @__PURE__ */ f("span", { className: "sr-only", children: "More pages" })
    ]
  }
);
CW.displayName = "PaginationEllipsis";
var Gc = "Progress", Kc = 100, [EW, uH] = Re(Gc), [SW, PW] = EW(Gc), _b = c.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: r = null,
      max: o,
      getValueLabel: a = xW,
      ...i
    } = e;
    (o || o === 0) && !md(o) && console.error(_W(`${o}`, "Progress"));
    const s = md(o) ? o : Kc;
    r !== null && !vd(r, s) && console.error(TW(`${r}`, "Progress"));
    const l = vd(r, s) ? r : null, u = Ro(l) ? a(l, s) : void 0;
    return /* @__PURE__ */ f(SW, { scope: n, value: l, max: s, children: /* @__PURE__ */ f(
      G.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": Ro(l) ? l : void 0,
        "aria-valuetext": u,
        role: "progressbar",
        "data-state": Rb(l, s),
        "data-value": l ?? void 0,
        "data-max": s,
        ...i,
        ref: t
      }
    ) });
  }
);
_b.displayName = Gc;
var Tb = "ProgressIndicator", Nb = c.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...r } = e, o = PW(Tb, n);
    return /* @__PURE__ */ f(
      G.div,
      {
        "data-state": Rb(o.value, o.max),
        "data-value": o.value ?? void 0,
        "data-max": o.max,
        ...r,
        ref: t
      }
    );
  }
);
Nb.displayName = Tb;
function xW(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function Rb(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function Ro(e) {
  return typeof e == "number";
}
function md(e) {
  return Ro(e) && !isNaN(e) && e > 0;
}
function vd(e, t) {
  return Ro(e) && !isNaN(e) && e <= t && e >= 0;
}
function _W(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${Kc}\`.`;
}
function TW(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${Kc} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var $b = _b, NW = Nb;
const RW = c.forwardRef(({ className: e, value: t, ...n }, r) => /* @__PURE__ */ f(
  $b,
  {
    ref: r,
    className: $(
      "relative h-2 w-full overflow-hidden rounded-full bg-primary/20",
      e
    ),
    ...n,
    children: /* @__PURE__ */ f(
      NW,
      {
        className: "h-full w-full flex-1 bg-primary transition-all",
        style: { transform: `translateX(-${100 - (t || 0)}%)` }
      }
    )
  }
));
RW.displayName = $b.displayName;
var Yc = "Radio", [$W, Ob] = Re(Yc), [OW, MW] = $W(Yc), Mb = c.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: o = !1,
      required: a,
      disabled: i,
      value: s = "on",
      onCheck: l,
      form: u,
      ...d
    } = e, [p, v] = c.useState(null), y = ne(t, (h) => v(h)), g = c.useRef(!1), m = p ? u || !!p.closest("form") : !0;
    return /* @__PURE__ */ X(OW, { scope: n, checked: o, disabled: i, children: [
      /* @__PURE__ */ f(
        G.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": Ib(o),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: s,
          ...d,
          ref: y,
          onClick: I(e.onClick, (h) => {
            o || l == null || l(), m && (g.current = h.isPropagationStopped(), g.current || h.stopPropagation());
          })
        }
      ),
      m && /* @__PURE__ */ f(
        DW,
        {
          control: p,
          bubbles: !g.current,
          name: r,
          value: s,
          checked: o,
          required: a,
          disabled: i,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Mb.displayName = Yc;
var Db = "RadioIndicator", Ab = c.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: r, ...o } = e, a = MW(Db, n);
    return /* @__PURE__ */ f(Fe, { present: r || a.checked, children: /* @__PURE__ */ f(
      G.span,
      {
        "data-state": Ib(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
Ab.displayName = Db;
var DW = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, a = c.useRef(null), i = Cr(n), s = yr(t);
  return c.useEffect(() => {
    const l = a.current, u = window.HTMLInputElement.prototype, p = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (i !== n && p) {
      const v = new Event("click", { bubbles: r });
      p.call(l, n), l.dispatchEvent(v);
    }
  }, [i, n, r]), /* @__PURE__ */ f(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: n,
      ...o,
      tabIndex: -1,
      ref: a,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Ib(e) {
  return e ? "checked" : "unchecked";
}
var AW = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], zc = "RadioGroup", [IW, dH] = Re(zc, [
  Kt,
  Ob
]), kb = Kt(), Lb = Ob(), [kW, LW] = IW(zc), Fb = c.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: o,
      value: a,
      required: i = !1,
      disabled: s = !1,
      orientation: l,
      dir: u,
      loop: d = !0,
      onValueChange: p,
      ...v
    } = e, y = kb(n), g = Ut(u), [m, h] = Me({
      prop: a,
      defaultProp: o,
      onChange: p
    });
    return /* @__PURE__ */ f(
      kW,
      {
        scope: n,
        name: r,
        required: i,
        disabled: s,
        value: m,
        onValueChange: h,
        children: /* @__PURE__ */ f(
          ea,
          {
            asChild: !0,
            ...y,
            orientation: l,
            dir: g,
            loop: d,
            children: /* @__PURE__ */ f(
              G.div,
              {
                role: "radiogroup",
                "aria-required": i,
                "aria-orientation": l,
                "data-disabled": s ? "" : void 0,
                dir: g,
                ...v,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
Fb.displayName = zc;
var Bb = "RadioGroupItem", Wb = c.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: r, ...o } = e, a = LW(Bb, n), i = a.disabled || r, s = kb(n), l = Lb(n), u = c.useRef(null), d = ne(t, u), p = a.value === o.value, v = c.useRef(!1);
    return c.useEffect(() => {
      const y = (m) => {
        AW.includes(m.key) && (v.current = !0);
      }, g = () => v.current = !1;
      return document.addEventListener("keydown", y), document.addEventListener("keyup", g), () => {
        document.removeEventListener("keydown", y), document.removeEventListener("keyup", g);
      };
    }, []), /* @__PURE__ */ f(
      ta,
      {
        asChild: !0,
        ...s,
        focusable: !i,
        active: p,
        children: /* @__PURE__ */ f(
          Mb,
          {
            disabled: i,
            required: a.required,
            checked: p,
            ...l,
            ...o,
            name: a.name,
            ref: d,
            onCheck: () => a.onValueChange(o.value),
            onKeyDown: I((y) => {
              y.key === "Enter" && y.preventDefault();
            }),
            onFocus: I(o.onFocus, () => {
              var y;
              v.current && ((y = u.current) == null || y.click());
            })
          }
        )
      }
    );
  }
);
Wb.displayName = Bb;
var FW = "RadioGroupIndicator", jb = c.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...r } = e, o = Lb(n);
    return /* @__PURE__ */ f(Ab, { ...o, ...r, ref: t });
  }
);
jb.displayName = FW;
var Hb = Fb, Ub = Wb, BW = jb;
const WW = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Hb,
  {
    className: $("grid gap-2", e),
    ...t,
    ref: n
  }
));
WW.displayName = Hb.displayName;
const jW = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Ub,
  {
    ref: n,
    className: $(
      "aspect-square h-4 w-4 rounded-full border border-primary text-primary shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    children: /* @__PURE__ */ f(BW, { className: "flex items-center justify-center", children: /* @__PURE__ */ f(bs, { className: "h-3.5 w-3.5 fill-primary" }) })
  }
));
jW.displayName = Ub.displayName;
var Vb = ["PageUp", "PageDown"], Gb = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Kb = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, Hn = "Slider", [qi, HW, UW] = Vt(Hn), [Yb, fH] = Re(Hn, [
  UW
]), [VW, sa] = Yb(Hn), zb = c.forwardRef(
  (e, t) => {
    const {
      name: n,
      min: r = 0,
      max: o = 100,
      step: a = 1,
      orientation: i = "horizontal",
      disabled: s = !1,
      minStepsBetweenThumbs: l = 0,
      defaultValue: u = [r],
      value: d,
      onValueChange: p = () => {
      },
      onValueCommit: v = () => {
      },
      inverted: y = !1,
      form: g,
      ...m
    } = e, h = c.useRef(/* @__PURE__ */ new Set()), b = c.useRef(0), C = i === "horizontal" ? GW : KW, [E = [], P] = Me({
      prop: d,
      defaultProp: u,
      onChange: (L) => {
        var M;
        (M = [...h.current][b.current]) == null || M.focus(), p(L);
      }
    }), x = c.useRef(E);
    function S(L) {
      const U = ZW(E, L);
      k(L, U);
    }
    function _(L) {
      k(L, b.current);
    }
    function T() {
      const L = x.current[b.current];
      E[b.current] !== L && v(E);
    }
    function k(L, U, { commit: M } = { commit: !1 }) {
      const F = tj(a), W = nj(Math.round((L - r) / a) * a + r, F), H = Td(W, [r, o]);
      P((A = []) => {
        const D = qW(A, H, U);
        if (ej(D, l * a)) {
          b.current = D.indexOf(H);
          const B = String(D) !== String(A);
          return B && M && v(D), B ? D : A;
        } else
          return A;
      });
    }
    return /* @__PURE__ */ f(
      VW,
      {
        scope: e.__scopeSlider,
        name: n,
        disabled: s,
        min: r,
        max: o,
        valueIndexToChangeRef: b,
        thumbs: h.current,
        values: E,
        orientation: i,
        form: g,
        children: /* @__PURE__ */ f(qi.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ f(qi.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ f(
          C,
          {
            "aria-disabled": s,
            "data-disabled": s ? "" : void 0,
            ...m,
            ref: t,
            onPointerDown: I(m.onPointerDown, () => {
              s || (x.current = E);
            }),
            min: r,
            max: o,
            inverted: y,
            onSlideStart: s ? void 0 : S,
            onSlideMove: s ? void 0 : _,
            onSlideEnd: s ? void 0 : T,
            onHomeKeyDown: () => !s && k(r, 0, { commit: !0 }),
            onEndKeyDown: () => !s && k(o, E.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: L, direction: U }) => {
              if (!s) {
                const W = Vb.includes(L.key) || L.shiftKey && Gb.includes(L.key) ? 10 : 1, H = b.current, A = E[H], D = a * W * U;
                k(A + D, H, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
zb.displayName = Hn;
var [qb, Xb] = Yb(Hn, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), GW = c.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      dir: o,
      inverted: a,
      onSlideStart: i,
      onSlideMove: s,
      onSlideEnd: l,
      onStepKeyDown: u,
      ...d
    } = e, [p, v] = c.useState(null), y = ne(t, (C) => v(C)), g = c.useRef(void 0), m = Ut(o), h = m === "ltr", b = h && !a || !h && a;
    function w(C) {
      const E = g.current || p.getBoundingClientRect(), P = [0, E.width], S = qc(P, b ? [n, r] : [r, n]);
      return g.current = E, S(C - E.left);
    }
    return /* @__PURE__ */ f(
      qb,
      {
        scope: e.__scopeSlider,
        startEdge: b ? "left" : "right",
        endEdge: b ? "right" : "left",
        direction: b ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ f(
          Zb,
          {
            dir: m,
            "data-orientation": "horizontal",
            ...d,
            ref: y,
            style: {
              ...d.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (C) => {
              const E = w(C.clientX);
              i == null || i(E);
            },
            onSlideMove: (C) => {
              const E = w(C.clientX);
              s == null || s(E);
            },
            onSlideEnd: () => {
              g.current = void 0, l == null || l();
            },
            onStepKeyDown: (C) => {
              const P = Kb[b ? "from-left" : "from-right"].includes(C.key);
              u == null || u({ event: C, direction: P ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), KW = c.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      inverted: o,
      onSlideStart: a,
      onSlideMove: i,
      onSlideEnd: s,
      onStepKeyDown: l,
      ...u
    } = e, d = c.useRef(null), p = ne(t, d), v = c.useRef(void 0), y = !o;
    function g(m) {
      const h = v.current || d.current.getBoundingClientRect(), b = [0, h.height], C = qc(b, y ? [r, n] : [n, r]);
      return v.current = h, C(m - h.top);
    }
    return /* @__PURE__ */ f(
      qb,
      {
        scope: e.__scopeSlider,
        startEdge: y ? "bottom" : "top",
        endEdge: y ? "top" : "bottom",
        size: "height",
        direction: y ? 1 : -1,
        children: /* @__PURE__ */ f(
          Zb,
          {
            "data-orientation": "vertical",
            ...u,
            ref: p,
            style: {
              ...u.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (m) => {
              const h = g(m.clientY);
              a == null || a(h);
            },
            onSlideMove: (m) => {
              const h = g(m.clientY);
              i == null || i(h);
            },
            onSlideEnd: () => {
              v.current = void 0, s == null || s();
            },
            onStepKeyDown: (m) => {
              const b = Kb[y ? "from-bottom" : "from-top"].includes(m.key);
              l == null || l({ event: m, direction: b ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Zb = c.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: n,
      onSlideStart: r,
      onSlideMove: o,
      onSlideEnd: a,
      onHomeKeyDown: i,
      onEndKeyDown: s,
      onStepKeyDown: l,
      ...u
    } = e, d = sa(Hn, n);
    return /* @__PURE__ */ f(
      G.span,
      {
        ...u,
        ref: t,
        onKeyDown: I(e.onKeyDown, (p) => {
          p.key === "Home" ? (i(p), p.preventDefault()) : p.key === "End" ? (s(p), p.preventDefault()) : Vb.concat(Gb).includes(p.key) && (l(p), p.preventDefault());
        }),
        onPointerDown: I(e.onPointerDown, (p) => {
          const v = p.target;
          v.setPointerCapture(p.pointerId), p.preventDefault(), d.thumbs.has(v) ? v.focus() : r(p);
        }),
        onPointerMove: I(e.onPointerMove, (p) => {
          p.target.hasPointerCapture(p.pointerId) && o(p);
        }),
        onPointerUp: I(e.onPointerUp, (p) => {
          const v = p.target;
          v.hasPointerCapture(p.pointerId) && (v.releasePointerCapture(p.pointerId), a(p));
        })
      }
    );
  }
), Qb = "SliderTrack", Jb = c.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, o = sa(Qb, n);
    return /* @__PURE__ */ f(
      G.span,
      {
        "data-disabled": o.disabled ? "" : void 0,
        "data-orientation": o.orientation,
        ...r,
        ref: t
      }
    );
  }
);
Jb.displayName = Qb;
var Xi = "SliderRange", ey = c.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, o = sa(Xi, n), a = Xb(Xi, n), i = c.useRef(null), s = ne(t, i), l = o.values.length, u = o.values.map(
      (v) => ny(v, o.min, o.max)
    ), d = l > 1 ? Math.min(...u) : 0, p = 100 - Math.max(...u);
    return /* @__PURE__ */ f(
      G.span,
      {
        "data-orientation": o.orientation,
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: s,
        style: {
          ...e.style,
          [a.startEdge]: d + "%",
          [a.endEdge]: p + "%"
        }
      }
    );
  }
);
ey.displayName = Xi;
var Zi = "SliderThumb", ty = c.forwardRef(
  (e, t) => {
    const n = HW(e.__scopeSlider), [r, o] = c.useState(null), a = ne(t, (s) => o(s)), i = c.useMemo(
      () => r ? n().findIndex((s) => s.ref.current === r) : -1,
      [n, r]
    );
    return /* @__PURE__ */ f(YW, { ...e, ref: a, index: i });
  }
), YW = c.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, index: r, name: o, ...a } = e, i = sa(Zi, n), s = Xb(Zi, n), [l, u] = c.useState(null), d = ne(t, (w) => u(w)), p = l ? i.form || !!l.closest("form") : !0, v = yr(l), y = i.values[r], g = y === void 0 ? 0 : ny(y, i.min, i.max), m = XW(r, i.values.length), h = v == null ? void 0 : v[s.size], b = h ? QW(h, g, s.direction) : 0;
    return c.useEffect(() => {
      if (l)
        return i.thumbs.add(l), () => {
          i.thumbs.delete(l);
        };
    }, [l, i.thumbs]), /* @__PURE__ */ X(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [s.startEdge]: `calc(${g}% + ${b}px)`
        },
        children: [
          /* @__PURE__ */ f(qi.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ f(
            G.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || m,
              "aria-valuemin": i.min,
              "aria-valuenow": y,
              "aria-valuemax": i.max,
              "aria-orientation": i.orientation,
              "data-orientation": i.orientation,
              "data-disabled": i.disabled ? "" : void 0,
              tabIndex: i.disabled ? void 0 : 0,
              ...a,
              ref: d,
              style: y === void 0 ? { display: "none" } : e.style,
              onFocus: I(e.onFocus, () => {
                i.valueIndexToChangeRef.current = r;
              })
            }
          ) }),
          p && /* @__PURE__ */ f(
            zW,
            {
              name: o ?? (i.name ? i.name + (i.values.length > 1 ? "[]" : "") : void 0),
              form: i.form,
              value: y
            },
            r
          )
        ]
      }
    );
  }
);
ty.displayName = Zi;
var zW = (e) => {
  const { value: t, ...n } = e, r = c.useRef(null), o = Cr(t);
  return c.useEffect(() => {
    const a = r.current, i = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(i, "value").set;
    if (o !== t && l) {
      const u = new Event("input", { bubbles: !0 });
      l.call(a, t), a.dispatchEvent(u);
    }
  }, [o, t]), /* @__PURE__ */ f("input", { style: { display: "none" }, ...n, ref: r, defaultValue: t });
};
function qW(e = [], t, n) {
  const r = [...e];
  return r[n] = t, r.sort((o, a) => o - a);
}
function ny(e, t, n) {
  const a = 100 / (n - t) * (e - t);
  return Td(a, [0, 100]);
}
function XW(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function ZW(e, t) {
  if (e.length === 1)
    return 0;
  const n = e.map((o) => Math.abs(o - t)), r = Math.min(...n);
  return n.indexOf(r);
}
function QW(e, t, n) {
  const r = e / 2, a = qc([0, 50], [0, r]);
  return (r - a(t) * n) * n;
}
function JW(e) {
  return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
function ej(e, t) {
  if (t > 0) {
    const n = JW(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function qc(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function tj(e) {
  return (String(e).split(".")[1] || "").length;
}
function nj(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
var ry = zb, rj = Jb, oj = ey, aj = ty;
const ij = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ X(
  ry,
  {
    ref: n,
    className: $(
      "relative flex w-full touch-none select-none items-center",
      e
    ),
    ...t,
    children: [
      /* @__PURE__ */ f(rj, { className: "relative h-1.5 w-full grow overflow-hidden rounded-full bg-primary/20", children: /* @__PURE__ */ f(oj, { className: "absolute h-full bg-primary" }) }),
      /* @__PURE__ */ f(aj, { className: "block h-4 w-4 rounded-full border border-primary/50 bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" })
    ]
  }
));
ij.displayName = ry.displayName;
var oy = c.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = c.Children.toArray(n), a = o.find(cj);
  if (a) {
    const i = a.props.children, s = o.map((l) => l === a ? c.Children.count(i) > 1 ? c.Children.only(null) : c.isValidElement(i) ? i.props.children : null : l);
    return /* @__PURE__ */ f(Qi, { ...r, ref: t, children: c.isValidElement(i) ? c.cloneElement(i, void 0, s) : null });
  }
  return /* @__PURE__ */ f(Qi, { ...r, ref: t, children: n });
});
oy.displayName = "Slot";
var Qi = c.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (c.isValidElement(n)) {
    const o = uj(n);
    return c.cloneElement(n, {
      ...lj(r, n.props),
      // @ts-ignore
      ref: t ? wr(t, o) : o
    });
  }
  return c.Children.count(n) > 1 ? c.Children.only(null) : null;
});
Qi.displayName = "SlotClone";
var sj = ({ children: e }) => /* @__PURE__ */ f(Oe, { children: e });
function cj(e) {
  return c.isValidElement(e) && e.type === sj;
}
function lj(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function uj(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var dj = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ay = dj.reduce((e, t) => {
  const n = c.forwardRef((r, o) => {
    const { asChild: a, ...i } = r, s = a ? oy : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(s, { ...i, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Xc = "Switch", [fj, pH] = Re(Xc), [pj, mj] = fj(Xc), iy = c.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: l = "on",
      onCheckedChange: u,
      form: d,
      ...p
    } = e, [v, y] = c.useState(null), g = ne(t, (C) => y(C)), m = c.useRef(!1), h = v ? d || !!v.closest("form") : !0, [b = !1, w] = Me({
      prop: o,
      defaultProp: a,
      onChange: u
    });
    return /* @__PURE__ */ X(pj, { scope: n, checked: b, disabled: s, children: [
      /* @__PURE__ */ f(
        ay.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": b,
          "aria-required": i,
          "data-state": ly(b),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...p,
          ref: g,
          onClick: I(e.onClick, (C) => {
            w((E) => !E), h && (m.current = C.isPropagationStopped(), m.current || C.stopPropagation());
          })
        }
      ),
      h && /* @__PURE__ */ f(
        vj,
        {
          control: v,
          bubbles: !m.current,
          name: r,
          value: l,
          checked: b,
          required: i,
          disabled: s,
          form: d,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
iy.displayName = Xc;
var sy = "SwitchThumb", cy = c.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, o = mj(sy, n);
    return /* @__PURE__ */ f(
      ay.span,
      {
        "data-state": ly(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
cy.displayName = sy;
var vj = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, a = c.useRef(null), i = Cr(n), s = yr(t);
  return c.useEffect(() => {
    const l = a.current, u = window.HTMLInputElement.prototype, p = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (i !== n && p) {
      const v = new Event("click", { bubbles: r });
      p.call(l, n), l.dispatchEvent(v);
    }
  }, [i, n, r]), /* @__PURE__ */ f(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...o,
      tabIndex: -1,
      ref: a,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function ly(e) {
  return e ? "checked" : "unchecked";
}
var uy = iy, hj = cy;
const gj = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  uy,
  {
    className: $(
      "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      e
    ),
    ...t,
    ref: n,
    children: /* @__PURE__ */ f(
      hj,
      {
        className: $(
          "pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
        )
      }
    )
  }
));
gj.displayName = uy.displayName;
const bj = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ f(
  "table",
  {
    ref: n,
    className: $("w-full caption-bottom text-sm", e),
    ...t
  }
) }));
bj.displayName = "Table";
const yj = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f("thead", { ref: n, className: $("[&_tr]:border-b", e), ...t }));
yj.displayName = "TableHeader";
const wj = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "tbody",
  {
    ref: n,
    className: $("[&_tr:last-child]:border-0", e),
    ...t
  }
));
wj.displayName = "TableBody";
const Cj = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "tfoot",
  {
    ref: n,
    className: $(
      "border-t bg-muted/50 font-medium [&>tr]:last:border-b-0",
      e
    ),
    ...t
  }
));
Cj.displayName = "TableFooter";
const Ej = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "tr",
  {
    ref: n,
    className: $(
      "border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted",
      e
    ),
    ...t
  }
));
Ej.displayName = "TableRow";
const Sj = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "th",
  {
    ref: n,
    className: $(
      "h-10 px-2 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
      e
    ),
    ...t
  }
));
Sj.displayName = "TableHead";
const Pj = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "td",
  {
    ref: n,
    className: $(
      "p-2 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
      e
    ),
    ...t
  }
));
Pj.displayName = "TableCell";
const xj = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "caption",
  {
    ref: n,
    className: $("mt-4 text-sm text-muted-foreground", e),
    ...t
  }
));
xj.displayName = "TableCaption";
const _j = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  "textarea",
  {
    className: $(
      "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
      e
    ),
    ref: n,
    ...t
  }
));
_j.displayName = "Textarea";
const Tj = 1, Nj = 1e6;
let qa = 0;
function Rj() {
  return qa = (qa + 1) % Number.MAX_SAFE_INTEGER, qa.toString();
}
const Xa = /* @__PURE__ */ new Map(), hd = (e) => {
  if (Xa.has(e))
    return;
  const t = setTimeout(() => {
    Xa.delete(e), nr({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, Nj);
  Xa.set(e, t);
}, $j = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, Tj)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map(
          (n) => n.id === t.toast.id ? { ...n, ...t.toast } : n
        )
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return n ? hd(n) : e.toasts.forEach((r) => {
        hd(r.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, oo = [];
let ao = { toasts: [] };
function nr(e) {
  ao = $j(ao, e), oo.forEach((t) => {
    t(ao);
  });
}
function Oj({ ...e }) {
  const t = Rj(), n = (o) => nr({
    type: "UPDATE_TOAST",
    toast: { ...o, id: t }
  }), r = () => nr({ type: "DISMISS_TOAST", toastId: t });
  return nr({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (o) => {
        o || r();
      }
    }
  }), {
    id: t,
    dismiss: r,
    update: n
  };
}
function Mj() {
  const [e, t] = c.useState(ao);
  return c.useEffect(() => (oo.push(t), () => {
    const n = oo.indexOf(t);
    n > -1 && oo.splice(n, 1);
  }), [e]), {
    ...e,
    toast: Oj,
    dismiss: (n) => nr({ type: "DISMISS_TOAST", toastId: n })
  };
}
var Dj = "DismissableLayer", Ji = "dismissableLayer.update", Aj = "dismissableLayer.pointerDownOutside", Ij = "dismissableLayer.focusOutside", gd, dy = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), fy = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, u = c.useContext(dy), [d, p] = c.useState(null), v = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, y] = c.useState({}), g = ne(t, (S) => p(S)), m = Array.from(u.layers), [h] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), b = m.indexOf(h), w = d ? m.indexOf(d) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, E = w >= b, P = Lj((S) => {
      const _ = S.target, T = [...u.branches].some((k) => k.contains(_));
      !E || T || (o == null || o(S), i == null || i(S), S.defaultPrevented || s == null || s());
    }, v), x = Fj((S) => {
      const _ = S.target;
      [...u.branches].some((k) => k.contains(_)) || (a == null || a(S), i == null || i(S), S.defaultPrevented || s == null || s());
    }, v);
    return br((S) => {
      w === u.layers.size - 1 && (r == null || r(S), !S.defaultPrevented && s && (S.preventDefault(), s()));
    }, v), c.useEffect(() => {
      if (d)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (gd = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), bd(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (v.body.style.pointerEvents = gd);
        };
    }, [d, v, n, u]), c.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), bd());
    }, [d, u]), c.useEffect(() => {
      const S = () => y({});
      return document.addEventListener(Ji, S), () => document.removeEventListener(Ji, S);
    }, []), /* @__PURE__ */ f(
      G.div,
      {
        ...l,
        ref: g,
        style: {
          pointerEvents: C ? E ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: I(e.onFocusCapture, x.onFocusCapture),
        onBlurCapture: I(e.onBlurCapture, x.onBlurCapture),
        onPointerDownCapture: I(
          e.onPointerDownCapture,
          P.onPointerDownCapture
        )
      }
    );
  }
);
fy.displayName = Dj;
var kj = "DismissableLayerBranch", py = c.forwardRef((e, t) => {
  const n = c.useContext(dy), r = c.useRef(null), o = ne(t, r);
  return c.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ f(G.div, { ...e, ref: o });
});
py.displayName = kj;
function Lj(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = me(e), r = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          my(
            Aj,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Fj(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = me(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && my(Ij, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function bd() {
  const e = new CustomEvent(Ji);
  document.dispatchEvent(e);
}
function my(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Ot(o, a) : o.dispatchEvent(a);
}
var Bj = fy, Wj = py, jj = "Portal", vy = c.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [o, a] = c.useState(!1);
  mt(() => a(!0), []);
  const i = n || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? Er.createPortal(/* @__PURE__ */ f(G.div, { ...r, ref: t }), i) : null;
});
vy.displayName = jj;
var Zc = "ToastProvider", [Qc, Hj, Uj] = Vt("Toast"), [hy, mH] = Re("Toast", [Uj]), [Vj, ca] = hy(Zc), gy = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: a = 50,
    children: i
  } = e, [s, l] = c.useState(null), [u, d] = c.useState(0), p = c.useRef(!1), v = c.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${Zc}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ f(Qc.Provider, { scope: t, children: /* @__PURE__ */ f(
    Vj,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: a,
      toastCount: u,
      viewport: s,
      onViewportChange: l,
      onToastAdd: c.useCallback(() => d((y) => y + 1), []),
      onToastRemove: c.useCallback(() => d((y) => y - 1), []),
      isFocusedToastEscapeKeyDownRef: p,
      isClosePausedRef: v,
      children: i
    }
  ) });
};
gy.displayName = Zc;
var by = "ToastViewport", Gj = ["F8"], es = "toast.viewportPause", ts = "toast.viewportResume", yy = c.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = Gj,
      label: o = "Notifications ({hotkey})",
      ...a
    } = e, i = ca(by, n), s = Hj(n), l = c.useRef(null), u = c.useRef(null), d = c.useRef(null), p = c.useRef(null), v = ne(t, p, i.onViewportChange), y = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), g = i.toastCount > 0;
    c.useEffect(() => {
      const h = (b) => {
        var C;
        r.length !== 0 && r.every((E) => b[E] || b.code === E) && ((C = p.current) == null || C.focus());
      };
      return document.addEventListener("keydown", h), () => document.removeEventListener("keydown", h);
    }, [r]), c.useEffect(() => {
      const h = l.current, b = p.current;
      if (g && h && b) {
        const w = () => {
          if (!i.isClosePausedRef.current) {
            const x = new CustomEvent(es);
            b.dispatchEvent(x), i.isClosePausedRef.current = !0;
          }
        }, C = () => {
          if (i.isClosePausedRef.current) {
            const x = new CustomEvent(ts);
            b.dispatchEvent(x), i.isClosePausedRef.current = !1;
          }
        }, E = (x) => {
          !h.contains(x.relatedTarget) && C();
        }, P = () => {
          h.contains(document.activeElement) || C();
        };
        return h.addEventListener("focusin", w), h.addEventListener("focusout", E), h.addEventListener("pointermove", w), h.addEventListener("pointerleave", P), window.addEventListener("blur", w), window.addEventListener("focus", C), () => {
          h.removeEventListener("focusin", w), h.removeEventListener("focusout", E), h.removeEventListener("pointermove", w), h.removeEventListener("pointerleave", P), window.removeEventListener("blur", w), window.removeEventListener("focus", C);
        };
      }
    }, [g, i.isClosePausedRef]);
    const m = c.useCallback(
      ({ tabbingDirection: h }) => {
        const w = s().map((C) => {
          const E = C.ref.current, P = [E, ...o8(E)];
          return h === "forwards" ? P : P.reverse();
        });
        return (h === "forwards" ? w.reverse() : w).flat();
      },
      [s]
    );
    return c.useEffect(() => {
      const h = p.current;
      if (h) {
        const b = (w) => {
          var P, x, S;
          const C = w.altKey || w.ctrlKey || w.metaKey;
          if (w.key === "Tab" && !C) {
            const _ = document.activeElement, T = w.shiftKey;
            if (w.target === h && T) {
              (P = u.current) == null || P.focus();
              return;
            }
            const U = m({ tabbingDirection: T ? "backwards" : "forwards" }), M = U.findIndex((F) => F === _);
            Za(U.slice(M + 1)) ? w.preventDefault() : T ? (x = u.current) == null || x.focus() : (S = d.current) == null || S.focus();
          }
        };
        return h.addEventListener("keydown", b), () => h.removeEventListener("keydown", b);
      }
    }, [s, m]), /* @__PURE__ */ X(
      Wj,
      {
        ref: l,
        role: "region",
        "aria-label": o.replace("{hotkey}", y),
        tabIndex: -1,
        style: { pointerEvents: g ? void 0 : "none" },
        children: [
          g && /* @__PURE__ */ f(
            ns,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const h = m({
                  tabbingDirection: "forwards"
                });
                Za(h);
              }
            }
          ),
          /* @__PURE__ */ f(Qc.Slot, { scope: n, children: /* @__PURE__ */ f(G.ol, { tabIndex: -1, ...a, ref: v }) }),
          g && /* @__PURE__ */ f(
            ns,
            {
              ref: d,
              onFocusFromOutsideViewport: () => {
                const h = m({
                  tabbingDirection: "backwards"
                });
                Za(h);
              }
            }
          )
        ]
      }
    );
  }
);
yy.displayName = by;
var wy = "ToastFocusProxy", ns = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, a = ca(wy, n);
    return /* @__PURE__ */ f(
      ia,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (i) => {
          var u;
          const s = i.relatedTarget;
          !((u = a.viewport) != null && u.contains(s)) && r();
        }
      }
    );
  }
);
ns.displayName = wy;
var la = "Toast", Kj = "toast.swipeStart", Yj = "toast.swipeMove", zj = "toast.swipeCancel", qj = "toast.swipeEnd", Cy = c.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: o, onOpenChange: a, ...i } = e, [s = !0, l] = Me({
      prop: r,
      defaultProp: o,
      onChange: a
    });
    return /* @__PURE__ */ f(Fe, { present: n || s, children: /* @__PURE__ */ f(
      Qj,
      {
        open: s,
        ...i,
        ref: t,
        onClose: () => l(!1),
        onPause: me(e.onPause),
        onResume: me(e.onResume),
        onSwipeStart: I(e.onSwipeStart, (u) => {
          u.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: I(e.onSwipeMove, (u) => {
          const { x: d, y: p } = u.detail.delta;
          u.currentTarget.setAttribute("data-swipe", "move"), u.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${d}px`), u.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${p}px`);
        }),
        onSwipeCancel: I(e.onSwipeCancel, (u) => {
          u.currentTarget.setAttribute("data-swipe", "cancel"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), u.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: I(e.onSwipeEnd, (u) => {
          const { x: d, y: p } = u.detail.delta;
          u.currentTarget.setAttribute("data-swipe", "end"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), u.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${d}px`), u.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${p}px`), l(!1);
        })
      }
    ) });
  }
);
Cy.displayName = la;
var [Xj, Zj] = hy(la, {
  onClose() {
  }
}), Qj = c.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: o,
      open: a,
      onClose: i,
      onEscapeKeyDown: s,
      onPause: l,
      onResume: u,
      onSwipeStart: d,
      onSwipeMove: p,
      onSwipeCancel: v,
      onSwipeEnd: y,
      ...g
    } = e, m = ca(la, n), [h, b] = c.useState(null), w = ne(t, (F) => b(F)), C = c.useRef(null), E = c.useRef(null), P = o || m.duration, x = c.useRef(0), S = c.useRef(P), _ = c.useRef(0), { onToastAdd: T, onToastRemove: k } = m, L = me(() => {
      var W;
      (h == null ? void 0 : h.contains(document.activeElement)) && ((W = m.viewport) == null || W.focus()), i();
    }), U = c.useCallback(
      (F) => {
        !F || F === 1 / 0 || (window.clearTimeout(_.current), x.current = (/* @__PURE__ */ new Date()).getTime(), _.current = window.setTimeout(L, F));
      },
      [L]
    );
    c.useEffect(() => {
      const F = m.viewport;
      if (F) {
        const W = () => {
          U(S.current), u == null || u();
        }, H = () => {
          const A = (/* @__PURE__ */ new Date()).getTime() - x.current;
          S.current = S.current - A, window.clearTimeout(_.current), l == null || l();
        };
        return F.addEventListener(es, H), F.addEventListener(ts, W), () => {
          F.removeEventListener(es, H), F.removeEventListener(ts, W);
        };
      }
    }, [m.viewport, P, l, u, U]), c.useEffect(() => {
      a && !m.isClosePausedRef.current && U(P);
    }, [a, P, m.isClosePausedRef, U]), c.useEffect(() => (T(), () => k()), [T, k]);
    const M = c.useMemo(() => h ? Ny(h) : null, [h]);
    return m.viewport ? /* @__PURE__ */ X(Oe, { children: [
      M && /* @__PURE__ */ f(
        Jj,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: M
        }
      ),
      /* @__PURE__ */ f(Xj, { scope: n, onClose: L, children: Nd.createPortal(
        /* @__PURE__ */ f(Qc.ItemSlot, { scope: n, children: /* @__PURE__ */ f(
          Bj,
          {
            asChild: !0,
            onEscapeKeyDown: I(s, () => {
              m.isFocusedToastEscapeKeyDownRef.current || L(), m.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ f(
              G.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": a ? "open" : "closed",
                "data-swipe-direction": m.swipeDirection,
                ...g,
                ref: w,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: I(e.onKeyDown, (F) => {
                  F.key === "Escape" && (s == null || s(F.nativeEvent), F.nativeEvent.defaultPrevented || (m.isFocusedToastEscapeKeyDownRef.current = !0, L()));
                }),
                onPointerDown: I(e.onPointerDown, (F) => {
                  F.button === 0 && (C.current = { x: F.clientX, y: F.clientY });
                }),
                onPointerMove: I(e.onPointerMove, (F) => {
                  if (!C.current)
                    return;
                  const W = F.clientX - C.current.x, H = F.clientY - C.current.y, A = !!E.current, D = ["left", "right"].includes(m.swipeDirection), B = ["left", "up"].includes(m.swipeDirection) ? Math.min : Math.max, Q = D ? B(0, W) : 0, q = D ? 0 : B(0, H), O = F.pointerType === "touch" ? 10 : 2, j = { x: Q, y: q }, Y = { originalEvent: F, delta: j };
                  A ? (E.current = j, Jr(Yj, p, Y, {
                    discrete: !1
                  })) : yd(j, m.swipeDirection, O) ? (E.current = j, Jr(Kj, d, Y, {
                    discrete: !1
                  }), F.target.setPointerCapture(F.pointerId)) : (Math.abs(W) > O || Math.abs(H) > O) && (C.current = null);
                }),
                onPointerUp: I(e.onPointerUp, (F) => {
                  const W = E.current, H = F.target;
                  if (H.hasPointerCapture(F.pointerId) && H.releasePointerCapture(F.pointerId), E.current = null, C.current = null, W) {
                    const A = F.currentTarget, D = { originalEvent: F, delta: W };
                    yd(W, m.swipeDirection, m.swipeThreshold) ? Jr(qj, y, D, {
                      discrete: !0
                    }) : Jr(
                      zj,
                      v,
                      D,
                      {
                        discrete: !0
                      }
                    ), A.addEventListener("click", (B) => B.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        m.viewport
      ) })
    ] }) : null;
  }
), Jj = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = ca(la, t), [a, i] = c.useState(!1), [s, l] = c.useState(!1);
  return n8(() => i(!0)), c.useEffect(() => {
    const u = window.setTimeout(() => l(!0), 1e3);
    return () => window.clearTimeout(u);
  }, []), s ? null : /* @__PURE__ */ f(vy, { asChild: !0, children: /* @__PURE__ */ f(ia, { ...r, children: a && /* @__PURE__ */ X(Oe, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, e8 = "ToastTitle", Ey = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ f(G.div, { ...r, ref: t });
  }
);
Ey.displayName = e8;
var t8 = "ToastDescription", Sy = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ f(G.div, { ...r, ref: t });
  }
);
Sy.displayName = t8;
var Py = "ToastAction", xy = c.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ f(Ty, { altText: n, asChild: !0, children: /* @__PURE__ */ f(Jc, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${Py}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
xy.displayName = Py;
var _y = "ToastClose", Jc = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, o = Zj(_y, n);
    return /* @__PURE__ */ f(Ty, { asChild: !0, children: /* @__PURE__ */ f(
      G.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: I(e.onClick, o.onClose)
      }
    ) });
  }
);
Jc.displayName = _y;
var Ty = c.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ f(
    G.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: t
    }
  );
});
function Ny(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), r8(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", a = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (a) {
          const i = r.dataset.radixToastAnnounceAlt;
          i && t.push(i);
        } else
          t.push(...Ny(r));
    }
  }), t;
}
function Jr(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, a = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Ot(o, a) : o.dispatchEvent(a);
}
var yd = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), a = r > o;
  return t === "left" || t === "right" ? a && r > n : !a && o > n;
};
function n8(e = () => {
}) {
  const t = me(e);
  mt(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function r8(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function o8(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Za(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var a8 = gy, Ry = yy, $y = Cy, Oy = Ey, My = Sy, Dy = xy, Ay = Jc;
const i8 = a8, Iy = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Ry,
  {
    ref: n,
    className: $(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
Iy.displayName = Ry.displayName;
const s8 = An(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-2 overflow-hidden rounded-md border p-4 pr-6 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), ky = c.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ f(
  $y,
  {
    ref: r,
    className: $(s8({ variant: t }), e),
    ...n
  }
));
ky.displayName = $y.displayName;
const c8 = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Dy,
  {
    ref: n,
    className: $(
      "inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium transition-colors hover:bg-secondary focus:outline-none focus:ring-1 focus:ring-ring disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive",
      e
    ),
    ...t
  }
));
c8.displayName = Dy.displayName;
const Ly = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Ay,
  {
    ref: n,
    className: $(
      "absolute right-1 top-1 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-1 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ f(Dd, { className: "h-4 w-4" })
  }
));
Ly.displayName = Ay.displayName;
const Fy = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  Oy,
  {
    ref: n,
    className: $("text-sm font-semibold [&+div]:text-xs", e),
    ...t
  }
));
Fy.displayName = Oy.displayName;
const By = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f(
  My,
  {
    ref: n,
    className: $("text-sm opacity-90", e),
    ...t
  }
));
By.displayName = My.displayName;
function vH() {
  const { toasts: e } = Mj();
  return /* @__PURE__ */ X(i8, { children: [
    e.map(function({ id: t, title: n, description: r, action: o, ...a }) {
      return /* @__PURE__ */ X(ky, { ...a, children: [
        /* @__PURE__ */ X("div", { className: "grid gap-1", children: [
          n && /* @__PURE__ */ f(Fy, { children: n }),
          r && /* @__PURE__ */ f(By, { children: r })
        ] }),
        o,
        /* @__PURE__ */ f(Ly, {})
      ] }, t);
    }),
    /* @__PURE__ */ f(Iy, {})
  ] });
}
var l8 = "Toggle", el = c.forwardRef((e, t) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: o, ...a } = e, [i = !1, s] = Me({
    prop: n,
    onChange: o,
    defaultProp: r
  });
  return /* @__PURE__ */ f(
    G.button,
    {
      type: "button",
      "aria-pressed": i,
      "data-state": i ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...a,
      ref: t,
      onClick: I(e.onClick, () => {
        e.disabled || s(!i);
      })
    }
  );
});
el.displayName = l8;
var Wy = el, Un = "ToggleGroup", [jy, hH] = Re(Un, [
  Kt
]), Hy = Kt(), tl = R.forwardRef((e, t) => {
  const { type: n, ...r } = e;
  if (n === "single")
    return /* @__PURE__ */ f(u8, { ...r, ref: t });
  if (n === "multiple")
    return /* @__PURE__ */ f(d8, { ...r, ref: t });
  throw new Error(`Missing prop \`type\` expected on \`${Un}\``);
});
tl.displayName = Un;
var [Uy, Vy] = jy(Un), u8 = R.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...a
  } = e, [i, s] = Me({
    prop: n,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ f(
    Uy,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: i ? [i] : [],
      onItemActivate: s,
      onItemDeactivate: R.useCallback(() => s(""), [s]),
      children: /* @__PURE__ */ f(Gy, { ...a, ref: t })
    }
  );
}), d8 = R.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...a
  } = e, [i = [], s] = Me({
    prop: n,
    defaultProp: r,
    onChange: o
  }), l = R.useCallback(
    (d) => s((p = []) => [...p, d]),
    [s]
  ), u = R.useCallback(
    (d) => s((p = []) => p.filter((v) => v !== d)),
    [s]
  );
  return /* @__PURE__ */ f(
    Uy,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: i,
      onItemActivate: l,
      onItemDeactivate: u,
      children: /* @__PURE__ */ f(Gy, { ...a, ref: t })
    }
  );
});
tl.displayName = Un;
var [f8, p8] = jy(Un), Gy = R.forwardRef(
  (e, t) => {
    const {
      __scopeToggleGroup: n,
      disabled: r = !1,
      rovingFocus: o = !0,
      orientation: a,
      dir: i,
      loop: s = !0,
      ...l
    } = e, u = Hy(n), d = Ut(i), p = { role: "group", dir: d, ...l };
    return /* @__PURE__ */ f(f8, { scope: n, rovingFocus: o, disabled: r, children: o ? /* @__PURE__ */ f(
      ea,
      {
        asChild: !0,
        ...u,
        orientation: a,
        dir: d,
        loop: s,
        children: /* @__PURE__ */ f(G.div, { ...p, ref: t })
      }
    ) : /* @__PURE__ */ f(G.div, { ...p, ref: t }) });
  }
), $o = "ToggleGroupItem", Ky = R.forwardRef(
  (e, t) => {
    const n = Vy($o, e.__scopeToggleGroup), r = p8($o, e.__scopeToggleGroup), o = Hy(e.__scopeToggleGroup), a = n.value.includes(e.value), i = r.disabled || e.disabled, s = { ...e, pressed: a, disabled: i }, l = R.useRef(null);
    return r.rovingFocus ? /* @__PURE__ */ f(
      ta,
      {
        asChild: !0,
        ...o,
        focusable: !i,
        active: a,
        ref: l,
        children: /* @__PURE__ */ f(wd, { ...s, ref: t })
      }
    ) : /* @__PURE__ */ f(wd, { ...s, ref: t });
  }
);
Ky.displayName = $o;
var wd = R.forwardRef(
  (e, t) => {
    const { __scopeToggleGroup: n, value: r, ...o } = e, a = Vy($o, n), i = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, s = a.type === "single" ? i : void 0;
    return /* @__PURE__ */ f(
      el,
      {
        ...s,
        ...o,
        ref: t,
        onPressedChange: (l) => {
          l ? a.onItemActivate(r) : a.onItemDeactivate(r);
        }
      }
    );
  }
), Yy = tl, zy = Ky;
const qy = An(
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground"
      },
      size: {
        default: "h-9 px-2 min-w-9",
        sm: "h-8 px-1.5 min-w-8",
        lg: "h-10 px-2.5 min-w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), m8 = c.forwardRef(({ className: e, variant: t, size: n, ...r }, o) => /* @__PURE__ */ f(
  Wy,
  {
    ref: o,
    className: $(qy({ variant: t, size: n, className: e })),
    ...r
  }
));
m8.displayName = Wy.displayName;
const Xy = c.createContext({
  size: "default",
  variant: "default"
}), v8 = c.forwardRef(({ className: e, variant: t, size: n, children: r, ...o }, a) => /* @__PURE__ */ f(
  Yy,
  {
    ref: a,
    className: $("flex items-center justify-center gap-1", e),
    ...o,
    children: /* @__PURE__ */ f(Xy.Provider, { value: { variant: t, size: n }, children: r })
  }
));
v8.displayName = Yy.displayName;
const h8 = c.forwardRef(({ className: e, children: t, variant: n, size: r, ...o }, a) => {
  const i = c.useContext(Xy);
  return /* @__PURE__ */ f(
    zy,
    {
      ref: a,
      className: $(
        qy({
          variant: i.variant || n,
          size: i.size || r
        }),
        e
      ),
      ...o,
      children: t
    }
  );
});
h8.displayName = zy.displayName;
export {
  T8 as Accordion,
  kw as AccordionContent,
  Aw as AccordionItem,
  Iw as AccordionTrigger,
  z0 as Alert,
  X0 as AlertDescription,
  R8 as AlertDialog,
  G0 as AlertDialogAction,
  K0 as AlertDialogCancel,
  W0 as AlertDialogContent,
  V0 as AlertDialogDescription,
  H0 as AlertDialogFooter,
  j0 as AlertDialogHeader,
  Yf as AlertDialogOverlay,
  B0 as AlertDialogPortal,
  U0 as AlertDialogTitle,
  $8 as AlertDialogTrigger,
  q0 as AlertTitle,
  O8 as AspectRatio,
  d6 as Avatar,
  f6 as AvatarFallback,
  p6 as AvatarImage,
  M8 as Badge,
  eC as Breadcrumb,
  iC as BreadcrumbEllipsis,
  nC as BreadcrumbItem,
  rC as BreadcrumbLink,
  tC as BreadcrumbList,
  oC as BreadcrumbPage,
  aC as BreadcrumbSeparator,
  Sd as Button,
  YS as Calendar,
  zS as Card,
  QS as CardContent,
  ZS as CardDescription,
  JS as CardFooter,
  qS as CardHeader,
  XS as CardTitle,
  AP as Carousel,
  IP as CarouselContent,
  kP as CarouselItem,
  FP as CarouselNext,
  LP as CarouselPrevious,
  LL as ChartContainer,
  A8 as ChartLegend,
  WL as ChartLegendContent,
  FL as ChartStyle,
  D8 as ChartTooltip,
  BL as ChartTooltipContent,
  KL as Checkbox,
  L8 as Collapsible,
  B8 as CollapsibleContent,
  F8 as CollapsibleTrigger,
  Jm as Command,
  j8 as CommandDialog,
  IF as CommandEmpty,
  kF as CommandGroup,
  DF as CommandInput,
  FF as CommandItem,
  AF as CommandList,
  LF as CommandSeparator,
  BF as CommandShortcut,
  U8 as ContextMenu,
  $3 as ContextMenuCheckboxItem,
  N3 as ContextMenuContent,
  G8 as ContextMenuGroup,
  R3 as ContextMenuItem,
  M3 as ContextMenuLabel,
  K8 as ContextMenuPortal,
  z8 as ContextMenuRadioGroup,
  O3 as ContextMenuRadioItem,
  D3 as ContextMenuSeparator,
  A3 as ContextMenuShortcut,
  Y8 as ContextMenuSub,
  T3 as ContextMenuSubContent,
  _3 as ContextMenuSubTrigger,
  V8 as ContextMenuTrigger,
  c5 as Drawer,
  X8 as DrawerClose,
  u5 as DrawerContent,
  m5 as DrawerDescription,
  f5 as DrawerFooter,
  d5 as DrawerHeader,
  ng as DrawerOverlay,
  l5 as DrawerPortal,
  p5 as DrawerTitle,
  q8 as DrawerTrigger,
  m6 as DropdownMenu,
  v6 as DropdownMenuCheckboxItem,
  h6 as DropdownMenuContent,
  g6 as DropdownMenuGroup,
  b6 as DropdownMenuItem,
  y6 as DropdownMenuLabel,
  w6 as DropdownMenuPortal,
  C6 as DropdownMenuRadioGroup,
  E6 as DropdownMenuRadioItem,
  S6 as DropdownMenuSeparator,
  P6 as DropdownMenuShortcut,
  x6 as DropdownMenuSub,
  _6 as DropdownMenuSubContent,
  T6 as DropdownMenuSubTrigger,
  N6 as DropdownMenuTrigger,
  J8 as HoverCard,
  O5 as HoverCardContent,
  eH as HoverCardTrigger,
  yH as Input,
  G5 as InputOTP,
  K5 as InputOTPGroup,
  z5 as InputOTPSeparator,
  Y5 as InputOTPSlot,
  r4 as Label,
  T4 as Menubar,
  D4 as MenubarCheckboxItem,
  O4 as MenubarContent,
  rH as MenubarGroup,
  M4 as MenubarItem,
  I4 as MenubarLabel,
  nH as MenubarMenu,
  oH as MenubarPortal,
  aH as MenubarRadioGroup,
  A4 as MenubarRadioItem,
  k4 as MenubarSeparator,
  L4 as MenubarShortcut,
  iH as MenubarSub,
  $4 as MenubarSubContent,
  R4 as MenubarSubTrigger,
  N4 as MenubarTrigger,
  uW as NavigationMenu,
  mW as NavigationMenuContent,
  vW as NavigationMenuIndicator,
  cH as NavigationMenuItem,
  lH as NavigationMenuLink,
  dW as NavigationMenuList,
  pW as NavigationMenuTrigger,
  xb as NavigationMenuViewport,
  hW as Pagination,
  gW as PaginationContent,
  CW as PaginationEllipsis,
  bW as PaginationItem,
  Vc as PaginationLink,
  wW as PaginationNext,
  yW as PaginationPrevious,
  wH as Popover,
  CH as PopoverAnchor,
  EH as PopoverContent,
  SH as PopoverTrigger,
  RW as Progress,
  WW as RadioGroup,
  jW as RadioGroupItem,
  R6 as ResizableHandle,
  $6 as ResizablePanel,
  O6 as ResizablePanelGroup,
  M6 as ScrollArea,
  D6 as ScrollBar,
  A6 as Select,
  I6 as SelectContent,
  k6 as SelectGroup,
  L6 as SelectItem,
  F6 as SelectLabel,
  B6 as SelectScrollDownButton,
  W6 as SelectScrollUpButton,
  j6 as SelectSeparator,
  H6 as SelectTrigger,
  U6 as SelectValue,
  PH as Separator,
  xH as Sheet,
  _H as SheetClose,
  TH as SheetContent,
  NH as SheetDescription,
  RH as SheetFooter,
  $H as SheetHeader,
  OH as SheetOverlay,
  MH as SheetPortal,
  DH as SheetTitle,
  AH as SheetTrigger,
  IH as Sidebar,
  kH as SidebarContent,
  LH as SidebarFooter,
  FH as SidebarGroup,
  BH as SidebarGroupAction,
  WH as SidebarGroupContent,
  jH as SidebarGroupLabel,
  HH as SidebarHeader,
  UH as SidebarInput,
  VH as SidebarInset,
  GH as SidebarMenu,
  KH as SidebarMenuAction,
  YH as SidebarMenuBadge,
  zH as SidebarMenuButton,
  qH as SidebarMenuItem,
  XH as SidebarMenuSkeleton,
  ZH as SidebarMenuSub,
  QH as SidebarMenuSubButton,
  JH as SidebarMenuSubItem,
  e6 as SidebarProvider,
  t6 as SidebarRail,
  n6 as SidebarSeparator,
  r6 as SidebarTrigger,
  o6 as Skeleton,
  ij as Slider,
  gj as Switch,
  bj as Table,
  wj as TableBody,
  xj as TableCaption,
  Pj as TableCell,
  Cj as TableFooter,
  Sj as TableHead,
  yj as TableHeader,
  Ej as TableRow,
  V6 as Tabs,
  G6 as TabsContent,
  K6 as TabsList,
  Y6 as TabsTrigger,
  _j as Textarea,
  vH as Toaster,
  m8 as Toggle,
  v8 as ToggleGroup,
  h8 as ToggleGroupItem,
  a6 as Tooltip,
  i6 as TooltipContent,
  s6 as TooltipProvider,
  c6 as TooltipTrigger,
  J0 as badgeVariants,
  or as buttonVariants,
  fW as navigationMenuTriggerStyle,
  qy as toggleVariants,
  l6 as useSidebar
};
